// SAPA - Bangalore Spa Directory
// Total: 902 verified spas with 3+ star ratings
// Source: Google Maps Data - Last Updated: December 2025

export const ALL_SPAS = [
  {
    "id": "candid-beauty-salon-and-spa",
    "name": "Candid Beauty Salon and Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd Floor, Sri Vinayaka Complex, Siddhapura Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 452,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9557787,
    "longitude": 77.7280973,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Candid+Beauty+Salon+and+Spa/data=!4m7!3m6!1s0x3bae1368d524e71f:0x7a6927975f88a266!8m2!3d12.9557787!4d77.7280973!16s%2Fg%2F11y5_sw763!19sChIJH-ck1WgTrjsRZqKIX5cnaXo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-spa-house-in-hsr-layout-spa-and-massage-near-hsr-layout",
    "name": "The Spa house In HSR Layout | Spa And Massage Near HSR Layout",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "484 Lakshmi Arcade 2nd Floor 27th main road, 17th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 287,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9118753,
    "longitude": 77.6514654,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Spa+house+In+HSR+Layout+%7C+Spa+And+Massage+Near+HSR+Layout/data=!4m7!3m6!1s0x3bae158fabc2f693:0xc89c6694ec664952!8m2!3d12.9118753!4d77.6514654!16s%2Fg%2F11x5szpmy_!19sChIJk_bCq48VrjsRUklm7JRmnMg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "amanzi-wellness-spa",
    "name": "Amanzi Wellness Spa",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "1607, 17th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 243,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9127877,
    "longitude": 77.5916434,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Amanzi+Wellness+Spa/data=!4m7!3m6!1s0x3bae15710e96cd9f:0x5c919a6a1e88de8e!8m2!3d12.9127877!4d77.5916434!16s%2Fg%2F11ld_m5c0j!19sChIJn82WDnEVrjsRjt6IHmqakVw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "auto-bubbles-car-spa",
    "name": "Auto Bubbles Car Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "18/3, 3rd Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 228,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 13.0487039,
    "longitude": 77.6043838,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Auto+Bubbles+Car+Spa/data=!4m7!3m6!1s0x3bae176b582ed4ef:0xe3a4b38815e0d118!8m2!3d13.0487039!4d77.6043838!16s%2Fg%2F11vdn5p_dn!19sChIJ79QuWGsXrjsRGNHgFYizpOM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "harmony-luxe-spa",
    "name": "Harmony Luxe Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "51, 9th A Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 226,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9777509,
    "longitude": 77.6399293,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Harmony+Luxe+Spa/data=!4m7!3m6!1s0x3bae17c5c8622e9b:0x8ed8ddfe54651018!8m2!3d12.9777509!4d77.6399293!16s%2Fg%2F11xft_6g66!19sChIJmy5iyMUXrjsRGBBlVP7d2I4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "male-spa",
    "name": "Male spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 214,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9732527,
    "longitude": 77.5761533,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Male+spa/data=!4m7!3m6!1s0x3bae17049070e327:0xbc86c050341b25e!8m2!3d12.9732527!4d77.5761533!16s%2Fg%2F11vzpyjy4d!19sChIJJ-NwkAQXrjsRXrJBAwVsyAs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "swati-spa",
    "name": "Swati Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 204,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9314583,
    "longitude": 77.6299858,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Swati+Spa/data=!4m7!3m6!1s0x3bae1567f7973997:0xe4c003f064cdbbab!8m2!3d12.9314583!4d77.6299858!16s%2Fg%2F11wp129vvf!19sChIJlzmX92cVrjsRq7vNZPADwOQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "palm-spa",
    "name": "PALM SPA",
    "description": "Highly rated day spa in Whitefield with excellent reviews and professional service.",
    "address": "Resort, Palm Meadows, Whitefield Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 160,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9639599,
    "longitude": 77.7397394,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/PALM+SPA/data=!4m7!3m6!1s0x3bae135053476d4b:0x90ac1cc2b753d57c!8m2!3d12.9639599!4d77.7397394!16s%2Fg%2F11ygs0w5qr!19sChIJS21HU1ATrjsRfNVTt8IcrJA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "lavish-moto-spa",
    "name": "Lavish moto spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Lavish moto spa, Kumar layout, opp. Ambedkar Medical College Road",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 139,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 13.0232551,
    "longitude": 77.6123222,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Lavish+moto+spa/data=!4m7!3m6!1s0x3bae17beaf00d7b1:0x8b7db1a9877339c4!8m2!3d13.0232551!4d77.6123222!16s%2Fg%2F11tk08w84g!19sChIJsdcAr74XrjsRxDlzh6mxfYs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "delightful-spa",
    "name": "Delightful Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Unit No2, Mahakavi Vemana Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 128,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9302886,
    "longitude": 77.6221498,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Delightful+Spa/data=!4m7!3m6!1s0x3bae15a017109497:0xedc4a8ba4a52a30a!8m2!3d12.9302886!4d77.6221498!16s%2Fg%2F11xngtfhn0!19sChIJl5QQF6AVrjsRCqNSSrqoxO0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "araki-international-spa",
    "name": "Araki International Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "16, 80 Feet Rd, next to SBI BANK",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 121,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9330216,
    "longitude": 77.631479,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Araki+International+Spa/data=!4m7!3m6!1s0x3bae152ff12b61d5:0xff0ac84f7943baa!8m2!3d12.9330216!4d77.631479!16s%2Fg%2F11yqlych3x!19sChIJ1WEr8S8VrjsRqjuU94Ss8A8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "urvashi-spa",
    "name": "Urvashi Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "SN98, Diagonal Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 108,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9518857,
    "longitude": 77.5766931,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Urvashi+Spa/data=!4m7!3m6!1s0x3bae150a0b6b9655:0x993c8fceafb09353!8m2!3d12.9518857!4d77.5766931!16s%2Fg%2F11xkmftcbb!19sChIJVZZrCwoVrjsRU5Owr86PPJk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "swa-ayurvedic-salon-for-women-only",
    "name": "Swa Ayurvedic Salon (For Women only)",
    "description": "Highly rated ayurvedic spa in Bangalore with excellent reviews and professional service.",
    "address": "7,Ground Floor, 8th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 72,
    "spa_type": "Ayurvedic Spa",
    "services": [
      "Abhyanga",
      "Shirodhara",
      "Panchakarma",
      "Pizhichil",
      "Kerala Massage",
      "Ayurvedic Facial"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.938392,
    "longitude": 77.5828535,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Swa+Ayurvedic+Salon+%28For+Women+only%29/data=!4m7!3m6!1s0x3bae15876f6f84bf:0x1a7649a15b588365!8m2!3d12.938392!4d77.5828535!16s%2Fg%2F11txjghrgw!19sChIJv4Rvb4cVrjsRZYNYW6FJdho?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "elysian-strands-unisex-hair-salon-in-indiranagar",
    "name": "Elysian Strands Unisex Hair Salon In Indiranagar",
    "description": "Highly rated beauty spa in Indiranagar with excellent reviews and professional service.",
    "address": "2020, 100 Feet Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 50,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9668522,
    "longitude": 77.6416422,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Elysian+Strands+Unisex+Hair+Salon+In+Indiranagar/data=!4m7!3m6!1s0x3bae150018418f33:0xa3134c56e465d529!8m2!3d12.9668522!4d77.6416422!16s%2Fg%2F11yhrgq48h!19sChIJM49BGAAVrjsRKdVl5FZME6M?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "kavita-home-massage-service-spa",
    "name": "Kavita-Home Massage Service Spa.",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Ground Flr, Bloom Cafe, 103, 17th Main Rd, near Calicut Biriyani",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 47,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9064912,
    "longitude": 77.641387,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Kavita-Home+Massage+Service+Spa./data=!4m7!3m6!1s0x3bae15b3547b1607:0x1020829bd5db1741!8m2!3d12.9064912!4d77.641387!16s%2Fg%2F11y_wyw9gt!19sChIJBxZ7VLMVrjsRQRfb1ZuCIBA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "krasa-wellness-massage-spa-near-rt-nagar-bangalore",
    "name": "Krasa Wellness | Massage Spa Near RT Nagar, Bangalore",
    "description": "Highly rated wellness spa in RT Nagar with excellent reviews and professional service.",
    "address": "88, 1st Main Rd, behind R.T. Nagar",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "RT Nagar",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 45,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 13.0240589,
    "longitude": 77.5949326,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Krasa+Wellness+%7C+Massage+Spa+Near+RT+Nagar,+Bangalore/data=!4m7!3m6!1s0x3bae177d47214e75:0x5dfa370d6112cb8!8m2!3d13.0240589!4d77.5949326!16s%2Fg%2F11y5d6ggh2!19sChIJdU4hR30XrjsRuCwR1nCj3wU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-ark-spa",
    "name": "The ark spa",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "3rd floor, NO 114-115, HSR, 27th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 41,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9106398,
    "longitude": 77.6520287,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+ark+spa/data=!4m7!3m6!1s0x3bae150102309305:0xfd5c1f8cdf88058e!8m2!3d12.9106398!4d77.6520287!16s%2Fg%2F11xcfjwq18!19sChIJBZMwAgEVrjsRjgWI34wfXP0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "blossom-ladies-beauty-salon",
    "name": "Blossom Ladies Beauty Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "104, 6th Main Road, 15th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 39,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 13.0053572,
    "longitude": 77.5766965,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Blossom+Ladies+Beauty+Salon/data=!4m7!3m6!1s0x3bae170042e6b595:0x52f1a8605c28e0a!8m2!3d13.0053572!4d77.5766965!16s%2Fg%2F11vqs787bg!19sChIJlbXmQgAXrjsRCo7CBYYaLwU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "g-luxsh-doorstep-spa",
    "name": "g luxsh doorstep spa",
    "description": "Highly rated day spa in Kodichikkanahalli with excellent reviews and professional service.",
    "address": "421, 3rd Cross, Kodichikknahalli Main Road, near Mahaveer Zephyr",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Kodichikkanahalli",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 37,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.911105,
    "longitude": 77.6241654,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/g+luxsh+doorstep+spa/data=!4m7!3m6!1s0x3bae15b4071441f3:0xb110593d9c56b2bc!8m2!3d12.911105!4d77.6241654!16s%2Fg%2F11yhb2_3my!19sChIJ80EUB7QVrjsRvLJWnD1ZELE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "b2b-bangkok-style-massage-spa",
    "name": "B2B Bangkok style massage spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 33,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9121125,
    "longitude": 77.6470827,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/B2B+Bangkok+style+massage+spa/data=!4m7!3m6!1s0x3bae1570000eaef7:0x2e8c2a8a44591895!8m2!3d12.9121125!4d77.6470827!16s%2Fg%2F11yt328crx!19sChIJ964OAHAVrjsRlRhZRIoqjC4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "le-clat-signature-spa-salon-jayanagar",
    "name": "Le Clat Signature SPA & Salon - Jayanagar",
    "description": "Highly rated beauty spa in Jayanagar with excellent reviews and professional service.",
    "address": "2nd floor, B&B",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 33,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9212578,
    "longitude": 77.5998683,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Le+Clat+Signature+SPA+%26+Salon+-+Jayanagar/data=!4m7!3m6!1s0x3bae15b2f24ba727:0x7ad6795a5b0b2cf2!8m2!3d12.9212578!4d77.5998683!16s%2Fg%2F11yhs8t529!19sChIJJ6dL8rIVrjsR8iwLW1p51no?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "dhash-makeup-studio-and-academy",
    "name": "DHASH MAKEUP STUDIO AND ACADEMY",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "30/2, 4th cross, kanakanagar, POST",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 30,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 13.0352455,
    "longitude": 77.6077723,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/DHASH+MAKEUP+STUDIO+AND+ACADEMY/data=!4m7!3m6!1s0x3bae174a86446247:0xa1930c963107abce!8m2!3d13.0352455!4d77.6077723!16s%2Fg%2F11v3z676z2!19sChIJR2JEhkoXrjsRzqsHMZYMk6E?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "zoya-b2b-international-day-spa",
    "name": "Zoya b2b International Day Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "H.S.R",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 29,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9090673,
    "longitude": 77.6444832,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Zoya+b2b+International+Day+Spa/data=!4m7!3m6!1s0x3bae150a402e4a57:0x11e418097f3e6b6f!8m2!3d12.9090673!4d77.6444832!16s%2Fg%2F11sfbpz1tx!19sChIJV0ouQAoVrjsRb2s-fwkY5BE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ethos-salon-spa-and-aesthetic-clinic",
    "name": "ETHOS SALON SPA AND AESTHETIC CLINIC",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "1541/23, 39th cross, 23rd Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 29,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.920519,
    "longitude": 77.5920726,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/ETHOS+SALON+SPA+AND+AESTHETIC+CLINIC/data=!4m7!3m6!1s0x3bae1513312e0695:0xaf27c9852bf29e02!8m2!3d12.920519!4d77.5920726!16s%2Fg%2F11zj8b2wv3!19sChIJlQYuMRMVrjsRAp7yK4XJJ68?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "pure-serenity-spa",
    "name": "Pure Serenity Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Bangalore",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 23,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9782312,
    "longitude": 77.633233,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Pure+Serenity+Spa/data=!4m7!3m6!1s0x3bae17000381c84d:0x3513447b9eef9749!8m2!3d12.9782312!4d77.633233!16s%2Fg%2F11w8xkssbj!19sChIJTciBAwAXrjsRSZfvnntEEzU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "maria-night-spa",
    "name": "Maria Night Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "SN54, Chinmaya Mission Hospital Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 21,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9782686,
    "longitude": 77.6388995,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Maria+Night+Spa/data=!4m7!3m6!1s0x3bae179ea94ff3df:0x1c0d15aa176e7503!8m2!3d12.9782686!4d77.6388995!16s%2Fg%2F11ywghx258!19sChIJ3_NPqZ4XrjsRA3VuF6oVDRw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "iremia-wellness-spa",
    "name": "Iremia Wellness & Spa",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "Second Floor, 11, 16th Main Rd, above Crazy Head Salon",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 21,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9660701,
    "longitude": 77.642039,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Iremia+Wellness+%26+Spa/data=!4m7!3m6!1s0x3bae15d286b5ce8f:0x6afb3d6015b34b70!8m2!3d12.9660701!4d77.642039!16s%2Fg%2F11x78kq3rz!19sChIJj861htIVrjsRcEuzFWA9-2o?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-le-paris-jagadish-hotel",
    "name": "Spa Le Paris @ Jagadish Hotel",
    "description": "Highly rated day spa in Sankey Road with excellent reviews and professional service.",
    "address": "10, Sankey Rd, next to BDA Head Office",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Sankey Road",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 18,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9971086,
    "longitude": 77.5841329,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spa+Le+Paris+@+Jagadish+Hotel/data=!4m7!3m6!1s0x3bae1716d2b1fcc1:0xef4c04722ddd9ad!8m2!3d12.9971086!4d77.5841329!16s%2Fg%2F11jybnz7hc!19sChIJwfyx0hYXrjsRrdndIkfA9A4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "mayra-home-massage-bangalore-spa",
    "name": "Mayra Home Massage Bangalore Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 16,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9340982,
    "longitude": 77.6253266,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Mayra+Home+Massage+Bangalore+Spa/data=!4m7!3m6!1s0x3bae15608d9013b7:0xd8fdf8b57d54ac5b!8m2!3d12.9340982!4d77.6253266!16s%2Fg%2F11yy_hhy0k!19sChIJtxOQjWAVrjsRW6xUfbX4_dg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nawan-international-thai-spa-koramangala",
    "name": "Nawan International Thai Spa Koramangala",
    "description": "Highly rated thai spa in Koramangala with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 16,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9349524,
    "longitude": 77.6294002,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nawan+International+Thai+Spa+Koramangala/data=!4m7!3m6!1s0x3bae15646aaf3e61:0x9292aeba31d02543!8m2!3d12.9349524!4d77.6294002!16s%2Fg%2F11xghfh3bt!19sChIJYT6vamQVrjsRQyXQMbqukpI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "tiara-doorstep-spa",
    "name": "Tiara Doorstep Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "near indian oil petrol pump",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 15,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9090103,
    "longitude": 77.6442835,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Tiara+Doorstep+Spa/data=!4m7!3m6!1s0x3bae15a09b068ddf:0x707a56737d3b5fe!8m2!3d12.9090103!4d77.6442835!16s%2Fg%2F11vx2dbvzv!19sChIJ340Gm6AVrjsR_rXTN2elBwc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sia-studio-hair-and-beauty-spa",
    "name": "Sia studio Hair and beauty spa",
    "description": "Highly rated beauty spa in Rajajinagar with excellent reviews and professional service.",
    "address": "467/A 2nd Stage 5th main Subramanyamnagar rajajinagar",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Rajajinagar",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 15,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 13.0079027,
    "longitude": 77.5559065,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sia+studio+Hair+and+beauty+spa/data=!4m7!3m6!1s0x3bae3de336d8e5a5:0x21fc76fa8a4948b7!8m2!3d13.0079027!4d77.5559065!16s%2Fg%2F11xcy1rr3g!19sChIJpeXYNuM9rjsRt0hJivp2_CE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "aura-luxury-beauty-spa",
    "name": "Aura Luxury Beauty & Spa",
    "description": "Highly rated beauty spa in Brigade Road with excellent reviews and professional service.",
    "address": "6th Floor, AK Castle Suites Building, 35, 6th floor, AK Castle Suites, Castle St, Off Brigade Road Richmond Town, 35, Castle St, off Brigade Road",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Brigade Road",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 14,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9673423,
    "longitude": 77.6090249,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Aura+Luxury+Beauty+%26+Spa/data=!4m7!3m6!1s0x3bae157615e3975b:0x62b70aea4331f97b!8m2!3d12.9673423!4d77.6090249!16s%2Fg%2F11m5qjjztg!19sChIJW5fjFXYVrjsRe_kxQ-oKt2I?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sweet-salt-unisex-salon-spa",
    "name": "Sweet & salt Unisex salon&spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd floor, 191, New BEL Rd, opp. to mc Donald's",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 14,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 13.0293636,
    "longitude": 77.5710545,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sweet+%26+salt+Unisex+salon%26spa/data=!4m7!3m6!1s0x3bae1766bb1a7dd9:0x14006b8cb53dd682!8m2!3d13.0293636!4d77.5710545!16s%2Fg%2F11vynp9j_l!19sChIJ2X0au2YXrjsRgtY9tYxrABQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ak-beauty-spa",
    "name": "AK Beauty Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "300/C, 36th Cross, 9th A Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 14,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9231633,
    "longitude": 77.5843795,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/AK+Beauty+Spa/data=!4m7!3m6!1s0x3bae157dc009cbf1:0x8ab9dc59ce946ee6!8m2!3d12.9231633!4d77.5843795!16s%2Fg%2F11tnzx8vmb!19sChIJ8csJwH0VrjsR5m6UzlncuYo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "madhura-unisex-salon-spa",
    "name": "Madhura Unisex Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Gange Complex, Nallurahalli Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 14,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9567267,
    "longitude": 77.7310868,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Madhura+Unisex+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae13ad7d7c4aab:0x2eda2d26713ff594!8m2!3d12.9567267!4d77.7310868!16s%2Fg%2F11yyhp8pt6!19sChIJq0p8fa0TrjsRlPU_cSYt2i4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "orchid-wellness-spa",
    "name": "Orchid Wellness Spa",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 13,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9797709,
    "longitude": 77.6465667,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Orchid+Wellness+Spa/data=!4m7!3m6!1s0x3bae179e9dc4c7eb:0xf6bf8156f71ff838!8m2!3d12.9797709!4d77.6465667!16s%2Fg%2F11yz8jtlhp!19sChIJ68fEnZ4XrjsROPgf91aBv_Y?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "kiva-thai-spa",
    "name": "Kiva Thai Spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "1st Floor, 5th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 13,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9801113,
    "longitude": 77.6397979,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Kiva+Thai+Spa/data=!4m7!3m6!1s0x3bae176ae7ab0dc1:0x8223e6a89ae49438!8m2!3d12.9801113!4d77.6397979!16s%2Fg%2F11yhxsrh53!19sChIJwQ2r52oXrjsROJTkmqjmI4I?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "pearl-spa",
    "name": "Pearl spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "111/1, opp to Mongolia apartment Shivanakunte Temple road Nogondahalli, post",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 13,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9750201,
    "longitude": 77.7683627,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Pearl+spa/data=!4m7!3m6!1s0x3bae0d8667221b89:0x9adf22c5bdaff4e0!8m2!3d12.9750201!4d77.7683627!16s%2Fg%2F11w3c3ptck!19sChIJiRsiZ4YNrjsR4PSvvcUi35o?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "aga-hamami-spa",
    "name": "Aga Hamami Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 13,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9812027,
    "longitude": 77.7432542,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Aga+Hamami+Spa/data=!4m7!3m6!1s0x3bae1172f4adc29f:0xcb66fa934a00184a!8m2!3d12.9812027!4d77.7432542!16s%2Fg%2F11mzg32j7v!19sChIJn8Kt9HIRrjsRShgASpP6Zss?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-element-spa-and-salon-best-spa-center-in-bangalore",
    "name": "The Element Spa and Salon - Best SPA Center in Bangalore",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 12,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9917036,
    "longitude": 77.5943311,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Element+Spa+and+Salon+-+Best+SPA+Center+in+Bangalore/data=!4m7!3m6!1s0x3bae175389c01817:0xd27bebb52a79ce62!8m2!3d12.9917036!4d77.5943311!16s%2Fg%2F11vptffcsn!19sChIJFxjAiVMXrjsRYs55KrXre9I?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "blooms-unisex-salon-spa-whitefield",
    "name": "Blooms Unisex Salon & Spa - Whitefield",
    "description": "Highly rated beauty spa in Whitefield with excellent reviews and professional service.",
    "address": "First Floor, VB nilaya, Hagadur Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 12,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9649827,
    "longitude": 77.7577681,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Blooms+Unisex+Salon+%26+Spa+-+Whitefield/data=!4m7!3m6!1s0x3bae0d61a24d7b6b:0xed6d907f396cdb7b!8m2!3d12.9649827!4d77.7577681!16s%2Fg%2F11yshsswrm!19sChIJa3tNomENrjsRe9tsOX-Qbe0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "brunda-luxury-spa",
    "name": "Brunda Luxury Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "1st Floor, White Stone Inn, 6/7 15&16, Amruthahalli Main Rd, above Udupi Delicacy",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 10,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 13.065903,
    "longitude": 77.5983241,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Brunda+Luxury+Spa/data=!4m7!3m6!1s0x3bae19db598c5123:0xe7119a86601e16d1!8m2!3d13.065903!4d77.5983241!16s%2Fg%2F11ytk8344l!19sChIJI1GMWdsZrjsR0RYeYIaaEec?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "royal-auto-spa",
    "name": "Royal Auto Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "33/1 5th A Cross, Sultanpalya Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 10,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 13.0361901,
    "longitude": 77.6050938,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Royal+Auto+Spa/data=!4m7!3m6!1s0x3bae1776eb057f2d:0xa5b46a6a8152bc54!8m2!3d13.0361901!4d77.6050938!16s%2Fg%2F11xlnlh9xw!19sChIJLX8F63YXrjsRVLxSgWpqtKU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "a3-salon-spa",
    "name": "A3 SALON & SPA",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "No,411,1st floor, 1st Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 9,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9352862,
    "longitude": 77.6128534,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/A3+SALON+%26+SPA/data=!4m7!3m6!1s0x3bae15a857824231:0x8b24c2b954a7361!8m2!3d12.9352862!4d77.6128534!16s%2Fg%2F11ks97zmfl!19sChIJMUKCV6gVrjsRYXNKlStMsgg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nikhil-male-therapist-m2f-spa-home-services",
    "name": "Nikhil male therapist_ M2F_ Spa Home Services",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "6, 2nd Cross, Road",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 9,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9661724,
    "longitude": 77.7507407,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nikhil+male+therapist_+M2F_+Spa+Home+Services/data=!4m7!3m6!1s0x3bae0d0cabd88c07:0xb5aedb359bc561d0!8m2!3d12.9661724!4d77.7507407!16s%2Fg%2F11v9yjbttg!19sChIJB4zYqwwNrjsR0GHFmzXbrrU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "star-unisex-salon-spa",
    "name": "Star unisex salon & spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "528, 16th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 8,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9810733,
    "longitude": 77.6354689,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Star+unisex+salon+%26+spa/data=!4m7!3m6!1s0x3bae172cdf234327:0xefa4f5b85e58bfba!8m2!3d12.9810733!4d77.6354689!16s%2Fg%2F11yx9d120m!19sChIJJ0Mj3ywXrjsRur9YXrj1pO8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "mk7-spa-and-salon",
    "name": "MK7 SPA AND SALON",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "First Floor, 1809, New Thippasandra Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 8,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9723866,
    "longitude": 77.6510675,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/MK7+SPA+AND+SALON/data=!4m7!3m6!1s0x3bae11f25d7426db:0x708d36dc52bcc732!8m2!3d12.9723866!4d77.6510675!16s%2Fg%2F11xrn_xj9k!19sChIJ2yZ0XfIRrjsRMse8Utw2jXA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "look-at-me-unisex-spa",
    "name": "Look at me unisex spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "1699, 19th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 8,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9062381,
    "longitude": 77.644419,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Look+at+me+unisex+spa/data=!4m7!3m6!1s0x3bae1550f5a5d707:0xef44e4776f46144d!8m2!3d12.9062381!4d77.644419!16s%2Fg%2F11y9hrz8rz!19sChIJB9el9VAVrjsRTRRGb3fkRO8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "premium-luxury-b2b-spa",
    "name": "Premium Luxury B2b Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "33, 22nd Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 8,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9090125,
    "longitude": 77.6436194,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Premium+Luxury+B2b+Spa/data=!4m7!3m6!1s0x3bae1538e3c801c3:0xeecf7b4791bd2adb!8m2!3d12.9090125!4d77.6436194!16s%2Fg%2F11yv29drgm!19sChIJwwHI4zgVrjsR2yq9kUd7z-4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "v-k-salon-spa",
    "name": "V K Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 8,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.907987,
    "longitude": 77.6493287,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/V+K+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae15f68ab4c6fd:0x7d1408cf047b47cc!8m2!3d12.907987!4d77.6493287!16s%2Fg%2F11z0ktly20!19sChIJ_ca0ivYVrjsRzEd7BM8IFH0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nilaya-spa-bmw",
    "name": "Nilaya spa Bmw",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Plot No 75, 8th Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 8,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9787577,
    "longitude": 77.7287389,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nilaya+spa+Bmw/data=!4m7!3m6!1s0x3bae116d9b4f7a87:0x3fea36c3e8ee289a!8m2!3d12.9787577!4d77.7287389!16s%2Fg%2F11yfqxth9k!19sChIJh3pPm20RrjsRmiju6MM26j8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "royal-gold-salon-and-spa",
    "name": "Royal Gold Salon and Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "3rd floor, No 5, Sirur Park Rd, near to Mantri square mall",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 7,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9930001,
    "longitude": 77.5722307,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Royal+Gold+Salon+and+Spa/data=!4m7!3m6!1s0x3bae17180c073f15:0xafb8051130b0c0b6!8m2!3d12.9930001!4d77.5722307!16s%2Fg%2F11wtkntj1f!19sChIJFT8HDBgXrjsRtsCwMBEFuK8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vvip-couple-body-massage-hsr-layout",
    "name": "Vvip Couple Body Massage HSR Layout",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "Opulence Home Decor Palazzo",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 7,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9194605,
    "longitude": 77.6452846,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Vvip+Couple+Body+Massage+HSR+Layout/data=!4m7!3m6!1s0x3bae150058b8f2e5:0x5e0bf32b3b5668c1!8m2!3d12.9194605!4d77.6452846!16s%2Fg%2F11vzpgnf4_!19sChIJ5fK4WAAVrjsRwWhWOyvzC14?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bella-spa-salon",
    "name": "Bella spa & salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "152 3rd floor, 1st Main Rd, opp. Sai Baba Temple",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 7,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9363474,
    "longitude": 77.6141334,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bella+spa+%26+salon/data=!4m7!3m6!1s0x3bae156627d739a3:0xa20a2473e387be0c!8m2!3d12.9363474!4d77.6141334!16s%2Fg%2F11y3jj7yw2!19sChIJoznXJ2YVrjsRDL6H43MkCqI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "o3-spa-salon",
    "name": "O3 Spa & Salon",
    "description": "Highly rated beauty spa in ITPL with excellent reviews and professional service.",
    "address": "ITPL Back Gate, 92/2, Pattanduru Araghara",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "ITPL",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 7,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9771503,
    "longitude": 77.7337249,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/O3+Spa+%26+Salon/data=!4m7!3m6!1s0x3bae133de7b4d0b9:0xd733e963ab96e629!8m2!3d12.9771503!4d77.7337249!16s%2Fg%2F11wr3lnx87!19sChIJudC05z0TrjsRKeaWq2PpM9c?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "swathi-spa",
    "name": "Swathi SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Bangalore",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 7,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9571909,
    "longitude": 77.7459142,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Swathi+SPA/data=!4m7!3m6!1s0x3bae0d2b863bf439:0xfcba70a90af9ba72!8m2!3d12.9571909!4d77.7459142!16s%2Fg%2F11x5nlfvf0!19sChIJOfQ7hisNrjsRcrr5Cqlwuvw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "mentomenmassagebangalore-in",
    "name": "Mentomenmassagebangalore.in",
    "description": "Highly rated day spa in Malleshwaram with excellent reviews and professional service.",
    "address": "Malleshwaram 18th cross, Sankey Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Malleshwaram",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 7,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 13.0059426,
    "longitude": 77.5796298,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Mentomenmassagebangalore.in/data=!4m7!3m6!1s0x3bae176b9e1bc4f3:0x5d96bcfd7072ccf!8m2!3d13.0059426!4d77.5796298!16s%2Fg%2F11wxcrqk88!19sChIJ88QbnmsXrjsRzywH189r2QU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "rustic-spa",
    "name": "Rustic Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "101, 17th A Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 6,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9795913,
    "longitude": 77.6342901,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Rustic+Spa/data=!4m7!3m6!1s0x3bae1444bb71d645:0x186912805ae3a111!8m2!3d12.9795913!4d77.6342901!16s%2Fg%2F11h7rqxdhc!19sChIJRdZxu0QUrjsREaHjWoASaRg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "star-beauty-parlour-unisex-saloon-spa",
    "name": "Star Beauty Parlour- Unisex Saloon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "No 29.1st floor, Chinmaya Mission Hospital Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 6,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9783027,
    "longitude": 77.6345686,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Star+Beauty+Parlour-+Unisex+Saloon+%26+Spa/data=!4m7!3m6!1s0x3bae171c67b2cd09:0x1175651d9145aad8!8m2!3d12.9783027!4d77.6345686!16s%2Fg%2F11k4_cxypx!19sChIJCc2yZxwXrjsR2KpFkR1ldRE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "angell-salon-spa",
    "name": "ANGELL SALON & SPA",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd Floor, 12/25, 9th Cross Rd, above Davanagere Benne Dose Mane",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 6,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9107368,
    "longitude": 77.5790962,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/ANGELL+SALON+%26+SPA/data=!4m7!3m6!1s0x3bae15555defd13f:0xc94ca639172975fc!8m2!3d12.9107368!4d77.5790962!16s%2Fg%2F11mcjb41tg!19sChIJP9HvXVUVrjsR_HUpFzmmTMk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "golden-spa-and-wellness-center",
    "name": "Golden spa and wellness center",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "stall 1 floor, and, opposite to Brigade Irv Center, near chaitanya bakery Ajanaappa",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 6,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9704826,
    "longitude": 77.7323879,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Golden+spa+and+wellness+center/data=!4m7!3m6!1s0x3bae13e3f89559e3:0xc2e8c697b5419006!8m2!3d12.9704826!4d77.7323879!16s%2Fg%2F11n9cjwf0y!19sChIJ41mV-OMTrjsRBpBBtZfG6MI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "mas-beauty-and-spa-unisex",
    "name": "MAS Beauty and Spa - Unisex",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "apartments, Pattandur Agrahara ECC Rd, opp. to Gopalan Atlantis",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 6,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9755467,
    "longitude": 77.7439096,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/MAS+Beauty+and+Spa+-+Unisex/data=!4m7!3m6!1s0x3bae114cfaeba191:0x5c09636a7a24527!8m2!3d12.9755467!4d77.7439096!16s%2Fg%2F11mf2pfy27!19sChIJkaHr-kwRrjsRJ0WipzaWwAU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-wash-spa-dry-cleaning-hebbal",
    "name": "The Wash & Spa Dry Cleaning Hebbal",
    "description": "Highly rated day spa in Hebbal with excellent reviews and professional service.",
    "address": "63, Janatha Colony Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Hebbal",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 5,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 13.0489605,
    "longitude": 77.6011224,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Wash+%26+Spa+Dry+Cleaning+Hebbal/data=!4m7!3m6!1s0x3bae17007717831f:0xf7c862b201d2560!8m2!3d13.0489605!4d77.6011224!16s%2Fg%2F11xt2qb91j!19sChIJH4MXdwAXrjsRYCUdICuGfA8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "f2m-b2b-relax-spa",
    "name": "F2M b2b Relax Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 5,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9061232,
    "longitude": 77.6298239,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/F2M+b2b+Relax+Spa/data=!4m7!3m6!1s0x3bae15bf74cb1bad:0x30da2da91629c9d8!8m2!3d12.9061232!4d77.6298239!16s%2Fg%2F11ms34_0zs!19sChIJrRvLdL8VrjsR2MkpFqkt2jA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sparsh-spa-koramangala",
    "name": "Sparsh Spa Koramangala",
    "description": "Highly rated day spa in Koramangala with excellent reviews and professional service.",
    "address": "2nd floor, Sparsh Spa, 474, 1st Cross Rd, near Amudham Cafe",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 5,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9338418,
    "longitude": 77.6194543,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sparsh+Spa+Koramangala/data=!4m7!3m6!1s0x3bae15e0eec96f5b:0x5fe1e741e0ae1d12!8m2!3d12.9338418!4d77.6194543!16s%2Fg%2F11msfk8f5z!19sChIJW2_J7uAVrjsREh2u4EHn4V8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "beauty-spa-pvr",
    "name": "Beauty Spa PVR",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Immadihalli Main Rd, above New Udupi veg",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 5,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9670395,
    "longitude": 77.7612858,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Beauty+Spa+PVR/data=!4m7!3m6!1s0x3bae0d19be79580d:0x558eab9aa87ff11a!8m2!3d12.9670395!4d77.7612858!16s%2Fg%2F11y6b5f8wl!19sChIJDVh5vhkNrjsRGvF_qJqrjlU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "jasmine-salon-spa",
    "name": "Jasmine Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "586, 52nd Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 4,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9871662,
    "longitude": 77.5549324,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Jasmine+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae3d110b4bbaad:0x7394649a06010b69!8m2!3d12.9871662!4d77.5549324!16s%2Fg%2F11kj32b76x!19sChIJrbpLCxE9rjsRaQsBBppklHM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "a1-golden-shine-car-spa",
    "name": "A1 Golden Shine Car Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Euro kids, 26/4",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 4,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 13.0551754,
    "longitude": 77.602378,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/A1+Golden+Shine+Car+Spa/data=!4m7!3m6!1s0x3bae174d973d4d65:0x2503e476e078f02b!8m2!3d13.0551754!4d77.602378!16s%2Fg%2F11flbpzpjz!19sChIJZU09l00XrjsRK_B44HbkAyU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "platinum-spa",
    "name": "PLATINUM SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "1st block, 125 Godrej, 10th cross road, 10, B St, near tcl tv showroom",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 3,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9766247,
    "longitude": 77.5610776,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/PLATINUM+SPA/data=!4m7!3m6!1s0x3bae3d6eb3c43d0f:0x58f62ebe482030ae!8m2!3d12.9766247!4d77.5610776!16s%2Fg%2F11t7crcgcc!19sChIJDz3Es249rjsRrjAgSL4u9lg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nivan-international-thai-spa-indiranagar",
    "name": "Nivan International Thai Spa Indiranagar",
    "description": "Highly rated thai spa in Indiranagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 3,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9780703,
    "longitude": 77.638007,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nivan+International+Thai+Spa+Indiranagar/data=!4m7!3m6!1s0x3bae173bd4dab05f:0x46b7fa6cca361999!8m2!3d12.9780703!4d77.638007!16s%2Fg%2F11y_0br669!19sChIJX7Da1DsXrjsRmRk2ymz6t0Y?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-spa",
    "name": "the spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd Floor, plot no 764, 100 Feet Rd, above brook brothers, next to loft",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 3,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9709903,
    "longitude": 77.6410041,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/the+spa/data=!4m7!3m6!1s0x3bae1759b48cade7:0x673710d61abdbd0b!8m2!3d12.9709903!4d77.6410041!16s%2Fg%2F11x8sspr6k!19sChIJ562MtFkXrjsRC729GtYQN2c?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "gladden-salon-wellness-spa",
    "name": "Gladden Salon Wellness Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "1285, 13th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 3,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9761854,
    "longitude": 77.6356087,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Gladden+Salon+Wellness+Spa/data=!4m7!3m6!1s0x3bae17005b2049f1:0x2fc722aba7cc0109!8m2!3d12.9761854!4d77.6356087!16s%2Fg%2F11yqh41p0r!19sChIJ8UkgWwAXrjsRCQHMp6sixy8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "neha-day-night-in-out-spa-service",
    "name": "NEHA-DAY Night In Out Spa Service.",
    "description": "Highly rated day spa in BTM Layout with excellent reviews and professional service.",
    "address": "Alcove Service BTM Layout Bangalore 148/2 20Th Main, 2nd Cross Rd, next to Friends Hotel",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "BTM Layout",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 3,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9123987,
    "longitude": 77.6099426,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/NEHA-DAY+Night+In+Out+Spa+Service./data=!4m7!3m6!1s0x3bae155e68cb68cf:0x93af143b6c29e10e!8m2!3d12.9123987!4d77.6099426!16s%2Fg%2F11z1rcxccm!19sChIJz2jLaF4VrjsRDuEpbDsUr5M?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-hsr-luxury-spa",
    "name": "THE HSR LUXURY SPA",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "123, 14th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 3,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9154847,
    "longitude": 77.6358044,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/THE+HSR+LUXURY+SPA/data=!4m7!3m6!1s0x3bae154a6673a0c1:0xb44d9806f6c1c90b!8m2!3d12.9154847!4d77.6358044!16s%2Fg%2F11yz_cn0q6!19sChIJwaBzZkoVrjsRC8nB9gaYTbQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ayur-spa",
    "name": "Ayur Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "No.47, 2nd Floor, 2nd Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 3,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9317712,
    "longitude": 77.6291028,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ayur+Spa/data=!4m7!3m6!1s0x3bae145da1983b4d:0xf2ef3a8b8475efbc!8m2!3d12.9317712!4d77.6291028!16s%2Fg%2F11rxv16m67!19sChIJTTuYoV0UrjsRvO91hIs67_I?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "tranquil-doorstep-spa",
    "name": "Tranquil Doorstep Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 3,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9379287,
    "longitude": 77.6261167,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Tranquil+Doorstep+Spa/data=!4m7!3m6!1s0xd60bc7c89424a69:0x26d0acdd519cde58!8m2!3d12.9379287!4d77.6261167!16s%2Fg%2F11k4ryz4cb!19sChIJaUpCiXy8YA0RWN6cUd2s0CY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "b2-bangalore-spa",
    "name": "B2 Bangalore spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "WJPH+3RH",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 3,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9351918,
    "longitude": 77.6296228,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/B2+Bangalore+spa/data=!4m7!3m6!1s0x3bae15f47bcdd71f:0xd9d51cb67818ca39!8m2!3d12.9351918!4d77.6296228!16s%2Fg%2F11h555029c!19sChIJH9fNe_QVrjsROcoYeLYc1dk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "mesmerize-the-tranquil-spa-koramangala",
    "name": "Mesmerize the tranquil Spa Koramangala",
    "description": "Highly rated day spa in Koramangala with excellent reviews and professional service.",
    "address": "234/A, 1st Main Rd, opposite Star Bazar",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 3,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9371437,
    "longitude": 77.6117845,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Mesmerize+the+tranquil+Spa+Koramangala/data=!4m7!3m6!1s0x3bae15fc4bcbb0a1:0x38c24fce99ec6c0!8m2!3d12.9371437!4d77.6117845!16s%2Fg%2F11vl7kcdht!19sChIJobDLS_wVrjsRwMae6fwkjAM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "silver-spa-salon",
    "name": "Silver Spa & Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "27/2, Immadihalli Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 3,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9670802,
    "longitude": 77.7605353,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Silver+Spa+%26+Salon/data=!4m7!3m6!1s0x3bae0d7d5f86fc3d:0x1db9ed94dd616c9f!8m2!3d12.9670802!4d77.7605353!16s%2Fg%2F11xgq5mg21!19sChIJPfyGX30NrjsRn2xh3ZTtuR0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bangalore-spa",
    "name": "Bangalore spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "1130, 100 Feet Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 2,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9696179,
    "longitude": 77.6414997,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bangalore+spa/data=!4m7!3m6!1s0x3bae172dd9a0def5:0x7fcbb0758fca7b91!8m2!3d12.9696179!4d77.6414997!16s%2Fg%2F11w9swspr3!19sChIJ9d6g2S0XrjsRkXvKj3Wwy38?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "crystal-spa-spa-in-indiara-nagar",
    "name": "Crystal SPA | SPA in Indiara Nagar",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 2,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9828308,
    "longitude": 77.6403486,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Crystal+SPA+%7C+SPA+in+Indiara+Nagar/data=!4m7!3m6!1s0x3bae17003a7f33b9:0x866ee1e8d0cc65b7!8m2!3d12.9828308!4d77.6403486!16s%2Fg%2F11m6wq_6vz!19sChIJuTN_OgAXrjsRt2XM0OjhboY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "dolphin-spa-at-ur-door-step-by-step",
    "name": "Dolphin Spa at ur door step-by-step",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "4024, 100 Feet Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 2,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9629887,
    "longitude": 77.6415203,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Dolphin+Spa+at+ur+door+step-by-step/data=!4m7!3m6!1s0x3bae141d2f823313:0xe03a0a9f69ed53b!8m2!3d12.9629887!4d77.6415203!16s%2Fg%2F11fnw16802!19sChIJEzOCLx0UrjsRO9We9qmgAw4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ragams-03-salon-and-spa",
    "name": "Ragams 03 Salon And Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "abve shaap, 83/4, 13th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 2,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.968436,
    "longitude": 77.6402392,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ragams+03+Salon+And+Spa/data=!4m7!3m6!1s0x3bae152e7b378ca3:0x34b36897bb73dd9c!8m2!3d12.968436!4d77.6402392!16s%2Fg%2F11xs4lhcdt!19sChIJo4w3ey4VrjsRnN1zu5doszQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "le-spa",
    "name": "LE SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "186, 9th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 2,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9790197,
    "longitude": 77.6394156,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/LE+SPA/data=!4m7!3m6!1s0x3bae17c91a3476f9:0x8771a978a690db4a!8m2!3d12.9790197!4d77.6394156!16s%2Fg%2F11x27jlmy0!19sChIJ-XY0GskXrjsRStuQpnipcYc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sunshine-wellness-salon-and-spa",
    "name": "Sunshine wellness salon and spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "1st floor, 3194, 7th Main Rd, above shrushti store patanjali",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 2,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9711887,
    "longitude": 77.6345549,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sunshine+wellness+salon+and+spa/data=!4m7!3m6!1s0x3bae17717be33bbf:0xdb843d30827d28af!8m2!3d12.9711887!4d77.6345549!16s%2Fg%2F11fszl60z1!19sChIJvzvje3EXrjsRryh9gjA9hNs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "siri-saloon-spa",
    "name": "SIRI SALOON & SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "VM47+8C3",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 2,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.8557614,
    "longitude": 77.6635387,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/SIRI+SALOON+%26+SPA/data=!4m7!3m6!1s0x3bae6d07e388cbc9:0x615b9cb40ff9cc3c!8m2!3d12.8557614!4d77.6635387!16s%2Fg%2F11v62kdwnj!19sChIJycuI4wdtrjsRPMz5D7ScW2E?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-saloon",
    "name": "Spa & saloon",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "RK St",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 2,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 13.0734548,
    "longitude": 77.51788,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spa+%26+saloon/data=!4m7!3m6!1s0x3bae239dea457b5b:0x9d772616d64a506f!8m2!3d13.0734548!4d77.51788!16s%2Fg%2F11sf9rvf6c!19sChIJW3tF6p0jrjsRb1BK1hYmd50?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nidhi-spa",
    "name": "Nidhi spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Bangalore",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 2,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9105832,
    "longitude": 77.6520353,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nidhi+spa/data=!4m7!3m6!1s0x3bae152bce6a937b:0xc530dbfe988c9001!8m2!3d12.9105832!4d77.6520353!16s%2Fg%2F11w57svf52!19sChIJe5NqzisVrjsRAZCMmP7bMMU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "thai-spa-koramangala",
    "name": "Thai Spa Koramangala",
    "description": "Highly rated thai spa in Koramangala with excellent reviews and professional service.",
    "address": "Oracle building, opposite INDIQUBE, near to St John hospital",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 2,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9311174,
    "longitude": 77.6106697,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Thai+Spa+Koramangala/data=!4m7!3m6!1s0x3bae153edeebc989:0x54383216265d6111!8m2!3d12.9311174!4d77.6106697!16s%2Fg%2F11n4l5b5rr!19sChIJicnr3j4VrjsREWFdJhYyOFQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "rewa-spa-and-salon",
    "name": "Rewa Spa And Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "412",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 2,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9354508,
    "longitude": 77.6129317,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Rewa+Spa+And+Salon/data=!4m7!3m6!1s0x3bae1504de941401:0x56c2d39181db2dc1!8m2!3d12.9354508!4d77.6129317!16s%2Fg%2F11vwjcsg6l!19sChIJARSU3gQVrjsRwS3bgZHTwlY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "eden-salon-and-spa",
    "name": "Eden Salon And Spa",
    "description": "Highly rated beauty spa in Koramangala with excellent reviews and professional service.",
    "address": "Eden Salon and Spa, BDA Complex, near Koramangala",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 2,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9361362,
    "longitude": 77.6147123,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Eden+Salon+And+Spa/data=!4m7!3m6!1s0x3bae144e690e2fcd:0x381c5b211433caa8!8m2!3d12.9361362!4d77.6147123!16s%2Fg%2F11yh2ctpqz!19sChIJzS8OaU4UrjsRqMozFCFbHDg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "slv-thai-spa",
    "name": "SLV THAI SPA",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd Floor, Annapurneshwari Tower, No582, Immadihalli Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 2,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9696958,
    "longitude": 77.7514578,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/SLV+THAI+SPA/data=!4m7!3m6!1s0x3bae0dfc1b2a06cb:0x8d008c202e305968!8m2!3d12.9696958!4d77.7514578!16s%2Fg%2F11yh27bklw!19sChIJywYqG_wNrjsRaFkwLiCMAI0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "teena-daynight-spa-nallurhalli-whitefield-bengaluru",
    "name": "Teena Daynight Spa Nallurhalli Whitefield Bengaluru",
    "description": "Highly rated day spa in Whitefield with excellent reviews and professional service.",
    "address": "XP9X+MVV",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 2,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9692443,
    "longitude": 77.749681,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Teena+Daynight+Spa+Nallurhalli+Whitefield+Bengaluru/data=!4m7!3m6!1s0x3bae0d0030620c97:0x14dd7fbb196c763d!8m2!3d12.9692443!4d77.749681!16s%2Fg%2F11x_rmgg7y!19sChIJlwxiMAANrjsRPXZsGbt_3RQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "therapyca-spa-centre",
    "name": "Therapyca Spa Centre",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "2 nd floor, SS TOWER, 13th Cross Rd, above Third Wave Coffee",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 2,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 13.0037832,
    "longitude": 77.5668639,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Therapyca+Spa+Centre/data=!4m7!3m6!1s0x3bae17ba2819e6a1:0xe19fb56c34397363!8m2!3d13.0037832!4d77.5668639!16s%2Fg%2F11vb7dmx0b!19sChIJoeYZKLoXrjsRY3M5NGy1n-E?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "yoni-tantra-spa",
    "name": "yoni tantra spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Bangalore",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 1,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9844747,
    "longitude": 77.6400202,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/yoni+tantra+spa/data=!4m7!3m6!1s0x3bae177ac6a0f3dd:0x37ac63ba5d7ded7f!8m2!3d12.9844747!4d77.6400202!16s%2Fg%2F11ty24v8cp!19sChIJ3fOgxnoXrjsRf-19XbpjrDc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "pixies-salon-spa",
    "name": "Pixies Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd floor, Sheriif House, 203, Richmond Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 1,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9652632,
    "longitude": 77.6029215,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Pixies+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae1559b587085b:0xf1e4cad2e9e930f5!8m2!3d12.9652632!4d77.6029215!16s%2Fg%2F11yxmnqcr_!19sChIJWwiHtVkVrjsR9TDp6dLK5PE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bangalore-spa-centre",
    "name": "Bangalore spa centre",
    "description": "Highly rated day spa in Madiwala with excellent reviews and professional service.",
    "address": "Opposite Madiwala, sidharta colony",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Madiwala",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 1,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.92465,
    "longitude": 77.6206071,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bangalore+spa+centre/data=!4m7!3m6!1s0x3bae15e5b14f605d:0x149eb57b432f2509!8m2!3d12.92465!4d77.6206071!16s%2Fg%2F11xvqtpqqp!19sChIJXWBPseUVrjsRCSUvQ3u1nhQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-golden-wellness",
    "name": "The Golden Wellness",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "5th A Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 1,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 13.0362372,
    "longitude": 77.5900293,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Golden+Wellness/data=!4m7!3m6!1s0x3bae174a0d02ca49:0x8cc22e600a1412b6!8m2!3d13.0362372!4d77.5900293!16s%2Fg%2F11tn80p6qy!19sChIJScoCDUoXrjsRthIUCmAuwow?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "baby-massage-bangalore",
    "name": "BABY Massage Bangalore",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "24-29, 2nd Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 1,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 13.0244512,
    "longitude": 77.597838,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/BABY+Massage+Bangalore/data=!4m7!3m6!1s0x3bae17c2c63d7c09:0x4a184b0766d8dde9!8m2!3d13.0244512!4d77.597838!16s%2Fg%2F11qg4qyxwj!19sChIJCXw9xsIXrjsR6d3YZgdLGEo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "akshra-unisex-spa-salon",
    "name": "AKSHRA UNISEX SPA & SALON",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd Floor, 258/A, 14th Main Rd, below Bharat Gas",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 1,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9089825,
    "longitude": 77.637926,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/AKSHRA+UNISEX+SPA+%26+SALON/data=!4m7!3m6!1s0x3bae150005866243:0x1bff10be997b3be8!8m2!3d12.9089825!4d77.637926!16s%2Fg%2F11lp7l5qf8!19sChIJQ2KGBQAVrjsR6Dt7mb4Q_xs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "dream-salon-and-spa",
    "name": "Dream Salon And Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "1st Floor, Shanthi Sadhana, N 1830, opposite Shanti Jewellery Shop",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 1,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9189119,
    "longitude": 77.5934966,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Dream+Salon+And+Spa/data=!4m7!3m6!1s0x3bae1508ffd6d5f1:0xd5370f70a23b77d6!8m2!3d12.9189119!4d77.5934966!16s%2Fg%2F11yh2m7rxq!19sChIJ8dXW_wgVrjsR1nc7onAPN9U?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "b2b-unisex-massage-spa",
    "name": "B2B - Unisex Massage Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "1/1",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 1,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9345801,
    "longitude": 77.6132618,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/B2B+-+Unisex+Massage+Spa/data=!4m7!3m6!1s0x3bae150068e9e3d1:0x6d30504988ff9ca4!8m2!3d12.9345801!4d77.6132618!16s%2Fg%2F11lp13sqnm!19sChIJ0ePpaAAVrjsRpJz_iElQMG0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "r-r-heaven-spa",
    "name": "R R heaven spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "No.481,1st floor, near Krishna Temple Road",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 1,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9344444,
    "longitude": 77.6197105,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/R+R+heaven+spa/data=!4m7!3m6!1s0x3bae15348c7d88d7:0x12c466147cad7093!8m2!3d12.9344444!4d77.6197105!16s%2Fg%2F11sv33njly!19sChIJ14h9jDQVrjsRk3CtfBRmxBI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-ayur-kormangala",
    "name": "Spa Ayur - Kormangala",
    "description": "Highly rated day spa in Koramangala with excellent reviews and professional service.",
    "address": "Ground floor, Apartment, Naveen Terraces, 75/15, 100 Feet Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 1,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9381535,
    "longitude": 77.6290147,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spa+Ayur+-+Kormangala/data=!4m7!3m6!1s0x3bae156e2a3639a7:0x2bb9064defd15fa5!8m2!3d12.9381535!4d77.6290147!16s%2Fg%2F11syr01q4y!19sChIJpzk2Km4VrjsRpV_R700GuSs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "koramangala-bangalore",
    "name": "Koramangala, Bangalore",
    "description": "Highly rated day spa in Koramangala with excellent reviews and professional service.",
    "address": "WJMH+8GV, 4th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 1,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9333529,
    "longitude": 77.6288041,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Koramangala,+Bangalore/data=!4m7!3m6!1s0x3bae15007c556937:0x7e636e31b330236a!8m2!3d12.9333529!4d77.6288041!16s%2Fg%2F11xsrwklqk!19sChIJN2lVfAAVrjsRaiMwszFuY34?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "blue-stone-spa",
    "name": "BLUE STONE SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Second floor, V G R Complex, No 2",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 1,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9571418,
    "longitude": 77.7380624,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/BLUE+STONE+SPA/data=!4m7!3m6!1s0x3bae1304e3b2308d:0x1bca372815c54238!8m2!3d12.9571418!4d77.7380624!16s%2Fg%2F11yfg6s54k!19sChIJjTCy4wQTrjsROELFFSg3yhs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "kl-unisex-saloon-and-spa",
    "name": "KL UNISEX SALOON AND SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Bangalore",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 1,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9697572,
    "longitude": 77.766165,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/KL+UNISEX+SALOON+AND+SPA/data=!4m7!3m6!1s0x3bae0dc2c8572043:0xd9f425b8b3fd5fc2!8m2!3d12.9697572!4d77.766165!16s%2Fg%2F11tsxs_n0f!19sChIJQyBXyMINrjsRwl_9s7gl9Nk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "signature-wellness",
    "name": "Signature Wellness",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "456, Immadihalli Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 1,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9667349,
    "longitude": 77.7635246,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Signature+Wellness/data=!4m7!3m6!1s0x3bae0de68a09c285:0x3dc50536711edeb8!8m2!3d12.9667349!4d77.7635246!16s%2Fg%2F11rn3yv_4m!19sChIJhcIJiuYNrjsRuN4ecTYFxT0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "new-bornz-family-saloon-and-spa",
    "name": "NEW BORNZ Family saloon and spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "No 26 RR building Narayanappa layout, Borewell Rd, opp. to Whispering Winds Main Road",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 1,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9691593,
    "longitude": 77.7427492,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/NEW+BORNZ+Family+saloon+and+spa/data=!4m7!3m6!1s0x3bae13fbd0b90b0d:0x57d1a19f64924151!8m2!3d12.9691593!4d77.7427492!16s%2Fg%2F11xms2q__k!19sChIJDQu50PsTrjsRUUGSZJ-h0Vc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "r-s-unisex-salon-and-spa",
    "name": "R S Unisex Salon and Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "1st Floor, No 114, Hagadur Main Rd, near Shiva Temple",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 1,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.964224,
    "longitude": 77.7545538,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/R+S+Unisex+Salon+and+Spa/data=!4m7!3m6!1s0x3bae0dfa9aa0e3ed:0x533f8872256b69d7!8m2!3d12.964224!4d77.7545538!16s%2Fg%2F11xrlchf02!19sChIJ7eOgmvoNrjsR12lrJXKIP1M?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "grand-honey-international-spa",
    "name": "Grand Honey International Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 1,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 13.0035183,
    "longitude": 77.5784298,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Grand+Honey+International+Spa/data=!4m7!3m6!1s0x3bae17f9c787981d:0xe3a1f1e32527aa38!8m2!3d13.0035183!4d77.5784298!16s%2Fg%2F11z0n9d0n0!19sChIJHZiHx_kXrjsROKonJePxoeM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "image-beauty-parlour-spa",
    "name": "Image Beauty Parlour & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "242, 1st St",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 5.0,
    "reviews_count": 1,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 13.0067378,
    "longitude": 77.5710562,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Image+Beauty+Parlour+%26+Spa/data=!4m7!3m6!1s0x3bae162dc8b989ef:0x167395f102cdd601!8m2!3d13.0067378!4d77.5710562!16s%2Fg%2F11jsjjl7mj!19sChIJ74m5yC0WrjsRAdbNAvGVcxY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "new-era-international-spa",
    "name": "New Era International Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 1888,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9230384,
    "longitude": 77.5564865,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/New+Era+International+Spa/data=!4m7!3m6!1s0x3bae3fcc2e2fe759:0xf4a5f9ac59cd7e4e!8m2!3d12.9230384!4d77.5564865!16s%2Fg%2F11tw_lcd3t!19sChIJWecvLsw_rjsRTn7NWaz5pfQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "lakme-salon-in-hebbal-bengaluru",
    "name": "Lakme Salon in Hebbal,Bengaluru",
    "description": "Highly rated beauty spa in Hebbal with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Hebbal",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 1831,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 13.0504264,
    "longitude": 77.5975134,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Lakme+Salon+in+Hebbal,Bengaluru/data=!4m7!3m6!1s0x3bae178b28486191:0x3bf58569ce281d11!8m2!3d13.0504264!4d77.5975134!16s%2Fg%2F11f7sj0719!19sChIJkWFIKIsXrjsRER0ozmmF9Ts?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "envoq-salon-jayanagar",
    "name": "Envoq Salon - Jayanagar",
    "description": "Highly rated beauty spa in Jayanagar with excellent reviews and professional service.",
    "address": "No. 37, 1st floor, 10th Main Rd, near Ashoka Pillar Road",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 1218,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9436264,
    "longitude": 77.5853953,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Envoq+Salon+-+Jayanagar/data=!4m7!3m6!1s0x3bae15a691327a91:0x13b46422abaf1432!8m2!3d12.9436264!4d77.5853953!16s%2Fg%2F11vr6sgvlq!19sChIJkXoykaYVrjsRMhSvqyJktBM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "meghavi-wellness-spa-holiday-inn-bengaluru-racecourse-by-ihg",
    "name": "Meghavi Wellness Spa | Holiday Inn Bengaluru Racecourse by IHG",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 908,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9801467,
    "longitude": 77.5785416,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Meghavi+Wellness+Spa+%7C+Holiday+Inn+Bengaluru+Racecourse+by+IHG/data=!4m7!3m6!1s0x3bae1732f23612b9:0x3f06d72640cf4075!8m2!3d12.9801467!4d77.5785416!16s%2Fg%2F11mw0h1qdw!19sChIJuRI28jIXrjsRdUDPQCbXBj8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "posh-pixie-premium-unisex-salon-in-hsr-layout",
    "name": "Posh & Pixie | Premium Unisex Salon in HSR Layout",
    "description": "Highly rated beauty spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 877,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9123412,
    "longitude": 77.6430999,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Posh+%26+Pixie+%7C+Premium+Unisex+Salon+in+HSR+Layout/data=!4m7!3m6!1s0x3bae15d6a70624db:0xfd6a1870e818fa8!8m2!3d12.9123412!4d77.6430999!16s%2Fg%2F11xctxnblv!19sChIJ2yQGp9YVrjsRqI-BDoeh1g8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ajna-spa-massage-centre-bangalore",
    "name": "Ajna Spa - Massage Centre Bangalore",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 809,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.8924999,
    "longitude": 77.6197458,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ajna+Spa+-+Massage+Centre+Bangalore/data=!4m7!3m6!1s0x3bae15b3442fe887:0x51e68f639767fbc8!8m2!3d12.8924999!4d77.6197458!16s%2Fg%2F11kjlw9cjm!19sChIJh-gvRLMVrjsRyPtnl2OP5lE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "tranquil-international-spa-best-spa-in-koramangala-jacuzzi-therapy",
    "name": "Tranquil International Spa - Best Spa in Koramangala | Jacuzzi Therapy",
    "description": "Highly rated day spa in Koramangala with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 720,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9344613,
    "longitude": 77.6134262,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Tranquil+International+Spa+-+Best+Spa+in+Koramangala+%7C+Jacuzzi+Therapy/data=!4m7!3m6!1s0x3bae155ed9afc793:0xf10ef8f575ec6dc!8m2!3d12.9344613!4d77.6134262!16s%2Fg%2F11v5z907by!19sChIJk8ev2V4VrjsR3MZeV4_vEA8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "amanzi-spa-and-salon",
    "name": "Amanzi Spa and Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "404, 8th B Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 637,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9279384,
    "longitude": 77.5826687,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Amanzi+Spa+and+Salon/data=!4m7!3m6!1s0x3bae15b469b52ead:0x562f3168cf4b3ffc!8m2!3d12.9279384!4d77.5826687!16s%2Fg%2F11h5rlw3n7!19sChIJrS61abQVrjsR_D9Lz2gxL1Y?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "chi-the-spa",
    "name": "CHI The Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 619,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9919271,
    "longitude": 77.5882961,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/CHI+The+Spa/data=!4m7!3m6!1s0x3bae16410e7984db:0xc434caf5bc1df8cb!8m2!3d12.9919271!4d77.5882961!16s%2Fg%2F11j2xmn3c6!19sChIJ24R5DkEWrjsRy_gdvPXKNMQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "toni-guy-hairdressing-sadashivanagar",
    "name": "Toni&Guy Hairdressing, Sadashivanagar",
    "description": "Highly rated day spa in Sadashivanagar with excellent reviews and professional service.",
    "address": "404/7 8th Main, 12th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Sadashivanagar",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 491,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 13.0091139,
    "longitude": 77.5800079,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Toni%26Guy+Hairdressing,+Sadashivanagar/data=!4m7!3m6!1s0x3bae17d6ce1ae90d:0x790015508708177a!8m2!3d13.0091139!4d77.5800079!16s%2Fg%2F11l_52_g52!19sChIJDekaztYXrjsRehcIh1AVAHk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "lexus-international-spa",
    "name": "Lexus International Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd Floor, 79/3, Vanivilas Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 481,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9480936,
    "longitude": 77.569229,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Lexus+International+Spa/data=!4m7!3m6!1s0x3bae15de47a039d1:0x37126e4cd52ce285!8m2!3d12.9480936!4d77.569229!16s%2Fg%2F11xh5h4n8w!19sChIJ0TmgR94VrjsRheIs1UxuEjc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "play-salon-hsr-layout",
    "name": "Play Salon | HSR Layout",
    "description": "Highly rated beauty spa in HSR Layout with excellent reviews and professional service.",
    "address": "1st Floor, 1791, 19th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 455,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9137762,
    "longitude": 77.6449535,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Play+Salon+%7C+HSR+Layout/data=!4m7!3m6!1s0x3bae15160c3a362b:0x6c9b11db77fbd441!8m2!3d12.9137762!4d77.6449535!16s%2Fg%2F11wnyk3p7g!19sChIJKzY6DBYVrjsRQdT7d9sRm2w?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-zen-aura-spa-jayanagar",
    "name": "The Zen Aura Spa Jayanagar",
    "description": "Highly rated day spa in Jayanagar with excellent reviews and professional service.",
    "address": "2nd Floor, Inspira, West Inn, 9th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 392,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.935179,
    "longitude": 77.5842742,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Zen+Aura+Spa+Jayanagar/data=!4m7!3m6!1s0x3bae156978e57d45:0x392df3b1a0a7875!8m2!3d12.935179!4d77.5842742!16s%2Fg%2F11y2886dhr!19sChIJRX3leGkVrjsRdXgKGjvfkgM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "la-crown-dermatology-aesthetic-clinic-celebrity-secrets-best-in-jayanagar-bangalore",
    "name": "LA CROWN\u00ae\ufe0f DERMATOLOGY AESTHETIC CLINIC (Celebrity secrets) (Best in Jayanagar, Bangalore)",
    "description": "Highly rated day spa in Jayanagar with excellent reviews and professional service.",
    "address": "No.37 ,First Floor, Ashoka pillar road, 10th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 386,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9411464,
    "longitude": 77.584977,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/LA+CROWN%C2%AE%EF%B8%8F+DERMATOLOGY+AESTHETIC+CLINIC+%28Celebrity+secrets%29+%28Best+in+Jayanagar,+Bangalore%29/data=!4m7!3m6!1s0x3bae15829e72eefb:0x9c4bc2a6e833af48!8m2!3d12.9411464!4d77.584977!16s%2Fg%2F11tk0jrwql!19sChIJ--5ynoIVrjsRSK8z6KbCS5w?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "foot-relief-indiranagar",
    "name": "Foot Relief - Indiranagar",
    "description": "Highly rated day spa in Indiranagar with excellent reviews and professional service.",
    "address": "2nd Floor, No. 560, 9th A Main Rd, near Metro Station Indira Nagar, behind coffee Day",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 377,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9778247,
    "longitude": 77.6388147,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Foot+Relief+-+Indiranagar/data=!4m7!3m6!1s0x3bae17e5b79a10fd:0x830a2bbd263ee94e!8m2!3d12.9778247!4d77.6388147!16s%2Fg%2F11x85v00_8!19sChIJ_RCat-UXrjsRTuk-Jr0rCoM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "soul-salon",
    "name": "Soul Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 372,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9897157,
    "longitude": 77.5561331,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Soul+Salon/data=!4m7!3m6!1s0x3bae3df291ab2e61:0xfd862aa424320a61!8m2!3d12.9897157!4d77.5561331!16s%2Fg%2F11cn8x7s8n!19sChIJYS6rkfI9rjsRYQoyJKQqhv0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vedaearth-lounge-spa-salon-bannerghatta-vijaya-bank-layout-for-women-only",
    "name": "Vedaearth Lounge Spa & Salon (Bannerghatta - Vijaya Bank Layout) - For Women Only",
    "description": "Highly rated beauty spa in BTM Layout with excellent reviews and professional service.",
    "address": "108, First floor, Sir M Visveswaraya Road, BTM 4th Stage, near SBI",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "BTM Layout",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 358,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.888738,
    "longitude": 77.6105705,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Vedaearth+Lounge+Spa+%26+Salon+%28Bannerghatta+-+Vijaya+Bank+Layout%29+-+For+Women+Only/data=!4m7!3m6!1s0x3bae159743e964bf:0xb71c0c3b746a09aa!8m2!3d12.888738!4d77.6105705!16s%2Fg%2F11sgz19ghy!19sChIJv2TpQ5cVrjsRqglqdDsMHLc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "naturals-signature-unisex-salon-and-spa-koramangala",
    "name": "Naturals Signature Unisex Salon and Spa Koramangala",
    "description": "Highly rated beauty spa in Koramangala with excellent reviews and professional service.",
    "address": "1st Floor, Maharaja Signal, No 985, 80 Feet Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 329,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9346756,
    "longitude": 77.6296652,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Naturals+Signature+Unisex+Salon+and+Spa+Koramangala/data=!4m7!3m6!1s0x3bae159addcd6ab9:0x8198c3455c126435!8m2!3d12.9346756!4d77.6296652!16s%2Fg%2F11y19h4bsz!19sChIJuWrN3ZoVrjsRNWQSXEXDmIE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "octane-luxury-spa",
    "name": "Octane Luxury Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "NO 37 old No.368 100 feet road, 10th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 317,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9410414,
    "longitude": 77.5849613,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Octane+Luxury+Spa/data=!4m7!3m6!1s0x669c98b7b4f593ef:0x982305af7d31cb4f!8m2!3d12.9410414!4d77.5849613!16s%2Fg%2F11xdb8vyn9!19sChIJ75P1tLeYnGYRT8sxfa8FI5g?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "variety-salon-spa-best-unisex-salon-in-nandini-layout-bengaluru",
    "name": "Variety Salon & Spa - Best Unisex Salon in Nandini Layout, Bengaluru",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 284,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 13.0114184,
    "longitude": 77.5396036,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Variety+Salon+%26+Spa+-+Best+Unisex+Salon+in+Nandini+Layout,+Bengaluru/data=!4m7!3m6!1s0x3bae3d75371a4a15:0x4de73d19e2e8f773!8m2!3d13.0114184!4d77.5396036!16s%2Fg%2F11c0xhc48p!19sChIJFUoaN3U9rjsRc_fo4hk9500?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-zen-aura-spa-bannerghatta-road",
    "name": "The Zen Aura Spa Bannerghatta Road",
    "description": "Highly rated day spa in Bannerghatta Road with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bannerghatta Road",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 277,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.8909426,
    "longitude": 77.6060808,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Zen+Aura+Spa+Bannerghatta+Road/data=!4m7!3m6!1s0x3bae15f5fb25e8ad:0xe5ce6e03240dbec2!8m2!3d12.8909426!4d77.6060808!16s%2Fg%2F11x1jbyslc!19sChIJregl-_UVrjsRwr4NJANuzuU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "lilac-wellness-spa-and-pain-relief",
    "name": "Lilac Wellness Spa and Pain Relief",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 271,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.957132,
    "longitude": 77.73894,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Lilac+Wellness+Spa+and+Pain+Relief/data=!4m7!3m6!1s0x3bae13e87a7f1df9:0xe5dde3f4fc961651!8m2!3d12.957132!4d77.73894!16s%2Fg%2F11kb_p7_nw!19sChIJ-R1_eugTrjsRURaW_PTj3eU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "pixie-unisex-salon-spa",
    "name": "Pixie Unisex Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 255,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9247339,
    "longitude": 77.6378944,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Pixie+Unisex+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae15aabcf219ed:0x6609e78a2a03e839!8m2!3d12.9247339!4d77.6378944!16s%2Fg%2F11t7hywvh7!19sChIJ7RnyvKoVrjsROegDKornCWY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "russian-spa-home-massage-service",
    "name": "Russian Spa & Home Massage Service",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 239,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9344197,
    "longitude": 77.6240538,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Russian+Spa+%26+Home+Massage+Service/data=!4m7!3m6!1s0x3bae1511258910f1:0xd6fe8881efe256c2!8m2!3d12.9344197!4d77.6240538!16s%2Fg%2F11lth3n8xh!19sChIJ8RCJJREVrjsRwlbi74GI_tY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "shine-spa-spa-near-electronic-city-phase-1",
    "name": "Shine Spa | Spa Near Electronic City Phase 1",
    "description": "Highly rated day spa in Electronic City with excellent reviews and professional service.",
    "address": "No,19 &, K, 324, Hulimangala Main Rd, near Sai Baba Temple",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Electronic City",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 221,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.8324461,
    "longitude": 77.647588,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Shine+Spa+%7C+Spa+Near+Electronic+City+Phase+1/data=!4m7!3m6!1s0x3bae6bb6a88e791d:0x179c14d9e411c67!8m2!3d12.8324461!4d77.647588!16s%2Fg%2F11w3zkl22v!19sChIJHXmOqLZrrjsRZxxBnk3BeQE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bliss-thai-spa-banglore",
    "name": "Bliss Thai Spa Banglore",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "Ft Floor, SVR Tower, 1, Begur - Koppa Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 220,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.8598375,
    "longitude": 77.6123703,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bliss+Thai+Spa+Banglore/data=!4m7!3m6!1s0x3bae6b73eeb8b1e1:0x984b8c347b536856!8m2!3d12.8598375!4d77.6123703!16s%2Fg%2F11m5nk42c3!19sChIJ4bG47nNrrjsRVmhTezSMS5g?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "eva-international-spa-best-spa-in-koramangala-international-luxury-spa",
    "name": "Eva International Spa - Best Spa In Koramangala | International Luxury Spa",
    "description": "Highly rated day spa in Koramangala with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 215,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9365169,
    "longitude": 77.6165791,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Eva+International+Spa+-+Best+Spa+In+Koramangala+%7C+International+Luxury+Spa/data=!4m7!3m6!1s0x3bae157b0755baf9:0xd3b1d6f32ca02e41!8m2!3d12.9365169!4d77.6165791!16s%2Fg%2F11x08bdyf7!19sChIJ-bpVB3sVrjsRQS6gLPPWsdM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "lipsy-thai-spa",
    "name": "Lipsy Thai Spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "Shop No. 4, behind IndiQube ascent, 8th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 214,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9349864,
    "longitude": 77.6245261,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Lipsy+Thai+Spa/data=!4m7!3m6!1s0x3bae15a493a7f8d7:0x5139067faf826d0d!8m2!3d12.9349864!4d77.6245261!16s%2Fg%2F11vk8l1yfl!19sChIJ1_ink6QVrjsRDW2Cr38GOVE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "eevee-luxury-spa",
    "name": "Eevee Luxury Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd Floor, 765, 100 Feet Rd, above Pecos pub",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 211,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.970786,
    "longitude": 77.6410647,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Eevee+Luxury+Spa/data=!4m7!3m6!1s0x3bae1701e8b041ed:0x7ebf9246b5a1ccbf!8m2!3d12.970786!4d77.6410647!16s%2Fg%2F11md2zdv25!19sChIJ7UGw6AEXrjsRv8yhtUaSv34?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "june-salon-and-spa-unisex-spa-hair-salon-in-indiranagar",
    "name": "June Salon and Spa \u2013 Unisex Spa & Hair Salon in Indiranagar",
    "description": "Highly rated beauty spa in Indiranagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 210,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.981291,
    "longitude": 77.6405837,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/June+Salon+and+Spa+%E2%80%93+Unisex+Spa+%26+Hair+Salon+in+Indiranagar/data=!4m7!3m6!1s0x3bae1700596573e9:0xf35a80822f08b69b!8m2!3d12.981291!4d77.6405837!16s%2Fg%2F11y5sm1zk7!19sChIJ6XNlWQAXrjsRm7YIL4KAWvM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "silver-lounge-unisex-salon-spa",
    "name": "SILVER LOUNGE (Unisex Salon & Spa)",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "1st Floor, 142, 19th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 205,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 13.0004569,
    "longitude": 77.5506347,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/SILVER+LOUNGE+%28Unisex+Salon+%26+Spa%29/data=!4m7!3m6!1s0x3bae3dd08cec018d:0x18868d73066cbebe!8m2!3d13.0004569!4d77.5506347!16s%2Fg%2F11s82vn75_!19sChIJjQHsjNA9rjsRvr5sBnONhhg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "premium-b2b-massage-and-happy-ending-spa-bangalore",
    "name": "Premium b2b Massage and happy ending Spa Bangalore",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 201,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9136798,
    "longitude": 77.6372965,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Premium+b2b+Massage+and+happy+ending+Spa+Bangalore/data=!4m7!3m6!1s0x3bae156b004b0ab3:0x5881f181ac80b188!8m2!3d12.9136798!4d77.6372965!16s%2Fg%2F11sjfw33c5!19sChIJswpLAGsVrjsRiLGArIHxgVg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "toni-guy-essensuals-hairdressing-malleshwaram",
    "name": "Toni&Guy Essensuals Hairdressing, Malleshwaram",
    "description": "Highly rated day spa in Malleshwaram with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Malleshwaram",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 200,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 13.0017281,
    "longitude": 77.5712478,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Toni%26Guy+Essensuals+Hairdressing,+Malleshwaram/data=!4m7!3m6!1s0x3bae172a6acb8969:0x7bb90fc1ab96ec91!8m2!3d13.0017281!4d77.5712478!16s%2Fg%2F11xkwmz_rk!19sChIJaYnLaioXrjsRkeyWq8EPuXs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "shathayu-ayurveda-clinic-sadashiva-nagar",
    "name": "Shathayu Ayurveda Clinic Sadashiva Nagar",
    "description": "Highly rated ayurvedic spa in Sadashivanagar with excellent reviews and professional service.",
    "address": "1st Floor, No.13, 2nd Main Rd, above Namdhari Fresh",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Sadashivanagar",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 196,
    "spa_type": "Ayurvedic Spa",
    "services": [
      "Abhyanga",
      "Shirodhara",
      "Panchakarma",
      "Pizhichil",
      "Kerala Massage",
      "Ayurvedic Facial"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 13.0034224,
    "longitude": 77.5782132,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Shathayu+Ayurveda+Clinic+Sadashiva+Nagar/data=!4m7!3m6!1s0x3bae17271a3c6ccf:0xecbefdc96143815a!8m2!3d13.0034224!4d77.5782132!16s%2Fg%2F11vcr9gh0t!19sChIJz2w8GicXrjsRWoFDYcn9vuw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "silver-stream-spa",
    "name": "Silver Stream Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "1st Floor, No #10, 1st, Anjaneya Temple St",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 195,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 13.0475099,
    "longitude": 77.6011714,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Silver+Stream+Spa/data=!4m7!3m6!1s0x3bae17a87d683a5d:0x47baa55b0b4698fb!8m2!3d13.0475099!4d77.6011714!16s%2Fg%2F11w95qfd75!19sChIJXTpofagXrjsR-5hGC1ulukc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "elate-unisex-salon-hsr-layout",
    "name": "Elate Unisex Salon - HSR Layout",
    "description": "Highly rated beauty spa in HSR Layout with excellent reviews and professional service.",
    "address": "24th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 191,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9075413,
    "longitude": 77.6488844,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Elate+Unisex+Salon+-+HSR+Layout/data=!4m7!3m6!1s0x3bae155fe09de80d:0xfd77eabe0ee98b06!8m2!3d12.9075413!4d77.6488844!16s%2Fg%2F11pgj3gkcc!19sChIJDeid4F8VrjsRBovpDr7qd_0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "foot-relief-sadashiva-nagar",
    "name": "FOOT RELIEF - Sadashiva Nagar",
    "description": "Highly rated day spa in Sadashivanagar with excellent reviews and professional service.",
    "address": "2nd floor jaya enclave, 1st main road, lower orchards",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Sadashivanagar",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 182,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 13.0052285,
    "longitude": 77.5796983,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/FOOT+RELIEF+-+Sadashiva+Nagar/data=!4m7!3m6!1s0x3bae170b7e536209:0x98d484df433505f5!8m2!3d13.0052285!4d77.5796983!16s%2Fg%2F11yhb4zj0d!19sChIJCWJTfgsXrjsR9QU1Q9-E1Jg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "unconditional-the-pet-store-and-spa-clinic",
    "name": "Unconditional the pet store and spa + Clinic",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "3J25+6WV, St Anthony Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 167,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 13.0505806,
    "longitude": 77.6099567,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Unconditional+the+pet+store+and+spa+%2B+Clinic/data=!4m7!3m6!1s0x3bae17bfe07017a9:0xbac461246b9ebc4c!8m2!3d13.0505806!4d77.6099567!16s%2Fg%2F11srv7rx2p!19sChIJqRdw4L8XrjsRTLyeayRhxLo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sculpt-glam-studio",
    "name": "Sculpt Glam Studio",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd Floor, 765, 100 Feet Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 165,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9707972,
    "longitude": 77.641077,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sculpt+Glam+Studio/data=!4m7!3m6!1s0x3bae17c5ee579aef:0x768e562041ff5797!8m2!3d12.9707972!4d77.641077!16s%2Fg%2F11s86p8f_j!19sChIJ75pX7sUXrjsRl1f_QSBWjnY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "rung-luxury-spa-best-spa-in-hsr",
    "name": "Rung Luxury Spa - Best Spa In Hsr",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "Padma Sri Arcade, 69/3, 19th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 161,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9129639,
    "longitude": 77.6448138,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Rung+Luxury+Spa+-+Best+Spa+In+Hsr/data=!4m7!3m6!1s0x3bae15000ef21f43:0xd7ec35431ec37940!8m2!3d12.9129639!4d77.6448138!16s%2Fg%2F11wx5k30fx!19sChIJQx_yDgAVrjsRQHnDHkM17Nc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "paradise-thai-spa-international-massage-spa-in-whitefield-bangalore",
    "name": "Paradise Thai Spa - International Massage Spa in Whitefield Bangalore",
    "description": "Highly rated thai spa in Whitefield with excellent reviews and professional service.",
    "address": "2nd floor, Sumeru Arcade, 2, Whitefield Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 154,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9657951,
    "longitude": 77.7491866,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Paradise+Thai+Spa+-+International+Massage+Spa+in+Whitefield+Bangalore/data=!4m7!3m6!1s0x3bae0d9472e5266f:0xb13e145e84947aaf!8m2!3d12.9657951!4d77.7491866!16s%2Fg%2F11x33krvzg!19sChIJbyblcpQNrjsRr3qUhF4UPrE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "day-night-outcall-massage-spa",
    "name": "Day Night Outcall massage spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "4th Floor, 427, 10th G Main Rd, above Just Bake",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 138,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9370627,
    "longitude": 77.6148127,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Day+Night+Outcall+massage+spa/data=!4m7!3m6!1s0x3bae3d9706f0abfd:0x2d67865a46e9971b!8m2!3d12.9370627!4d77.6148127!16s%2Fg%2F11t29gdw4b!19sChIJ_avwBpc9rjsRG5fpRlqGZy0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "amaira-international-unisex-spa-best-spa-in-malleshwaram-spa-near-malleshwaram",
    "name": "Amaira International Unisex Spa | Best Spa in Malleshwaram | Spa Near Malleshwaram",
    "description": "Highly rated day spa in Malleshwaram with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Malleshwaram",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 137,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9962133,
    "longitude": 77.5716443,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Amaira+International+Unisex+Spa+%7C+Best+Spa+in+Malleshwaram+%7C+Spa+Near+Malleshwaram/data=!4m7!3m6!1s0x3bae17d6eaa702c7:0xc559fe8e60e38435!8m2!3d12.9962133!4d77.5716443!16s%2Fg%2F11yq2ld7py!19sChIJxwKn6tYXrjsRNYTjYI7-WcU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "neha-day-night-outcall-spa",
    "name": "Neha Day Night Outcall Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 134,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9673169,
    "longitude": 77.643309,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Neha+Day+Night+Outcall+Spa/data=!4m7!3m6!1s0x3bae152a5fcb6175:0x3aa6971f79d66ee7!8m2!3d12.9673169!4d77.643309!16s%2Fg%2F11w4ymc4_w!19sChIJdWHLXyoVrjsR527WeR-Xpjo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ce16-salons",
    "name": "CE16 Salons",
    "description": "Highly rated beauty spa in Malleshwaram with excellent reviews and professional service.",
    "address": "11, Sri Sai Krupa, Door No 2G, Sampige Main Road, 14th Cross Road, behind CCD Malleshwaram Sampige Main Road, 14th Cross Rd, behind CCD",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Malleshwaram",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 133,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 13.0045872,
    "longitude": 77.5709723,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/CE16+Salons/data=!4m7!3m6!1s0x3bae1713704daa1b:0x29ea45b7bb756722!8m2!3d13.0045872!4d77.5709723!16s%2Fg%2F11k4k4q7jz!19sChIJG6pNcBMXrjsRImd1u7dF6ik?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "delta-spa-in-koramangala-jacuzzi-spa-massage-spa-koramangala-best-spa",
    "name": "Delta Spa in Koramangala - Jacuzzi Spa - Massage Spa Koramangala - Best Spa",
    "description": "Highly rated day spa in Koramangala with excellent reviews and professional service.",
    "address": "5th Block 60, 126, Feet Road",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 129,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9338464,
    "longitude": 77.6193754,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Delta+Spa+in+Koramangala+-+Jacuzzi+Spa+-+Massage+Spa+Koramangala+-+Best+Spa/data=!4m7!3m6!1s0x3bae15abab588197:0xf7c9bcc51fe7cb42!8m2!3d12.9338464!4d77.6193754!16s%2Fg%2F11x5w1grvp!19sChIJl4FYq6sVrjsRQsvnH8W8yfc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "red-stone-spa-best-home-massage-service-in-bengaluru",
    "name": "Red Stone Spa-Best Home Massage Service in Bengaluru",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 128,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9223231,
    "longitude": 77.6338299,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Red+Stone+Spa-Best+Home+Massage+Service+in+Bengaluru/data=!4m7!3m6!1s0x3bae1526bc5f35d9:0xb0b557ffe586a4c9!8m2!3d12.9223231!4d77.6338299!16s%2Fg%2F11x0hn_yng!19sChIJ2TVfvCYVrjsRyaSG5f9XtbA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "adhira-wellness-spa-best-spa-in-choodasandra-luxury-spa",
    "name": "Adhira Wellness Spa | Best Spa in Choodasandra | Luxury Spa",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 127,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.8893125,
    "longitude": 77.6733533,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Adhira+Wellness+Spa+%7C+Best+Spa+in+Choodasandra+%7C+Luxury+Spa/data=!4m7!3m6!1s0x3bae13b82cd91129:0xeb2867e3a4cc0e13!8m2!3d12.8893125!4d77.6733533!16s%2Fg%2F11ycc2v8w0!19sChIJKRHZLLgTrjsREw7MpONnKOs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "simran-spa-home-massage-service",
    "name": "Simran Spa Home Massage Service",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "97A",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 125,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.931647,
    "longitude": 77.6356773,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Simran+Spa+Home+Massage+Service/data=!4m7!3m6!1s0x3bae1509e07769db:0xda64882d09307055!8m2!3d12.931647!4d77.6356773!16s%2Fg%2F11xd20818s!19sChIJ22l34AkVrjsRVXAwCS2IZNo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "body-raaga-wellness-spa-koramangala",
    "name": "Body Raaga Wellness Spa Koramangala",
    "description": "Highly rated wellness spa in Koramangala with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 124,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9331099,
    "longitude": 77.6276996,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Body+Raaga+Wellness+Spa+Koramangala/data=!4m7!3m6!1s0x3bae15c4756e3359:0x99486596da53556d!8m2!3d12.9331099!4d77.6276996!16s%2Fg%2F11wbn_l7wm!19sChIJWTNudcQVrjsRbVVT2pZlSJk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ruchi-vip-spa",
    "name": "Ruchi VIP Spa",
    "description": "Highly rated day spa in Indiranagar with excellent reviews and professional service.",
    "address": "Metro Station Indira Nagar, Metro station, SN59",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 121,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9783751,
    "longitude": 77.6386247,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ruchi+VIP+Spa/data=!4m7!3m6!1s0x3bae177eee075e69:0xa597a33eae3575e!8m2!3d12.9783751!4d77.6386247!16s%2Fg%2F11xrhx9xbt!19sChIJaV4H7n4XrjsRXlfj6jN6WQo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-byke-international-jacuzzi-massage-spa-in-koramangala",
    "name": "Spa Byke International Jacuzzi - Massage Spa in Koramangala",
    "description": "Highly rated day spa in Koramangala with excellent reviews and professional service.",
    "address": "125, 1st Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 118,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9345182,
    "longitude": 77.6164041,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spa+Byke+International+Jacuzzi+-+Massage+Spa+in+Koramangala/data=!4m7!3m6!1s0x3bae158edc9b0785:0xbdcd20fd718a1df8!8m2!3d12.9345182!4d77.6164041!16s%2Fg%2F11mchzxz1b!19sChIJhQeb3I4VrjsR-B2Kcf0gzb0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-mallika-international-spa",
    "name": "The Mallika International SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "3-300, 60 Feet Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 111,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9350834,
    "longitude": 77.6228809,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Mallika+International+SPA/data=!4m7!3m6!1s0x873935d070d69d1b:0xfe1eb8a04659879e!8m2!3d12.9350834!4d77.6228809!16s%2Fg%2F11ypmv6t3s!19sChIJG53WcNA1OYcRnodZRqC4Hv4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "pinkfox-bespoke-salon",
    "name": "Pinkfox Bespoke Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "1st floor, above fenesta signature studio, Citadel Plaza, Bearing No. 3293/A, 12th Main, Paramahansa Yogananda Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 103,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9696954,
    "longitude": 77.636139,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Pinkfox+Bespoke+Salon/data=!4m7!3m6!1s0x3bae173a7dbe7575:0x1cf22ca9b8ee5a7f!8m2!3d12.9696954!4d77.636139!16s%2Fg%2F11ylbtfqdp!19sChIJdXW-fToXrjsRf1ruuKks8hw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "aventra-international-spa-in-jayanagar-bengaluru-spa-near-me-jacuzzi",
    "name": "Aventra International Spa in Jayanagar, Bengaluru | Spa Near Me | Jacuzzi",
    "description": "Highly rated day spa in Jayanagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 100,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9168744,
    "longitude": 77.5976163,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Aventra+International+Spa+in+Jayanagar,+Bengaluru+%7C+Spa+Near+Me+%7C+Jacuzzi/data=!4m7!3m6!1s0x3bae15ef8b138d5f:0x609a4ef0fffb7ebd!8m2!3d12.9168744!4d77.5976163!16s%2Fg%2F11ygs8fphv!19sChIJX40Ti-8VrjsRvX77__BOmmA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "phoenix-international-spa",
    "name": "Phoenix International Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 95,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9591589,
    "longitude": 77.74649,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Phoenix+International+Spa/data=!4m7!3m6!1s0x3bae0da0ab7d5aeb:0x5ba39e484eb3bff9!8m2!3d12.9591589!4d77.74649!16s%2Fg%2F11xv_3l2rx!19sChIJ61p9q6ANrjsR-b-zTkieo1s?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "green-unisex-salon-and-spa-best-spa-in-koramangala",
    "name": "Green Unisex Salon and Spa - Best Spa in Koramangala",
    "description": "Highly rated beauty spa in Koramangala with excellent reviews and professional service.",
    "address": "1st Floor, 897/D, 80 Feet Rd, opp. to pizza hut",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 94,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.940234,
    "longitude": 77.6253003,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Green+Unisex+Salon+and+Spa+-+Best+Spa+in+Koramangala/data=!4m7!3m6!1s0x3bae15e872d4c797:0xe70b44c60d668222!8m2!3d12.940234!4d77.6253003!16s%2Fg%2F11xf1nj1v2!19sChIJl8fUcugVrjsRIoJmDcZEC-c?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "prestige-luxury-spa",
    "name": "Prestige Luxury Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "No.1, 3rd floor, ASN Signature Building Site no. 212, Beside Laughing waters, Ramagondanahalli",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 92,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9571405,
    "longitude": 77.7354624,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Prestige+Luxury+Spa/data=!4m7!3m6!1s0x3bae13a826d3693b:0x9fdffd1a1d4d694a!8m2!3d12.9571405!4d77.7354624!16s%2Fg%2F11yqqlgb51!19sChIJO2nTJqgTrjsRSmlNHRr9358?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "rosirelax-salon-and-spa",
    "name": "Rosirelax salon and spa",
    "description": "Highly rated beauty spa in Madiwala with excellent reviews and professional service.",
    "address": "kaveri multisepcialy hospital madiwala Sidharth colony 4th Cross Road Bangalore 570068 kaveri multisepcialy hospital madiwala Sidharth colony 4th Cross Road Bangalore 570068",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Madiwala",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 88,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9236144,
    "longitude": 77.6191933,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Rosirelax+salon+and+spa/data=!4m7!3m6!1s0x6b98a55d8497028f:0xf392ea507d128c99!8m2!3d12.9236144!4d77.6191933!16s%2Fg%2F11wb_55479!19sChIJjwKXhF2lmGsRmYwSfVDqkvM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "turquoise-salon-and-spa",
    "name": "Turquoise salon and Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Sy No, Nirantara Resort, SY No. 221/1 & 222, and, 320 & 253, Hulimangala Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 88,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.8258697,
    "longitude": 77.6481268,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Turquoise+salon+and+Spa/data=!4m7!3m6!1s0x3bae6b7034bf5839:0x57e2b553bbd78784!8m2!3d12.8258697!4d77.6481268!16s%2Fg%2F11y5mfth0f!19sChIJOVi_NHBrrjsRhIfXu1O14lc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "stargirl-salon-and-beauty-academy",
    "name": "Stargirl Salon And Beauty Academy",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Bangalore",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 88,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 13.0514884,
    "longitude": 77.597599,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Stargirl+Salon+And+Beauty+Academy/data=!4m7!3m6!1s0x3bae1718c8d90ca5:0x1af5efd4b97cdd52!8m2!3d13.0514884!4d77.597599!16s%2Fg%2F11x0q5hr8l!19sChIJpQzZyBgXrjsRUt18udTv9Ro?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "hairconnect-unisex-salon-hsr-layout",
    "name": "HairConnect Unisex Salon HSR Layout",
    "description": "Highly rated beauty spa in HSR Layout with excellent reviews and professional service.",
    "address": "764/ A, 2nd Floor, 22nd Cross, Parangipalya Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 88,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9090252,
    "longitude": 77.6447237,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/HairConnect+Unisex+Salon+HSR+Layout/data=!4m7!3m6!1s0x3bae15f5260ff7e3:0x9400e58406f7ff12!8m2!3d12.9090252!4d77.6447237!16s%2Fg%2F11vzxn30dq!19sChIJ4_cPJvUVrjsREv_3BoTlAJQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "s-r-swagath-unisex-spa",
    "name": "S R Swagath Unisex Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "No.528, 2 nd floor, 1 st cross, Sampige Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 87,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9941153,
    "longitude": 77.571598,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/S+R+Swagath+Unisex+Spa/data=!4m7!3m6!1s0x3bae1786f42fd655:0xbb36aa465e4bdbf0!8m2!3d12.9941153!4d77.571598!16s%2Fg%2F11xkl92gm8!19sChIJVdYv9IYXrjsR8NtLXkaqNrs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "indriya-wellness-spa-koramangala-bangalore",
    "name": "Indriya Wellness Spa - Koramangala (Bangalore)",
    "description": "Highly rated wellness spa in Koramangala with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 80,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9338197,
    "longitude": 77.6105014,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Indriya+Wellness+Spa+-+Koramangala+%28Bangalore%29/data=!4m7!3m6!1s0x3bae15bfd9f6595f:0x3dff7f91a037a11b!8m2!3d12.9338197!4d77.6105014!16s%2Fg%2F11wnn0jk5s!19sChIJX1n22b8VrjsRG6E3oJF__z0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "tattvaa-wellness-spa",
    "name": "Tattvaa Wellness Spa",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "4th Floor, S. S. Arcade, DLF Main Rd, opp. D mart, above KFC",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 78,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.8769329,
    "longitude": 77.6105831,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Tattvaa+Wellness+Spa/data=!4m7!3m6!1s0x3bae6b71b6753fa7:0x2e1ed0852581e1b6!8m2!3d12.8769329!4d77.6105831!16s%2Fg%2F11y5rfsb8s!19sChIJpz91tnFrrjsRtuGBJYXQHi4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "jade-salon",
    "name": "Jade Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "16, 7th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 77,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9982528,
    "longitude": 77.571727,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Jade+Salon/data=!4m7!3m6!1s0x3bae17004a42fe15:0x87a2342b9c4ded2!8m2!3d12.9982528!4d77.571727!16s%2Fg%2F11y83kx4tt!19sChIJFf5CSgAXrjsR0t7EuUIjegg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "grace-glamour-unisex-beauty-salon",
    "name": "Grace & Glamour Unisex Beauty Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Akash Avenue,1st Main Road,S.B.M colony,Anandnagar,Habbal post Akash Avenue,1st Main Road post",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 72,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 13.0299013,
    "longitude": 77.5895296,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Grace+%26+Glamour+Unisex+Beauty+Salon/data=!4m7!3m6!1s0x3bae176f2d541823:0xf3bb8d591befdc6a!8m2!3d13.0299013!4d77.5895296!16s%2Fg%2F11xnt6s6n0!19sChIJIxhULW8XrjsRatzvG1mNu_M?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "pure-thai-spa-thai-spa-in-sahakara-nagar",
    "name": "Pure Thai Spa - Thai Spa in Sahakara Nagar",
    "description": "Highly rated thai spa in Sahakara Nagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Sahakara Nagar",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 71,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 13.0638219,
    "longitude": 77.5876446,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Pure+Thai+Spa+-+Thai+Spa+in+Sahakara+Nagar/data=!4m7!3m6!1s0x3bae19f24b2e05f3:0x3b291be2ce30a240!8m2!3d13.0638219!4d77.5876446!16s%2Fg%2F11v_4sccyh!19sChIJ8wUuS_IZrjsRQKIwzuIbKTs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "hairloom-spa",
    "name": "HAIRLOOM SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "SAP Rd, near SAP LABS",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 57,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9816387,
    "longitude": 77.7172939,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/HAIRLOOM+SPA/data=!4m7!3m6!1s0x3bae117f6906b2d5:0xff34cc5b0388d724!8m2!3d12.9816387!4d77.7172939!16s%2Fg%2F11l5n9_1n5!19sChIJ1bIGaX8RrjsRJNeIA1vMNP8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bharath-car-spa",
    "name": "Bharath car spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Chord Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 56,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.995317,
    "longitude": 77.550778,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bharath+car+spa/data=!4m7!3m6!1s0x3bae3d49a0022dc7:0x94d849c243a9644f!8m2!3d12.995317!4d77.550778!16s%2Fg%2F11lnrz6syw!19sChIJxy0CoEk9rjsRT2SpQ8JJ2JQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vaanya-spa-door-step-home-massage",
    "name": "Vaanya Spa Door Step Home Massage",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "RK Plaza, SN90, 30, Chinmaya Mission Hospital Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 55,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9785173,
    "longitude": 77.6346937,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Vaanya+Spa+Door+Step+Home+Massage/data=!4m7!3m6!1s0x3bae172bb3f916eb:0x9cb0bca463cad69!8m2!3d12.9785173!4d77.6346937!16s%2Fg%2F11xp496npl!19sChIJ6xb5sysXrjsRaa08RsoLywk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "divine-beauty-studio",
    "name": "Divine Beauty Studio",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "No 81 Preksha ground floor 1st main road temple street, Bet 10th and 11th cross, Food camp lane, next to SuchiRuchi",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 54,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 13.0015312,
    "longitude": 77.572359,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Divine+Beauty+Studio/data=!4m7!3m6!1s0x3bae17004dc655ef:0xd6904b9f45213d6!8m2!3d13.0015312!4d77.572359!16s%2Fg%2F11wr3yp3xk!19sChIJ71XGTQAXrjsR1hNS9LkEaQ0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "varna-salon-spa-spa-near-konappana-agrahara",
    "name": "Varna Salon & Spa | Spa Near Konappana Agrahara",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "807, 1st Cross, Govinda Shetty Palya Rd, beside Akshara Spoken English",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 51,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.8550792,
    "longitude": 77.6655676,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Varna+Salon+%26+Spa+%7C+Spa+Near+Konappana+Agrahara/data=!4m7!3m6!1s0x3bae6d001c6dfdd7:0xf77c1be10e279b1c!8m2!3d12.8550792!4d77.6655676!16s%2Fg%2F11wncyd_0l!19sChIJ1_1tHABtrjsRHJsnDuEbfPc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "divine-spa-wellness",
    "name": "Divine spa & wellness",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd Floor, HDFC Bank, Paramahansa Yogananda Rd, opposite MRP, above Mad Fitness",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 42,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9779515,
    "longitude": 77.6365378,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Divine+spa+%26+wellness/data=!4m7!3m6!1s0x3bae17864d01e4bf:0x17032b89ffa7a7a6!8m2!3d12.9779515!4d77.6365378!16s%2Fg%2F11l6t2zhvd!19sChIJv-QBTYYXrjsRpqen_4krAxc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "apsara-beauty-wellness-rajajinagar-bangalore",
    "name": "APSARA Beauty & Wellness Rajajinagar Bangalore",
    "description": "Highly rated beauty spa in Rajajinagar with excellent reviews and professional service.",
    "address": "Bashyam circle, 309 /43, 1st floor 20th main, 59th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Rajajinagar",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 37,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9842983,
    "longitude": 77.5545133,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/APSARA+Beauty+%26+Wellness+Rajajinagar+Bangalore/data=!4m7!3m6!1s0x3bae3dc67338d24f:0x980be30b671f32cc!8m2!3d12.9842983!4d77.5545133!16s%2Fg%2F11mcxfmvwg!19sChIJT9I4c8Y9rjsRzDIfZwvjC5g?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "mj-unisex-salon",
    "name": "MJ Unisex Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd floor, Shree maruthi complex, 389, post, above nilgiris",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 35,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 13.0236357,
    "longitude": 77.5920614,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/MJ+Unisex+Salon/data=!4m7!3m6!1s0x3bae17805f26ece7:0x2e12b5c3a57d34c5!8m2!3d13.0236357!4d77.5920614!16s%2Fg%2F11sswy51kg!19sChIJ5-wmX4AXrjsRxTR9pcO1Ei4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "zenova-unisex-salon-and-spa",
    "name": "Zenova Unisex Salon and Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 20,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9159893,
    "longitude": 77.6512316,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Zenova+Unisex+Salon+and+Spa/data=!4m7!3m6!1s0x3bae15044a922b97:0xcfbc8d0b97a4e7e6!8m2!3d12.9159893!4d77.6512316!16s%2Fg%2F11yf2zftg8!19sChIJlyuSSgQVrjsR5ueklwuNvM8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "kaya-kalp-the-spa",
    "name": "Kaya Kalp The Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 15,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9942569,
    "longitude": 77.5857885,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Kaya+Kalp+The+Spa/data=!4m7!3m6!1s0x3bae1640bc710143:0x5b24ee2a6db5bd6b!8m2!3d12.9942569!4d77.5857885!16s%2Fg%2F11c70cptc8!19sChIJQwFxvEAWrjsRa721bSruJFs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-in-new-bel-road-bangalore",
    "name": "Spa in New Bel Road, Bangalore",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "R.K. Plaza, No.5/A, 80 Feet Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 14,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 13.0275147,
    "longitude": 77.5773874,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spa+in+New+Bel+Road,+Bangalore/data=!4m7!3m6!1s0x3bae170034cd3631:0x22f637d852fc09fb!8m2!3d13.0275147!4d77.5773874!16s%2Fg%2F11x2w5hqbk!19sChIJMTbNNAAXrjsR-wn8Utg39iI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sunrise-spa",
    "name": "Sunrise Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd Floor, S V Arcade, above Akshara Hospital, next to Karnataka Bank",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 11,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.8991071,
    "longitude": 77.6054554,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sunrise+Spa/data=!4m7!3m6!1s0x6b7f31ffbc29df6b:0x5b9a5a4751f3addb!8m2!3d12.8991071!4d77.6054554!16s%2Fg%2F11t8516jhg!19sChIJa98pvP8xf2sR263zUUdamls?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "isha-thai-spa",
    "name": "Isha Thai Spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "19, Hosur Rd, near Grand krishna hotel",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.9,
    "reviews_count": 9,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9233117,
    "longitude": 77.6187957,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Isha+Thai+Spa/data=!4m7!3m6!1s0x3bae15780e4af1dd:0xe03b554babfcb830!8m2!3d12.9233117!4d77.6187957!16s%2Fg%2F11mt096pp3!19sChIJ3fFKDngVrjsRMLj8q0tVO-A?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "zazzle-salon-indira-nagar-bangalore",
    "name": "Zazzle Salon - Indira Nagar, Bangalore",
    "description": "Highly rated beauty spa in Indiranagar with excellent reviews and professional service.",
    "address": "1082, 12th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 2834,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9701875,
    "longitude": 77.6386054,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Zazzle+Salon+-+Indira+Nagar,+Bangalore/data=!4m7!3m6!1s0x3bae1775de506f89:0xc05f37332917bd08!8m2!3d12.9701875!4d77.6386054!16s%2Fg%2F11tdrskhs2!19sChIJiW9Q3nUXrjsRCL0XKTM3X8A?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "marie-claire-paris",
    "name": "Marie Claire Paris",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 2377,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9700746,
    "longitude": 77.6407868,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Marie+Claire+Paris/data=!4m7!3m6!1s0x3bae3d8b8c8ac195:0xbf74ad9be630471a!8m2!3d12.9700746!4d77.6407868!16s%2Fg%2F11n5r6srlx!19sChIJlcGKjIs9rjsRGkcw5putdL8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "aha-unisex-salon-spa",
    "name": "Aha Unisex Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 1707,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9183567,
    "longitude": 77.6518191,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Aha+Unisex+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae14823b53ce5f:0x7915872cd98edc2b!8m2!3d12.9183567!4d77.6518191!16s%2Fg%2F12hlwwx1n!19sChIJX85TO4IUrjsRK9yO2SyHFXk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "kimera-wellness-salon-spa-hsr-layout",
    "name": "Kimera Wellness Salon & Spa - HSR Layout",
    "description": "Highly rated beauty spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 1667,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.911741,
    "longitude": 77.6433681,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Kimera+Wellness+Salon+%26+Spa+-+HSR+Layout/data=!4m7!3m6!1s0x3bae149abf0436b3:0x4372dcbdf4cb8277!8m2!3d12.911741!4d77.6433681!16s%2Fg%2F11cmx39xs6!19sChIJszYEv5oUrjsRd4LL9L3cckM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vurve-salon-jaya-nagar",
    "name": "Vurve Salon | Jaya Nagar",
    "description": "Highly rated beauty spa in Jayanagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 1568,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9248426,
    "longitude": 77.5840119,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Vurve+Salon+%7C+Jaya+Nagar/data=!4m7!3m6!1s0x3bae15bb85e0332d:0x3f4bd91ebc5af3c2!8m2!3d12.9248426!4d77.5840119!16s%2Fg%2F11k45637ls!19sChIJLTPghbsVrjsRwvNavB7ZSz8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "green-trends-unisex-hair-style-salon-rajajinagar",
    "name": "Green Trends Unisex Hair & Style Salon, Rajajinagar",
    "description": "Highly rated beauty spa in Rajajinagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Rajajinagar",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 1490,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 13.0042574,
    "longitude": 77.5534178,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Green+Trends+Unisex+Hair+%26+Style+Salon,+Rajajinagar/data=!4m7!3m6!1s0x3bae3d763e648737:0x7f85c434ffe7a24f!8m2!3d13.0042574!4d77.5534178!16s%2Fg%2F11khz1rc5v!19sChIJN4dkPnY9rjsRT6Ln_zTEhX8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "style-lounge-unisex-salon-in-nagawara-bangalore",
    "name": "Style Lounge Unisex Salon in Nagawara, Bangalore",
    "description": "Highly rated beauty spa in Nagawara with excellent reviews and professional service.",
    "address": "81/2, Deeksha Archade, 1st Floor, 2nd Cross Rd, near Domino's pizza",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Nagawara",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 1442,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 13.0401578,
    "longitude": 77.6203334,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Style+Lounge+Unisex+Salon+in+Nagawara,+Bangalore/data=!4m7!3m6!1s0x3bae1718d25c7e25:0x44dc7a7a51f4d6d8!8m2!3d13.0401578!4d77.6203334!16s%2Fg%2F11pv2fhgmp!19sChIJJX5c0hgXrjsR2Nb0UXp63EQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "desio-unisex-salon-hsr",
    "name": "Desio Unisex Salon HSR",
    "description": "Highly rated beauty spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 1314,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9076096,
    "longitude": 77.6441237,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Desio+Unisex+Salon+HSR/data=!4m7!3m6!1s0x3bae159265a59389:0xac938c591e95bdbc!8m2!3d12.9076096!4d77.6441237!16s%2Fg%2F11h0wcj81z!19sChIJiZOlZZIVrjsRvL2VHlmMk6w?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nira-thai-spa-international-spa-gold-class",
    "name": "Nira Thai Spa International Spa Gold Class",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 1303,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9060714,
    "longitude": 77.5855327,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nira+Thai+Spa+International+Spa+Gold+Class/data=!4m7!3m6!1s0x3bae1596d4458d7b:0xfedaf7788e4a6b58!8m2!3d12.9060714!4d77.5855327!16s%2Fg%2F11t1n9s4yl!19sChIJe41F1JYVrjsRWGtKjnj32v4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vurve-salon-sadashiva-nagar",
    "name": "Vurve Salon | Sadashiva Nagar",
    "description": "Highly rated beauty spa in Sadashivanagar with excellent reviews and professional service.",
    "address": "Ground Floor, 40/B, 8th Main 4th Cross Road, RMV Extension",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Sadashivanagar",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 1226,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 13.0093199,
    "longitude": 77.5800156,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Vurve+Salon+%7C+Sadashiva+Nagar/data=!4m7!3m6!1s0x3bae17b7e59412f9:0x8799435e060f09d8!8m2!3d13.0093199!4d77.5800156!16s%2Fg%2F11sdb77vql!19sChIJ-RKU5bcXrjsR2AkPBl5DmYc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "toni-guy-hairdressing-mantrisquare-mall-malleswaram",
    "name": "Toni&Guy Hairdressing, MantriSquare Mall(Malleswaram)",
    "description": "Highly rated day spa in Malleshwaram with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Malleshwaram",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 1173,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9922323,
    "longitude": 77.5705931,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Toni%26Guy+Hairdressing,+MantriSquare+Mall%28Malleswaram%29/data=!4m7!3m6!1s0x3bae178b8a494657:0x137cb982367203aa!8m2!3d12.9922323!4d77.5705931!16s%2Fg%2F11t7r8bbb5!19sChIJV0ZJiosXrjsRqgNyNoK5fBM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-capital-international-spa-royal-jacuzzi-turkish-hammam-luxury-spa",
    "name": "The Capital International Spa -Royal Jacuzzi | Turkish Hammam | Luxury spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "beside Imperio Restaurant",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 1066,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.962422,
    "longitude": 77.71677,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Capital+International+Spa+-Royal+Jacuzzi+%7C+Turkish+Hammam+%7C+Luxury+spa/data=!4m7!3m6!1s0x3bae1371c8722bbf:0x98de2e2eeef8c952!8m2!3d12.962422!4d77.71677!16s%2Fg%2F11y29mxqqp!19sChIJvytyyHETrjsRUsn47i4u3pg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "golden-hive-luxury-salon",
    "name": "Golden Hive Luxury Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "484, 2nd Floor, Signature Square, Circle, Chinmaya Mission Hospital Rd, near KFC, next to aLL the plus size store",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 1046,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9785368,
    "longitude": 77.6411986,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Golden+Hive+Luxury+Salon/data=!4m7!3m6!1s0x3bae17510e0b21c5:0x971e77679996872e!8m2!3d12.9785368!4d77.6411986!16s%2Fg%2F11rhvvcd3f!19sChIJxSELDlEXrjsRLoeWmWd3Hpc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "tattva-wellness-spa",
    "name": "Tattva Wellness Spa",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 936,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9288713,
    "longitude": 77.6276589,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Tattva+Wellness+Spa/data=!4m7!3m6!1s0x3bae15682db187d9:0xeaf5e470ad677e0b!8m2!3d12.9288713!4d77.6276589!16s%2Fg%2F11fjqjvpm9!19sChIJ2YexLWgVrjsRC35nrXDk9eo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-zen-aura-spa-whitefield",
    "name": "The Zen Aura Spa (Whitefield)",
    "description": "Highly rated day spa in Whitefield with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 758,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9573964,
    "longitude": 77.7367584,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Zen+Aura+Spa+%28Whitefield%29/data=!4m7!3m6!1s0x3bae13262d63534d:0xf8561b84c3507e22!8m2!3d12.9573964!4d77.7367584!16s%2Fg%2F11tdtc2db9!19sChIJTVNjLSYTrjsRIn5Qw4QbVvg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "wheelies-spa",
    "name": "Wheelies Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "3, 3rd Cross Rd, next to Kc General Hospital",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 685,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9955537,
    "longitude": 77.5688249,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Wheelies+Spa/data=!4m7!3m6!1s0x3bae1778f6e35289:0x80bb4f3fa73b57b6!8m2!3d12.9955537!4d77.5688249!16s%2Fg%2F11pcx4696f!19sChIJiVLj9ngXrjsRtlc7pz9Pu4A?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-zen-aura-spa-hsr-layout",
    "name": "The Zen Aura Spa HSR Layout",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "2 Floor, 39, Shabari Arcade, 14th Main Rd, above Theobroma",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 659,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9114106,
    "longitude": 77.6379978,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Zen+Aura+Spa+HSR+Layout/data=!4m7!3m6!1s0x68d1e26f0a961a19:0x6a8af34a0853bcfd!8m2!3d12.9114106!4d77.6379978!16s%2Fg%2F11stb01djz!19sChIJGRqWCm_i0WgR_bxTCErzimo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "royal-oak-spa-in-koramangala",
    "name": "Royal Oak Spa In Koramangala",
    "description": "Highly rated day spa in Koramangala with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 606,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9353312,
    "longitude": 77.6228694,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Royal+Oak+Spa+In+Koramangala/data=!4m7!3m6!1s0x3bae15ba2261f891:0x9c040c81b8b8cc16!8m2!3d12.9353312!4d77.6228694!16s%2Fg%2F11p11dqp07!19sChIJkfhhIroVrjsRFsy4uIEMBJw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "urban-aqua-international-spa-best-spa-in-koramangala",
    "name": "Urban Aqua International Spa - Best Spa in Koramangala",
    "description": "Highly rated day spa in Koramangala with excellent reviews and professional service.",
    "address": "612, 2nd Floor, 80 Feet Rd, opp. to Sony Centre",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 602,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9364573,
    "longitude": 77.6274682,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Urban+Aqua+International+Spa+-+Best+Spa+in+Koramangala/data=!4m7!3m6!1s0x3bae156f90c8f131:0x4e45b9eabe1a6dbd!8m2!3d12.9364573!4d77.6274682!16s%2Fg%2F11vqrqs6rx!19sChIJMfHIkG8VrjsRvW0avuq5RU4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vip-international-spa",
    "name": "VIP International Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Rs, 665, 2nd Floor, Above Karachi Bakery, KFC Signal 1st Main Rd, 100 Feet Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 578,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9774638,
    "longitude": 77.6410881,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/VIP+International+Spa/data=!4m7!3m6!1s0x3bae170c2e84000b:0xa27deb8bf76e5971!8m2!3d12.9774638!4d77.6410881!16s%2Fg%2F11vdw6jgcb!19sChIJCwCELgwXrjsRcVlu94vrfaI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nail-room-nail-art-studio-salon-in-malleshwaram",
    "name": "Nail Room - Nail Art Studio & Salon in Malleshwaram",
    "description": "Highly rated beauty spa in Malleshwaram with excellent reviews and professional service.",
    "address": "No 107, Ground Floor, Near Born Babies, between 13th & 14th cross, 3rd Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Malleshwaram",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 540,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 13.0040731,
    "longitude": 77.5694083,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nail+Room+-+Nail+Art+Studio+%26+Salon+in+Malleshwaram/data=!4m7!3m6!1s0x3bae17dcc54ef8bf:0x9db9ace18b8b1618!8m2!3d13.0040731!4d77.5694083!16s%2Fg%2F11lct4v4qh!19sChIJv_hOxdwXrjsRGBaLi-GsuZ0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-nest-spa-in-koramangala",
    "name": "Spa Nest - Spa In Koramangala",
    "description": "Highly rated day spa in Koramangala with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 516,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9401341,
    "longitude": 77.6197518,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spa+Nest+-+Spa+In+Koramangala/data=!4m7!3m6!1s0x3bae157e73ee19cd:0xd61a7530e36c9e3f!8m2!3d12.9401341!4d77.6197518!16s%2Fg%2F11vm4zjm65!19sChIJzRnuc34VrjsRP55s4zB1GtY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "siri-beauty-and-wellness-center-in-jayanagar-best-weight-loss-fast-weight-loss-bangalore",
    "name": "Siri Beauty and Wellness Center in Jayanagar | Best Weight Loss | Fast Weight Loss | Bangalore",
    "description": "Highly rated beauty spa in Jayanagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 511,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9196902,
    "longitude": 77.5924929,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Siri+Beauty+and+Wellness+Center+in+Jayanagar+%7C+Best+Weight+Loss+%7C+Fast+Weight+Loss+%7C+Bangalore/data=!4m7!3m6!1s0x3bae159b723937bf:0xc845b58a1e489d00!8m2!3d12.9196902!4d77.5924929!16s%2Fg%2F11vdmtt6hr!19sChIJvzc5cpsVrjsRAJ1IHoq1Rcg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "eleggance-spa-salon-borewell-road-whitefield",
    "name": "Eleggance Spa & Salon | Borewell Road, Whitefield",
    "description": "Highly rated beauty spa in Whitefield with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 464,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9687621,
    "longitude": 77.7448992,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Eleggance+Spa+%26+Salon+%7C+Borewell+Road,+Whitefield/data=!4m7!3m6!1s0x3bae13127315b675:0xec8a9b38209cc2d9!8m2!3d12.9687621!4d77.7448992!16s%2Fg%2F11t2f94vsh!19sChIJdbYVcxITrjsR2cKcIDibiuw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "new-royal-international-thai-spa-best-spa-in-singasandra-jacuzzi-steam-couple-massage",
    "name": "New Royal International Thai Spa \u2013 Best Spa in Singasandra | Jacuzzi, Steam & Couple Massage",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "3rd Floor, 36/37, Manipal County Rd, above KFC, opposite Arrat Royal Citadel",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 460,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.8765169,
    "longitude": 77.6395708,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/New+Royal+International+Thai+Spa+%E2%80%93+Best+Spa+in+Singasandra+%7C+Jacuzzi,+Steam+%26+Couple+Massage/data=!4m7!3m6!1s0x3bae1533a169051f:0x578c7b5302c8fa65!8m2!3d12.8765169!4d77.6395708!16s%2Fg%2F11x6b_zk64!19sChIJHwVpoTMVrjsRZfrIAlN7jFc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "saanvii-spa",
    "name": "Saanvii Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 446,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.8791988,
    "longitude": 77.6465064,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Saanvii+Spa/data=!4m7!3m6!1s0x3bae6d2909f0412b:0xf70ea5079f1712ea!8m2!3d12.8791988!4d77.6465064!16s%2Fg%2F11p66ly719!19sChIJK0HwCSltrjsR6hIXnwelDvc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vedaearth-lounge-spa-salon-jp-nagar-3rd-phase-for-women-only",
    "name": "Vedaearth Lounge Spa & Salon (JP Nagar 3rd Phase) FOR WOMEN ONLY",
    "description": "Highly rated beauty spa in JP Nagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "JP Nagar",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 444,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9166638,
    "longitude": 77.5967014,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Vedaearth+Lounge+Spa+%26+Salon+%28JP+Nagar+3rd+Phase%29+FOR+WOMEN+ONLY/data=!4m7!3m6!1s0x3bae15a0c00d219d:0xf994c65f4c8c8b39!8m2!3d12.9166638!4d77.5967014!16s%2Fg%2F11fzb213mv!19sChIJnSENwKAVrjsROYuMTF_GlPk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "well-care-spa-best-spa-in-kaikondrahalli-sarjapur-road",
    "name": "Well Care Spa - Best Spa In Kaikondrahalli Sarjapur Road",
    "description": "Highly rated day spa in Sarjapur Road with excellent reviews and professional service.",
    "address": "opposite to B.K. Mathrushree",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Sarjapur Road",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 424,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.914467,
    "longitude": 77.676827,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Well+Care+Spa+-+Best+Spa+In+Kaikondrahalli+Sarjapur+Road/data=!4m7!3m6!1s0x3bae13923e02d53d:0x68dac0135f986e79!8m2!3d12.914467!4d77.676827!16s%2Fg%2F11y8gk1597!19sChIJPdUCPpITrjsReW6YXxPA2mg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "arrow-spa-bellandur-massage-spa-center-in-bangalore",
    "name": "Arrow spa bellandur - Massage Spa Center in Bangalore",
    "description": "Highly rated day spa in Bellandur with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bellandur",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 404,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9314073,
    "longitude": 77.6862733,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Arrow+spa+bellandur+-+Massage+Spa+Center+in+Bangalore/data=!4m7!3m6!1s0x3bae13d7d2a57d89:0xe164cd47f9a27f8f!8m2!3d12.9314073!4d77.6862733!16s%2Fg%2F11h57ld424!19sChIJiX2l0tcTrjsRj3-i-UfNZOE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "lavish-international-spa",
    "name": "Lavish International Spa",
    "description": "Highly rated day spa in Outer Ring Road with excellent reviews and professional service.",
    "address": "62 Outer Ring Road",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Outer Ring Road",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 399,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.968752,
    "longitude": 77.701627,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Lavish+International+Spa/data=!4m7!3m6!1s0x3bae115c94d5233d:0xfa2d36076b846e63!8m2!3d12.968752!4d77.701627!16s%2Fg%2F11w84pmddz!19sChIJPSPVlFwRrjsRY26Eawc2Lfo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vanilla-spa-and-salon",
    "name": "Vanilla Spa and Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 398,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 13.0593581,
    "longitude": 77.5925518,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Vanilla+Spa+and+Salon/data=!4m7!3m6!1s0x3bae19b686178cf9:0xae7fa76c569718e2!8m2!3d13.0593581!4d77.5925518!16s%2Fg%2F11h4zly1ql!19sChIJ-YwXhrYZrjsR4hiXVmynf64?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "joie-de-vivre-unisex-family-salon-hsr",
    "name": "Joie De Vivre , Unisex Family Salon,HSR",
    "description": "Highly rated beauty spa in HSR Layout with excellent reviews and professional service.",
    "address": "3rd floor, Innovate India, 668, 9th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 396,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9083553,
    "longitude": 77.6349779,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Joie+De+Vivre+,+Unisex+Family+Salon,HSR/data=!4m7!3m6!1s0x3bae150b0f6167f7:0x5c15e72542916768!8m2!3d12.9083553!4d77.6349779!16s%2Fg%2F11t_jq5fw8!19sChIJ92dhDwsVrjsRaGeRQiXnFVw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "body-care-craft-unisex-salon-spa-and-skin-clinic",
    "name": "Body Care & Craft \u2013 Unisex Salon | Spa And Skin Clinic",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 388,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 13.0244246,
    "longitude": 77.5927791,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Body+Care+%26+Craft+%E2%80%93+Unisex+Salon+%7C+Spa+And+Skin+Clinic/data=!4m7!3m6!1s0x3bae1708be21cd17:0x951adc9371014f65!8m2!3d13.0244246!4d77.5927791!16s%2Fg%2F11tsxm7cv8!19sChIJF80hvggXrjsRZU8BcZPcGpU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "js-hair-story-unisex-salon-whitefield",
    "name": "JS Hair Story Unisex Salon (Whitefield)",
    "description": "Highly rated beauty spa in Whitefield with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 358,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9697143,
    "longitude": 77.7331203,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/JS+Hair+Story+Unisex+Salon+%28Whitefield%29/data=!4m7!3m6!1s0xa577b156d86d9c49:0x7947d211eb225003!8m2!3d12.9697143!4d77.7331203!16s%2Fg%2F11l36gxhvc!19sChIJSZxt2Faxd6URA1Ai6xHSR3k?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vihaan-spa",
    "name": "Vihaan spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "1st floor, nandhini deluxe hotel building, silicon city hotel",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 357,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.8841753,
    "longitude": 77.6434591,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Vihaan+spa/data=!4m7!3m6!1s0x3bae15d26302df8b:0x74280bea9c075a64!8m2!3d12.8841753!4d77.6434591!16s%2Fg%2F11py_tbbt9!19sChIJi98CY9IVrjsRZFoHnOoLKHQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "balance-wellness-and-spa",
    "name": "Balance Wellness and Spa",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 341,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9789733,
    "longitude": 77.6405459,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Balance+Wellness+and+Spa/data=!4m7!3m6!1s0x3bae1770217916d9:0x9fedc69e250212ba!8m2!3d12.9789733!4d77.6405459!16s%2Fg%2F11lcj6x3_0!19sChIJ2RZ5IXAXrjsRuhICJZ7G7Z8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "appu-hair-studio",
    "name": "Appu Hair Studio",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 334,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9868824,
    "longitude": 77.5562146,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Appu+Hair+Studio/data=!4m7!3m6!1s0x3bae3d1a08104eef:0x5f425272a4a39d97!8m2!3d12.9868824!4d77.5562146!16s%2Fg%2F11s7g34tz7!19sChIJ704QCBo9rjsRl52jpHJSQl8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-trends-unisex-salon-academy",
    "name": "THE TRENDS UNISEX SALON ACADEMY",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "184 3rd cross, Link Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 330,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9957852,
    "longitude": 77.5736054,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/THE+TRENDS+UNISEX+SALON+ACADEMY/data=!4m7!3m6!1s0x3bae17e5bdefcc47:0x2b59c0b5070295c6!8m2!3d12.9957852!4d77.5736054!16s%2Fg%2F11v0x3g1_c!19sChIJR8zvveUXrjsRxpUCB7XAWSs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "v-one-spa-spa-near-me-spa-in-rajajinagar",
    "name": "V one Spa | Spa near me | Spa in Rajajinagar",
    "description": "Highly rated day spa in Rajajinagar with excellent reviews and professional service.",
    "address": "4th Floor, 59/A, 10th Main Rd, above Richwin Gem & Jewel",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Rajajinagar",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 307,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9887094,
    "longitude": 77.5561025,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/V+one+Spa+%7C+Spa+near+me+%7C+Spa+in+Rajajinagar/data=!4m7!3m6!1s0x3bae3d7a47724197:0x73d539b75f903e3f!8m2!3d12.9887094!4d77.5561025!16s%2Fg%2F11vhsf1jsx!19sChIJl0FyR3o9rjsRPz6QX7c51XM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "eleggance-spa-salon-nagondahalli",
    "name": "ELEGGANCE SPA & SALON | NAGONDAHALLI",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 299,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9688924,
    "longitude": 77.7655259,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/ELEGGANCE+SPA+%26+SALON+%7C+NAGONDAHALLI/data=!4m7!3m6!1s0x3bae0d5db4534803:0x3dd94fbd466f460c!8m2!3d12.9688924!4d77.7655259!16s%2Fg%2F11tg7rtplr!19sChIJA0hTtF0NrjsRDEZvRr1P2T0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-world",
    "name": "Spa World",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "4th Floor, Plot No 382, 100 Feet Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 289,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.970539,
    "longitude": 77.6414542,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spa+World/data=!4m7!3m6!1s0x3bae1768fd9d1913:0x7401132e0774a324!8m2!3d12.970539!4d77.6414542!16s%2Fg%2F11vyztqwcd!19sChIJExmd_WgXrjsRJKN0By4TAXQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "haven-unisex-salon-malleswaram",
    "name": "Haven unisex salon Malleswaram",
    "description": "Highly rated beauty spa in Malleshwaram with excellent reviews and professional service.",
    "address": "12, 11th Cross Rd, near to mahaveer medical",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Malleshwaram",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 274,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 13.0018219,
    "longitude": 77.5734916,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Haven+unisex+salon+Malleswaram/data=!4m7!3m6!1s0x3bae17bdd45a4655:0xe0ad31636a8157bb!8m2!3d13.0018219!4d77.5734916!16s%2Fg%2F11ld3cx3bl!19sChIJVUZa1L0XrjsRu1eBamMxreA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vedaearth-lounge-spa-salon-jayanagar-3rd-block-south-end-circle-for-women-only",
    "name": "Vedaearth Lounge Spa & Salon (Jayanagar 3rd Block - South End Circle) - For Women Only",
    "description": "Highly rated beauty spa in Jayanagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 270,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9360114,
    "longitude": 77.5810583,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Vedaearth+Lounge+Spa+%26+Salon+%28Jayanagar+3rd+Block+-+South+End+Circle%29+-+For+Women+Only/data=!4m7!3m6!1s0x3bae1517010097f1:0x9ad6b3526a90e28b!8m2!3d12.9360114!4d77.5810583!16s%2Fg%2F11hzm0dky_!19sChIJ8ZcAARcVrjsRi-KQalKz1po?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "la-luxury-spa",
    "name": "LA LUXURY SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 264,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9060118,
    "longitude": 77.6322298,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/LA+LUXURY+SPA/data=!4m7!3m6!1s0x3bae15090e3a1b95:0xb0bf01d46b8e18da!8m2!3d12.9060118!4d77.6322298!16s%2Fg%2F11yfvd_kfx!19sChIJlRs6DgkVrjsR2hiOa9QBv7A?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sky-beauty-spa",
    "name": "Sky Beauty Spa",
    "description": "Highly rated beauty spa in Jakkur with excellent reviews and professional service.",
    "address": "11 & 12, 1st Floor, Pushpa Complex, Amruthahalli, Jakkur Village",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jakkur",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 261,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 13.0684184,
    "longitude": 77.6060223,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sky+Beauty+Spa/data=!4m7!3m6!1s0x3bae19d46c12f0f3:0x5c970337260d6cec!8m2!3d13.0684184!4d77.6060223!16s%2Fg%2F11y6b3q5m5!19sChIJ8_ASbNQZrjsR7GwNJjcDl1w?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sri-sri-wellbeing-spa",
    "name": "Sri Sri Wellbeing SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Sri Sri Wellbeing Spa, 39th 'A' Cross, 11th Main Rd, opposite Shalini Ground",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 261,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9202219,
    "longitude": 77.5860689,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sri+Sri+Wellbeing+SPA/data=!4m7!3m6!1s0x3bae15db86df1fa9:0x1e285d8abfc02e3a!8m2!3d12.9202219!4d77.5860689!16s%2Fg%2F11kq27d43t!19sChIJqR_fhtsVrjsROi7Av4pdKB4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "thara-thai-spa-electronic-city",
    "name": "Thara Thai Spa Electronic City",
    "description": "Highly rated thai spa in Electronic City with excellent reviews and professional service.",
    "address": "Floor 3, 268, 2, Neeladri Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Electronic City",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 260,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.8418353,
    "longitude": 77.6455719,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Thara+Thai+Spa+Electronic+City/data=!4m7!3m6!1s0x2c1612fb956a6a27:0xefe9672b428c24dc!8m2!3d12.8418353!4d77.6455719!16s%2Fg%2F11kpts0br2!19sChIJJ2pqlfsSFiwR3CSMQitn6e8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "arth-thai-spa-hebbal",
    "name": "Arth Thai Spa Hebbal",
    "description": "Highly rated thai spa in Hebbal with excellent reviews and professional service.",
    "address": "3rd Floor, Esteem Mall, Bellary Rd, near Hebbal Flyover",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Hebbal",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 249,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 13.0490751,
    "longitude": 77.5933513,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Arth+Thai+Spa+Hebbal/data=!4m7!3m6!1s0x3bae174c1b74e357:0x86139db88f098829!8m2!3d13.0490751!4d77.5933513!16s%2Fg%2F11yb_2b0q6!19sChIJV-N0G0wXrjsRKYgJj7idE4Y?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "meghavi-wellness-spa-salon-rg-royal-hotel",
    "name": "Meghavi Wellness Spa & Salon | RG Royal Hotel",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "RG Royal, Spa, at Parking B1, behind Ravindu Toyota, near ISKCON Temple",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 237,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 13.0169038,
    "longitude": 77.5490188,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Meghavi+Wellness+Spa+%26+Salon+%7C+RG+Royal+Hotel/data=!4m7!3m6!1s0x3bae3d9e4c06cb65:0x25fe95df76b03cd9!8m2!3d13.0169038!4d77.5490188!16s%2Fg%2F11t49z4789!19sChIJZcsGTJ49rjsR2Tywdt-V_iU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-nail-foot-spa",
    "name": "The Nail & Foot Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "7th Block, 9, 20th Main Rd, opp. Airtel Office",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 221,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9362412,
    "longitude": 77.6157116,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Nail+%26+Foot+Spa/data=!4m7!3m6!1s0x3bae15f7b477855b:0xdc9e7a8e607586b4!8m2!3d12.9362412!4d77.6157116!16s%2Fg%2F11kjp17377!19sChIJW4V3tPcVrjsRtIZ1YI56ntw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "aishwarya-beauty-saloon-spa",
    "name": "Aishwarya Beauty Saloon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "88, 10th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 221,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 13.0011161,
    "longitude": 77.5706511,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Aishwarya+Beauty+Saloon+%26+Spa/data=!4m7!3m6!1s0x3bae17aa019b0793:0xf3e9911eb48b1a78!8m2!3d13.0011161!4d77.5706511!16s%2Fg%2F11fks68hwj!19sChIJkwebAaoXrjsReBqLtB6R6fM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "celina-s-salon",
    "name": "Celina's salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Mathru chaya building, 1st floor,5th cross, KHB Colony Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 220,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 13.0355019,
    "longitude": 77.6093812,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Celina%27s+salon/data=!4m7!3m6!1s0x3bae1765e4804371:0x9854bd0fe2142efe!8m2!3d13.0355019!4d77.6093812!16s%2Fg%2F11mwjlz1mf!19sChIJcUOA5GUXrjsR_i4U4g-9VJg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "carnation-car-bike-spa",
    "name": "Carnation Car & Bike Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "99 11th A Cross, Dasarahalli Main Rd, opp. Muthoot Fincorp",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 213,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 13.0551764,
    "longitude": 77.6034405,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Carnation+Car+%26+Bike+Spa/data=!4m7!3m6!1s0x3bae17366aea4d6f:0xf2a35811db12815e!8m2!3d13.0551764!4d77.6034405!16s%2Fg%2F11q581lhlc!19sChIJb03qajYXrjsRXoES2xFYo_I?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "style-beauty-salon",
    "name": "Style & Beauty Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "358, 12th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 207,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9853853,
    "longitude": 77.5542945,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Style+%26+Beauty+Salon/data=!4m7!3m6!1s0x3bae3df30ee343eb:0x43a81241c6490eb!8m2!3d12.9853853!4d77.5542945!16s%2Fg%2F11g9qw30_w!19sChIJ60PjDvM9rjsR65BkHCSBOgQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "studio11-family-salon-indiranagar",
    "name": "STUDIO11 Family Salon Indiranagar",
    "description": "Highly rated beauty spa in Indiranagar with excellent reviews and professional service.",
    "address": "No. 621/B, 12th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 206,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9706013,
    "longitude": 77.6471587,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/STUDIO11+Family+Salon+Indiranagar/data=!4m7!3m6!1s0x3bae17e68904df95:0xd0967b4daa26cbc1!8m2!3d12.9706013!4d77.6471587!16s%2Fg%2F11x1n2lzy8!19sChIJld8EieYXrjsRwcsmqk17ltA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "glamsjo-salon-spa",
    "name": "GLAMSJO Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "62/1, SPRINGDALE LAYOUT, 1st Cross, Main Road",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 204,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9766381,
    "longitude": 77.7572254,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/GLAMSJO+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae0f16b4fdc3ed:0xfebc1c6f344c0379!8m2!3d12.9766381!4d77.7572254!16s%2Fg%2F11y3wzszxy!19sChIJ7cP9tBYPrjsReQNMNG8cvP4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "body-raaga-wellness-spa-jp-nagar",
    "name": "Body Raaga Wellness Spa Jp Nagar",
    "description": "Highly rated wellness spa in JP Nagar with excellent reviews and professional service.",
    "address": "No 2 , 1st Floor, 24th Main Rd, opposite Da Pandu Memorial Rv Dental College",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "JP Nagar",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 202,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9117379,
    "longitude": 77.585802,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Body+Raaga+Wellness+Spa+Jp+Nagar/data=!4m7!3m6!1s0x3bae15c9d8a9fa01:0xca7dd6ac27314723!8m2!3d12.9117379!4d77.585802!16s%2Fg%2F11v0lft5ks!19sChIJAfqp2MkVrjsRI0cxJ6zWfco?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "black-stone-salon-spa",
    "name": "black stone salon & spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd floor, apsara arcade, Channasandra Main Rd, near mvj engineering college",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 202,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9825345,
    "longitude": 77.7630286,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/black+stone+salon+%26+spa/data=!4m7!3m6!1s0x3bae0f09b1ede069:0xa5f2c779ff40feb5!8m2!3d12.9825345!4d77.7630286!16s%2Fg%2F11sjjwrd0y!19sChIJaeDtsQkPrjsRtf5A_3nH8qU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "celebrity-day-spa-spa-near-hulimangala-spa-near-electronic-city-phase-1",
    "name": "Celebrity Day Spa | Spa Near Hulimangala | Spa Near Electronic City Phase 1",
    "description": "Highly rated day spa in Electronic City with excellent reviews and professional service.",
    "address": "1st Floor, Govt School, 355, VRR Garden Enclave, VRR Sports Club, near Hulimangala",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Electronic City",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 193,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.8233162,
    "longitude": 77.6525812,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Celebrity+Day+Spa+%7C+Spa+Near+Hulimangala+%7C+Spa+Near+Electronic+City+Phase+1/data=!4m7!3m6!1s0x4919c21ce499ea0f:0xf9c346bda58c65b2!8m2!3d12.8233162!4d77.6525812!16s%2Fg%2F11l249w6c0!19sChIJD-qZ5BzCGUkRsmWMpb1Gw_k?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "page-spa-saloon",
    "name": "Page Spa &Saloon",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Bombay dyeing road",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 190,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 13.0234519,
    "longitude": 77.556892,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Page+Spa+%26Saloon/data=!4m7!3m6!1s0x3bae3dc77647ec2d:0x4553b2965e36c66f!8m2!3d13.0234519!4d77.556892!16s%2Fg%2F11svs9fczr!19sChIJLexHdsc9rjsRb8Y2XpayU0U?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vistara-thai-spa",
    "name": "Vistara Thai Spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "1st floor, Maruthi Complex, 19, Rabindranath Tagore Nagar Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 188,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 13.0215409,
    "longitude": 77.5923678,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Vistara+Thai+Spa/data=!4m7!3m6!1s0x3bae1727e56b3c91:0x5c667967e26630e4!8m2!3d13.0215409!4d77.5923678!16s%2Fg%2F11vwqcyl9h!19sChIJkTxr5ScXrjsR5DBm4md5Zlw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "icon-luxury-spa-jacuzzi-best-spa-in-new-bel-road-international-spa-vip-spa",
    "name": "Icon Luxury Spa- jacuzzi |Best Spa In New BEL Road | international spa | vip spa |",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 180,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 13.027374,
    "longitude": 77.5794931,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Icon+Luxury+Spa-+jacuzzi+%7CBest+Spa+In+New+BEL+Road+%7C+international+spa+%7C+vip+spa+%7C/data=!4m7!3m6!1s0xb6595d190c3f6a5:0xbdc03011f61a3df3!8m2!3d13.027374!4d77.5794931!16s%2Fg%2F11w_mh008_!19sChIJpfbDkNGVZQsR8z0a9hEwwL0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "lova-thai-spa",
    "name": "Lova Thai Spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 165,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9405286,
    "longitude": 77.5710167,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Lova+Thai+Spa/data=!4m7!3m6!1s0x3bae15e8f8a5d485:0xd98cc1b858e04f94!8m2!3d12.9405286!4d77.5710167!16s%2Fg%2F11y50lg7t0!19sChIJhdSl-OgVrjsRlE_gWLjBjNk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-berry-sahakar-nagar",
    "name": "Spa Berry - Sahakar Nagar",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Second Floor, 273, Bellary Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 155,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 13.0682796,
    "longitude": 77.5927253,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spa+Berry+-+Sahakar+Nagar/data=!4m7!3m6!1s0x3bae1933fe737d7f:0x5fab467bd83bf690!8m2!3d13.0682796!4d77.5927253!16s%2Fg%2F11yb_y3pl7!19sChIJf31z_jMZrjsRkPY72HtGq18?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ona-thai-spa",
    "name": "Ona Thai Spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "shop no 2, 10th main, 27th B Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 155,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9247741,
    "longitude": 77.5851237,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ona+Thai+Spa/data=!4m7!3m6!1s0x3bae15fecbb0b8f9:0xa4c16dceb55914a0!8m2!3d12.9247741!4d77.5851237!16s%2Fg%2F11w48jldy1!19sChIJ-biwy_4VrjsRoBRZtc5twaQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "tatva-body-spa-care",
    "name": "Tatva Body Spa Care",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "4th Floor, Hegde Nagar, 918, s Main Road",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 153,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 13.0678609,
    "longitude": 77.6323264,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Tatva+Body+Spa+Care/data=!4m7!3m6!1s0x3bae176edd2f667b:0xa128f03b80fbf8ca!8m2!3d13.0678609!4d77.6323264!16s%2Fg%2F11x2l6wzdf!19sChIJe2Yv3W4XrjsRyvj7gDvwKKE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "look-glow-beauty-spa",
    "name": "Look & Glow Beauty Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Milk Dairy, Immadihalli Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 149,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9670222,
    "longitude": 77.7612717,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Look+%26+Glow+Beauty+Spa/data=!4m7!3m6!1s0x3bae0dde246e551b:0x67b7321449894779!8m2!3d12.9670222!4d77.7612717!16s%2Fg%2F11f440brq5!19sChIJG1VuJN4NrjsReUeJSRQyt2c?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "felicity-spa-electronic-city",
    "name": "Felicity Spa Electronic City",
    "description": "Highly rated day spa in Electronic City with excellent reviews and professional service.",
    "address": "2nd Floor, Western Silicon Hotel Building, Bus Stop, 62/3, Hosur Rd, behind Konappana Agrahara",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Electronic City",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 146,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.8542675,
    "longitude": 77.666368,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Felicity+Spa+Electronic+City/data=!4m7!3m6!1s0x3bae6d0e9eecfe53:0xa95fd29549e417a2!8m2!3d12.8542675!4d77.666368!16s%2Fg%2F11wfcgjtl6!19sChIJU_7sng5trjsRohfkSZXSX6k?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "soulful-spa-wellness",
    "name": "Soulful spa & wellness",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "Soulful spa and wellness, 2nd floor, Dr Y.V.S Tower ,RR sports corner, 2nd cross, Chandapura- Anekal Rd, next to Relaince Mart",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 144,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.7990746,
    "longitude": 77.7055846,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Soulful+spa+%26+wellness/data=!4m7!3m6!1s0x3bae6d7a67c91253:0x682b2882e6a8607a!8m2!3d12.7990746!4d77.7055846!16s%2Fg%2F11s75pt5zz!19sChIJUxLJZ3ptrjsRemCo5oIoK2g?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "glamour-zone-laser-and-beauty-studio-in-kempapura-bangalore",
    "name": "Glamour Zone laser and beauty studio in Kempapura, Bangalore",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd Floor, Vishnu Sai Arcade, 35/B, Dasarahalli Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 138,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 13.0550118,
    "longitude": 77.6010731,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Glamour+Zone+laser+and+beauty+studio+in+Kempapura,+Bangalore/data=!4m7!3m6!1s0x3bae17e6e743d331:0xfdd491ed41c62e65!8m2!3d13.0550118!4d77.6010731!16s%2Fg%2F11ssd1jm_q!19sChIJMdND5-YXrjsRZS7GQe2R1P0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sonia-luxury-spa-bengaluru",
    "name": "Sonia Luxury Spa Bengaluru",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "The Nexus Mall, Near, SN 208, Hosur Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 138,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9401398,
    "longitude": 77.6091379,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sonia+Luxury+Spa+Bengaluru/data=!4m7!3m6!1s0x3bae150e1dd6aa4b:0xbfc67cbc4e2069c9!8m2!3d12.9401398!4d77.6091379!16s%2Fg%2F11xrhxcqqc!19sChIJS6rWHQ4VrjsRyWkgTrx8xr8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "refresh-d-thai-spa-spa-near-me-best-spa-in-koramangala-international-spa-jacuzzi",
    "name": "Refresh D Thai Spa | Spa Near Me | Best Spa In Koramangala| International Spa & Jacuzzi",
    "description": "Highly rated thai spa in Koramangala with excellent reviews and professional service.",
    "address": "New, 45, 526, 80 Feet Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 131,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9438052,
    "longitude": 77.6210704,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Refresh+D+Thai+Spa+%7C+Spa+Near+Me+%7C+Best+Spa+In+Koramangala%7C+International+Spa+%26+Jacuzzi/data=!4m7!3m6!1s0x3bae15aa8358bcf9:0x9c36c3005e03b327!8m2!3d12.9438052!4d77.6210704!16s%2Fg%2F11v5bxphm4!19sChIJ-bxYg6oVrjsRJ7MDXgDDNpw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "mudita-luxury-spa-in-jayanagar",
    "name": "Mudita Luxury Spa In Jayanagar",
    "description": "Highly rated day spa in Jayanagar with excellent reviews and professional service.",
    "address": "3rd Floor, No. 364/1, Sri Srinivasa Mansion, 11th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 125,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9326699,
    "longitude": 77.586023,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Mudita+Luxury+Spa+In+Jayanagar/data=!4m7!3m6!1s0x3bae151f0168fd37:0xa10873fa0e476311!8m2!3d12.9326699!4d77.586023!16s%2Fg%2F11yb9f_080!19sChIJN_1oAR8VrjsREWNHDvpzCKE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "beautyfly-ladies-salon-spa",
    "name": "Beautyfly Ladies Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "142 A, 8th - Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 122,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9318636,
    "longitude": 77.6332707,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Beautyfly+Ladies+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae15b68d74cfb5:0xc845c5275fabaf3b!8m2!3d12.9318636!4d77.6332707!16s%2Fg%2F11js7c9b_k!19sChIJtc90jbYVrjsRO6-rXyfFRcg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sense-of-style",
    "name": "Sense of Style",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "8 vinayaka kurupa 6 th Cross, 03",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 121,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9976291,
    "longitude": 77.5728124,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sense+of+Style/data=!4m7!3m6!1s0x3bae177a2929fbd5:0xd3552a20abead00b!8m2!3d12.9976291!4d77.5728124!16s%2Fg%2F11sh4bbqyv!19sChIJ1fspKXoXrjsRC9DqqyAqVdM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "wild-flower-spa-salon",
    "name": "Wild Flower Spa & Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "no 507, 1st floor, next to Krishna Sagar Hotel",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 120,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9371506,
    "longitude": 77.6247645,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Wild+Flower+Spa+%26+Salon/data=!4m7!3m6!1s0x3bae15dda0c71e45:0x298960ab294ca82c!8m2!3d12.9371506!4d77.6247645!16s%2Fg%2F11scn3t2w6!19sChIJRR7HoN0VrjsRLKhMKatgiSk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "white-petals-spa",
    "name": "White Petals Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 116,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9776566,
    "longitude": 77.7570832,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/White+Petals+Spa/data=!4m7!3m6!1s0x3bae173d0ddb2e91:0x22f87dda4a85726b!8m2!3d12.9776566!4d77.7570832!16s%2Fg%2F11trjpqcy9!19sChIJkS7bDT0XrjsRa3KFStp9-CI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "amrutasthanam-wellness-spa",
    "name": "AmrutaSthanam Wellness SPA",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "39, 20th main, 1st Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 104,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9172222,
    "longitude": 77.6129464,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/AmrutaSthanam+Wellness+SPA/data=!4m7!3m6!1s0x3bae1596db681011:0x2c06b10d78b92ba4!8m2!3d12.9172222!4d77.6129464!16s%2Fg%2F11sm70hz05!19sChIJERBo25YVrjsRpCu5eA2xBiw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "wannasa-wellness-and-spa-jayanagar",
    "name": "Wannasa Wellness and Spa Jayanagar.",
    "description": "Highly rated wellness spa in Jayanagar with excellent reviews and professional service.",
    "address": "2nd floor New door no 61 old, 319 B, 9th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 104,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9193076,
    "longitude": 77.5838999,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Wannasa+Wellness+and+Spa+Jayanagar./data=!4m7!3m6!1s0x3bae15005fc8f7ab:0xca30ec478dd364b3!8m2!3d12.9193076!4d77.5838999!16s%2Fg%2F11y64x_13z!19sChIJq_fIXwAVrjsRs2TTjUfsMMo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ohw-family-spa-skin-care-best-spa",
    "name": "OHW Family Spa & Skin Care-best spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 102,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9361389,
    "longitude": 77.5847191,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/OHW+Family+Spa+%26+Skin+Care-best+spa/data=!4m7!3m6!1s0x3bae1528f2d66441:0x2dad6b86ada96b43!8m2!3d12.9361389!4d77.5847191!16s%2Fg%2F11qq3x76p1!19sChIJQWTW8igVrjsRQ2uprYZrrS0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "zola-b2b-happyending-relaxing-spa-centre",
    "name": "Zola b2b happyending-relaxing Spa centre",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 101,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9061075,
    "longitude": 77.629491,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Zola+b2b+happyending-relaxing+Spa+centre/data=!4m7!3m6!1s0x3bae151cea7aaf01:0x5a95148108c88a31!8m2!3d12.9061075!4d77.629491!16s%2Fg%2F11pyk1fgx5!19sChIJAa966hwVrjsRMYrICIEUlVo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "roshan-spa",
    "name": "Roshan Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "18th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 98,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 13.0019537,
    "longitude": 77.5712244,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Roshan+Spa/data=!4m7!3m6!1s0x3bae17bab1117727:0x2b31ca126452a0de!8m2!3d13.0019537!4d77.5712244!16s%2Fg%2F11h5_vfg50!19sChIJJ3cRsboXrjsR3qBSZBLKMSs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "green-day-spa-new-bel-road",
    "name": "Green Day Spa - New BEL Road",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 98,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 13.0337227,
    "longitude": 77.5689859,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Green+Day+Spa+-+New+BEL+Road/data=!4m7!3m6!1s0x3bae17ee1b85fe55:0xd36ed56c8f0bbd22!8m2!3d13.0337227!4d77.5689859!16s%2Fg%2F11vq9p45pb!19sChIJVf6FG-4XrjsRIr0Lj2zVbtM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "a1-unisex-salon-hsr-layout",
    "name": "A1 Unisex Salon (HSR Layout)",
    "description": "Highly rated beauty spa in HSR Layout with excellent reviews and professional service.",
    "address": "1st Floor, 135, Venkatapura Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 97,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9190523,
    "longitude": 77.6327741,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/A1+Unisex+Salon+%28HSR+Layout%29/data=!4m7!3m6!1s0x3bae153b9b015cef:0xb7785d421585ebd9!8m2!3d12.9190523!4d77.6327741!16s%2Fg%2F11w8gnwv5t!19sChIJ71wBmzsVrjsR2euFFUJdeLc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "lilly-spa",
    "name": "Lilly Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "11, Adya Complex, Govinda Shetty Palya Rd, near Canara Bank",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 97,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.8488496,
    "longitude": 77.6702489,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Lilly+Spa/data=!4m7!3m6!1s0x3bae6dfbeb3acb9f:0xf709e48d4431acd!8m2!3d12.8488496!4d77.6702489!16s%2Fg%2F11shn0kbyx!19sChIJn8s66_ttrjsRzRpD1EiecA8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vibrant-visage-unisex-salon",
    "name": "Vibrant Visage Unisex Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "2Y, 40, 59th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 96,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.984786,
    "longitude": 77.5535434,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Vibrant+Visage+Unisex+Salon/data=!4m7!3m6!1s0x3bae3d23ecd55343:0x799f118d520f34b5!8m2!3d12.984786!4d77.5535434!16s%2Fg%2F11xnt04z0y!19sChIJQ1PV7CM9rjsRtTQPUo0Rn3k?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "magical-touch-de-stress-spa-and-salon",
    "name": "MAGICAL TOUCH DE-STRESS SPA AND SALON",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "3rd floor, 6th Main Rd, above d mart ready",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 96,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.8958352,
    "longitude": 77.610961,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/MAGICAL+TOUCH+DE-STRESS+SPA+AND+SALON/data=!4m7!3m6!1s0x3bae15f5a85dcf47:0xa97e9e3e4c6da010!8m2!3d12.8958352!4d77.610961!16s%2Fg%2F11vsq18bw0!19sChIJR89dqPUVrjsREKBtTD6efqk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "tranquilo-wellness-centre-r",
    "name": "Tranquilo Wellness Centre R",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "Madniemaara, No 18/1, Second floor, Alexandria St, above Raw Fitness Gym",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 91,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9629832,
    "longitude": 77.6031032,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Tranquilo+Wellness+Centre+R/data=!4m7!3m6!1s0x3bae15d411602db1:0x22458813f2b99671!8m2!3d12.9629832!4d77.6031032!16s%2Fg%2F11g5z_s03z!19sChIJsS1gEdQVrjsRcZa58hOIRSI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "lush-thai-spa",
    "name": "Lush Thai Spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "Shop 2, 2nd Floor, 7th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 88,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9137096,
    "longitude": 77.6056151,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Lush+Thai+Spa/data=!4m7!3m6!1s0x3bae150070d8ebfd:0xb13ed934ce2faa78!8m2!3d12.9137096!4d77.6056151!16s%2Fg%2F11y3vd99g_!19sChIJ_evYcAAVrjsReKovzjTZPrE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nirman-spa-bannerghatta-road-spa-and-jacuzzi-massage-in-bangalore",
    "name": "Nirman Spa Bannerghatta Road, Spa and Jacuzzi Massage in Bangalore",
    "description": "Highly rated day spa in Bannerghatta Road with excellent reviews and professional service.",
    "address": "Building 161A, Pvr Pixel, NO:161/166 2nd Floor, 166, Bannerghatta Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bannerghatta Road",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 86,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.8880763,
    "longitude": 77.5973821,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nirman+Spa+Bannerghatta+Road,+Spa+and+Jacuzzi+Massage+in+Bangalore/data=!4m7!3m6!1s0x3bae156f7a2c4879:0x6a046db64e287b37!8m2!3d12.8880763!4d77.5973821!16s%2Fg%2F11x5jmldyt!19sChIJeUgsem8VrjsRN3soTrZtBGo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ode-spa-wellness-la-marvella-bangalore",
    "name": "Ode Spa Wellness -La Marvella, Bangalore",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "6th floor, La Marvella Hotel, 14th Cross, South End Circle",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 86,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9371679,
    "longitude": 77.5806133,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ode+Spa+Wellness+-La+Marvella,+Bangalore/data=!4m7!3m6!1s0x3bae159d61f02143:0xd0e5f5ec3dc7594d!8m2!3d12.9371679!4d77.5806133!16s%2Fg%2F11lnzpn4ch!19sChIJQyHwYZ0VrjsRTVnHPez15dA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "aroma-russian-spa-electronic-city-bengaluru",
    "name": "Aroma Russian Spa Electronic City Bengaluru",
    "description": "Highly rated day spa in Electronic City with excellent reviews and professional service.",
    "address": "Bangalore",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Electronic City",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 86,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.8483662,
    "longitude": 77.6726672,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Aroma+Russian+Spa+Electronic+City+Bengaluru/data=!4m7!3m6!1s0x3bae6d841824c647:0x96773d7b2df42944!8m2!3d12.8483662!4d77.6726672!16s%2Fg%2F11ygxyjj0s!19sChIJR8YkGIRtrjsRRCn0LXs9d5Y?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nava-luxury-thai-spa",
    "name": "Nava Luxury Thai Spa",
    "description": "Highly rated thai spa in Indiranagar with excellent reviews and professional service.",
    "address": "No - 22, 3rd Floor, CMH Road, Metro Pillar No-80,, Hoysala Nagar Indiranagar, Binnamangla",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 82,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.978354,
    "longitude": 77.6355339,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nava+Luxury+Thai+Spa/data=!4m7!3m6!1s0x3bae1726fd855915:0x4167923c2ac58f84!8m2!3d12.978354!4d77.6355339!16s%2Fg%2F11x11ydhmy!19sChIJFVmF_SYXrjsRhI_FKjySZ0E?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "tres-mink-salon-academy-indiranagar-bengaluru",
    "name": "Tres Mink Salon & Academy, Indiranagar, Bengaluru",
    "description": "Highly rated beauty spa in Indiranagar with excellent reviews and professional service.",
    "address": "1st Floor, Above Health and Glow Shop 956 12th Main Road, HAL Second Stage",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 75,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9702054,
    "longitude": 77.6402168,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Tres+Mink+Salon+%26+Academy,+Indiranagar,+Bengaluru/data=!4m7!3m6!1s0x3bae1799b4fd5391:0x7ce002321b7e287a!8m2!3d12.9702054!4d77.6402168!16s%2Fg%2F11xm3rqgq2!19sChIJkVP9tJkXrjsReih-GzIC4Hw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "hsr-unisex-spa",
    "name": "HSR Unisex Spa",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "No: 1702 Second Floor, 19th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 69,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9060766,
    "longitude": 77.6445757,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/HSR+Unisex+Spa/data=!4m7!3m6!1s0x3bae15e5e65ac383:0x2bd598f8ebfb7c87!8m2!3d12.9060766!4d77.6445757!16s%2Fg%2F11vr_qrsr_!19sChIJg8Na5uUVrjsRh3z76_iY1Ss?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "synerchi-wellness",
    "name": "SynerChi Wellness",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "76/A 18th C Main, 24th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 68,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9080025,
    "longitude": 77.6438271,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/SynerChi+Wellness/data=!4m7!3m6!1s0x3bae155256bda5e3:0x63ab912ee63d5597!8m2!3d12.9080025!4d77.6438271!16s%2Fg%2F11v3s04y37!19sChIJ46W9VlIVrjsRl1U95i6Rq2M?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "golden-hands-unisex-spa-malleshwaram",
    "name": "Golden Hands Unisex Spa Malleshwaram",
    "description": "Highly rated day spa in Malleshwaram with excellent reviews and professional service.",
    "address": "2nd cross, Sampige Rd, near Al-bek",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Malleshwaram",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 64,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9945593,
    "longitude": 77.5713938,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Golden+Hands+Unisex+Spa+Malleshwaram/data=!4m7!3m6!1s0x3bae175c022186f7:0x4b78a2923847507f!8m2!3d12.9945593!4d77.5713938!16s%2Fg%2F11y5yx0pvg!19sChIJ94YhAlwXrjsRf1BHOJKieEs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "green-day-spa-8th-block-koramangala",
    "name": "Green Day Spa - 8th block Koramangala",
    "description": "Highly rated day spa in Koramangala with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 63,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9395239,
    "longitude": 77.619415,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Green+Day+Spa+-+8th+block+Koramangala/data=!4m7!3m6!1s0x3bae151ee05a565b:0x2147d57f5398d054!8m2!3d12.9395239!4d77.619415!16s%2Fg%2F11vr0t9zw4!19sChIJW1Za4B4VrjsRVNCYU3_VRyE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "exotic-unisex-salon-beauty-care",
    "name": "Exotic Unisex Salon & Beauty Care",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Besides Bosch Showroom, 20, 16th A cross, East Park Road, Sampige Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 63,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 13.0064768,
    "longitude": 77.5707482,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Exotic+Unisex+Salon+%26+Beauty+Care/data=!4m7!3m6!1s0x3bae17bfb6ed27a9:0xa2356674e9096d29!8m2!3d13.0064768!4d77.5707482!16s%2Fg%2F11vqhpjl27!19sChIJqSfttr8XrjsRKW0J6XRmNaI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "aloka-spa",
    "name": "Aloka Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 60,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.850432,
    "longitude": 77.6602708,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Aloka+Spa/data=!4m7!3m6!1s0x3bae6d40fcb5b043:0x4ef9f1670df7be87!8m2!3d12.850432!4d77.6602708!16s%2Fg%2F11glwgpw9m!19sChIJQ7C1_EBtrjsRh773DWfx-U4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "yuki-spa",
    "name": "Yuki Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "1st Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 59,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9287086,
    "longitude": 77.6356171,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Yuki+Spa/data=!4m7!3m6!1s0x3bae1554e0441f99:0xe39785cf1e0476e5!8m2!3d12.9287086!4d77.6356171!16s%2Fg%2F11ldp7gbvw!19sChIJmR9E4FQVrjsR5XYEHs-Fl-M?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "signature-hair-studio",
    "name": "Signature Hair Studio",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 57,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 13.0323293,
    "longitude": 77.6040745,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Signature+Hair+Studio/data=!4m7!3m6!1s0x3bae3f00560d469b:0x6f7cf813a4bcc20f!8m2!3d13.0323293!4d77.6040745!16s%2Fg%2F11ltbb0047!19sChIJm0YNVgA_rjsRD8K8pBP4fG8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bliss-beauty-parlour",
    "name": "Bliss Beauty Parlour",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "7th A Cross, Sultanpalya Main Rd, opposite IOB Bank, above Cool Town",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 57,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 13.036902,
    "longitude": 77.6049048,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bliss+Beauty+Parlour/data=!4m7!3m6!1s0x3bae177e96c6e199:0x80b1987bab4db65b!8m2!3d13.036902!4d77.6049048!16s%2Fg%2F11l6sjl6by!19sChIJmeHGln4XrjsRW7ZNq3uYsYA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "gujar-international-ayurveda-foundation-s-ayurveda-ashraya",
    "name": "Gujar International Ayurveda Foundation's, Ayurveda Ashraya",
    "description": "Highly rated ayurvedic spa in Malleshwaram with excellent reviews and professional service.",
    "address": "6th cross, Malleshwaram circle, sampige road",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Malleshwaram",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 56,
    "spa_type": "Ayurvedic Spa",
    "services": [
      "Abhyanga",
      "Shirodhara",
      "Panchakarma",
      "Pizhichil",
      "Kerala Massage",
      "Ayurvedic Facial"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9977136,
    "longitude": 77.5719272,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Gujar+International+Ayurveda+Foundation%27s,+Ayurveda+Ashraya/data=!4m7!3m6!1s0x3bae1625188ed629:0xda0dd0b78c599678!8m2!3d12.9977136!4d77.5719272!16s%2Fg%2F11fyx82fkh!19sChIJKdaOGCUWrjsReJZZjLfQDdo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nilaya-spa",
    "name": "Nilaya Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Inorbit Mall, Rd Number 7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 55,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9790794,
    "longitude": 77.7285762,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nilaya+Spa/data=!4m7!3m6!1s0x3bae11ab9383d5fd:0x6e24c458ca6da401!8m2!3d12.9790794!4d77.7285762!16s%2Fg%2F11t7vt69n0!19sChIJ_dWDk6sRrjsRAaRtyljEJG4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vedha-spa-salon",
    "name": "Vedha Spa & Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Gurukrupa Building, 3 3main road, 10, market road",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 51,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 13.0344139,
    "longitude": 77.55799,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Vedha+Spa+%26+Salon/data=!4m7!3m6!1s0x3bae3d0037d5a8b3:0x76a344f6e656721d!8m2!3d13.0344139!4d77.55799!16s%2Fg%2F11x2x768y0!19sChIJs6jVNwA9rjsRHXJW5vZEo3Y?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "b2b-bangalore-spa",
    "name": "B2b Bangalore spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "WJ6J+HW9",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 47,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9114098,
    "longitude": 77.6323714,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/B2b+Bangalore+spa/data=!4m7!3m6!1s0x3bae158fa132936b:0xef94b055dcc1beb5!8m2!3d12.9114098!4d77.6323714!16s%2Fg%2F11sc284z9z!19sChIJa5MyoY8VrjsRtb7B3FWwlO8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "eva-salon-spa",
    "name": "EVA SALON & SPA",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "3rd Floor, 1954/4, Hoodi Main Rd, opp. to BBMP Office",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 45,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.993801,
    "longitude": 77.7176937,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/EVA+SALON+%26+SPA/data=!4m7!3m6!1s0x3bae113a91450907:0x628102919fd421b8!8m2!3d12.993801!4d77.7176937!16s%2Fg%2F11x74s66wj!19sChIJBwlFkToRrjsRuCHUn5ECgWI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "hugge-wellness",
    "name": "Hugge wellness",
    "description": "Highly rated wellness spa in Whitefield with excellent reviews and professional service.",
    "address": "site No 2 khata 139, Sumeru Arcade, 5 the floor, PNO 12/3, Whitefield Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 41,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9657538,
    "longitude": 77.7492452,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Hugge+wellness/data=!4m7!3m6!1s0x3bae0dc6dedaa16d:0x2e8a288ee3d05185!8m2!3d12.9657538!4d77.7492452!16s%2Fg%2F11rkh9f60_!19sChIJbaHa3sYNrjsRhVHQ444oii4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-ce-the-spa-best-spa-in-gandhi-nagar-bangalore",
    "name": "SPA.ce the Spa Best spa in Gandhi Nagar Bangalore",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 34,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9808078,
    "longitude": 77.57603,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/SPA.ce+the+Spa+Best+spa+in+Gandhi+Nagar+Bangalore/data=!4m7!3m6!1s0x3bae17c8d663f4b9:0xe6be408905007f2c!8m2!3d12.9808078!4d77.57603!16s%2Fg%2F11rnk0llgp!19sChIJufRj1sgXrjsRLH8ABYlAvuY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "just-relax-best-massage-parlour-in-bangalore",
    "name": "Just Relax - Best Massage Parlour in Bangalore",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "4th Main Rd, near kaveri speciality hospital",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 32,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9183989,
    "longitude": 77.6180156,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Just+Relax+-+Best+Massage+Parlour+in+Bangalore/data=!4m7!3m6!1s0x3bae2339d091e40d:0xfef8f7ec7d2b3ca0!8m2!3d12.9183989!4d77.6180156!16s%2Fg%2F11y7b0fdb9!19sChIJDeSR0DkjrjsRoDwrfez3-P4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "v7-spa-and-salon",
    "name": "V7 Spa and salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 32,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 13.0538417,
    "longitude": 77.5751621,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/V7+Spa+and+salon/data=!4m7!3m6!1s0x3bae1767fc9ac311:0xe429bdc523c314fa!8m2!3d13.0538417!4d77.5751621!16s%2Fg%2F11l329n9kk!19sChIJEcOa_GcXrjsR-hTDI8W9KeQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "hian-family-salon-spa",
    "name": "Hian family salon & spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "7th Cross Road",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 32,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.8386097,
    "longitude": 77.6484523,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Hian+family+salon+%26+spa/data=!4m7!3m6!1s0x3bae6bb2e9368745:0x6bc86a1b8ef6ce67!8m2!3d12.8386097!4d77.6484523!16s%2Fg%2F11svznw8jn!19sChIJRYc26bJrrjsRZ872jhtqyGs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "thapovana-luxury-spa",
    "name": "Thapovana Luxury spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "V. V Nagar, 3, next to Asha sweets",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 26,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 13.0251541,
    "longitude": 77.5931447,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Thapovana+Luxury+spa/data=!4m7!3m6!1s0x3bae17fc540b7f39:0x6c9cb13aabefea30!8m2!3d13.0251541!4d77.5931447!16s%2Fg%2F11mt2xq7lk!19sChIJOX8LVPwXrjsRMOrvqzqxnGw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nova-luxury-spa",
    "name": "Nova luxury spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "BDA Complex, No 87,4th floor 14th main, ner, opposite white House",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 25,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9125035,
    "longitude": 77.6383987,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nova+luxury+spa/data=!4m7!3m6!1s0x3bae1521875d87b7:0x19598fbc6ad04d6f!8m2!3d12.9125035!4d77.6383987!16s%2Fg%2F11vbqq6wwl!19sChIJt4ddhyEVrjsRb03QaryPWRk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vibe-salon-indiranagar",
    "name": "VIBE SALON INDIRANAGAR",
    "description": "Highly rated beauty spa in Indiranagar with excellent reviews and professional service.",
    "address": "9th, 5th Cross Rd, opp. to Rithu tution centre",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 22,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9689839,
    "longitude": 77.6499236,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/VIBE+SALON+INDIRANAGAR/data=!4m7!3m6!1s0x3bae15d9bfec5201:0xc2707fb103cde8d4!8m2!3d12.9689839!4d77.6499236!16s%2Fg%2F11yntyw0cf!19sChIJAVLsv9kVrjsR1OjNA7F_cMI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-divine-delight-salon-spa",
    "name": "The Divine Delight Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd floor, Annapurneshwarai Tower, 582, Immadihalli Main Rd, opposite Dmart Ready",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 22,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9697357,
    "longitude": 77.7514487,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Divine+Delight+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae0db1068e823b:0xb47166dbe5c13a85!8m2!3d12.9697357!4d77.7514487!16s%2Fg%2F11sk0tcc1h!19sChIJO4KOBrENrjsRhTrB5dtmcbQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "opal-wellness-spa",
    "name": "Opal Wellness Spa",
    "description": "Highly rated wellness spa in Whitefield with excellent reviews and professional service.",
    "address": "3RD FLOOR, MCC CHAMBER BUILDING, CIRCLE, 17/2, Whitefield Main Rd, above RAMDEV MEDICAL",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 21,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9566948,
    "longitude": 77.7457578,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Opal+Wellness+Spa/data=!4m7!3m6!1s0x3bae0dd151eabb53:0xd4db9a7ab072df15!8m2!3d12.9566948!4d77.7457578!16s%2Fg%2F11x7qkmvnm!19sChIJU7vqUdENrjsRFd9ysHqa29Q?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "orra-spa",
    "name": "Orra Spa",
    "description": "Highly rated day spa in Outer Ring Road with excellent reviews and professional service.",
    "address": "Sreeram Complex, 13, 5th Cross Rd, near Printo",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Outer Ring Road",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 20,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.935503,
    "longitude": 77.622602,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Orra+Spa/data=!4m7!3m6!1s0x3bae152ce6894f51:0x764c7a60cee56473!8m2!3d12.935503!4d77.622602!16s%2Fg%2F11ldcz3s25!19sChIJUU-J5iwVrjsRc2TlzmB6THY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "purebliss-spa",
    "name": "PureBliss Spa",
    "description": "Highly rated day spa in Whitefield with excellent reviews and professional service.",
    "address": "2nd floor, MCC Tower, No 578/444 Sy No 07, Whitefield Main Road",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 20,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9558823,
    "longitude": 77.7309091,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/PureBliss+Spa/data=!4m7!3m6!1s0x3bae13567400898f:0x9baa683a3c775f10!8m2!3d12.9558823!4d77.7309091!16s%2Fg%2F11wn47ddnl!19sChIJj4kAdFYTrjsREF93PDpoqps?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sunflower-spa",
    "name": "Sunflower Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Sunflower Spa 1st floor, opposite K.C.B. Minerals fresh and pure drinking factory Kaithota, cross, Nagondanahalli Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 17,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9657595,
    "longitude": 77.767773,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sunflower+Spa/data=!4m7!3m6!1s0x3bae0de886cea23d:0x5f2495f2922684f3!8m2!3d12.9657595!4d77.767773!16s%2Fg%2F11y6jj805x!19sChIJPaLOhugNrjsR84QmkvKVJF8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sunshine-salon-spa",
    "name": "Sunshine salon & SPA",
    "description": "Highly rated beauty spa in Marathahalli with excellent reviews and professional service.",
    "address": "4, 2nd floor, SAS complex Siddapura-Nallurahalli Marathahalli, Road, near Hanuman Temple",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Marathahalli",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 16,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9586195,
    "longitude": 77.7320328,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sunshine+salon+%26+SPA/data=!4m7!3m6!1s0x3bae132c997475c1:0xdd1bd4c9f33a079d!8m2!3d12.9586195!4d77.7320328!16s%2Fg%2F11y5q9hw0v!19sChIJwXV0mSwTrjsRnQc688nUG90?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "gm-bhavani-saloon-spa",
    "name": "GM Bhavani saloon & spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "XQ94+FQ3, Immadihalli Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 11,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.968642,
    "longitude": 77.756946,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/GM+Bhavani+saloon+%26+spa/data=!4m7!3m6!1s0x3bae0da542266c43:0xfc84ceb058791d09!8m2!3d12.968642!4d77.756946!16s%2Fg%2F11lcb_jcxd!19sChIJQ2wmQqUNrjsRCR15WLDOhPw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "princess-unisex-salon-and-spa",
    "name": "Princess Unisex Salon and Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 5,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9846857,
    "longitude": 77.547638,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Princess+Unisex+Salon+and+Spa/data=!4m7!3m6!1s0x3bae3d327131c34b:0xb5d28aa3720b124a!8m2!3d12.9846857!4d77.547638!16s%2Fg%2F11x7vj50_9!19sChIJS8MxcTI9rjsRShILcqOK0rU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vimoha-wellness-spa-hsr",
    "name": "Vimoha Wellness Spa HSR",
    "description": "Highly rated wellness spa in HSR Layout with excellent reviews and professional service.",
    "address": "318/296/6, 24th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 5,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9192818,
    "longitude": 77.6485844,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Vimoha+Wellness+Spa+HSR/data=!4m7!3m6!1s0x3bae154250aa0acb:0x4094b59bae017f58!8m2!3d12.9192818!4d77.6485844!16s%2Fg%2F11n3p_8h_5!19sChIJywqqUEIVrjsRWH8Brpu1lEA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "wild-fantasy-spa-hsr-layout-massage-near-me-spa-near-me-jacuzzi-spa",
    "name": "Wild Fantasy spa HSR Layout Massage near me Spa near me Jacuzzi Spa",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "19th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.8,
    "reviews_count": 4,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.913571,
    "longitude": 77.644732,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Wild+Fantasy+spa+HSR+Layout+Massage+near+me+Spa+near+me+Jacuzzi+Spa/data=!4m7!3m6!1s0x3bae15a05108bc2d:0x8de2f8969c29112f!8m2!3d12.913571!4d77.644732!16s%2Fg%2F11lyjfhkh4!19sChIJLbwIUaAVrjsRLxEpnJb44o0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "hair-speak-family-salon-hsr-layout",
    "name": "Hair Speak Family Salon, HSR Layout",
    "description": "Highly rated beauty spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 5755,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9118922,
    "longitude": 77.6379347,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Hair+Speak+Family+Salon,+HSR+Layout/data=!4m7!3m6!1s0x3bae1491c2bcff19:0x39556dd8491197e7!8m2!3d12.9118922!4d77.6379347!16s%2Fg%2F11b7g0s2l8!19sChIJGf-8wpEUrjsR55cRSdhtVTk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "hair-speak-family-salon",
    "name": "Hair Speak Family Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 4859,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9314006,
    "longitude": 77.5840538,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Hair+Speak+Family+Salon/data=!4m7!3m6!1s0x3bae15986d9bf071:0xbe06dae1c2e10fba!8m2!3d12.9314006!4d77.5840538!16s%2Fg%2F11cmccmcd8!19sChIJcfCbbZgVrjsRug_hwuHaBr4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "green-trends-unisex-salon-rt-nagar-bengaluru",
    "name": "Green Trends Unisex Salon, RT Nagar, Bengaluru",
    "description": "Highly rated beauty spa in RT Nagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "RT Nagar",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 4651,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 13.0190198,
    "longitude": 77.5924421,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Green+Trends+Unisex+Salon,+RT+Nagar,+Bengaluru/data=!4m7!3m6!1s0x3bae17b16c04cb69:0x99e2ee2b8d33f2d4!8m2!3d13.0190198!4d77.5924421!16s%2Fg%2F1v76y28_!19sChIJacsEbLEXrjsR1PIzjSvu4pk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "plum-sugar-salon-spa-hsr-layout",
    "name": "Plum & Sugar Salon & Spa - HSR Layout",
    "description": "Highly rated beauty spa in HSR Layout with excellent reviews and professional service.",
    "address": "1655, 27th Main Rd, opp. Nift College, nearby SBI Building",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 4005,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9112586,
    "longitude": 77.6517145,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Plum+%26+Sugar+Salon+%26+Spa+-+HSR+Layout/data=!4m7!3m6!1s0x3bae1482ef07fec5:0x14091382440dcbc4!8m2!3d12.9112586!4d77.6517145!16s%2Fg%2F11clyt6y8y!19sChIJxf4H74IUrjsRxMsNRIITCRQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vurve-salon-indira-nagar",
    "name": "Vurve Salon | Indira Nagar",
    "description": "Highly rated beauty spa in Indiranagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 3535,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9700992,
    "longitude": 77.6439391,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Vurve+Salon+%7C+Indira+Nagar/data=!4m7!3m6!1s0x3bae16a823700001:0x72a69a9bbd45ee77!8m2!3d12.9700992!4d77.6439391!16s%2Fg%2F11hbq9btc7!19sChIJAQBwI6gWrjsRd-5FvZuapnI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bounce-koramangala-unisex-salon",
    "name": "Bounce Koramangala Unisex Salon",
    "description": "Highly rated beauty spa in Koramangala with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 3182,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9401188,
    "longitude": 77.6197881,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bounce+Koramangala+Unisex+Salon/data=!4m7!3m6!1s0x3bae144607e62f11:0x7e9cd1c391b36520!8m2!3d12.9401188!4d77.6197881!16s%2Fg%2F1hdzpy45x!19sChIJES_mB0YUrjsRIGWzkcPRnH4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "green-s-unisex-salon-and-spa",
    "name": "Green's Unisex Salon and Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 2087,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9086128,
    "longitude": 77.6492436,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Green%27s+Unisex+Salon+and+Spa/data=!4m7!3m6!1s0x3bae156408ad0015:0x7271b5acfd878cd2!8m2!3d12.9086128!4d77.6492436!16s%2Fg%2F11fn8yxv76!19sChIJFQCtCGQVrjsR0oyH_ay1cXI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spin-salon-rt-nagar-bengaluru",
    "name": "Spin Salon | RT Nagar, Bengaluru",
    "description": "Highly rated beauty spa in RT Nagar with excellent reviews and professional service.",
    "address": "No 582, CBI Road, 4th Main Rd, above Brahmins Thatte Idly",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "RT Nagar",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 2029,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 13.0267212,
    "longitude": 77.5921317,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spin+Salon+%7C+RT+Nagar,+Bengaluru/data=!4m7!3m6!1s0x3bae17bbb59f1665:0x80b8c87edf4eda24!8m2!3d13.0267212!4d77.5921317!16s%2Fg%2F11gfnf97r0!19sChIJZRaftbsXrjsRJNpO337IuIA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "jean-claude-biguine-salon-spa-koramangala",
    "name": "Jean-Claude Biguine Salon & Spa, Koramangala",
    "description": "Highly rated beauty spa in Koramangala with excellent reviews and professional service.",
    "address": "2nd Floor, 115TH Road, opp. Raheja Arcade, above Starbucks",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 1645,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.935237,
    "longitude": 77.6134969,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Jean-Claude+Biguine+Salon+%26+Spa,+Koramangala/data=!4m7!3m6!1s0x3bae144de30dcb6b:0x8bf91f78dd640324!8m2!3d12.935237!4d77.6134969!16s%2Fg%2F11b775yc3m!19sChIJa8sN400UrjsRJANk3Xgf-Ys?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "lakme-salon-in-richmond-road-bengaluru",
    "name": "Lakme Salon in Richmond Road,Bengaluru",
    "description": "Highly rated beauty spa in Richmond Road with excellent reviews and professional service.",
    "address": "No 85, Sheriff House, Richmond Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Richmond Road",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 1598,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9652632,
    "longitude": 77.6029215,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Lakme+Salon+in+Richmond+Road,Bengaluru/data=!4m7!3m6!1s0x3bae15d5c7d273ed:0xbd141ad02534fef8!8m2!3d12.9652632!4d77.6029215!16s%2Fg%2F1tjf8q2q!19sChIJ7XPSx9UVrjsR-P40JdAaFL0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "lakme-salon-for-him-and-her-in-malleshwaram-15th-cross-bengaluru",
    "name": "Lakme Salon For Him and Her in Malleshwaram 15th Cross,Bengaluru",
    "description": "Highly rated beauty spa in Malleshwaram with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Malleshwaram",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 1421,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 13.0056988,
    "longitude": 77.5691439,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Lakme+Salon+For+Him+and+Her+in+Malleshwaram+15th+Cross,Bengaluru/data=!4m7!3m6!1s0x3bae162c1e11604d:0xe538b0ee229ef9af!8m2!3d13.0056988!4d77.5691439!16s%2Fg%2F11b8jd1m4r!19sChIJTWARHiwWrjsRr_meIu6wOOU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-zen-aura-spa-sarjapur-rd",
    "name": "The Zen Aura Spa (Sarjapur Rd)",
    "description": "Highly rated day spa in Sarjapur Road with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Sarjapur Road",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 1282,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.912047,
    "longitude": 77.6826345,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Zen+Aura+Spa+%28Sarjapur+Rd%29/data=!4m7!3m6!1s0x3bae1376dd6f54c5:0x6accf7641c7c0cdd!8m2!3d12.912047!4d77.6826345!16s%2Fg%2F12qgckx9t!19sChIJxVRv3XYTrjsR3Qx8HGT3zGo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "og-spa-and-salon",
    "name": "OG SPA AND SALON",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 1265,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9350407,
    "longitude": 77.6091787,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/OG+SPA+AND+SALON/data=!4m7!3m6!1s0x3bae15745b0c0389:0x181915f526cb84d7!8m2!3d12.9350407!4d77.6091787!16s%2Fg%2F11h1zf4ycs!19sChIJiQMMW3QVrjsR14TLJvUVGRg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ylg-salon-sadashiva-nagar",
    "name": "YLG Salon / Sadashiva Nagar",
    "description": "Highly rated beauty spa in Sadashivanagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Sadashivanagar",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 1236,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 13.007236,
    "longitude": 77.579551,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/YLG+Salon+%2F+Sadashiva+Nagar/data=!4m7!3m6!1s0x3bae16346dfe29f3:0x76b7e87fcbd59423!8m2!3d13.007236!4d77.579551!16s%2Fg%2F11c4670_vr!19sChIJ8yn-bTQWrjsRI5TVy3_ot3Y?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "enrich-salon-sadashiv-nagar",
    "name": "Enrich Salon Sadashiv Nagar",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "32/A, Opp Vibes, 8th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 1084,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 13.0092403,
    "longitude": 77.5808313,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Enrich+Salon+Sadashiv+Nagar/data=!4m7!3m6!1s0x3bae17d2e8483da1:0xfbf7bdec1b6602b7!8m2!3d13.0092403!4d77.5808313!16s%2Fg%2F11fqt8dm8k!19sChIJoT1I6NIXrjsRtwJmG-y99_s?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "avyang-health-care-best-spa-in-koramangala",
    "name": "Avyang Health Care - BEST SPA in Koramangala",
    "description": "Highly rated day spa in Koramangala with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 991,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.93875,
    "longitude": 77.623901,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Avyang+Health+Care+-+BEST+SPA+in+Koramangala/data=!4m7!3m6!1s0x3bae14446c7f85c9:0x43b8e7969bdccf34!8m2!3d12.93875!4d77.623901!16s%2Fg%2F11c37l53yw!19sChIJyYV_bEQUrjsRNM_cm5bnuEM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "aura-international-thai-spa-best-spa-in-kalyan-nagar",
    "name": "Aura International Thai Spa - Best Spa In Kalyan Nagar",
    "description": "Highly rated thai spa in Kalyan Nagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Kalyan Nagar",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 984,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 13.0217465,
    "longitude": 77.6372596,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Aura+International+Thai+Spa+-+Best+Spa+In+Kalyan+Nagar/data=!4m7!3m6!1s0x3bae17f448eeab9f:0xc3f278a620c2dedd!8m2!3d13.0217465!4d77.6372596!16s%2Fg%2F11t6ywyv_2!19sChIJn6vuSPQXrjsR3d7CIKZ48sM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "naturals-unisex-salon-and-spa",
    "name": "Naturals unisex salon and spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 922,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9992531,
    "longitude": 77.5496384,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Naturals+unisex+salon+and+spa/data=!4m7!3m6!1s0x3bae3d9aa612c5cd:0x861c1c25b22ca59!8m2!3d12.9992531!4d77.5496384!16s%2Fg%2F1ptyl7rqw!19sChIJzcUSppo9rjsRWcoiW8LBYQg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-palette-sadashivnagar",
    "name": "The Palette Sadashivnagar",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "1st floor, A S orchids, sadhashivnagar, 74, 1st Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 883,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 13.0057168,
    "longitude": 77.5788586,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Palette+Sadashivnagar/data=!4m7!3m6!1s0x3bae17482e16f41d:0x274d2f8f2fa00a23!8m2!3d13.0057168!4d77.5788586!16s%2Fg%2F11h0twqkbw!19sChIJHfQWLkgXrjsRIwqgL48vTSc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ponytail-unisex-salon-spa",
    "name": "Ponytail Unisex Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 800,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9037454,
    "longitude": 77.6500121,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ponytail+Unisex+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae15ccaa3fc359:0x693fe8b6f8680e2c!8m2!3d12.9037454!4d77.6500121!16s%2Fg%2F11fhxj0hjp!19sChIJWcM_qswVrjsRLA5o-LboP2k?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "aveda-x-nykaa-lifestyle-salon",
    "name": "Aveda x Nykaa Lifestyle Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "AVEDA X NYKAA LIFESTYLE SALON SITE, 112, 27th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 736,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9104534,
    "longitude": 77.6520398,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Aveda+x+Nykaa+Lifestyle+Salon/data=!4m7!3m6!1s0x3bae152f0b4472a9:0xe87a47da137f1f97!8m2!3d12.9104534!4d77.6520398!16s%2Fg%2F11q3ln116y!19sChIJqXJECy8VrjsRlx9_E9pHeug?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "herbal-ground-spa-best-spa-in-electronic-city-phase-2",
    "name": "Herbal Ground Spa - Best Spa In Electronic city Phase 2",
    "description": "Highly rated day spa in Electronic City with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Electronic City",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 678,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.844623,
    "longitude": 77.6746181,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Herbal+Ground+Spa+-+Best+Spa+In+Electronic+city+Phase+2/data=!4m7!3m6!1s0x3bae6d77f136b49b:0x8041e1512a04fe8e!8m2!3d12.844623!4d77.6746181!16s%2Fg%2F11vq_ks4nv!19sChIJm7Q28XdtrjsRjv4EKlHhQYA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "newyork-newyork-unisex-studio-salon-nyny",
    "name": "Newyork Newyork Unisex Studio & Salon (NYNY)",
    "description": "Highly rated beauty spa in Domlur with excellent reviews and professional service.",
    "address": "3155, 1st floor, Srinivasan Towers 1st Main Road Defence Colony, Domlur, above Suryavanshi Restaurant",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Domlur",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 602,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9702814,
    "longitude": 77.6358756,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Newyork+Newyork+Unisex+Studio+%26+Salon+%28NYNY%29/data=!4m7!3m6!1s0x3bae16a0b77b5c61:0xbafc49fa98065e5!8m2!3d12.9702814!4d77.6358756!16s%2Fg%2F11f32dv3p7!19sChIJYVx7t6AWrjsR5WWAqZ_Erws?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ayushman-ayurveda-ayurveda-hospital-for-back-pain-joint-pain-arthritis-in-guttahalli-sadashiva-nagar-bangalore",
    "name": "Ayushman Ayurveda \u2013 Ayurveda Hospital for Back Pain, Joint Pain & Arthritis in Guttahalli, Sadashiva Nagar, Bangalore",
    "description": "Highly rated ayurvedic spa in Sadashivanagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Sadashivanagar",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 586,
    "spa_type": "Ayurvedic Spa",
    "services": [
      "Abhyanga",
      "Shirodhara",
      "Panchakarma",
      "Pizhichil",
      "Kerala Massage",
      "Ayurvedic Facial"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9992805,
    "longitude": 77.57901,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ayushman+Ayurveda+%E2%80%93+Ayurveda+Hospital+for+Back+Pain,+Joint+Pain+%26+Arthritis+in+Guttahalli,+Sadashiva+Nagar,+Bangalore/data=!4m7!3m6!1s0x3bae17e151369fb7:0xa06403fb32749f20!8m2!3d12.9992805!4d77.57901!16s%2Fg%2F11f5vdgsxq!19sChIJt582UeEXrjsRIJ90MvsDZKA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "scent-salon-palm-meadows-whitefield",
    "name": "Scent Salon | Palm Meadows Whitefield",
    "description": "Highly rated beauty spa in Whitefield with excellent reviews and professional service.",
    "address": "XP5R+P76, No. 3/3, Ramaiah building, Palm Meadows, Boulevard, Varthur Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 556,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.959185,
    "longitude": 77.7406216,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Scent+Salon+%7C+Palm+Meadows+Whitefield/data=!4m7!3m6!1s0x3bae12093c173e17:0xa0dc4058f7c31adc!8m2!3d12.959185!4d77.7406216!16s%2Fg%2F11bzt3qpv5!19sChIJFz4XPAkSrjsR3BrD91hA3KA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "page-studio-unisex-saloon-academy",
    "name": "Page studio unisex saloon & academy",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 553,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 13.0507082,
    "longitude": 77.6087197,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Page+studio+unisex+saloon+%26+academy/data=!4m7!3m6!1s0x3bae177aaea361f7:0x232f201f6e838c5a!8m2!3d13.0507082!4d77.6087197!16s%2Fg%2F11fkdfzdz6!19sChIJ92GjrnoXrjsRWoyDbh8gLyM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "shathayu-ayurveda-clinic-rajaji-nagar",
    "name": "Shathayu Ayurveda Clinic Rajaji Nagar",
    "description": "Highly rated ayurvedic spa in Rajajinagar with excellent reviews and professional service.",
    "address": "313, 5th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Rajajinagar",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 535,
    "spa_type": "Ayurvedic Spa",
    "services": [
      "Abhyanga",
      "Shirodhara",
      "Panchakarma",
      "Pizhichil",
      "Kerala Massage",
      "Ayurvedic Facial"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 13.0039281,
    "longitude": 77.5446495,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Shathayu+Ayurveda+Clinic+Rajaji+Nagar/data=!4m7!3m6!1s0x3bae3d84f26b9d7d:0x9b039d760c413a10!8m2!3d13.0039281!4d77.5446495!16s%2Fg%2F11c609f28n!19sChIJfZ1r8oQ9rjsREDpBDHadA5s?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "meghavi-wellness-spa",
    "name": "Meghavi Wellness Spa",
    "description": "Highly rated wellness spa in Whitefield with excellent reviews and professional service.",
    "address": "2nd floor, 62, Whitefield Main Rd, next to Collage By Toscano",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 522,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9596677,
    "longitude": 77.7479193,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Meghavi+Wellness+Spa/data=!4m7!3m6!1s0x3bae0d4441916b9d:0x9a61bb17a05c7b51!8m2!3d12.9596677!4d77.7479193!16s%2Fg%2F11rhvyrr8m!19sChIJnWuRQUQNrjsRUXtcoBe7YZo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-meraki-whitefield",
    "name": "Spa Meraki (Whitefield)",
    "description": "Highly rated day spa in Whitefield with excellent reviews and professional service.",
    "address": "1st Floor, ASR Tower, 216, Whitefield Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 478,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9636332,
    "longitude": 77.7485366,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spa+Meraki+%28Whitefield%29/data=!4m7!3m6!1s0x3bae0d225de8e4e1:0xb47c3cc3b62abc19!8m2!3d12.9636332!4d77.7485366!16s%2Fg%2F11pm7dj236!19sChIJ4eToXSINrjsRGbwqtsM8fLQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "getlook-unisex-salon-hsr-layout",
    "name": "GetLook Unisex Salon HSR Layout",
    "description": "Highly rated beauty spa in HSR Layout with excellent reviews and professional service.",
    "address": "L377, 5th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 467,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9142079,
    "longitude": 77.6325242,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/GetLook+Unisex+Salon+HSR+Layout/data=!4m7!3m6!1s0x3bae150d7ffd4569:0x72dc715027a6771e!8m2!3d12.9142079!4d77.6325242!16s%2Fg%2F11vt5zyghy!19sChIJaUX9fw0VrjsRHnemJ1Bx3HI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "avantika-wellness-spa-foot-relax-btm-layout",
    "name": "Avantika Wellness Spa - Foot Relax | BTM Layout",
    "description": "Highly rated wellness spa in BTM Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "BTM Layout",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 413,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9136603,
    "longitude": 77.6075051,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Avantika+Wellness+Spa+-+Foot+Relax+%7C+BTM+Layout/data=!4m7!3m6!1s0x3bae15897063d8cd:0x5115436a3cdf3611!8m2!3d12.9136603!4d77.6075051!16s%2Fg%2F11gq5p3wpw!19sChIJzdhjcIkVrjsRETbfPGpDFVE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "neo-international-thai-spa-best-spa-in-electronic-city-international-luxury-spa",
    "name": "Neo International Thai Spa - best spa in Electronic City | international luxury spa",
    "description": "Highly rated thai spa in Electronic City with excellent reviews and professional service.",
    "address": "Oppsite, GM INFINITE, 30/29, Hulimangala Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Electronic City",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 411,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.8200071,
    "longitude": 77.6615238,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Neo+International+Thai+Spa+-+best+spa+in+Electronic+City+%7C+international+luxury+spa/data=!4m7!3m6!1s0x3bae6d3e00ba2543:0x77a80a9bedb56326!8m2!3d12.8200071!4d77.6615238!16s%2Fg%2F11vdnvd5kq!19sChIJQyW6AD5trjsRJmO17ZsKqHc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "shathayu-ayurveda-clinic-indiranagar",
    "name": "Shathayu Ayurveda Clinic Indiranagar",
    "description": "Highly rated ayurvedic spa in Indiranagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 401,
    "spa_type": "Ayurvedic Spa",
    "services": [
      "Abhyanga",
      "Shirodhara",
      "Panchakarma",
      "Pizhichil",
      "Kerala Massage",
      "Ayurvedic Facial"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9639914,
    "longitude": 77.6381435,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Shathayu+Ayurveda+Clinic+Indiranagar/data=!4m7!3m6!1s0x3bae140290d00b65:0xfeddea596c190167!8m2!3d12.9639914!4d77.6381435!16s%2Fg%2F1tdzv4nf!19sChIJZQvQkAIUrjsRZwEZbFnq3f4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "adya-wellness-spa",
    "name": "Adya Wellness Spa",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 372,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.898057,
    "longitude": 77.6185149,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Adya+Wellness+Spa/data=!4m7!3m6!1s0x3bae15106e308e45:0x67544824aaf6dae8!8m2!3d12.898057!4d77.6185149!16s%2Fg%2F11w9qjb7hr!19sChIJRY4wbhAVrjsR6Nr2qiRIVGc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-soul-bellandur",
    "name": "Spa Soul Bellandur",
    "description": "Highly rated day spa in Bellandur with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bellandur",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 359,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.920142,
    "longitude": 77.6671459,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spa+Soul+Bellandur/data=!4m7!3m6!1s0x3bae1372c34f74b1:0x5df25f03eedf9727!8m2!3d12.920142!4d77.6671459!16s%2Fg%2F11k9lm89r5!19sChIJsXRPw3ITrjsRJ5ff7gNf8l0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "shape-shine-beauty-salon-spa",
    "name": "Shape & Shine Beauty Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "45, Chowdeshwari N.Byamma Building Immadihalli Main Road Near Sri Rama Temple, Post",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 356,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9681357,
    "longitude": 77.7559212,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Shape+%26+Shine+Beauty+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae0d8f3ec148a1:0xfb54da4df76211c7!8m2!3d12.9681357!4d77.7559212!16s%2Fg%2F11s48_hx3j!19sChIJoUjBPo8NrjsRxxFi903aVPs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nova-international-thai-spa-best-spa-in-hulimavu-international-luxury-spa",
    "name": "Nova International Thai Spa - best spa in Hulimavu | international luxury spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd Floor, Karthikeya Arcade, 4th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 349,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.8764989,
    "longitude": 77.6070909,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nova+International+Thai+Spa+-+best+spa+in+Hulimavu+%7C+international+luxury+spa/data=!4m7!3m6!1s0x3bae6bb3cabd362d:0xdcc4b796196207fe!8m2!3d12.8764989!4d77.6070909!16s%2Fg%2F11w3kx3d8g!19sChIJLTa9yrNrrjsR_gdiGZa3xNw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-treats",
    "name": "Spa Treats",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "XHRC+M3W, 1, Sampige Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 344,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9917728,
    "longitude": 77.5701981,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spa+Treats/data=!4m7!3m6!1s0x3bae172737a05f5b:0xb721f44ac44a14d6!8m2!3d12.9917728!4d77.5701981!16s%2Fg%2F11r_xxx3t9!19sChIJW1-gNycXrjsR1hRKxEr0Ibc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "adhara-international-spa",
    "name": "Adhara International Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 327,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9162651,
    "longitude": 77.6135643,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Adhara+International+Spa/data=!4m7!3m6!1s0x3bae150bdf1b6189:0xb0575f1520498374!8m2!3d12.9162651!4d77.6135643!16s%2Fg%2F11k9z68mw1!19sChIJiWEb3wsVrjsRdINJIBVfV7A?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "footworks-jayanagar-best-foot-reflexology-stress-relief",
    "name": "Footworks Jayanagar - Best Foot Reflexology | Stress Relief",
    "description": "Highly rated day spa in Jayanagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 316,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9373363,
    "longitude": 77.5846031,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Footworks+Jayanagar+-+Best+Foot+Reflexology+%7C+Stress+Relief/data=!4m7!3m6!1s0x3bae15961f30b7f9:0x528c44a8d035eac1!8m2!3d12.9373363!4d77.5846031!16s%2Fg%2F11fyxbjs92!19sChIJ-bcwH5YVrjsRweo10KhEjFI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "maya-international-spa-hsr-layout-bangalore",
    "name": "Maya international spa HSR layout Bangalore",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "1542 . 7th cross, 19th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 313,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9196872,
    "longitude": 77.645175,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Maya+international+spa+HSR+layout+Bangalore/data=!4m7!3m6!1s0x3bae152ee4467607:0x244038aaa629fc5e!8m2!3d12.9196872!4d77.645175!16s%2Fg%2F11vxh8k3yv!19sChIJB3ZG5C4VrjsRXvwppqo4QCQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "havana-the-salon-indiranagar-for-your-beauty",
    "name": "Havana the Salon | Indiranagar | for your Beauty",
    "description": "Highly rated beauty spa in Indiranagar with excellent reviews and professional service.",
    "address": "1st Floor, 1155, 12th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 283,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9701897,
    "longitude": 77.6433962,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Havana+the+Salon+%7C+Indiranagar+%7C+for+your+Beauty/data=!4m7!3m6!1s0x3bae17a8c6d3f931:0x77f4e94980e162e1!8m2!3d12.9701897!4d77.6433962!16s%2Fg%2F11p5l6b7j4!19sChIJMfnTxqgXrjsR4WLhgEnp9Hc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "viva-spa",
    "name": "Viva Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 280,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9833092,
    "longitude": 77.6403269,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Viva+Spa/data=!4m7!3m6!1s0x3bae1735101174fd:0x9a15a6649c92dfcd!8m2!3d12.9833092!4d77.6403269!16s%2Fg%2F11vqn9vyh1!19sChIJ_XQREDUXrjsRzd-SnGSmFZo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "revive-style-family-salon",
    "name": "Revive & Style family salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "1309, 25th Main Rd, near Bangalore Central",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 272,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9181433,
    "longitude": 77.5925091,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Revive+%26+Style+family+salon/data=!4m7!3m6!1s0x3bae153fde393327:0x50ff25039b1287fc!8m2!3d12.9181433!4d77.5925091!16s%2Fg%2F11lh3dq4v6!19sChIJJzM53j8VrjsR_IcSmwMl_1A?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bodhi-wellness-spa",
    "name": "Bodhi Wellness Spa",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 269,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9144326,
    "longitude": 77.6325416,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bodhi+Wellness+Spa/data=!4m7!3m6!1s0x3bae15cb4d828499:0x8fb664d20f4523c4!8m2!3d12.9144326!4d77.6325416!16s%2Fg%2F11p15lwpv_!19sChIJmYSCTcsVrjsRxCNFD9Jkto8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "crystal-thai-spa-new-bel-road",
    "name": "Crystal Thai Spa New Bel Road",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 263,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 13.0385539,
    "longitude": 77.5645772,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Crystal+Thai+Spa+New+Bel+Road/data=!4m7!3m6!1s0x3bae17e1709d98eb:0x4a5e7ff83fb668ca!8m2!3d13.0385539!4d77.5645772!16s%2Fg%2F11kk641118!19sChIJ65idcOEXrjsRymi2P_h_Xko?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "urban-serene-unisex-salon-n-spa",
    "name": "Urban Serene Unisex Salon N' Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Pattandur Agrahara Chandrodaya Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 256,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.985173,
    "longitude": 77.7444345,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Urban+Serene+Unisex+Salon+N%27+Spa/data=!4m7!3m6!1s0x3bae0fcf65bf86cb:0x449ece9795c04721!8m2!3d12.985173!4d77.7444345!16s%2Fg%2F11krccmbgf!19sChIJy4a_Zc8PrjsRIUfAlZfOnkQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "kerala-ayurveda-multi-speciality-clinic",
    "name": "Kerala Ayurveda Multi Speciality Clinic",
    "description": "Highly rated ayurvedic spa in Bangalore with excellent reviews and professional service.",
    "address": "452, 7th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 236,
    "spa_type": "Ayurvedic Spa",
    "services": [
      "Abhyanga",
      "Shirodhara",
      "Panchakarma",
      "Pizhichil",
      "Kerala Massage",
      "Ayurvedic Facial"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9275018,
    "longitude": 77.5819482,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Kerala+Ayurveda+Multi+Speciality+Clinic/data=!4m7!3m6!1s0x3bae159ed5b5bcc1:0xce61f78bd503cfd5!8m2!3d12.9275018!4d77.5819482!16s%2Fg%2F11bzzz1h24!19sChIJwby11Z4VrjsR1c8D1Yv3Yc4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "s-ence-spa",
    "name": "S'ence Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 234,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9269038,
    "longitude": 77.5861674,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/S%27ence+Spa/data=!4m7!3m6!1s0x3bae15873b186183:0x3d8288b461db88c7!8m2!3d12.9269038!4d77.5861674!16s%2Fg%2F11fr11zf_4!19sChIJg2EYO4cVrjsRx4jbYbSIgj0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vanity-fayre-salon-spa",
    "name": "Vanity Fayre Salon & Spa",
    "description": "Highly rated beauty spa in Whitefield with excellent reviews and professional service.",
    "address": "1st floor, Oasis Club, Whitefield Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 232,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9599153,
    "longitude": 77.7500195,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Vanity+Fayre+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae0df6db03357d:0x558e045c36db0451!8m2!3d12.9599153!4d77.7500195!16s%2Fg%2F11c61j3d79!19sChIJfTUD2_YNrjsRUQTbNlwEjlU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "aaroh-thai-spa-electronic-city",
    "name": "Aaroh Thai Spa Electronic city",
    "description": "Highly rated thai spa in Electronic City with excellent reviews and professional service.",
    "address": "3rd floor, pub building, Fire station, Neeladri Rd, opp. to kotak mahindra bank",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Electronic City",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 230,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.8415284,
    "longitude": 77.6473708,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Aaroh+Thai+Spa+Electronic+city/data=!4m7!3m6!1s0x3bae6be61dedc127:0xccfface108c0294e!8m2!3d12.8415284!4d77.6473708!16s%2Fg%2F11kjzb14bb!19sChIJJ8HtHeZrrjsRTinACOGs_8w?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "page-spa",
    "name": "PAGE SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "No.213/C, 1st Floor, swaroopa, 28th Cross Road",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 224,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9952179,
    "longitude": 77.5517907,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/PAGE+SPA/data=!4m7!3m6!1s0x3bae3db804eebb7b:0x9c4322776095e03b!8m2!3d12.9952179!4d77.5517907!16s%2Fg%2F11y1cf158_!19sChIJe7vuBLg9rjsRO-CVYHciQ5w?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "de-stress-luxury-spa-in-madiwala",
    "name": "De-Stress Luxury Spa in Madiwala",
    "description": "Highly rated day spa in Madiwala with excellent reviews and professional service.",
    "address": "#1202, 1203, Maruthi Nagar Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Madiwala",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 222,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9230212,
    "longitude": 77.6143641,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/De-Stress+Luxury+Spa+in+Madiwala/data=!4m7!3m6!1s0x3bae15b995fea8f9:0xae3c2bf7023c204d!8m2!3d12.9230212!4d77.6143641!16s%2Fg%2F11g0_gbm23!19sChIJ-aj-lbkVrjsRTSA8AvcrPK4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "infinity-international-thai-spa-hennur-kothanur-bangalore",
    "name": "Infinity International Thai Spa - Hennur Kothanur Bangalore",
    "description": "Highly rated thai spa in Hennur with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Hennur",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 210,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 13.0711508,
    "longitude": 77.6518226,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Infinity+International+Thai+Spa+-+Hennur+Kothanur+Bangalore/data=!4m7!3m6!1s0x3bae194c121126db:0xb9ee5a6c2b592abe!8m2!3d13.0711508!4d77.6518226!16s%2Fg%2F11sb01l39l!19sChIJ2yYREkwZrjsRvipZK2xa7rk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "marie-claire-paris-salon-margosa-road-malleswaram",
    "name": "Marie Claire Paris Salon Margosa Road, Malleswaram",
    "description": "Highly rated beauty spa in Malleshwaram with excellent reviews and professional service.",
    "address": "No. 58/1, 1st floor, 13th Cross, Margosa Rd, near City Union Bank",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Malleshwaram",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 205,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 13.0038918,
    "longitude": 77.5692315,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Marie+Claire+Paris+Salon+Margosa+Road,+Malleswaram/data=!4m7!3m6!1s0x3bae17a327443761:0x8029db1525a53bb7!8m2!3d13.0038918!4d77.5692315!16s%2Fg%2F11lygf5tbd!19sChIJYTdEJ6MXrjsRtzulJRXbKYA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "green-day-spa-phase-7",
    "name": "Green Day Spa - Phase 7",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 187,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.8883357,
    "longitude": 77.5802086,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Green+Day+Spa+-+Phase+7/data=!4m7!3m6!1s0x3bae1545380a0af9:0x75a4d43ddb5cc1a6!8m2!3d12.8883357!4d77.5802086!16s%2Fg%2F11s7fx13k2!19sChIJ-QoKOEUVrjsRpsFc2z3UpHU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ananda-international-spa",
    "name": "Ananda International Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "120, 14th Main Rd, near HDFC bank",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 176,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9162821,
    "longitude": 77.6380896,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ananda+International+Spa/data=!4m7!3m6!1s0x3bae15975a5fb615:0xc66f3480e4e918!8m2!3d12.9162821!4d77.6380896!16s%2Fg%2F11vylhsf7s!19sChIJFbZfWpcVrjsRGOnkgDRvxgA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "wow-unisex-salon-and-spa-spa-near-electronic-city",
    "name": "Wow Unisex Salon and Spa | Spa Near Electronic City",
    "description": "Highly rated beauty spa in Electronic City with excellent reviews and professional service.",
    "address": "1st Floor, No. 78/5, Bettadasanapura Main Rd, next to HP Petrol Bunk",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Electronic City",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 168,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.8428082,
    "longitude": 77.6406061,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Wow+Unisex+Salon+and+Spa+%7C+Spa+Near+Electronic+City/data=!4m7!3m6!1s0x3bae6b4de60861a3:0xf10052d2a9044f86!8m2!3d12.8428082!4d77.6406061!16s%2Fg%2F11y4n5mdpx!19sChIJo2EI5k1rrjsRhk8EqdJSAPE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bellance-salon-whitefield-bengaluru",
    "name": "Bellance Salon - Whitefield, Bengaluru",
    "description": "Highly rated beauty spa in Whitefield with excellent reviews and professional service.",
    "address": "Survey No.14, Sumadhura Capitol Towers, Unit14, Tower2, 158, Taluk",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 162,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9844699,
    "longitude": 77.7507708,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bellance+Salon+-+Whitefield,+Bengaluru/data=!4m7!3m6!1s0x3bae0feb96abf2b1:0x497a14f335e63ec8!8m2!3d12.9844699!4d77.7507708!16s%2Fg%2F11yfz5pr1m!19sChIJsfKrlusPrjsRyD7mNfMUekk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "aura-thai-spa-hulimavu-bangalore",
    "name": "Aura Thai spa - Hulimavu Bangalore",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 151,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.8812503,
    "longitude": 77.6098526,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Aura+Thai+spa+-+Hulimavu+Bangalore/data=!4m7!3m6!1s0x3bae15195d1d2969:0xad52ef0f123329d6!8m2!3d12.8812503!4d77.6098526!16s%2Fg%2F11sg_l8s4y!19sChIJaSkdXRkVrjsR1ikzEg_vUq0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bellona-spa-in-btm-layout",
    "name": "Bellona Spa in Btm Layout",
    "description": "Highly rated day spa in BTM Layout with excellent reviews and professional service.",
    "address": "Om plaza, 7/8, 1st Floor, 20th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "BTM Layout",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 145,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9191855,
    "longitude": 77.6129593,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bellona+Spa+in+Btm+Layout/data=!4m7!3m6!1s0x3bae15d67b923b99:0xeaa4be1fc206b74!8m2!3d12.9191855!4d77.6129593!16s%2Fg%2F11s6794t8c!19sChIJmTuSe9YVrjsRdGsg_OFLqg4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nahum-international-thai-spa-indiranagar-spa-near-me-jacuzzi-steam",
    "name": "Nahum International Thai Spa Indiranagar | Spa Near Me | Jacuzzi & Steam",
    "description": "Highly rated thai spa in Indiranagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 135,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9704546,
    "longitude": 77.6447337,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nahum+International+Thai+Spa+Indiranagar+%7C+Spa+Near+Me+%7C+Jacuzzi+%26+Steam/data=!4m7!3m6!1s0x3bae1737fdf9d5ad:0xa8efd8d0de32ef56!8m2!3d12.9704546!4d77.6447337!16s%2Fg%2F11x6hr7hn2!19sChIJrdX5_TcXrjsRVu8y3tDY76g?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sahara-international-spa-banglore",
    "name": "Sahara International Spa banglore",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "80 Feet Rd, above Madhurama hotel",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 132,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9813831,
    "longitude": 77.6461829,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sahara+International+Spa+banglore/data=!4m7!3m6!1s0x3bae17ae7f1cb2c3:0xb9eac0f1227c1320!8m2!3d12.9813831!4d77.6461829!16s%2Fg%2F11y2bzzzq_!19sChIJw7Icf64XrjsRIBN8IvHA6rk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "isa-spa-hopefarm-whitefield",
    "name": "Isa Spa Hopefarm Whitefield",
    "description": "Highly rated day spa in Whitefield with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 121,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9820258,
    "longitude": 77.7579473,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Isa+Spa+Hopefarm+Whitefield/data=!4m7!3m6!1s0x678b080da2e0f651:0xe50c7ed3e9669314!8m2!3d12.9820258!4d77.7579473!16s%2Fg%2F11vdmwr5hv!19sChIJUfbgog0Ii2cRFJNm6dN-DOU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "divine-spa-in-hsr-layout-massage-spa-in-hsr-layout",
    "name": "Divine Spa in HSR Layout - Massage Spa in HSR Layout",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 120,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9165256,
    "longitude": 77.6519514,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Divine+Spa+in+HSR+Layout+-+Massage+Spa+in+HSR+Layout/data=!4m7!3m6!1s0x3bae15d14139e63b:0x3360ce4d1e21a6!8m2!3d12.9165256!4d77.6519514!16s%2Fg%2F11x912jjxm!19sChIJO-Y5QdEVrjsRpiEeTc5gMwA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "adi-spa-by-flw",
    "name": "adi spa by FLW",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 112,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9569426,
    "longitude": 77.7325841,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/adi+spa+by+FLW/data=!4m7!3m6!1s0x3bae1188db6bcfeb:0xfd5845884a7c223f!8m2!3d12.9569426!4d77.7325841!16s%2Fg%2F11fxzsgm0l!19sChIJ689r24gRrjsRPyJ8SohFWP0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sea3-salon-and-spa",
    "name": "Sea3 Salon and Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Sea3 Salon And Spa, 1ST floor, vinayakanagar hagadur main road, post Hagadhur road, opposite hp petrol pump",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 111,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9642298,
    "longitude": 77.7539315,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sea3+Salon+and+Spa/data=!4m7!3m6!1s0x3bae0dba223280a1:0x674fbeef0f4cae8a!8m2!3d12.9642298!4d77.7539315!16s%2Fg%2F11vdz9l0sw!19sChIJoYAyIroNrjsRiq5MD---T2c?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "pride-thai-spa-massage-spa-indiranagar-bengaluru",
    "name": "Pride Thai Spa - Massage Spa Indiranagar Bengaluru",
    "description": "Highly rated thai spa in Indiranagar with excellent reviews and professional service.",
    "address": "24, Chinmaya Mission Hospital Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 108,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9783618,
    "longitude": 77.6352366,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Pride+Thai+Spa+-+Massage+Spa+Indiranagar+Bengaluru/data=!4m7!3m6!1s0x3bae179106be50c3:0x12ef37292edb70ff!8m2!3d12.9783618!4d77.6352366!16s%2Fg%2F11vb0w7ydd!19sChIJw1C-BpEXrjsR_3DbLik37xI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "too-yoo-spa-by-tattva-wellness-spa",
    "name": "Too Yoo Spa by Tattva Wellness Spa",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "No 93, The Pride Hotel, Richmond Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 106,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9650662,
    "longitude": 77.5997982,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Too+Yoo+Spa+by+Tattva+Wellness+Spa/data=!4m7!3m6!1s0x3bae15ae514fdaf1:0x4bac4de5b287672b!8m2!3d12.9650662!4d77.5997982!16s%2Fg%2F11y46xmgry!19sChIJ8dpPUa4VrjsRK2eHsuVNrEs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "aarna-thai-spa-best-spa-in-jayanagar-spa-near-jayanagar",
    "name": "Aarna Thai Spa | Best Spa in Jayanagar | Spa Near Jayanagar",
    "description": "Highly rated thai spa in Jayanagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 101,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9294244,
    "longitude": 77.5855195,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Aarna+Thai+Spa+%7C+Best+Spa+in+Jayanagar+%7C+Spa+Near+Jayanagar/data=!4m7!3m6!1s0x3bae15d9d217bd05:0xfec14404733b7cd1!8m2!3d12.9294244!4d77.5855195!16s%2Fg%2F11s1w5_38q!19sChIJBb0X0tkVrjsR0Xw7cwREwf4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "woolly-spa",
    "name": "Woolly spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 98,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9771311,
    "longitude": 77.6388783,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Woolly+spa/data=!4m7!3m6!1s0x3bae179a2041f48f:0x8ea56a709e8b9638!8m2!3d12.9771311!4d77.6388783!16s%2Fg%2F11rhstf1jd!19sChIJj_RBIJoXrjsROJaLnnBqpY4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "kimayaa-spa-salon",
    "name": "Kimayaa Spa & Salon",
    "description": "Highly rated beauty spa in Sankey Road with excellent reviews and professional service.",
    "address": "Lower Palace Orchards, Sankey Rd, above Kotak Bank",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Sankey Road",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 95,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 13.0052471,
    "longitude": 77.5804741,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Kimayaa+Spa+%26+Salon/data=!4m7!3m6!1s0x3bae17e12ee5935d:0x9848655eae440b99!8m2!3d13.0052471!4d77.5804741!16s%2Fg%2F11l2ws44jx!19sChIJXZPlLuEXrjsRmQtErl5lSJg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ispa",
    "name": "iSpa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "2011, 100 Feet Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 92,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9655108,
    "longitude": 77.6417659,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/iSpa/data=!4m7!3m6!1s0x3bae15b6cfd4a821:0x3e7313a0f5f39822!8m2!3d12.9655108!4d77.6417659!16s%2Fg%2F11fkvywmns!19sChIJIajUz7YVrjsRIpjz9aATcz4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "green-wild-salon-day-spa",
    "name": "Green Wild Salon & Day Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Shop No. 837, First Floor, 26th Main, 11th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 87,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9174135,
    "longitude": 77.6514137,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Green+Wild+Salon+%26+Day+Spa/data=!4m7!3m6!1s0x3bae15196beb0685:0x1fd293e47eeb1d56!8m2!3d12.9174135!4d77.6514137!16s%2Fg%2F11vkbgx_hr!19sChIJhQbraxkVrjsRVh3rfuST0h8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "royal-blue-unisex-saloon-and-spa",
    "name": "Royal blue unisex saloon and spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 80,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.993899,
    "longitude": 77.5394186,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Royal+blue+unisex+saloon+and+spa/data=!4m7!3m6!1s0x3bae3d340578fc19:0x6de90e8da98f916b!8m2!3d12.993899!4d77.5394186!16s%2Fg%2F11kqffhhxd!19sChIJGfx4BTQ9rjsRa5GPqY0O6W0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "meridian-international-spa",
    "name": "Meridian International Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "621, 12th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 74,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9705617,
    "longitude": 77.6469837,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Meridian+International+Spa/data=!4m7!3m6!1s0x3bae17e7ccc25fd3:0xf93a3e9d106d38e8!8m2!3d12.9705617!4d77.6469837!16s%2Fg%2F11x6vpf7rt!19sChIJ01_CzOcXrjsR6DhtEJ0-Ovk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "atya-thai-spa-massage-spa-in-domlur-bangalore",
    "name": "Atya Thai Spa - Massage Spa in Domlur Bangalore",
    "description": "Highly rated thai spa in Domlur with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Domlur",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 73,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9674608,
    "longitude": 77.6366599,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Atya+Thai+Spa+-+Massage+Spa+in+Domlur+Bangalore/data=!4m7!3m6!1s0x3bae15a4eda9613d:0x24a9d332b990133f!8m2!3d12.9674608!4d77.6366599!16s%2Fg%2F11wc1rpjk0!19sChIJPWGp7aQVrjsRPxOQuTLTqSQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "international-b2b-with-happy-ending-spa-hsr-layout-bangalore",
    "name": "International b2b with happy ending spa HSR layout Bangalore",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 73,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9151677,
    "longitude": 77.599626,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/International+b2b+with+happy+ending+spa+HSR+layout+Bangalore/data=!4m7!3m6!1s0x3bae15940ae4a791:0xa4936857e0e4a580!8m2!3d12.9151677!4d77.599626!16s%2Fg%2F11vx6pddqt!19sChIJkafkCpQVrjsRgKXk4Fdok6Q?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ritviz-the-thai-spa",
    "name": "Ritviz The Thai Spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "27th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 62,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9192045,
    "longitude": 77.651666,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ritviz+The+Thai+Spa/data=!4m7!3m6!1s0x3bae150ec58a967d:0x59e329a921d5a8f1!8m2!3d12.9192045!4d77.651666!16s%2Fg%2F11khkkz1_p!19sChIJfZaKxQ4VrjsR8ajVIakp41k?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-lemon-grass-spa",
    "name": "The Lemon Grass Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Shree Krishna Classy, 46/1, 1st Floor, Above Poorvika Mobiles Pillar No.62, Service Road, Hosur Rd, opp. Sai Baba Temple",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 59,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.8923489,
    "longitude": 77.6383454,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Lemon+Grass+Spa/data=!4m7!3m6!1s0x3bae150485fb1b23:0x26d1600d11d39058!8m2!3d12.8923489!4d77.6383454!16s%2Fg%2F11xcxxcwjn!19sChIJIxv7hQQVrjsRWJDTEQ1g0SY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "aluna-thai-spa-electronic-city",
    "name": "Aluna Thai Spa Electronic City",
    "description": "Highly rated thai spa in Electronic City with excellent reviews and professional service.",
    "address": "51/16, Grand falcon hotel building, Doddathogur Road, Near Velankani Tecch Park",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Electronic City",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 58,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.8504532,
    "longitude": 77.65766,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Aluna+Thai+Spa+Electronic+City/data=!4m7!3m6!1s0x3bae6d41dbd14e3f:0x9750c7581ec53143!8m2!3d12.8504532!4d77.65766!16s%2Fg%2F11ldy9_s0z!19sChIJP07R20FtrjsRQzHFHljHUJc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "buddha-blessing-spa",
    "name": "Buddha Blessing SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "metro station, next to TCS office, near Pattandur Agrahara",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 44,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9874956,
    "longitude": 77.7390099,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Buddha+Blessing+SPA/data=!4m7!3m6!1s0x3bae1102a3a57ca5:0x1e3999c64befcc38!8m2!3d12.9874956!4d77.7390099!16s%2Fg%2F11vb5d04hr!19sChIJpXylowIRrjsROMzvS8aZOR4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "glowish-beauty-and-wellness-electronic-city",
    "name": "Glowish Beauty and Wellness Electronic City",
    "description": "Highly rated beauty spa in Electronic City with excellent reviews and professional service.",
    "address": "Gollahalli Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Electronic City",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 39,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.8299366,
    "longitude": 77.6651077,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Glowish+Beauty+and+Wellness+Electronic+City/data=!4m7!3m6!1s0x3bae6d0f324d43fb:0x6321ee0b2116ff8d!8m2!3d12.8299366!4d77.6651077!16s%2Fg%2F11qfyfyx_3!19sChIJ-0NNMg9trjsRjf8WIQvuIWM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-meraki-koramangala",
    "name": "Spa Meraki (Koramangala)",
    "description": "Highly rated day spa in Koramangala with excellent reviews and professional service.",
    "address": "427, 80 Feet Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 39,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9417723,
    "longitude": 77.6233853,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spa+Meraki+%28Koramangala%29/data=!4m7!3m6!1s0x3bae150002592c87:0x74e5f804dd4bae1f!8m2!3d12.9417723!4d77.6233853!16s%2Fg%2F11mrdh4nm5!19sChIJhyxZAgAVrjsRH65L3QT45XQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nian-therapy-centre",
    "name": "Nian Therapy Centre",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd Floor, 90, 1st A Main Rd, near Central Mall",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 38,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 13.0950391,
    "longitude": 77.5833163,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nian+Therapy+Centre/data=!4m7!3m6!1s0x3bae15ecd027b741:0x43b87787b12862ee!8m2!3d13.0950391!4d77.5833163!16s%2Fg%2F11vzg07w_9!19sChIJQbcn0OwVrjsR7mIosYd3uEM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "mysa-spa-in-whitefield",
    "name": "Mysa Spa In Whitefield",
    "description": "Highly rated day spa in Whitefield with excellent reviews and professional service.",
    "address": "Shop No.201, 2RD FLOOR, Near Hope Farm Circle, ITPL Main Rd, above Bank of Baroda Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 37,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9844831,
    "longitude": 77.7495576,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Mysa+Spa+In+Whitefield/data=!4m7!3m6!1s0x3bae0ffbd5329655:0x33ccd071cf705e4a!8m2!3d12.9844831!4d77.7495576!16s%2Fg%2F11mywlkb4x!19sChIJVZYy1fsPrjsRSl5wz3HQzDM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "royal-massage",
    "name": "Royal Massage",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "59, 10th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 34,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9886391,
    "longitude": 77.5560989,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Royal+Massage/data=!4m7!3m6!1s0x3bae3d8667cac891:0x784eb92bdf01fdc!8m2!3d12.9886391!4d77.5560989!16s%2Fg%2F11vyfgmvs2!19sChIJkcjKZ4Y9rjsR3B_wvZLrhAc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "summerhill-spa-sadashiva-nagar",
    "name": "Summerhill Spa Sadashiva Nagar",
    "description": "Highly rated day spa in Sadashivanagar with excellent reviews and professional service.",
    "address": "384/1-1-2, 1st Floor, 13th Main Rd, adjacent Sankey Tank Trail",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Sadashivanagar",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 34,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 13.0068545,
    "longitude": 77.5789639,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Summerhill+Spa+Sadashiva+Nagar/data=!4m7!3m6!1s0x3bae17de2fb279a7:0x2c3a1f11d6321014!8m2!3d13.0068545!4d77.5789639!16s%2Fg%2F11xt5khbjk!19sChIJp3myL94XrjsRFBAy1hEfOiw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "js-unisex-saloon-and-spa",
    "name": "JS unisex saloon and spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "1328, 24th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 30,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9039709,
    "longitude": 77.6490005,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/JS+unisex+saloon+and+spa/data=!4m7!3m6!1s0x3bae152d29732c6d:0x24c1a9421e92625c!8m2!3d12.9039709!4d77.6490005!16s%2Fg%2F11l6wvkl35!19sChIJbSxzKS0VrjsRXGKSHkKpwSQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "namaste-day-spa-couple-massage-spa-bangalore",
    "name": "Namaste Day Spa Couple Massage Spa Bangalore",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "WJPH+Q64, 20th L Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 27,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.936889,
    "longitude": 77.628086,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Namaste+Day+Spa+Couple+Massage+Spa+Bangalore/data=!4m7!3m6!1s0x3bae1578b8d780f7:0x7a1d4ab62f0f948c!8m2!3d12.936889!4d77.628086!16s%2Fg%2F11vt8891wk!19sChIJ94DXuHgVrjsRjJQPL7ZKHXo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "shathayu-ayur-spa-and-salon-best-spa-in-koramangala",
    "name": "Shathayu Ayur Spa and Salon | Best Spa in Koramangala",
    "description": "Highly rated beauty spa in Koramangala with excellent reviews and professional service.",
    "address": "1st Floor, Sri Vari Plaza, No,1000",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 27,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9298883,
    "longitude": 77.6332735,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Shathayu+Ayur+Spa+and+Salon+%7C+Best+Spa+in+Koramangala/data=!4m7!3m6!1s0x3bae15347b8c5e69:0x5a8807de3e86848f!8m2!3d12.9298883!4d77.6332735!16s%2Fg%2F11w83fn3pt!19sChIJaV6MezQVrjsRj4SGPt4HiFo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "heaven-dreams-unisex-salon-and-spa",
    "name": "Heaven dreams unisex salon and spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "1st floor, chinnakutamma temple road, 110/1.9, Nagondanahalli Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 25,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9748831,
    "longitude": 77.7694531,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Heaven+dreams+unisex+salon+and+spa/data=!4m7!3m6!1s0x3bae0dc347a54695:0x801737bacac28a5d!8m2!3d12.9748831!4d77.7694531!16s%2Fg%2F11wx0t_7_y!19sChIJlUalR8MNrjsRXYrCyro3F4A?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "jk-luxury-spa",
    "name": "JK Luxury Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "2633, 1st Floor, Above Sketchers Showroom, 13th Cross, 27th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 21,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.915707,
    "longitude": 77.651578,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/JK+Luxury+Spa/data=!4m7!3m6!1s0x3bae150b0a64a9d3:0x8de732319e7e18e!8m2!3d12.915707!4d77.651578!16s%2Fg%2F11xv_3jfg5!19sChIJ06lkCgsVrjsRjuHnGSNz3gg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-anantara-the-wellness",
    "name": "Spa Anantara - The Wellness",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "No. 133/1 2nd floor 10th Main Road, 14th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 21,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9141592,
    "longitude": 77.6355542,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spa+Anantara+-+The+Wellness/data=!4m7!3m6!1s0x3bae156ab4a40153:0x3ab2b3eab23004dd!8m2!3d12.9141592!4d77.6355542!16s%2Fg%2F11vb0sxkky!19sChIJUwGktGoVrjsR3QQwsuqzsjo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "relax-couple-day-spa-hsr-layout-bangalore",
    "name": "Relax Couple Day Spa HSR Layout Bangalore",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "Opulence Home Decor Palazzo",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 19,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9194592,
    "longitude": 77.6452709,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Relax+Couple+Day+Spa+HSR+Layout+Bangalore/data=!4m7!3m6!1s0x3bae1500560cc32d:0x704814d0b49ad462!8m2!3d12.9194592!4d77.6452709!16s%2Fg%2F11y4h6yg9q!19sChIJLcMMVgAVrjsRYtSatNAUSHA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "benaka-spa",
    "name": "Benaka Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 19,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9080535,
    "longitude": 77.6350293,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Benaka+Spa/data=!4m7!3m6!1s0x3bae154b699ff9cb:0xa3b103f2a58c7ebf!8m2!3d12.9080535!4d77.6350293!16s%2Fg%2F11ybb7hq4d!19sChIJy_mfaUsVrjsRv36MpfIDsaM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "relief-zone-ayurvedic-wellness-centre",
    "name": "Relief Zone Ayurvedic Wellness Centre",
    "description": "Highly rated ayurvedic spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 16,
    "spa_type": "Ayurvedic Spa",
    "services": [
      "Abhyanga",
      "Shirodhara",
      "Panchakarma",
      "Pizhichil",
      "Kerala Massage",
      "Ayurvedic Facial"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9130785,
    "longitude": 77.6090396,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Relief+Zone+Ayurvedic+Wellness+Centre/data=!4m7!3m6!1s0x3bae1530ab89428b:0x82926b0f0215bc9f!8m2!3d12.9130785!4d77.6090396!16s%2Fg%2F11yrljtcsl!19sChIJi0KJqzAVrjsRn7wVAg9rkoI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "olive-ayurvedic-center-male-to-male-rt-nagar",
    "name": "Olive Ayurvedic Center Male to Male - Rt Nagar",
    "description": "Highly rated ayurvedic spa in RT Nagar with excellent reviews and professional service.",
    "address": "12, Shalom Villa, 3rd Main Road, 6th Cross Road, Khm Block",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "RT Nagar",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 16,
    "spa_type": "Ayurvedic Spa",
    "services": [
      "Abhyanga",
      "Shirodhara",
      "Panchakarma",
      "Pizhichil",
      "Kerala Massage",
      "Ayurvedic Facial"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 13.0228702,
    "longitude": 77.5913529,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Olive+Ayurvedic+Center+Male+to+Male+-+Rt+Nagar/data=!4m7!3m6!1s0x3bae1747db893aa1:0x1f0b5345d80fe812!8m2!3d13.0228702!4d77.5913529!16s%2Fg%2F11yhkc_j3l!19sChIJoTqJ20cXrjsREugP2EVTCx8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "apta-wellness-spa-best-spa-in-koramangala",
    "name": "Apta Wellness Spa |Best spa in koramangala",
    "description": "Highly rated wellness spa in Koramangala with excellent reviews and professional service.",
    "address": "982, 80 Feet Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 15,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9349,
    "longitude": 77.629165,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Apta+Wellness+Spa+%7CBest+spa+in+koramangala/data=!4m7!3m6!1s0x3bae1500321cd423:0x742326f48e66659b!8m2!3d12.9349!4d77.629165!16s%2Fg%2F11y4tkf3bl!19sChIJI9QcMgAVrjsRm2VmjvQmI3Q?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "your-nuru-spa",
    "name": "Your nuru spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "4, 20th L Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 15,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9367899,
    "longitude": 77.6287679,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Your+nuru+spa/data=!4m7!3m6!1s0x3bae1532c693a655:0xa119c7ba56df06e5!8m2!3d12.9367899!4d77.6287679!16s%2Fg%2F11srk4t348!19sChIJVaaTxjIVrjsR5QbfVrrHGaE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "prakruthi-thai-spa-electronic-city",
    "name": "Prakruthi Thai SPA Electronic City",
    "description": "Highly rated thai spa in Electronic City with excellent reviews and professional service.",
    "address": "1024, first floor ,shop no-2, 1st Cross 60feet Main road, Ananth Nagar Rd opp. to vishal Mega mart, kammasandra",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Electronic City",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 14,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.8356651,
    "longitude": 77.6912115,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Prakruthi+Thai+SPA+Electronic+City/data=!4m7!3m6!1s0x3bae6de20d0c9fe3:0x64f9de12d97e335d!8m2!3d12.8356651!4d77.6912115!16s%2Fg%2F11x6jzbyfj!19sChIJ458MDeJtrjsRXTN-2RLe-WQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ansun-saloon-spa",
    "name": "ANSUN Saloon Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "62, 18th Cross, Margosa Rd, behind HDFC Bank",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 14,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 13.0082605,
    "longitude": 77.5689019,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/ANSUN+Saloon+Spa/data=!4m7!3m6!1s0x3bae17aa1d8003c9:0x7f49c97a3520f2dc!8m2!3d13.0082605!4d77.5689019!16s%2Fg%2F11gjt998fk!19sChIJyQOAHaoXrjsR3PIgNXrJSX8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "royal-orchid-unisex-salon-spa",
    "name": "Royal Orchid Unisex Salon & Spa",
    "description": "Highly rated beauty spa in ITPL with excellent reviews and professional service.",
    "address": "2nd Floor, ITPL Back Gate Road, above Carry Mart",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "ITPL",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 13,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9723181,
    "longitude": 77.7341251,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Royal+Orchid+Unisex+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae11306283f71f:0xb330a34677c130c8!8m2!3d12.9723181!4d77.7341251!16s%2Fg%2F11qwxtqkwx!19sChIJH_eDYjARrjsRyDDBd0ajMLM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "maira-luxury-spa",
    "name": "Maira Luxury Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "No 618, 1st floor, 12th Main Rd, above Simpli Namdhari store",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 9,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9705185,
    "longitude": 77.6465127,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Maira+Luxury+Spa/data=!4m7!3m6!1s0x3bae170b80e598c7:0x6b40ea74ebd5fc4b!8m2!3d12.9705185!4d77.6465127!16s%2Fg%2F11fpz98qtx!19sChIJx5jlgAsXrjsRS_zV63TqQGs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "royal-b2b-spa",
    "name": "Royal B2B Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "22nd Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 6,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9090541,
    "longitude": 77.6474154,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Royal+B2B+Spa/data=!4m7!3m6!1s0x3bae1526d71a2523:0xa9bc54f6c8622198!8m2!3d12.9090541!4d77.6474154!16s%2Fg%2F11yv1nmqj4!19sChIJIyUa1yYVrjsRmCFiyPZUvKk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "green-lotus-beauty-spa-in-bangalore",
    "name": "Green Lotus beauty spa in Bangalore",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "3rd phase, 332, 3rd Main Rd, opposite to Hotel Soude Ole",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 3,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9923721,
    "longitude": 77.5460451,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Green+Lotus+beauty+spa+in+Bangalore/data=!4m7!3m6!1s0x3bae3dbc9b8880a1:0x60e95f08f678693a!8m2!3d12.9923721!4d77.5460451!16s%2Fg%2F11kqzlffrl!19sChIJoYCIm7w9rjsROml49ghf6WA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nature-spa-wellness-centre",
    "name": "Nature Spa & Wellness Centre",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "Narayana Health City Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.7,
    "reviews_count": 3,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.8066466,
    "longitude": 77.697965,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nature+Spa+%26+Wellness+Centre/data=!4m7!3m6!1s0x3bae6d4d8db9ad09:0x67c957986f487428!8m2!3d12.8066466!4d77.697965!16s%2Fg%2F11ssbzdgnh!19sChIJCa25jU1trjsRKHRIb5hXyWc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bodycraft-salon-spa-clinic-jayanagar",
    "name": "Bodycraft Salon, Spa & Clinic - Jayanagar",
    "description": "Highly rated beauty spa in Jayanagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 4431,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9422684,
    "longitude": 77.5856236,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bodycraft+Salon,+Spa+%26+Clinic+-+Jayanagar/data=!4m7!3m6!1s0x3bae15bfdbe9afa5:0xdc7bdd936c1b6421!8m2!3d12.9422684!4d77.5856236!16s%2Fg%2F1tdcdtlg!19sChIJpa_p278VrjsRIWQbbJPde9w?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "green-trends-unisex-hair-and-style-salon-malleshwaram",
    "name": "Green Trends Unisex Hair And Style Salon - Malleshwaram",
    "description": "Highly rated beauty spa in Malleshwaram with excellent reviews and professional service.",
    "address": "Shop No. 123, Margosa Road, 13th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Malleshwaram",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 4083,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 13.0035257,
    "longitude": 77.5691394,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Green+Trends+Unisex+Hair+And+Style+Salon+-+Malleshwaram/data=!4m7!3m6!1s0x3bae162e966e3ec1:0x91d0dec8a42199f3!8m2!3d13.0035257!4d77.5691394!16s%2Fg%2F1264bfpt_!19sChIJwT5uli4WrjsR85khpMje0JE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bodycraft-salon-spa-clinic-jp-nagar",
    "name": "Bodycraft Salon, Spa & Clinic - JP Nagar",
    "description": "Highly rated beauty spa in JP Nagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "JP Nagar",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 2906,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9069027,
    "longitude": 77.5999709,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bodycraft+Salon,+Spa+%26+Clinic+-+JP+Nagar/data=!4m7!3m6!1s0x3bae151bb74a0da1:0x2723a76f94cb11dd!8m2!3d12.9069027!4d77.5999709!16s%2Fg%2F11c2lqx9ph!19sChIJoQ1KtxsVrjsR3RHLlG-nIyc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bounce-salon-spa-indiranagar-call-us-on-8925836675",
    "name": "Bounce Salon & Spa, Indiranagar ( Call Us On :- 8925836675)",
    "description": "Highly rated beauty spa in Indiranagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 2857,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9705121,
    "longitude": 77.6452834,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bounce+Salon+%26+Spa,+Indiranagar+%28+Call+Us+On+:-+8925836675%29/data=!4m7!3m6!1s0x3bae16a9cdd6df0b:0x397e063af488785a!8m2!3d12.9705121!4d77.6452834!16s%2Fg%2F11b7stf7dm!19sChIJC9_WzakWrjsRWniI9DoGfjk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "green-trends-hebbal-kempapura-coffee-board-layout",
    "name": "Green Trends - Hebbal, Kempapura [Coffee Board Layout]",
    "description": "Highly rated day spa in Hebbal with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Hebbal",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 2767,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 13.0531395,
    "longitude": 77.6042117,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Green+Trends+-+Hebbal,+Kempapura+%5BCoffee+Board+Layout%5D/data=!4m7!3m6!1s0x3bae1786afb72ab3:0xc99225718a58f0e6!8m2!3d13.0531395!4d77.6042117!16s%2Fg%2F11bv6pwlvq!19sChIJsyq3r4YXrjsR5vBYinElksk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ylg-salon-hsr-layout-sector-6-hsr2",
    "name": "YLG Salon / HSR Layout Sector 6 (HSR2)",
    "description": "Highly rated beauty spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 2302,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9136637,
    "longitude": 77.6354441,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/YLG+Salon+%2F+HSR+Layout+Sector+6+%28HSR2%29/data=!4m7!3m6!1s0x3bae148deea81043:0x856ba7db03b163f3!8m2!3d12.9136637!4d77.6354441!16s%2Fg%2F11byvs46fx!19sChIJQxCo7o0UrjsR82OxA9una4U?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bounce-salon-spa-whitefield",
    "name": "Bounce Salon & Spa, Whitefield.",
    "description": "Highly rated beauty spa in Whitefield with excellent reviews and professional service.",
    "address": "14/3, Balraj Arcade, Whitefield Main Rd, near Forum Value Mall",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 2298,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9621166,
    "longitude": 77.7480245,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bounce+Salon+%26+Spa,+Whitefield./data=!4m7!3m6!1s0x3bae0df79d5a8533:0x4f6ea54dd23b303e!8m2!3d12.9621166!4d77.7480245!16s%2Fg%2F11c0rq1zqb!19sChIJM4VanfcNrjsRPjA70k2lbk8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "green-trends-unisex-hair-style-salon-jayanagar",
    "name": "Green Trends Unisex Hair & Style Salon - Jayanagar",
    "description": "Highly rated beauty spa in Jayanagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 1970,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9328128,
    "longitude": 77.582765,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Green+Trends+Unisex+Hair+%26+Style+Salon+-+Jayanagar/data=!4m7!3m6!1s0x3bae1599d4f24547:0x582955cf82710758!8m2!3d12.9328128!4d77.582765!16s%2Fg%2F11sg5ql7lk!19sChIJR0Xy1JkVrjsRWAdxgs9VKVg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bodycraft-salon-spa-clinic-lavelle-road",
    "name": "Bodycraft Salon, Spa & Clinic - Lavelle Road",
    "description": "Highly rated beauty spa in Lavelle Road with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Lavelle Road",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 1728,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9716426,
    "longitude": 77.598361,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bodycraft+Salon,+Spa+%26+Clinic+-+Lavelle+Road/data=!4m7!3m6!1s0x3bae167997db9b29:0x4dde4015d453c2cd!8m2!3d12.9716426!4d77.598361!16s%2Fg%2F11g9gz9n2h!19sChIJKZvbl3kWrjsRzcJT1BVA3k0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "d5n-koramangala",
    "name": "D5N koramangala",
    "description": "Highly rated day spa in Koramangala with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 1469,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9339406,
    "longitude": 77.6298184,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/D5N+koramangala/data=!4m7!3m6!1s0x3bae15b6f73cc17b:0xf271098e32a5e4a8!8m2!3d12.9339406!4d77.6298184!16s%2Fg%2F11fgkd_5d3!19sChIJe8E897YVrjsRqOSlMo4JcfI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bounce-salon-spa-hsr-layout-call-8925836678",
    "name": "Bounce Salon & Spa, HSR Layout (Call: 8925836678)",
    "description": "Highly rated beauty spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 1450,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9105628,
    "longitude": 77.6519722,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bounce+Salon+%26+Spa,+HSR+Layout+%28Call:+8925836678%29/data=!4m7!3m6!1s0x3bae15d93764f72f:0x30a9bd37d039b121!8m2!3d12.9105628!4d77.6519722!16s%2Fg%2F11ghnymhlz!19sChIJL_dkN9kVrjsRIbE50De9qTA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "envi-salon-spa-orion-bridgade-mall-rajaji-nagar",
    "name": "Envi Salon & Spa - Orion Bridgade Mall, Rajaji Nagar",
    "description": "Highly rated beauty spa in Rajajinagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Rajajinagar",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 1215,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 13.0109678,
    "longitude": 77.5549596,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Envi+Salon+%26+Spa+-+Orion+Bridgade+Mall,+Rajaji+Nagar/data=!4m7!3m6!1s0x3bae3d720b4e5dd7:0x2023cee7c519ea47!8m2!3d13.0109678!4d77.5549596!16s%2Fg%2F11r3l8xxph!19sChIJ111OC3I9rjsRR-oZxefOIyA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "limelite-salon-spa",
    "name": "Limelite Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 1098,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9263326,
    "longitude": 77.5868149,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Limelite+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae15a02161f147:0x6769d9ddf002eb54!8m2!3d12.9263326!4d77.5868149!16s%2Fg%2F1td0lg1s!19sChIJR_FhIaAVrjsRVOsC8N3ZaWc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bodycraft-salon-spa-clinic-basaveshwar-nagar",
    "name": "Bodycraft Salon, Spa & Clinic - Basaveshwar Nagar",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Shop 469, Second & third Flr, Block Extension West of Dr Siddaiah, Siddhaiah Puranik Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 1025,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9953287,
    "longitude": 77.5400094,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bodycraft+Salon,+Spa+%26+Clinic+-+Basaveshwar+Nagar/data=!4m7!3m6!1s0x3bae3dcdc19d0557:0xb9eccf63d0600bdc!8m2!3d12.9953287!4d77.5400094!16s%2Fg%2F11l799t5mk!19sChIJVwWdwc09rjsR3Atg0GPP7Lk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "naturals-unisex-salon-kempapura-bengaluru",
    "name": "Naturals Unisex Salon Kempapura , Bengaluru",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 999,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 13.0492379,
    "longitude": 77.6035378,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Naturals+Unisex+Salon+Kempapura+,+Bengaluru/data=!4m7!3m6!1s0x3bae17d2cb67020f:0xa7e33cd5e8a5bb14!8m2!3d13.0492379!4d77.6035378!16s%2Fg%2F11f8fwxlfd!19sChIJDwJny9IXrjsRFLul6NU846c?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "naturals-salon",
    "name": "Naturals Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 713,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9858195,
    "longitude": 77.5541034,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Naturals+Salon/data=!4m7!3m6!1s0x3bae3d22bc3ad6eb:0x6957714a888082b6!8m2!3d12.9858195!4d77.5541034!16s%2Fg%2F11hyz_k78n!19sChIJ69Y6vCI9rjsRtoKAiEpxV2k?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bodycraft-salon-spa-clinic-itpl-main-road",
    "name": "Bodycraft Salon, Spa & Clinic- ITPL Main Road",
    "description": "Highly rated beauty spa in ITPL with excellent reviews and professional service.",
    "address": "Shop 190, ITPL Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "ITPL",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 598,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9924042,
    "longitude": 77.7183281,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bodycraft+Salon,+Spa+%26+Clinic-+ITPL+Main+Road/data=!4m7!3m6!1s0x3bae11b9b5634cd3:0xf342be708406e580!8m2!3d12.9924042!4d77.7183281!16s%2Fg%2F11w9xvkmrb!19sChIJ00xjtbkRrjsRgOUGhHC-QvM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "cut-style-salon-hsr-layout-bengaluru",
    "name": "CUT&STYLE Salon - HSR Layout, Bengaluru",
    "description": "Highly rated beauty spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 483,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9088865,
    "longitude": 77.6455697,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/CUT%26STYLE+Salon+-+HSR+Layout,+Bengaluru/data=!4m7!3m6!1s0x3bae153ab7eecdff:0xd848f769ae02f460!8m2!3d12.9088865!4d77.6455697!16s%2Fg%2F11tmhmpqrx!19sChIJ_83utzoVrjsRYPQCrmn3SNg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "care-spa",
    "name": "Care Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 469,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9166628,
    "longitude": 77.5947218,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Care+Spa/data=!4m7!3m6!1s0x3bae15d4cafc3969:0x93c5dd77185f6659!8m2!3d12.9166628!4d77.5947218!16s%2Fg%2F11j4v87jmx!19sChIJaTn8ytQVrjsRWWZfGHfdxZM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "fiori-spa-best-spa-in-koramangala-spa-near-koramangala",
    "name": "Fiori Spa | Best Spa in Koramangala | Spa Near Koramangala",
    "description": "Highly rated day spa in Koramangala with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 460,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9367882,
    "longitude": 77.6183924,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Fiori+Spa+%7C+Best+Spa+in+Koramangala+%7C+Spa+Near+Koramangala/data=!4m7!3m6!1s0x3bae144f9b10fecd:0x4ec21450b2d510d2!8m2!3d12.9367882!4d77.6183924!16s%2Fg%2F11hbbsl2bd!19sChIJzf4Qm08UrjsR0hDVslAUwk4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "passion-venustas-beauty-salon-and-spa",
    "name": "Passion Venustas Beauty Salon and Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 401,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 13.0528828,
    "longitude": 77.6041873,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Passion+Venustas+Beauty+Salon+and+Spa/data=!4m7!3m6!1s0x3bae1786afb72ab3:0x4fd04e5e6a3618e6!8m2!3d13.0528828!4d77.6041873!16s%2Fg%2F11c3n1km2z!19sChIJsyq3r4YXrjsR5hg2al5O0E8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nirmaya-spa-madiwala-btm-layout",
    "name": "Nirmaya Spa Madiwala BTM Layout",
    "description": "Highly rated day spa in BTM Layout with excellent reviews and professional service.",
    "address": "1st floor, Hosur Rd, next to bajaj showroom, near ayyappa temple",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "BTM Layout",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 333,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9256436,
    "longitude": 77.6171857,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nirmaya+Spa+Madiwala+BTM+Layout/data=!4m7!3m6!1s0x3bae1528e241e627:0x7e462582e50c9bd!8m2!3d12.9256436!4d77.6171857!16s%2Fg%2F11nsvccnlz!19sChIJJ-ZB4igVrjsRvclQLlhi5Ac?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "thalassa-spa",
    "name": "Thalassa Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "No.22, 2nd Floor, New BEL Rd, next to Nandana Palace Hotel",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 312,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 13.0329944,
    "longitude": 77.5692147,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Thalassa+Spa/data=!4m7!3m6!1s0x3bae17dd93a37f61:0x18a0b5d32d7965ab!8m2!3d13.0329944!4d77.5692147!16s%2Fg%2F11gglpcqgx!19sChIJYX-jk90XrjsRq2V5LdO1oBg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vedaearth-lounge-hsr-layout-women-s-spa-salon",
    "name": "Vedaearth Lounge- HSR Layout (Women's Spa & Salon)",
    "description": "Highly rated beauty spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 307,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.910855,
    "longitude": 77.6379504,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Vedaearth+Lounge-+HSR+Layout+%28Women%27s+Spa+%26+Salon%29/data=!4m7!3m6!1s0x3bae15701ec865b3:0x5a967b82ddc579cf!8m2!3d12.910855!4d77.6379504!16s%2Fg%2F11l388bfs4!19sChIJs2XIHnAVrjsRz3nF3YJ7llo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "shathayu-ayurveda-clinic-whitefield",
    "name": "Shathayu Ayurveda Clinic Whitefield",
    "description": "Highly rated ayurvedic spa in Whitefield with excellent reviews and professional service.",
    "address": "House No, 719, 1st Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 302,
    "spa_type": "Ayurvedic Spa",
    "services": [
      "Abhyanga",
      "Shirodhara",
      "Panchakarma",
      "Pizhichil",
      "Kerala Massage",
      "Ayurvedic Facial"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9636241,
    "longitude": 77.7138327,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Shathayu+Ayurveda+Clinic+Whitefield/data=!4m7!3m6!1s0x3bae0e0407986597:0x9bf6ad774f569698!8m2!3d12.9636241!4d77.7138327!16s%2Fg%2F1hf0fxj2_!19sChIJl2WYBwQOrjsRmJZWT3et9ps?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "oceanic-spa-in-hsr-layout",
    "name": "Oceanic Spa in HSR Layout",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 252,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9160476,
    "longitude": 77.6519016,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Oceanic+Spa+in+HSR+Layout/data=!4m7!3m6!1s0x3bae150226c9cd01:0xe01efe78e6b55412!8m2!3d12.9160476!4d77.6519016!16s%2Fg%2F11v9kq56k_!19sChIJAc3JJgIVrjsRElS15nj-HuA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "stunning-salon",
    "name": "STUNNING SALON",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 239,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9842539,
    "longitude": 77.5545407,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/STUNNING+SALON/data=!4m7!3m6!1s0x3bae3df057c330f9:0xa4504cb9b7074871!8m2!3d12.9842539!4d77.5545407!16s%2Fg%2F11bz_4b35j!19sChIJ-TDDV_A9rjsRcUgHt7lMUKQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sparadise-day-spa-bommanahalli",
    "name": "Sparadise Day Spa Bommanahalli",
    "description": "Highly rated day spa in Bommanahalli with excellent reviews and professional service.",
    "address": "Udupi Grand Building, 2nd Floor ,Bommanahalli Signal Hosur Road, Besides, Begur Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bommanahalli",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 216,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9073012,
    "longitude": 77.6284078,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sparadise+Day+Spa+Bommanahalli/data=!4m7!3m6!1s0x3bae153387f2f0a1:0x1db10c518138b260!8m2!3d12.9073012!4d77.6284078!16s%2Fg%2F11h0b8v94l!19sChIJofDyhzMVrjsRYLI4gVEMsR0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "green-day-spa-sanjayanagara",
    "name": "Green Day Spa Sanjayanagara",
    "description": "Highly rated day spa in Jayanagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 215,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 13.0371286,
    "longitude": 77.5750262,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Green+Day+Spa+Sanjayanagara/data=!4m7!3m6!1s0x3bae17731709b03b:0x9bbb40d9e9a4f686!8m2!3d13.0371286!4d77.5750262!16s%2Fg%2F11thpcv3zs!19sChIJO7AJF3MXrjsRhvak6dlAu5s?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "alora-luxury-unisex-salon-hsr-layout",
    "name": "Alora Luxury Unisex Salon - HSR Layout",
    "description": "Highly rated beauty spa in HSR Layout with excellent reviews and professional service.",
    "address": "No 86. 2nd Floor, Radhakrishnan Grand, 27th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 211,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9203048,
    "longitude": 77.6518538,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Alora+Luxury+Unisex+Salon+-+HSR+Layout/data=!4m7!3m6!1s0x3bae159eef6a0a8b:0x7a1a2158774e11e7!8m2!3d12.9203048!4d77.6518538!16s%2Fg%2F11rs2vqgbd!19sChIJiwpq754VrjsR5xFOd1ghGno?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sanjeevini-spa-electronic-city",
    "name": "Sanjeevini Spa Electronic City",
    "description": "Highly rated day spa in Electronic City with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Electronic City",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 201,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.8404586,
    "longitude": 77.6505307,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sanjeevini+Spa+Electronic+City/data=!4m7!3m6!1s0x3bae15146f897bbd:0xd3bcf22a1fd17997!8m2!3d12.8404586!4d77.6505307!16s%2Fg%2F11tbz1nd70!19sChIJvXuJbxQVrjsRl3nRHyryvNM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ghogi-spa-whitefield",
    "name": "Ghogi Spa - Whitefield",
    "description": "Highly rated day spa in Whitefield with excellent reviews and professional service.",
    "address": "2nd floor, 65 & 66, Whitefield Main Rd, above Anand sweets, opp. to Vijaya bank",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 197,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9680243,
    "longitude": 77.7500193,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ghogi+Spa+-+Whitefield/data=!4m7!3m6!1s0x3bae0d1955bc7dc3:0xeefd8a5281a323cb!8m2!3d12.9680243!4d77.7500193!16s%2Fg%2F11h8l3kws0!19sChIJw328VRkNrjsRyyOjgVKK_e4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "namma-thai-spa-best-thai-spa-in-bangalore",
    "name": "Namma Thai Spa - Best Thai SPA in Bangalore",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd floor, Vindhya Heights, 80, Sri M Visveswaraya Road, above Raymond showroom",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 182,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.8809072,
    "longitude": 77.6102462,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Namma+Thai+Spa+-+Best+Thai+SPA+in+Bangalore/data=!4m7!3m6!1s0x3bae15b8204eb9ad:0x7a1d09882ce21d!8m2!3d12.8809072!4d77.6102462!16s%2Fg%2F11hdpzjss8!19sChIJrblOILgVrjsRHeIsiAkdegA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nuru-bj-spa",
    "name": "Nuru Bj Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 181,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9149099,
    "longitude": 77.6001957,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nuru+Bj+Spa/data=!4m7!3m6!1s0x3bae151b9b83cb53:0xd707323888729ac3!8m2!3d12.9149099!4d77.6001957!16s%2Fg%2F11k54377bk!19sChIJU8uDmxsVrjsRw5pyiDgyB9c?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "thara-thai-spa-spa-near-jayanagar",
    "name": "Thara Thai Spa | Spa Near Jayanagar",
    "description": "Highly rated thai spa in Jayanagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 176,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9267181,
    "longitude": 77.5863778,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Thara+Thai+Spa+%7C+Spa+Near+Jayanagar/data=!4m7!3m6!1s0x3bae15c3dcdb2fd7:0x2a29c19dbcf96661!8m2!3d12.9267181!4d77.5863778!16s%2Fg%2F11j_66dc9k!19sChIJ1y_b3MMVrjsRYWb5vJ3BKSo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "midas-touch-spa-and-salon",
    "name": "MIDAS TOUCH SPA AND SALON",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "1st Floor, Zenstays PG",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 172,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.848084,
    "longitude": 77.6717526,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/MIDAS+TOUCH+SPA+AND+SALON/data=!4m7!3m6!1s0x3bae6d41fc2c0b6d:0xb3be31da2e61a910!8m2!3d12.848084!4d77.6717526!16s%2Fg%2F11fjs7gyxy!19sChIJbQss_EFtrjsREKlhLtoxvrM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "aqua-family-salon-and-spa",
    "name": "Aqua family salon and spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 166,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9854628,
    "longitude": 77.5964701,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Aqua+family+salon+and+spa/data=!4m7!3m6!1s0x3bae1668a02caae5:0x14e83fce7763a2a0!8m2!3d12.9854628!4d77.5964701!16s%2Fg%2F1pt_16fpv!19sChIJ5aosoGgWrjsRoKJjd84_6BQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "isa-spa-yelenahalli-begur",
    "name": "Isa Spa Yelenahalli Begur",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 165,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.8625028,
    "longitude": 77.6144983,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Isa+Spa+Yelenahalli+Begur/data=!4m7!3m6!1s0x3bae6b3281c6b8bb:0x731e790d737e1d23!8m2!3d12.8625028!4d77.6144983!16s%2Fg%2F11s9dk9zdl!19sChIJu7jGgTJrrjsRIx1-cw15HnM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "flaunt-salon-spa-ladies-only",
    "name": "Flaunt Salon & Spa-Ladies Only",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 144,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9222203,
    "longitude": 77.5894313,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Flaunt+Salon+%26+Spa-Ladies+Only/data=!4m7!3m6!1s0x3bae15a0a5b4303d:0xcfac81640faad126!8m2!3d12.9222203!4d77.5894313!16s%2Fg%2F11bxc7mbsq!19sChIJPTC0paAVrjsRJtGqD2SBrM8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "green-day-spa-banashankari",
    "name": "Green Day Spa - Banashankari",
    "description": "Highly rated day spa in Banashankari with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Banashankari",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 144,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9271169,
    "longitude": 77.5483788,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Green+Day+Spa+-+Banashankari/data=!4m7!3m6!1s0x3bae3f7dadde388b:0xcc138698b440e32!8m2!3d12.9271169!4d77.5483788!16s%2Fg%2F11jt0qs57h!19sChIJizjerX0_rjsRMg5Ei2k4wQw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "seven-days-spa-in-hsr-layout",
    "name": "Seven Days Spa In HSR Layout",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 142,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9066133,
    "longitude": 77.649166,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Seven+Days+Spa+In+HSR+Layout/data=!4m7!3m6!1s0x3bae15d32b171219:0xb09b200d5f999247!8m2!3d12.9066133!4d77.649166!16s%2Fg%2F11t6y57hwg!19sChIJGRIXK9MVrjsRR5KZXw0gm7A?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "home-massage-therapy",
    "name": "Home Massage Therapy",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Anugraha Complex, 91, M.S. Palya Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 141,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 13.0807994,
    "longitude": 77.5515751,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Home+Massage+Therapy/data=!4m7!3m6!1s0x3bae23b00388f2cd:0x5a62530984a1108a!8m2!3d13.0807994!4d77.5515751!16s%2Fg%2F11h51_j3rq!19sChIJzfKIA7AjrjsRihChhAlTYlo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "pure-thai-spa",
    "name": "Pure Thai Spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "No. 371, First Floor, 8th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 131,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 13.0090248,
    "longitude": 77.5807948,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Pure+Thai+Spa/data=!4m7!3m6!1s0x63e2202fa4687977:0x6e603b37dea23bd8!8m2!3d13.0090248!4d77.5807948!16s%2Fg%2F11v5f5bdcf!19sChIJd3lopC8g4mMR2Dui3jc7YG4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "green-day-spa-4th-block",
    "name": "Green Day Spa - 4th Block",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 131,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9358093,
    "longitude": 77.6262665,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Green+Day+Spa+-+4th+Block/data=!4m7!3m6!1s0x3bae15245dec2559:0x6b0347a79c505344!8m2!3d12.9358093!4d77.6262665!16s%2Fg%2F11s7ckz_v9!19sChIJWSXsXSQVrjsRRFNQnKdHA2s?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "royal-thai-spa-beauty-bar",
    "name": "Royal Thai spa & Beauty bar",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "1st Floor, 393, 13th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 124,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 13.0079808,
    "longitude": 77.5796559,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Royal+Thai+spa+%26+Beauty+bar/data=!4m7!3m6!1s0x3bae17f70bf1a2ff:0x167febceb766657f!8m2!3d13.0079808!4d77.5796559!16s%2Fg%2F11kw6yq5fq!19sChIJ_6LxC_cXrjsRf2Vmt87rfxY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nayan-international-thai-spa",
    "name": "Nayan International Thai Spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd floor, 1106/07, above kfc",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 121,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.8353091,
    "longitude": 77.6922862,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nayan+International+Thai+Spa/data=!4m7!3m6!1s0x3bae6dc0098b1305:0xec1a37ac0c6b8e64!8m2!3d12.8353091!4d77.6922862!16s%2Fg%2F11y5ngxqx9!19sChIJBROLCcBtrjsRZI5rDKw3Guw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-green-spa",
    "name": "The Green SPA.",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 120,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9669044,
    "longitude": 77.7618936,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Green+SPA./data=!4m7!3m6!1s0x3bae0d261458f1fd:0xbb525bff6c8a4854!8m2!3d12.9669044!4d77.7618936!16s%2Fg%2F11fmrmd99q!19sChIJ_fFYFCYNrjsRVEiKbP9bUrs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "shell-spa",
    "name": "SHELL SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "# 596/1",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 115,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9361996,
    "longitude": 77.6272804,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/SHELL+SPA/data=!4m7!3m6!1s0x3bae159557f4a41f:0xd17935855eb718e0!8m2!3d12.9361996!4d77.6272804!16s%2Fg%2F11g1pp6q88!19sChIJH6T0V5UVrjsR4Bi3XoU1edE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-follicle-salon-spa",
    "name": "The Follicle Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 112,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.8467524,
    "longitude": 77.6813738,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Follicle+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae6d65a61084a5:0x182c00cbe2a37e2a!8m2!3d12.8467524!4d77.6813738!16s%2Fg%2F11vjl6c3lj!19sChIJpYQQpmVtrjsRKn6j4ssALBg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "aditi-spa-and-salon",
    "name": "Aditi Spa and Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd floor, B-BLOCK, No.1036, 12th Main Road, above HDFC Bank",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 107,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.8789263,
    "longitude": 77.6382659,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Aditi+Spa+and+Salon/data=!4m7!3m6!1s0x3bae15365807dcc3:0x223abf61b6948c37!8m2!3d12.8789263!4d77.6382659!16s%2Fg%2F11y7wrzy_r!19sChIJw9wHWDYVrjsRN4yUtmG_OiI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "mj-beauty-salon-and-ayurvedic-spa",
    "name": "MJ Beauty salon and Ayurvedic Spa",
    "description": "Highly rated ayurvedic spa in Bannerghatta Road with excellent reviews and professional service.",
    "address": "3rd floor, SV Arcade, Bilekahalli Main road, Bangalore, Bannerghatta Rd, near Akshara Eye hospital",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bannerghatta Road",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 97,
    "spa_type": "Ayurvedic Spa",
    "services": [
      "Abhyanga",
      "Shirodhara",
      "Panchakarma",
      "Pizhichil",
      "Kerala Massage",
      "Ayurvedic Facial"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.8990284,
    "longitude": 77.6057468,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/MJ+Beauty+salon+and+Ayurvedic+Spa/data=!4m7!3m6!1s0x3bae15a47938bc89:0x23dbbc7c898536ad!8m2!3d12.8990284!4d77.6057468!16s%2Fg%2F11y1xkgh00!19sChIJibw4eaQVrjsRrTaFiXy82yM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "zion-spa-best-spa-in-banashankari-bangalore",
    "name": "Zion Spa | Best Spa in Banashankari Bangalore",
    "description": "Highly rated day spa in Banashankari with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Banashankari",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 95,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9247329,
    "longitude": 77.5512121,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Zion+Spa+%7C+Best+Spa+in+Banashankari+Bangalore/data=!4m7!3m6!1s0x3bae3fb6bf537c45:0x1798933523ec46e!8m2!3d12.9247329!4d77.5512121!16s%2Fg%2F11trgdp52y!19sChIJRXxTv7Y_rjsRbsQ-UjOJeQE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "style-studio-unisex-salon",
    "name": "Style Studio Unisex Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 90,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 13.000037,
    "longitude": 77.5411696,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Style+Studio+Unisex+Salon/data=!4m7!3m6!1s0x3bae3d2a871d62b1:0x19ba8d081ca02fe3!8m2!3d13.000037!4d77.5411696!16s%2Fg%2F11h8bbv8x6!19sChIJsWIdhyo9rjsR4y-gHAiNuhk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "zenshin-spa-best-spa-in-hsr-layout",
    "name": "Zenshin Spa - Best Spa in HSR Layout",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 89,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9124179,
    "longitude": 77.6384752,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Zenshin+Spa+-+Best+Spa+in+HSR+Layout/data=!4m7!3m6!1s0x3bae1570556cb46f:0x9f3998c9a017128e!8m2!3d12.9124179!4d77.6384752!16s%2Fg%2F11vt9pzny0!19sChIJb7RsVXAVrjsRjhIXoMmYOZ8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "jubilee-international-spa",
    "name": "Jubilee International Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "1st Main, Dr Rajkumar Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 87,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.987534,
    "longitude": 77.5596796,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Jubilee+International+Spa/data=!4m7!3m6!1s0x3bae3d8904ff502b:0xf7e8071ffbd34eb!8m2!3d12.987534!4d77.5596796!16s%2Fg%2F11xcl1s0hy!19sChIJK1D_BIk9rjsR6zS9_3GAfg8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "golden-beauty-spa-best-spa-in-btm-layout-spa-near-me",
    "name": "Golden Beauty & Spa | Best Spa in BTM Layout | Spa Near Me",
    "description": "Highly rated beauty spa in BTM Layout with excellent reviews and professional service.",
    "address": "3, 7th Main Road, N.S Palya Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "BTM Layout",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 87,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9089965,
    "longitude": 77.6065762,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Golden+Beauty+%26+Spa+%7C+Best+Spa+in+BTM+Layout+%7C+Spa+Near+Me/data=!4m7!3m6!1s0x3bae15b84d863c1b:0xb211599cf9508ca7!8m2!3d12.9089965!4d77.6065762!16s%2Fg%2F11xfqh9yv0!19sChIJGzyGTbgVrjsRp4xQ-ZxZEbI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "lets-relax-thai-spa-indiranagar",
    "name": "Lets Relax Thai Spa Indiranagar",
    "description": "Highly rated thai spa in Indiranagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 85,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9690303,
    "longitude": 77.6406316,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Lets+Relax+Thai+Spa+Indiranagar/data=!4m7!3m6!1s0x3bae17af3885f891:0xc2b5b0e60c15069f!8m2!3d12.9690303!4d77.6406316!16s%2Fg%2F11jzf9x0qj!19sChIJkfiFOK8XrjsRnwYVDOawtcI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "l-m-unisex-salon-spa",
    "name": "L&M Unisex Salon & Spa",
    "description": "Highly rated beauty spa in Varthur with excellent reviews and professional service.",
    "address": "630/548, Varthur Main Rd, opposite to jagriti renaissance apartment",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Varthur",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 84,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9568289,
    "longitude": 77.7409764,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/L%26M+Unisex+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae1341d62bd717:0xa54c35ef1759211a!8m2!3d12.9568289!4d77.7409764!16s%2Fg%2F11tk4cqpf3!19sChIJF9cr1kETrjsRGiFZF-81TKU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "magic-touch-spa-salon",
    "name": "Magic Touch Spa & Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 82,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 13.0370107,
    "longitude": 77.5911182,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Magic+Touch+Spa+%26+Salon/data=!4m7!3m6!1s0x3bae171a4765191b:0x75d7675b51dc9fad!8m2!3d13.0370107!4d77.5911182!16s%2Fg%2F11x7rhjqv1!19sChIJGxllRxoXrjsRrZ_cUVtn13U?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "luxcherie-unisex-salon-hsr-layout-sector-1-bengaluru",
    "name": "Luxcherie Unisex Salon - HSR Layout, Sector 1, Bengaluru",
    "description": "Highly rated beauty spa in HSR Layout with excellent reviews and professional service.",
    "address": "3rd Floor, Building, 6, 27th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 79,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.922074,
    "longitude": 77.6514167,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Luxcherie+Unisex+Salon+-+HSR+Layout,+Sector+1,+Bengaluru/data=!4m7!3m6!1s0x3bae15ddb34746bd:0x28a68f84e079d33f!8m2!3d12.922074!4d77.6514167!16s%2Fg%2F11lym4jffb!19sChIJvUZHs90VrjsRP9N54ISPpig?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "kimaya-unisex-salon-spa",
    "name": "Kimaya Unisex Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 78,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 13.0295168,
    "longitude": 77.5707495,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Kimaya+Unisex+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae17eecefc8673:0xba6ab9bf8cca6088!8m2!3d13.0295168!4d77.5707495!16s%2Fg%2F11k2q7_8cx!19sChIJc4b8zu4XrjsRiGDKjL-5aro?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "suki-thai-spa-and-salon-nagawara-bangalore",
    "name": "Suki Thai Spa And Salon Nagawara Bangalore",
    "description": "Highly rated thai spa in Nagawara with excellent reviews and professional service.",
    "address": "36/37, 1st Floor, D.S. Chandragiri, Nagawara Main Rd, opposite Zudio Mystic in Hotel",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Nagawara",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 66,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 13.0404339,
    "longitude": 77.6194036,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Suki+Thai+Spa+And+Salon+Nagawara+Bangalore/data=!4m7!3m6!1s0x3bae172204a39e65:0x91501dcd676a11f!8m2!3d13.0404339!4d77.6194036!16s%2Fg%2F11vr_rdvyf!19sChIJZZ6jBCIXrjsRH6F21twBFQk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "new-senses-salon-spa",
    "name": "New Senses Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 62,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9651696,
    "longitude": 77.756306,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/New+Senses+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae0d2e4c907739:0xff53628f35f4ac62!8m2!3d12.9651696!4d77.756306!16s%2Fg%2F11y33w94k1!19sChIJOXeQTC4NrjsRYqz0NY9iU_8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "riya-b2b-with-happy-ending-spa-koramangla-bangalore",
    "name": "Riya b2b with happy ending spa Koramangla Bangalore",
    "description": "Highly rated day spa in Koramangala with excellent reviews and professional service.",
    "address": "172/8",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 49,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9369524,
    "longitude": 77.6279196,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Riya+b2b+with+happy+ending+spa+Koramangla+Bangalore/data=!4m7!3m6!1s0x3bae15006768382b:0xb7c5421dcf3f7f55!8m2!3d12.9369524!4d77.6279196!16s%2Fg%2F11vylzq6ky!19sChIJKzhoZwAVrjsRVX8_zx1Cxbc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "hosta-salon-spa",
    "name": "Hosta Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "17th H Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 49,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9344792,
    "longitude": 77.6170597,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Hosta+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae15c21ef652b5:0x2058cf8b82b7c834!8m2!3d12.9344792!4d77.6170597!16s%2Fg%2F11h8vkbw6d!19sChIJtVL2HsIVrjsRNMi3govPWCA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "hair-affair-salon",
    "name": "Hair Affair Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "6,Nanjappa Circle, Langford Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 42,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9584347,
    "longitude": 77.6055136,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Hair+Affair+Salon/data=!4m7!3m6!1s0x3bae15d1630d6f47:0x8d4c84970617e678!8m2!3d12.9584347!4d77.6055136!16s%2Fg%2F1pv2l7pm7!19sChIJR28NY9EVrjsReOYXBpeETI0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "rachi-thai-spa",
    "name": "Rachi Thai spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "No-711,1st floor Modi hospital road, WOC",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 41,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9976531,
    "longitude": 77.5482195,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Rachi+Thai+spa/data=!4m7!3m6!1s0x3bae3ddad2b26b79:0x7c4676a5d012475a!8m2!3d12.9976531!4d77.5482195!16s%2Fg%2F11w204yzky!19sChIJeWuy0to9rjsRWkcS0KV2Rnw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "revera-wellness-spa",
    "name": "Revera Wellness Spa",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd Floor,178, Revera Wellness Spa, 9th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 41,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9102222,
    "longitude": 77.6352416,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Revera+Wellness+Spa/data=!4m7!3m6!1s0x3bae1555dc4edf5f:0xb51a047916e68811!8m2!3d12.9102222!4d77.6352416!16s%2Fg%2F11xg_y_f6m!19sChIJX99O3FUVrjsREYjmFnkEGrU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "malnad-thai-spa-best-spa-in-hsr-layout-body-massage",
    "name": "Malnad Thai Spa | Best Spa in HSR Layout - Body Massage",
    "description": "Highly rated thai spa in HSR Layout with excellent reviews and professional service.",
    "address": "No.764/A, 3rd Floor, 22nd Cross, 19th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 38,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9089579,
    "longitude": 77.644837,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Malnad+Thai+Spa+%7C+Best+Spa+in+HSR+Layout+-+Body+Massage/data=!4m7!3m6!1s0x3bae1566e57653cb:0x7652ecadb450ace5!8m2!3d12.9089579!4d77.644837!16s%2Fg%2F11yfbzlyzc!19sChIJy1N25WYVrjsR5axQtK3sUnY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "new-kenz-spa",
    "name": "New kenz spa",
    "description": "Highly rated day spa in ITPL with excellent reviews and professional service.",
    "address": "2nd floor, Shubta towers, 10, ITPL Main Rd, near hope farm, above dr.santa animal health care",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "ITPL",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 38,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9846626,
    "longitude": 77.7491124,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/New+kenz+spa/data=!4m7!3m6!1s0x3bae0fbb4ed42299:0x44ba886ad8b220d1!8m2!3d12.9846626!4d77.7491124!16s%2Fg%2F11krhmnfxm!19sChIJmSLUTrsPrjsR0SCy2GqIukQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "red-velvet-luxury-spa-spa-near-chandapura",
    "name": "Red Velvet Luxury Spa | Spa Near Chandapura",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "119, Site No. 02, Ivy Dew Drops Hotel, 4th Floor, Kitthaganhalli Hennagara Main Road, Taluk",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 37,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.8007727,
    "longitude": 77.6905233,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Red+Velvet+Luxury+Spa+%7C+Spa+Near+Chandapura/data=!4m7!3m6!1s0x3bae6d9bac477943:0x69704cb85c819a2a!8m2!3d12.8007727!4d77.6905233!16s%2Fg%2F11wbfgbd8_!19sChIJQ3lHrJttrjsRKpqBXLhMcGk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "pearls-and-petal-spa-and-wellness",
    "name": "Pearls and petal spa and wellness",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "first floor, multi meridian, 687, CBI Main Rd, opp. jony walker, next to kanthi sweets",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 36,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 13.0266375,
    "longitude": 77.5900448,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Pearls+and+petal+spa+and+wellness/data=!4m7!3m6!1s0x3bae171f7a249225:0x49731183070467db!8m2!3d13.0266375!4d77.5900448!16s%2Fg%2F11lh59v_z9!19sChIJJZIkeh8XrjsR22cEB4MRc0k?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "body-spa-with-happy-ending-spa-with-body-to-body-spa-in-hsr-layout-bangalore",
    "name": "Body Spa with Happy ending Spa with body to body spa in hsr layout Bangalore",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "19th, 7th Cross Rd, opposite BMTC BUS DEPOT",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 32,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9199896,
    "longitude": 77.6449415,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Body+Spa+with+Happy+ending+Spa+with+body+to+body+spa+in+hsr+layout+Bangalore/data=!4m7!3m6!1s0x3bae152ea0869ab7:0x70d07a83cb43e53f!8m2!3d12.9199896!4d77.6449415!16s%2Fg%2F11wy338fqw!19sChIJt5qGoC4VrjsRP-VDy4N60HA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nourish-international-spa-luxury-spa-in-jayanagar",
    "name": "Nourish International Spa - Luxury Spa in Jayanagar",
    "description": "Highly rated day spa in Jayanagar with excellent reviews and professional service.",
    "address": "Site No.59, 3rd Floor, 11th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 32,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9267164,
    "longitude": 77.5861037,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nourish+International+Spa+-+Luxury+Spa+in+Jayanagar/data=!4m7!3m6!1s0x3bae15f78d2a6529:0x745c14fff2eda882!8m2!3d12.9267164!4d77.5861037!16s%2Fg%2F11yj61d7k1!19sChIJKWUqjfcVrjsRgqjt8v8UXHQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-nature-best-spa-in-jayanagar-bengaluru",
    "name": "Spa Nature - Best Spa in Jayanagar Bengaluru",
    "description": "Highly rated day spa in Jayanagar with excellent reviews and professional service.",
    "address": "Second Floor, Shubhasri Building, 396/85, 11th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 28,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9325788,
    "longitude": 77.5859655,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spa+Nature+-+Best+Spa+in+Jayanagar+Bengaluru/data=!4m7!3m6!1s0x3bae15e1922ac277:0x7e0ec1f49d467551!8m2!3d12.9325788!4d77.5859655!16s%2Fg%2F11stwpy46m!19sChIJd8IqkuEVrjsRUXVGnfTBDn4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "detox-foot-massage",
    "name": "Detox Foot Massage",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "ESI, No. 14/2, 1st Floor, Appareddy Palya, Paramahansa Yogananda Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 25,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9736233,
    "longitude": 77.6359394,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Detox+Foot+Massage/data=!4m7!3m6!1s0x3bae17dbee15e613:0x293dd51e3a413123!8m2!3d12.9736233!4d77.6359394!16s%2Fg%2F11ygktv8g9!19sChIJE-YV7tsXrjsRIzFBOh7VPSk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "angel-touch-beauty-salon",
    "name": "Angel Touch Beauty Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "1st Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 24,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 13.0392647,
    "longitude": 77.6010578,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Angel+Touch+Beauty+Salon/data=!4m7!3m6!1s0x3bae1731c36537dd:0x83152e0fe539931d!8m2!3d13.0392647!4d77.6010578!16s%2Fg%2F11sbz1cdl7!19sChIJ3TdlwzEXrjsRHZM55Q8uFYM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "siamese-therapyca-spa",
    "name": "SIAMESE (THERAPYCA SPA)",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd floor, SS Tower 396, near SBI ATM, above Third wave Cofee",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 24,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 13.0082254,
    "longitude": 77.5798264,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/SIAMESE+%28THERAPYCA+SPA%29/data=!4m7!3m6!1s0x3bae1730e5b71b07:0x8acd438da2132968!8m2!3d13.0082254!4d77.5798264!16s%2Fg%2F11rzprmcrr!19sChIJBxu35TAXrjsRaCkToo1DzYo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-sanctuary-spa",
    "name": "The Sanctuary Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Bangalore",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 23,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9645675,
    "longitude": 77.7365327,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Sanctuary+Spa/data=!4m7!3m6!1s0x3bae1190a953b3fd:0xc51715052318fc1b!8m2!3d12.9645675!4d77.7365327!16s%2Fg%2F11hzpcx5cy!19sChIJ_bNTqZARrjsRG_wYIwUVF8U?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bb-massage-therapy-best-body-massage-spa-female-to-male-body-spa-hsr-layout-bangalore",
    "name": "BB Massage Therapy Best Body Massage spa & Female To Male Body spa HSR Layout Bangalore",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "1st floor, 1573, HSR Fly Over",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 22,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9195503,
    "longitude": 77.6460441,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/BB+Massage+Therapy+Best+Body+Massage+spa+%26+Female+To+Male+Body+spa+HSR+Layout+Bangalore/data=!4m7!3m6!1s0x3bae1531f68525d3:0x7e0067d80779b451!8m2!3d12.9195503!4d77.6460441!16s%2Fg%2F11kjjhwlh1!19sChIJ0yWF9jEVrjsRUbR5B9hnAH4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "isiri-global-spa-jayanagar",
    "name": "Isiri Global Spa Jayanagar",
    "description": "Highly rated day spa in Jayanagar with excellent reviews and professional service.",
    "address": "2nd Floor, Emerald Square Building, 28th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 21,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9170874,
    "longitude": 77.595258,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Isiri+Global+Spa+Jayanagar/data=!4m7!3m6!1s0x3bae15027173ed27:0x87866489d0fef364!8m2!3d12.9170874!4d77.595258!16s%2Fg%2F11m5f84z3s!19sChIJJ-1zcQIVrjsRZPP-0Ilkhoc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "olive-ayurvedic-center-male-to-male-richmond",
    "name": "Olive Ayurvedic Center Male to Male - Richmond",
    "description": "Highly rated ayurvedic spa in Bangalore with excellent reviews and professional service.",
    "address": "GA, Ground Floor, 32, Langford Rd, opp. to St. Joseph's University",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 20,
    "spa_type": "Ayurvedic Spa",
    "services": [
      "Abhyanga",
      "Shirodhara",
      "Panchakarma",
      "Pizhichil",
      "Kerala Massage",
      "Ayurvedic Facial"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9619093,
    "longitude": 77.5965545,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Olive+Ayurvedic+Center+Male+to+Male+-+Richmond/data=!4m7!3m6!1s0x3bae15068f7f3b0f:0x4a63039c6d6417a6!8m2!3d12.9619093!4d77.5965545!16s%2Fg%2F11xmnhqyz2!19sChIJDzt_jwYVrjsRphdkbZwDY0o?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sa-auto-spa",
    "name": "SA Auto Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd cross Gundappareddy layout, Post, near Venkateshwara Temple",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 19,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 13.0345972,
    "longitude": 77.5966542,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/SA+Auto+Spa/data=!4m7!3m6!1s0x3bae17ca13a7f927:0xc1dd38fe1506714f!8m2!3d13.0345972!4d77.5966542!16s%2Fg%2F11jsncv4lm!19sChIJJ_mnE8oXrjsRT3EGFf443cE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "mitram-spa-in-jayanagar",
    "name": "Mitram Spa in Jayanagar",
    "description": "Highly rated day spa in Jayanagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 19,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9327565,
    "longitude": 77.5857976,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Mitram+Spa+in+Jayanagar/data=!4m7!3m6!1s0x3bae154289bed3a9:0xeacaeb8b1c69bf6f!8m2!3d12.9327565!4d77.5857976!16s%2Fg%2F11zkrzqw12!19sChIJqdO-iUIVrjsRb79pHIvryuo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "celestine-spa",
    "name": "Celestine Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd Floor, 23, 26th Main Rd, opposite Ragigudda Arch",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 19,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9170254,
    "longitude": 77.5934599,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Celestine+Spa/data=!4m7!3m6!1s0x3bae15173c82bde3:0x58a272664eeb16c7!8m2!3d12.9170254!4d77.5934599!16s%2Fg%2F11rvl_4hyl!19sChIJ472CPBcVrjsRxxbrTmZyolg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "lotus-spa",
    "name": "Lotus Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "124, 1st Cross Rd, above peace restorent",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 18,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9345692,
    "longitude": 77.6163516,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Lotus+Spa/data=!4m7!3m6!1s0x3bae15733b085489:0x6f5aa16e223740f3!8m2!3d12.9345692!4d77.6163516!16s%2Fg%2F11s_sdnc88!19sChIJiVQIO3MVrjsR80A3Im6hWm8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "stone-spa-whitefiled",
    "name": "stone spa whitefiled",
    "description": "Highly rated day spa in Whitefield with excellent reviews and professional service.",
    "address": "Whitefield Main Rd, opp. UNILIVER LTD",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 18,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9631016,
    "longitude": 77.7482909,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/stone+spa+whitefiled/data=!4m7!3m6!1s0x3bae0dedba831f71:0xcb546c7e9600058f!8m2!3d12.9631016!4d77.7482909!16s%2Fg%2F11tsxkt85l!19sChIJcR-Duu0NrjsRjwUAln5sVMs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "royal-saloon-spa",
    "name": "Royal Saloon & Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "286/4, No.3, Hosur Rd, opp. Vodaphone Store",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 17,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9065638,
    "longitude": 77.6277735,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Royal+Saloon+%26+Spa/data=!4m7!3m6!1s0x2f2d83c1405425e3:0xc61153ce51ff019c!8m2!3d12.9065638!4d77.6277735!16s%2Fg%2F11l209r49q!19sChIJ4yVUQMGDLS8RnAH_Uc5TEcY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "blue-moon-unisex-salon-spa",
    "name": "Blue Moon Unisex Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Site no 01, near by RK Township Road",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 12,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.8084074,
    "longitude": 77.6750156,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Blue+Moon+Unisex+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae6d645948c36b:0x22b867c28083fe9e!8m2!3d12.8084074!4d77.6750156!16s%2Fg%2F11w48cqrk5!19sChIJa8NIWWRtrjsRnv6DgMJnuCI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vimoha-wellness-spa",
    "name": "Vimoha Wellness Spa",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "1st floor, 411, C' cross, 1st Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 12,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9353021,
    "longitude": 77.6128855,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Vimoha+Wellness+Spa/data=!4m7!3m6!1s0x3bae157e4aaee34f:0xbfa45fc43591a21b!8m2!3d12.9353021!4d77.6128855!16s%2Fg%2F11xkm7f_75!19sChIJT-OuSn4VrjsRG6KRNcRfpL8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "body-rituals-thai-spa",
    "name": "BODY RITUALS THAI SPA",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "27th Main Rd, opp. cpwd quarters",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 9,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9136442,
    "longitude": 77.6516582,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/BODY+RITUALS+THAI+SPA/data=!4m7!3m6!1s0x3bae1517f84ffb1d:0xe00d0c5e89770c58!8m2!3d12.9136442!4d77.6516582!16s%2Fg%2F11khr17q82!19sChIJHftP-BcVrjsRWAx3iV4MDeA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ayursanjeevini",
    "name": "Ayursanjeevini",
    "description": "Highly rated day spa in Jayanagar with excellent reviews and professional service.",
    "address": "Jayanagar 3rd block jos allukas same building floor",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 9,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9351432,
    "longitude": 77.5840259,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ayursanjeevini/data=!4m7!3m6!1s0x3bae15695ab19b27:0x30b1b51766175994!8m2!3d12.9351432!4d77.5840259!16s%2Fg%2F11h0v0fzyy!19sChIJJ5uxWmkVrjsRlFkXZhe1sTA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "g-j-unisex-salon-and-spa",
    "name": "G&J Unisex Salon and Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "1st floor, No 485",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 9,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9337948,
    "longitude": 77.6189602,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/G%26J+Unisex+Salon+and+Spa/data=!4m7!3m6!1s0x3bae1506f6b0db4f:0x6d3ff7dbc5aa9853!8m2!3d12.9337948!4d77.6189602!16s%2Fg%2F11w9yc923q!19sChIJT9uw9gYVrjsRU5iqxdv3P20?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "reef-spa",
    "name": "REEF SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "1st Floor,2019,100 Feet Rd, 15th Main Rd, above Xero degree Restaurant or chai days",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 7,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9666018,
    "longitude": 77.6417031,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/REEF+SPA/data=!4m7!3m6!1s0x3bae15a6c7d0d4a1:0xce808a47ccbb617a!8m2!3d12.9666018!4d77.6417031!16s%2Fg%2F11mkm60w5s!19sChIJodTQx6YVrjsRemG7zEeKgM4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "aira-spa-and-wellness",
    "name": "Aira Spa and Wellness",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "100 Feet Rd, near Boba Tree Bubble Tea cafe",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.6,
    "reviews_count": 5,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9791345,
    "longitude": 77.640617,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Aira+Spa+and+Wellness/data=!4m7!3m6!1s0x3bae15ff5121ab89:0x9a55111ae1e05f9c!8m2!3d12.9791345!4d77.640617!16s%2Fg%2F11rf6nhx90!19sChIJiashUf8VrjsRnF_g4RoRVZo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ylg-salon-mantri-square-mall",
    "name": "YLG Salon / Mantri Square Mall",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 4041,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9916319,
    "longitude": 77.5703042,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/YLG+Salon+%2F+Mantri+Square+Mall/data=!4m7!3m6!1s0x3bae162303df6ee3:0x6d2f4f23316c5f31!8m2!3d12.9916319!4d77.5703042!16s%2Fg%2F1v_z7bnz!19sChIJ427fAyMWrjsRMV9sMSNPL20?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "green-trends-unisex-salon-hsr-layout-bengaluru",
    "name": "Green Trends Unisex Salon, HSR Layout, Bengaluru",
    "description": "Highly rated beauty spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 3858,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9124866,
    "longitude": 77.6517032,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Green+Trends+Unisex+Salon,+HSR+Layout,+Bengaluru/data=!4m7!3m6!1s0x3bae1519196e6e13:0xc6474c9569d845b7!8m2!3d12.9124866!4d77.6517032!16s%2Fg%2F11c13nlzq0!19sChIJE25uGRkVrjsRt0XYaZVMR8Y?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "green-trends-unisex-hair-style-salon-koramangala-5th-block",
    "name": "Green Trends - Unisex Hair & Style Salon - Koramangala 5th Block",
    "description": "Highly rated beauty spa in Koramangala with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 3327,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9366257,
    "longitude": 77.6202682,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Green+Trends+-+Unisex+Hair+%26+Style+Salon+-+Koramangala+5th+Block/data=!4m7!3m6!1s0x3bae14456dc6427f:0x15bec9c88e40a73c!8m2!3d12.9366257!4d77.6202682!16s%2Fg%2F124yd6dnc!19sChIJf0LGbUUUrjsRPKdAjsjJvhU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bodycraft-salon-spa-clinic-indiranagar",
    "name": "Bodycraft Salon, Spa & Clinic - Indiranagar",
    "description": "Highly rated beauty spa in Indiranagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 3140,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9775599,
    "longitude": 77.6406548,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bodycraft+Salon,+Spa+%26+Clinic+-+Indiranagar/data=!4m7!3m6!1s0x3bae141d153ecc01:0xb3cd3540165c935d!8m2!3d12.9775599!4d77.6406548!16s%2Fg%2F11cmq__sx7!19sChIJAcw-FR0UrjsRXZNcFkA1zbM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "green-trends-unisex-salon-jayanagar-bengaluru",
    "name": "Green Trends Unisex Salon, Jayanagar, Bengaluru",
    "description": "Highly rated beauty spa in Jayanagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 3060,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9223266,
    "longitude": 77.5894498,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Green+Trends+Unisex+Salon,+Jayanagar,+Bengaluru/data=!4m7!3m6!1s0x3bae15a0a3a316cb:0xdf565d778151c23f!8m2!3d12.9223266!4d77.5894498!16s%2Fg%2F1263pwfcb!19sChIJyxajo6AVrjsRP8JRgXddVt8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bodycraft-salon-spa-clinic-koramangala",
    "name": "Bodycraft Salon, Spa & Clinic - Koramangala",
    "description": "Highly rated beauty spa in Koramangala with excellent reviews and professional service.",
    "address": "Shop 118, Ganapathi Temple Rd, adjacent to Axis Bank, in-front of ICICI Bank",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 2637,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9355003,
    "longitude": 77.6141087,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bodycraft+Salon,+Spa+%26+Clinic+-+Koramangala/data=!4m7!3m6!1s0x3bae156f4797f1e3:0x11cd5434259398ca!8m2!3d12.9355003!4d77.6141087!16s%2Fg%2F11j570z0_h!19sChIJ4_GXR28VrjsRypiTJTRUzRE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "inventive-enrich-unisex-salon-spa",
    "name": "Inventive Enrich Unisex Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 1940,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9763264,
    "longitude": 77.7510597,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Inventive+Enrich+Unisex+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae0e0732503d5f:0x406645e39fa0197!8m2!3d12.9763264!4d77.7510597!16s%2Fg%2F1ptwzl9gw!19sChIJXz1QMgcOrjsRlwH6OV5kBgQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "enrich-salon-indira-nagar",
    "name": "Enrich Salon Indira Nagar",
    "description": "Highly rated beauty spa in Indiranagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 1865,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.975441,
    "longitude": 77.6412761,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Enrich+Salon+Indira+Nagar/data=!4m7!3m6!1s0x3bae16a8781ba29b:0x51289e2c94aefe45!8m2!3d12.975441!4d77.6412761!16s%2Fg%2F1pv5x4zng!19sChIJm6IbeKgWrjsRRf6ulCyeKFE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "naturals-salon-spa-margosa-road-malleshwaram",
    "name": "Naturals Salon & Spa, Margosa Road, Malleshwaram",
    "description": "Highly rated beauty spa in Malleshwaram with excellent reviews and professional service.",
    "address": "Jkr Complex, 30/6, 3rd Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Malleshwaram",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 1773,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 13.0028641,
    "longitude": 77.5691944,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Naturals+Salon+%26+Spa,+Margosa+Road,+Malleshwaram/data=!4m7!3m6!1s0x3bae16297caab93d:0x503e92388b19ca72!8m2!3d13.0028641!4d77.5691944!16s%2Fg%2F11b6t1sn4x!19sChIJPbmqfCkWrjsRcsoZiziSPlA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ylg-salon-malleshwaram",
    "name": "YLG Salon / Malleshwaram",
    "description": "Highly rated beauty spa in Malleshwaram with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Malleshwaram",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 1683,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 13.0033726,
    "longitude": 77.5650096,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/YLG+Salon+%2F+Malleshwaram/data=!4m7!3m6!1s0x3bae162a3590c321:0x5078b6f2ca1c5070!8m2!3d13.0033726!4d77.5650096!16s%2Fg%2F1thw553s!19sChIJIcOQNSoWrjsRcFAcyvK2eFA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "naturals-unisex-hair-beauty-salon-hsr-layout-27th-main",
    "name": "Naturals Unisex Hair & Beauty Salon, HSR Layout 27th Main",
    "description": "Highly rated beauty spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 1673,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9085342,
    "longitude": 77.6519811,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Naturals+Unisex+Hair+%26+Beauty+Salon,+HSR+Layout+27th+Main/data=!4m7!3m6!1s0x3bae149dc3e98847:0x85f79f4d75aad643!8m2!3d12.9085342!4d77.6519811!16s%2Fg%2F11cs5my626!19sChIJR4jpw50UrjsRQ9aqdU2f94U?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "enrich-salon",
    "name": "Enrich Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 1197,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.932139,
    "longitude": 77.5839518,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Enrich+Salon/data=!4m7!3m6!1s0x3bae1597c4600895:0x7da879c68f1dd20c!8m2!3d12.932139!4d77.5839518!16s%2Fg%2F1ptyt6jlh!19sChIJlQhgxJcVrjsRDNIdj8Z5qH0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vlcc-beauty-clinic-indira-nagar-bangalore",
    "name": "VLCC BEAUTY CLINIC ( Indira Nagar, Bangalore)",
    "description": "Highly rated beauty spa in Indiranagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 1171,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9701916,
    "longitude": 77.6390698,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/VLCC+BEAUTY+CLINIC+%28+Indira+Nagar,+Bangalore%29/data=!4m7!3m6!1s0x3bae16b3b3fda9df:0x889ad1649cfe8fa5!8m2!3d12.9701916!4d77.6390698!16s%2Fg%2F1td5vlls!19sChIJ36n9s7MWrjsRpY_-nGTRmog?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "d5n-malleshwaram",
    "name": "D5N Malleshwaram",
    "description": "Highly rated day spa in Malleshwaram with excellent reviews and professional service.",
    "address": "Roopashree Nilayam, 186(83/1), 6th Main Road, 18th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Malleshwaram",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 928,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 13.0081827,
    "longitude": 77.5667865,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/D5N+Malleshwaram/data=!4m7!3m6!1s0x3bae162ae339211f:0x3bf16184024a5720!8m2!3d13.0081827!4d77.5667865!16s%2Fg%2F1tdr1rbf!19sChIJHyE54yoWrjsRIFdKAoRh8Ts?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "shaakya-salon-spa",
    "name": "Shaakya Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 771,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 13.059105,
    "longitude": 77.648465,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Shaakya+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae1755e6ff1397:0xe2a01150b4bb30b0!8m2!3d13.059105!4d77.648465!16s%2Fg%2F11df0mq_rj!19sChIJlxP_5lUXrjsRsDC7tFARoOI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "u-me-hair-skin-nails",
    "name": "U & Me (Hair, Skin & Nails)",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 762,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9749274,
    "longitude": 77.7507843,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/U+%26+Me+%28Hair,+Skin+%26+Nails%29/data=!4m7!3m6!1s0x3bae1597e5e10d1d:0x2a61447729ed6e1b!8m2!3d12.9749274!4d77.7507843!16s%2Fg%2F1q2w20bbg!19sChIJHQ3h5ZcVrjsRG27tKXdEYSo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vilz-salon-and-spa-best-salon-in-hsr-layout",
    "name": "VILZ Salon and Spa | Best Salon in HSR Layout",
    "description": "Highly rated beauty spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 549,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.909388,
    "longitude": 77.6379082,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/VILZ+Salon+and+Spa+%7C+Best+Salon+in+HSR+Layout/data=!4m7!3m6!1s0x3bae14910d28dad7:0xa014745e5a6dcd13!8m2!3d12.909388!4d77.6379082!16s%2Fg%2F11fz95k73p!19sChIJ19ooDZEUrjsRE81tWl50FKA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ghogi-spa-hsr-layout",
    "name": "Ghogi Spa - HSR Layout",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 534,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9176359,
    "longitude": 77.6450658,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ghogi+Spa+-+HSR+Layout/data=!4m7!3m6!1s0x3bae1483b5e96119:0x78a5af2ef9869aeb!8m2!3d12.9176359!4d77.6450658!16s%2Fg%2F11fyzfq9dt!19sChIJGWHptYMUrjsR65qG-S6vpXg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "hwarang-thai-spa",
    "name": "Hwarang Thai Spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 397,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9684563,
    "longitude": 77.6408845,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Hwarang+Thai+Spa/data=!4m7!3m6!1s0x3bae158d9ea5530b:0xee7c6d128a3001c7!8m2!3d12.9684563!4d77.6408845!16s%2Fg%2F11h3lfk8gs!19sChIJC1Olno0VrjsRxwEwihJtfO4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "posh-styling-zone-mc-nails",
    "name": "POSH STYLING ZONE & MC NAILS",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 318,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 13.0037463,
    "longitude": 77.5699631,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/POSH+STYLING+ZONE+%26+MC+NAILS/data=!4m7!3m6!1s0x3bae162a55555555:0xb3a3fcec21153d29!8m2!3d13.0037463!4d77.5699631!16s%2Fg%2F1td23wpq!19sChIJVVVVVSoWrjsRKT0VIez8o7M?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bangalore-international-spa",
    "name": "Bangalore International Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Sri Balaji Complex, 20th L Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 251,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9369856,
    "longitude": 77.6280849,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bangalore+International+Spa/data=!4m7!3m6!1s0x3bae151b01891863:0x3947672474c44d2d!8m2!3d12.9369856!4d77.6280849!16s%2Fg%2F11jzpjp8xv!19sChIJYxiJARsVrjsRLU3EdCRnRzk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "trinity-thai-spa",
    "name": "Trinity Thai Spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 236,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9781749,
    "longitude": 77.6364059,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Trinity+Thai+Spa/data=!4m7!3m6!1s0x3bae1710b778b8b3:0xcc93ebb62a92af6e!8m2!3d12.9781749!4d77.6364059!16s%2Fg%2F11y3sl3_87!19sChIJs7h4txAXrjsRbq-SKrbrk8w?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sanjeevini-spa-hsr-layout",
    "name": "Sanjeevini SPA HSR Layout",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 219,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9196472,
    "longitude": 77.6506196,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sanjeevini+SPA+HSR+Layout/data=!4m7!3m6!1s0x3bae159f523be3e5:0xad96677454be6eea!8m2!3d12.9196472!4d77.6506196!16s%2Fg%2F11s6j1n325!19sChIJ5eM7Up8VrjsR6m6-VHRnlq0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-meraki-hsr-layout",
    "name": "Spa Meraki (HSR Layout)",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 218,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9109238,
    "longitude": 77.652005,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spa+Meraki+%28HSR+Layout%29/data=!4m7!3m6!1s0x3bae1599f4b49037:0x535da0f4c55a9990!8m2!3d12.9109238!4d77.652005!16s%2Fg%2F11s82z63p2!19sChIJN5C09JkVrjsRkJlaxfSgXVM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "summerhill-spa-best-spa-in-new-bel-road",
    "name": "SummerHill Spa | Best Spa in New Bel Road",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "#79 First floor Bhagyasri Complex 80 Feet Road, New BEL Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 211,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 13.0277779,
    "longitude": 77.5740016,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/SummerHill+Spa+%7C+Best+Spa+in+New+Bel+Road/data=!4m7!3m6!1s0x3bae17b9ccfd7fbf:0xbe148641a8bd8d8f!8m2!3d13.0277779!4d77.5740016!16s%2Fg%2F11h77m2mqm!19sChIJv3_9zLkXrjsRj429qEGGFL4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "magic-hand-spa-and-massage-in-bangalore",
    "name": "Magic Hand Spa And Massage In Bangalore",
    "description": "Highly rated day spa in Madiwala with excellent reviews and professional service.",
    "address": "New grand Krishna hotel, opposite madiwala",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Madiwala",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 201,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9240607,
    "longitude": 77.6193867,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Magic+Hand+Spa+And+Massage+In+Bangalore/data=!4m7!3m6!1s0x3bae15f465f34d2f:0x576a945530c5d760!8m2!3d12.9240607!4d77.6193867!16s%2Fg%2F11wh__zzrr!19sChIJL03zZfQVrjsRYNfFMFWUalc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "milo-unisex-salon-spa",
    "name": "Milo Unisex Salon & Spa",
    "description": "Highly rated beauty spa in Varthur with excellent reviews and professional service.",
    "address": "653, Varthur Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Varthur",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 183,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9571988,
    "longitude": 77.7381668,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Milo+Unisex+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae13de9914984b:0x151c32c3d91fc6bf!8m2!3d12.9571988!4d77.7381668!16s%2Fg%2F11g4hlf3ck!19sChIJS5gUmd4TrjsRv8Yf2cMyHBU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "green-day-spa-hsr-layout",
    "name": "Green Day Spa Hsr Layout",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "1090L, 18th Cross Rd, next to Subramanya Swami matha",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 173,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.91175,
    "longitude": 77.641237,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Green+Day+Spa+Hsr+Layout/data=!4m7!3m6!1s0x3bae15bbadddacc3:0x6e18780bc989e633!8m2!3d12.91175!4d77.641237!16s%2Fg%2F11thkjqql4!19sChIJw6zdrbsVrjsRM-aJyQt4GG4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "white-rabbit-spa-bangalore",
    "name": "White Rabbit spa Bangalore",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "31, 28th B Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 168,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9175174,
    "longitude": 77.5952438,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/White+Rabbit+spa+Bangalore/data=!4m7!3m6!1s0x3bae15070b34337f:0xe7ce4d288a873a58!8m2!3d12.9175174!4d77.5952438!16s%2Fg%2F11jywpdtf7!19sChIJfzM0CwcVrjsRWDqHiihNzuc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "salon-perimeter-hsr-layout-sector-1",
    "name": "Salon Perimeter HSR Layout Sector 1",
    "description": "Highly rated beauty spa in HSR Layout with excellent reviews and professional service.",
    "address": "First Floor, 1068, 24th Main Rd, above Zigly Pet Store",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 158,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9180646,
    "longitude": 77.6491035,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Salon+Perimeter+HSR+Layout+Sector+1/data=!4m7!3m6!1s0x3bae15fc2f4c9bc5:0xa4eff35351ce84a3!8m2!3d12.9180646!4d77.6491035!16s%2Fg%2F11vspjktyz!19sChIJxZtML_wVrjsRo4TOUVPz76Q?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "relax-spa-male-to-male-spa-men-s-spa-in-bangalore",
    "name": "Relax Spa | Male to Male Spa | Men's spa in Bangalore",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "First Floor, No 145/1, Old Agram Road",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 156,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9539211,
    "longitude": 77.6206215,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Relax+Spa+%7C+Male+to+Male+Spa+%7C+Men%27s+spa+in+Bangalore/data=!4m7!3m6!1s0x3bae157bf68b7a73:0xbfffe35a0e97abf2!8m2!3d12.9539211!4d77.6206215!16s%2Fg%2F11ltwtjfwm!19sChIJc3qL9nsVrjsR8quXDlrj_78?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "switch-wellness",
    "name": "Switch Wellness",
    "description": "Highly rated wellness spa in HAL with excellent reviews and professional service.",
    "address": "Siam House, 1/21, 3rd Floor, Sri Ramana Maharshi Rd, Raj Mahal Vilas",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HAL",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 155,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 13.0108417,
    "longitude": 77.58358,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Switch+Wellness/data=!4m7!3m6!1s0x3bae175332781fa9:0x39e9add713a00555!8m2!3d13.0108417!4d77.58358!16s%2Fg%2F11gy34_18g!19sChIJqR94MlMXrjsRVQWgE9et6Tk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "d6-unisex-saloon-and-spa",
    "name": "D6 Unisex Saloon And Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 147,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9991285,
    "longitude": 77.567798,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/D6+Unisex+Saloon+And+Spa/data=!4m7!3m6!1s0x3bae1703759f92fb:0xb32d8b1515f27cd9!8m2!3d12.9991285!4d77.567798!16s%2Fg%2F11p3h3fkwv!19sChIJ-5KfdQMXrjsR2XzyFRWLLbM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-villa-spa-in-hbr-layout",
    "name": "Spa Villa (Spa In HBR Layout)",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 144,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 13.0346976,
    "longitude": 77.6290271,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spa+Villa+%28Spa+In+HBR+Layout%29/data=!4m7!3m6!1s0x3bae175c05ac6fd5:0xa29aeef56465f65d!8m2!3d13.0346976!4d77.6290271!16s%2Fg%2F11v5dm1_y1!19sChIJ1W-sBVwXrjsRXfZlZPXumqI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "dhara-spa-in-hsr-layout-massage-spa-hsr-layout",
    "name": "Dhara Spa In HSR Layout - Massage Spa HSR Layout",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "No. 2610, 2nd Floor, Opp: Dominos, 27th Main Rd, above Fabindia",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 140,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.912981,
    "longitude": 77.6516715,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Dhara+Spa+In+HSR+Layout+-+Massage+Spa+HSR+Layout/data=!4m7!3m6!1s0x3bae157049c5506d:0xb6db89209633c06b!8m2!3d12.912981!4d77.6516715!16s%2Fg%2F11t7dlmqgz!19sChIJbVDFSXAVrjsRa8AzliCJ27Y?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "glow-up-unisex-salon-and-spa",
    "name": "Glow Up Unisex Salon and Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "1st floor, 100 Feet Ring Rd, near Water tank",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 119,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9164782,
    "longitude": 77.6063272,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Glow+Up+Unisex+Salon+and+Spa/data=!4m7!3m6!1s0x3bae15c1cf5a0741:0xf2b4fd6c9ed21c29!8m2!3d12.9164782!4d77.6063272!16s%2Fg%2F11ksnglng4!19sChIJQQdaz8EVrjsRKRzSnmz9tPI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "hair-confident-family-salon-and-spa",
    "name": "Hair Confident family salon and spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 111,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9315256,
    "longitude": 77.5795564,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Hair+Confident+family+salon+and+spa/data=!4m7!3m6!1s0x3bae159de91c0325:0x173c93da9d48cd59!8m2!3d12.9315256!4d77.5795564!16s%2Fg%2F11g0n1nq_y!19sChIJJQMc6Z0VrjsRWc1IndqTPBc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "treesbeau-salon-spa",
    "name": "Treesbeau Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 102,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.935179,
    "longitude": 77.6230493,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Treesbeau+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae151e295adc9b:0x4535053897b8b53e!8m2!3d12.935179!4d77.6230493!16s%2Fg%2F11tg51k8x2!19sChIJm9xaKR4VrjsRPrW4lzgFNUU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sun-shine-unisex-spa",
    "name": "SUN SHINE UNISEX SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "361 \"Shree krupa\" 1st floor, 15th cross, Sampige Rd, opposite karuru vysya Bank",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 96,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 13.0054971,
    "longitude": 77.5713177,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/SUN+SHINE+UNISEX+SPA/data=!4m7!3m6!1s0x3bae17484e413a07:0x7decad4fff1b6b17!8m2!3d13.0054971!4d77.5713177!16s%2Fg%2F11rzprlqh0!19sChIJBzpBTkgXrjsRF2sb_0-t7H0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "lavender-salon-spa-spa-near-bommasandra-best-spa-in-bommasandra",
    "name": "Lavender Salon & Spa | Spa near Bommasandra | Best Spa in Bommasandra",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "No.255/A, Hotel Jade Empire, Hosur Rd, near Narayana Hrudayalaya Hospital",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 79,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.80783,
    "longitude": 77.6972471,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Lavender+Salon+%26+Spa+%7C+Spa+near+Bommasandra+%7C+Best+Spa+in+Bommasandra/data=!4m7!3m6!1s0x3bae6dd7c82aa3c7:0xe7683a90ea1d5303!8m2!3d12.80783!4d77.6972471!16s%2Fg%2F11y3p83y6m!19sChIJx6MqyNdtrjsRA1Md6pA6aOc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "cherry-spa",
    "name": "Cherry Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 77,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9204644,
    "longitude": 77.6131006,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Cherry+Spa/data=!4m7!3m6!1s0x3bae15685e2584b3:0xdf7a44c76d1388e5!8m2!3d12.9204644!4d77.6131006!16s%2Fg%2F11r4xy3953!19sChIJs4QlXmgVrjsR5YgTbcdEet8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bodycraft-clinic-sadashivnagar",
    "name": "Bodycraft Clinic - Sadashivnagar",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Shop 371, 1st Flr, Royal orchid, 8th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 73,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 13.0089423,
    "longitude": 77.5807191,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bodycraft+Clinic+-+Sadashivnagar/data=!4m7!3m6!1s0x3bae17a92f868afd:0xa4cdc79a1f969c6e!8m2!3d13.0089423!4d77.5807191!16s%2Fg%2F11wfx05k6r!19sChIJ_YqGL6kXrjsRbpyWH5rHzaQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "relax-body-spa-top-rated-spa-in-hsr-layout",
    "name": "Relax Body Spa - Top Rated Spa In HSR Layout",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 70,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9176697,
    "longitude": 77.6515862,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Relax+Body+Spa+-+Top+Rated+Spa+In+HSR+Layout/data=!4m7!3m6!1s0x3bae15a7aafaff35:0xcdc6571ff918c5f5!8m2!3d12.9176697!4d77.6515862!16s%2Fg%2F11tp9z0nlz!19sChIJNf_6qqcVrjsR9cUY-R9Xxs0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "international-nuru-massage-spa-hsr-layout-bangalore",
    "name": "International Nuru Massage Spa HSR layout Bangalore",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "WJ9W+V3R",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 68,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9197347,
    "longitude": 77.6451374,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/International+Nuru+Massage+Spa+HSR+layout+Bangalore/data=!4m7!3m6!1s0x3bae1500072ff895:0x788b76cec14eeb9!8m2!3d12.9197347!4d77.6451374!16s%2Fg%2F11y49nzbff!19sChIJlfgvBwAVrjsRue4U7Gy3iAc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "trikaaya-luxury-spa-best-spa-in-hsr-layout",
    "name": "Trikaaya Luxury Spa- Best Spa in HSR Layout",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "3rd Floor, 9, 17th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 65,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9121706,
    "longitude": 77.6368171,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Trikaaya+Luxury+Spa-+Best+Spa+in+HSR+Layout/data=!4m7!3m6!1s0x3bae15c9cfde8c19:0x772a9bd15003a197!8m2!3d12.9121706!4d77.6368171!16s%2Fg%2F11xkkwc5jx!19sChIJGYzez8kVrjsRl6EDUNGbKnc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "relax-near-me-spa-b2b-massage-in-bangalore",
    "name": "Relax - near me spa - b2b massage in Bangalore",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 64,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9374627,
    "longitude": 77.6276728,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Relax+-+near+me+spa+-+b2b+massage+in+Bangalore/data=!4m7!3m6!1s0x3bae15f7396b1095:0x94f7f4e72c2ebb5!8m2!3d12.9374627!4d77.6276728!16s%2Fg%2F11swmpl110!19sChIJlRBrOfcVrjsRtevCck5_Twk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "aartha-thai-spa",
    "name": "Aartha Thai Spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 63,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.8931903,
    "longitude": 77.5861737,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Aartha+Thai+Spa/data=!4m7!3m6!1s0x3bae156e80af2123:0x5f341730233fce16!8m2!3d12.8931903!4d77.5861737!16s%2Fg%2F11rnhsnklm!19sChIJIyGvgG4VrjsRFs4_IzAXNF8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "kiya-beauty-spa",
    "name": "KIYA BEAUTY SPA",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 56,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9121392,
    "longitude": 77.636801,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/KIYA+BEAUTY+SPA/data=!4m7!3m6!1s0x3bae15005684ecb9:0x20d596f935adf96f!8m2!3d12.9121392!4d77.636801!16s%2Fg%2F11v9c5wzc8!19sChIJueyEVgAVrjsRb_mtNfmW1SA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "glamstudios",
    "name": "Glamstudios",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 55,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9792024,
    "longitude": 77.6413234,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Glamstudios/data=!4m7!3m6!1s0x3bae1578ac843d8d:0xb52a188f2fc492ef!8m2!3d12.9792024!4d77.6413234!16s%2Fg%2F11hdkz1bls!19sChIJjT2ErHgVrjsR75LEL48YKrU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-serenity",
    "name": "Spa Serenity",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "1705, 19th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 50,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9058157,
    "longitude": 77.6445731,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spa+Serenity/data=!4m7!3m6!1s0x3bae154cf0a15e8d:0x685cc04083071d63!8m2!3d12.9058157!4d77.6445731!16s%2Fg%2F11s6fgyfzt!19sChIJjV6h8EwVrjsRYx0Hg0DAXGg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "la-polish",
    "name": "La Polish",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 48,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 13.0075345,
    "longitude": 77.5635155,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/La+Polish/data=!4m7!3m6!1s0x3bae178aa65ce83f:0x43d27ecb05bfe9f2!8m2!3d13.0075345!4d77.5635155!16s%2Fg%2F11llc0cr8w!19sChIJP-hcpooXrjsR8um_Bct-0kM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "retro-salon-and-spa-unisex",
    "name": "Retro Salon and Spa (Unisex)",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 42,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 13.0595891,
    "longitude": 77.5812606,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Retro+Salon+and+Spa+%28Unisex%29/data=!4m7!3m6!1s0x3bae1972c0cd8633:0x91d0567265098b29!8m2!3d13.0595891!4d77.5812606!16s%2Fg%2F11lkyzzrml!19sChIJM4bNwHIZrjsRKYsJZXJW0JE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "coco-wellness-salon-spa",
    "name": "Coco Wellness Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "24th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 40,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9039257,
    "longitude": 77.649071,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Coco+Wellness+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae150009ff696d:0x7b62a4cea1c18d18!8m2!3d12.9039257!4d77.649071!16s%2Fg%2F11vq2yhpx0!19sChIJbWn_CQAVrjsRGI3Boc6kYns?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "rising-waves-salon-and-spa",
    "name": "Rising Waves Salon and Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "679, 1st Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 39,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 13.0001548,
    "longitude": 77.5533445,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Rising+Waves+Salon+and+Spa/data=!4m7!3m6!1s0x3bae3d8575f3ce6d:0xed54f4051f9010f!8m2!3d13.0001548!4d77.5533445!16s%2Fg%2F11f3bk8rnd!19sChIJbc7zdYU9rjsRDwH5UUBP1Q4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "d-glo-unisex-spa-and-salon",
    "name": "D Glo Unisex Spa and Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Chinmaya Mission Hospital Rd, next to meghanas hotel, opp. motherhood hospital",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 37,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9781217,
    "longitude": 77.6376685,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/D+Glo+Unisex+Spa+and+Salon/data=!4m7!3m6!1s0x3bae1723015c0fcb:0x859080aa512c6ab6!8m2!3d12.9781217!4d77.6376685!16s%2Fg%2F11sk5vl_py!19sChIJyw9cASMXrjsRtmosUaqAkIU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "beautyland-salon-and-spa",
    "name": "BEAUTYLAND SALON AND SPA",
    "description": "Highly rated beauty spa in Domlur with excellent reviews and professional service.",
    "address": "225, 1st floor, 1st Main 2nd Stage, Domlur, next to Sri Uddupi Food Hub",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Domlur",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 35,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9663722,
    "longitude": 77.637238,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/BEAUTYLAND+SALON+AND+SPA/data=!4m7!3m6!1s0x3bae1589ee19f6d5:0x167b82bc4e8813ac!8m2!3d12.9663722!4d77.637238!16s%2Fg%2F11vzbz_snm!19sChIJ1fYZ7okVrjsRrBOITryCexY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "lux-thai-spa-new-bel-road",
    "name": "Lux Thai Spa - New BEL Road",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "No 215, 2nd Floor, New BEL Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 34,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 13.0293486,
    "longitude": 77.5707649,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Lux+Thai+Spa+-+New+BEL+Road/data=!4m7!3m6!1s0x3bae172f0507f603:0x3ccf4becd2514f03!8m2!3d13.0293486!4d77.5707649!16s%2Fg%2F11w1vf4vp0!19sChIJA_YHBS8XrjsRA09R0uxLzzw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "mocca-unisex-spa",
    "name": "mocca unisex spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "ground floor, 43/2 6th cross, Borewell Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 22,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9691738,
    "longitude": 77.7392796,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/mocca+unisex+spa/data=!4m7!3m6!1s0x3bae13317bf05383:0xe606007039eb1fcb!8m2!3d12.9691738!4d77.7392796!16s%2Fg%2F11x6hwmrc2!19sChIJg1PwezETrjsRyx_rOXAABuY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "b2b-maasage-rajajinagar",
    "name": "B2B Maasage Rajajinagar",
    "description": "Highly rated day spa in Rajajinagar with excellent reviews and professional service.",
    "address": "No. 59, 4th Floor, Miskin Complex, above Richwin Gems & Jewel, 10th Main Rd, opposite NKKGSB Bank",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Rajajinagar",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 17,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9887187,
    "longitude": 77.5561035,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/B2B+Maasage+Rajajinagar/data=!4m7!3m6!1s0x3bae3d71897dd275:0xc9f9148acc683f06!8m2!3d12.9887187!4d77.5561035!16s%2Fg%2F11vptwrdry!19sChIJddJ9iXE9rjsRBj9ozIoU-ck?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "native-salon-and-spa-unisex",
    "name": "Native Salon And Spa (Unisex)",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "270, 2nd Floor, Coffee Board Cooperative Housing Society Layout, below BRRRN Fitness, next to HDFC & Chaista Chai Shop",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 17,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 13.0499903,
    "longitude": 77.6039234,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Native+Salon+And+Spa+%28Unisex%29/data=!4m7!3m6!1s0x3bae1723cd7b9dc5:0xf7700e593c64ed92!8m2!3d13.0499903!4d77.6039234!16s%2Fg%2F11v0l96fg3!19sChIJxZ17zSMXrjsRku1kPFkOcPc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "trends-unisex-saloon-spa",
    "name": "Trends unisex saloon & Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Opp: ALLEN Career Institute, 1704, 19th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 16,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9057934,
    "longitude": 77.6445635,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Trends+unisex+saloon+%26+Spa/data=!4m7!3m6!1s0x3bae15f0e8b9f8f5:0x543d204f9d596b71!8m2!3d12.9057934!4d77.6445635!16s%2Fg%2F11sc_qgb8l!19sChIJ9fi56PAVrjsRcWtZnU8gPVQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "belina-salon-spa",
    "name": "Belina Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "44, 6th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 16,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9364553,
    "longitude": 77.6252812,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Belina+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae15d977462101:0x52f75f062055332c!8m2!3d12.9364553!4d77.6252812!16s%2Fg%2F11rd29k37j!19sChIJASFGd9kVrjsRLDNVIAZf91I?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-moon-spa-and-salon",
    "name": "The Moon Spa and Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "1st floor, 224, 1st Main Rd, off 100 Feet Road, above Oziano - The Taste Of Undivided Bangla",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 15,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9662263,
    "longitude": 77.6373044,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Moon+Spa+and+Salon/data=!4m7!3m6!1s0x3bae154620ba4787:0x7864520181427c17!8m2!3d12.9662263!4d77.6373044!16s%2Fg%2F11l2nr7h17!19sChIJh0e6IEYVrjsRF3xCgQFSZHg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "green-apple-unisex-spa-and-salon-jayanagar",
    "name": "Green Apple Unisex Spa and Salon, Jayanagar",
    "description": "Highly rated beauty spa in Jayanagar with excellent reviews and professional service.",
    "address": "2nd Floor, S S Plaza, Commercial Complex, 627/23, 10th B Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 10,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9287648,
    "longitude": 77.5856331,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Green+Apple+Unisex+Spa+and+Salon,+Jayanagar/data=!4m7!3m6!1s0x3bae15b60fe676af:0xa23eb0e6d817b81c!8m2!3d12.9287648!4d77.5856331!16s%2Fg%2F11lychghjx!19sChIJr3bmD7YVrjsRHLgX2OawPqI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "l-oreal-men-s-spa-salon",
    "name": "L'OREAL Men's Spa & Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "2, 8th Main Rd, below wellness forever Medical",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 10,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9360699,
    "longitude": 77.5926835,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/L%27OREAL+Men%27s+Spa+%26+Salon/data=!4m7!3m6!1s0x3bae15f064efd9fb:0xe288b1ef39c0e5ac!8m2!3d12.9360699!4d77.5926835!16s%2Fg%2F11h7f_pt4k!19sChIJ-9nvZPAVrjsRrOXAOe-xiOI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ss-spa",
    "name": "SS Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "1st floor, 1664, 27th Main Rd, above Baskin Robins",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 8,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9101477,
    "longitude": 77.6517663,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/SS+Spa/data=!4m7!3m6!1s0x3bae15d78bf5b52f:0xcbc0a520609556c7!8m2!3d12.9101477!4d77.6517663!16s%2Fg%2F11yfkzp4vb!19sChIJL7X1i9cVrjsRx1aVYCClwMs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spring-wellness-spa",
    "name": "SPRING WELLNESS SPA",
    "description": "Highly rated wellness spa in Varthur with excellent reviews and professional service.",
    "address": "2ND FLOOR, SPRING WELLNESS SPA, 46/47, Varthur Main Rd, opposite DSR VERTEX AND APEX",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Varthur",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 8,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9555336,
    "longitude": 77.718696,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/SPRING+WELLNESS+SPA/data=!4m7!3m6!1s0x3bae132d98549c3f:0x75042d8a0f849a83!8m2!3d12.9555336!4d77.718696!16s%2Fg%2F11x7qk8348!19sChIJP5xUmC0TrjsRg5qED4otBHU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "body-golden-spa-thubarahalli",
    "name": "Body Golden Spa -Thubarahalli",
    "description": "Highly rated day spa in Marathahalli with excellent reviews and professional service.",
    "address": "3, Marathahalli Main Rd, beside Devi Eye Hospital",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Marathahalli",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 6,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9556508,
    "longitude": 77.7216491,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Body+Golden+Spa+-Thubarahalli/data=!4m7!3m6!1s0x3bae13298ebbcc81:0xbc51f311cbb4f273!8m2!3d12.9556508!4d77.7216491!16s%2Fg%2F11w7l5sf4v!19sChIJgcy7jikTrjsRc_K0yxHzUbw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-crystal-spa",
    "name": "THE CRYSTAL SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Bangalore",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 2,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9229508,
    "longitude": 77.6333015,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/THE+CRYSTAL+SPA/data=!4m7!3m6!1s0x3bae158b0d5bce13:0x370b8fef70ad470f!8m2!3d12.9229508!4d77.6333015!16s%2Fg%2F11yytmhs7p!19sChIJE85bDYsVrjsRD0etcO-PCzc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "divine-touch-sparssh-spa",
    "name": "Divine Touch Sparssh Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "No 11, 1st Floor, 8th, 6th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 2,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.931182,
    "longitude": 77.5827123,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Divine+Touch+Sparssh+Spa/data=!4m7!3m6!1s0x3bae158dc343c3ff:0x1af3bce2775d02e!8m2!3d12.931182!4d77.5827123!16s%2Fg%2F11wqs87273!19sChIJ_8NDw40VrjsRLtB1J847rwE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "csky-body-spa",
    "name": "CSKY BODY SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "3rd Block",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.5,
    "reviews_count": 2,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9286291,
    "longitude": 77.6291923,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/CSKY+BODY+SPA/data=!4m7!3m6!1s0x3bae15c3f2904469:0x86f7c6eccf84ce96!8m2!3d12.9286291!4d77.6291923!16s%2Fg%2F11fl3nd2_8!19sChIJaUSQ8sMVrjsRls6Ez-zG94Y?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bodycraft-salon-spa-clinic-hsr-layout",
    "name": "Bodycraft Salon, Spa & Clinic - HSR Layout",
    "description": "Highly rated beauty spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 2715,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9155447,
    "longitude": 77.6449739,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bodycraft+Salon,+Spa+%26+Clinic+-+HSR+Layout/data=!4m7!3m6!1s0x3bae148501b8f2d9:0x2a83a131ef676e9a!8m2!3d12.9155447!4d77.6449739!16s%2Fg%2F11hd9t0spj!19sChIJ2fK4AYUUrjsRmm5n7zGhgyo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bodycraft-salon-spa-clinic-whitefield",
    "name": "Bodycraft Salon, Spa & Clinic - Whitefield",
    "description": "Highly rated beauty spa in Whitefield with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 2469,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9585743,
    "longitude": 77.746603,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bodycraft+Salon,+Spa+%26+Clinic+-+Whitefield/data=!4m7!3m6!1s0x3bae0df65f4e86d3:0x3c2124447e6ab9d4!8m2!3d12.9585743!4d77.746603!16s%2Fg%2F1hf3lt8vr!19sChIJ04ZOX_YNrjsR1LlqfkQkITw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "green-trends-unisex-hair-style-salon-whitefield",
    "name": "Green Trends Unisex Hair & Style Salon - Whitefield",
    "description": "Highly rated beauty spa in Whitefield with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 2271,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9593654,
    "longitude": 77.7462227,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Green+Trends+Unisex+Hair+%26+Style+Salon+-+Whitefield/data=!4m7!3m6!1s0x3bae0df649034ac7:0xfd33ee0b505afbec!8m2!3d12.9593654!4d77.7462227!16s%2Fg%2F11b6gd9p7j!19sChIJx0oDSfYNrjsR7PtaUAvuM_0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "naturals-salon-spa-sahakara-nagar-bengaluru",
    "name": "Naturals Salon & Spa Sahakara Nagar, Bengaluru",
    "description": "Highly rated beauty spa in Sahakara Nagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Sahakara Nagar",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 1711,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 13.0631089,
    "longitude": 77.5920721,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Naturals+Salon+%26+Spa+Sahakara+Nagar,+Bengaluru/data=!4m7!3m6!1s0x3bae182420762a8f:0xa862bf91311dca94!8m2!3d13.0631089!4d77.5920721!16s%2Fg%2F1pp2vd8lk!19sChIJjyp2ICQYrjsRlModMZG_Yqg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "play-salon-mantri-mall-malleswaram",
    "name": "Play Salon | Mantri Mall Malleswaram",
    "description": "Highly rated beauty spa in Malleshwaram with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Malleshwaram",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 1222,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9915524,
    "longitude": 77.5703927,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Play+Salon+%7C+Mantri+Mall+Malleswaram/data=!4m7!3m6!1s0x3bae1633e91d6869:0x2cd89a4b85af03b3!8m2!3d12.9915524!4d77.5703927!16s%2Fg%2F1v2kvwy5!19sChIJaWgd6TMWrjsRswOvhUua2Cw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nirvana-international-spa",
    "name": "Nirvana International Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 1118,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9952584,
    "longitude": 77.6669003,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nirvana+International+Spa/data=!4m7!3m6!1s0x3bae11bdc1bf65a1:0xdb2a54803a10c9f3!8m2!3d12.9952584!4d77.6669003!16s%2Fg%2F11h75_wct5!19sChIJoWW_wb0RrjsR88kQOoBUKts?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "toni-guy-hairdressing-whitefield-siddapura",
    "name": "TONI&GUY Hairdressing, WHITEFIELD Siddapura",
    "description": "Highly rated day spa in Whitefield with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 1034,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9569692,
    "longitude": 77.7322365,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/TONI%26GUY+Hairdressing,+WHITEFIELD+Siddapura/data=!4m7!3m6!1s0x3bae137e4c0d247f:0xb1a3182640404875!8m2!3d12.9569692!4d77.7322365!16s%2Fg%2F11f5tvzs7_!19sChIJfyQNTH4TrjsRdUhAQCYYo7E?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "la-asia-spa-salon",
    "name": "La'ASIA Spa & Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 1030,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9698552,
    "longitude": 77.7350809,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/La%27ASIA+Spa+%26+Salon/data=!4m7!3m6!1s0x3bae12033fcb2d6f:0xf87f98cffdcb6!8m2!3d12.9698552!4d77.7350809!16s%2Fg%2F11fy_qk43c!19sChIJby3LPwMSrjsRttz_jPmHDwA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "saloon-101-itpl-loreal",
    "name": "SALOON 101-ITPL(LOREAL)",
    "description": "Highly rated day spa in ITPL with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "ITPL",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 676,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9803777,
    "longitude": 77.7333074,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/SALOON+101-ITPL%28LOREAL%29/data=!4m7!3m6!1s0x3bae11f0a68b6cc5:0xfc3979b89e39e8d2!8m2!3d12.9803777!4d77.7333074!16s%2Fg%2F11fxwm6gfz!19sChIJxWyLpvARrjsR0ug5nrh5Ofw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "toni-guy-hairdressing-whitefield-hope-farm-hair-nail-botox-keratin-unisex-salon",
    "name": "TONI&GUY Hairdressing Whitefield /Hope farm | Hair | Nail | Botox | Keratin | Unisex Salon",
    "description": "Highly rated beauty spa in Whitefield with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 653,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9790941,
    "longitude": 77.7516903,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/TONI%26GUY+Hairdressing+Whitefield+%2FHope+farm+%7C+Hair+%7C+Nail+%7C+Botox+%7C+Keratin+%7C+Unisex+Salon/data=!4m7!3m6!1s0x3bae0e06b868cb6d:0xcb502534d61e8af!8m2!3d12.9790941!4d77.7516903!16s%2Fg%2F11f_22sgps!19sChIJbctouAYOrjsRr-hhTVMCtQw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "refresh-salon-spa-the-best-family-salon-and-spa-in-hsr-layout",
    "name": "Refresh Salon & Spa The Best Family Salon And Spa In HSR Layout",
    "description": "Highly rated beauty spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 643,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9077832,
    "longitude": 77.6491111,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Refresh+Salon+%26+Spa+The+Best+Family+Salon+And+Spa+In+HSR+Layout/data=!4m7!3m6!1s0x3bae15485d0948fd:0x4b37bec6b75865d6!8m2!3d12.9077832!4d77.6491111!16s%2Fg%2F11pv0q4jmz!19sChIJ_UgJXUgVrjsR1mVYt8a-N0s?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "four-fountains-de-stress-spa-brookefield",
    "name": "Four Fountains De-Stress Spa Brookefield",
    "description": "Highly rated day spa in Brookefield with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Brookefield",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 596,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9609829,
    "longitude": 77.7167648,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Four+Fountains+De-Stress+Spa+Brookefield/data=!4m7!3m6!1s0x3bae123ca7e6c023:0x3e322cc7363c45b7!8m2!3d12.9609829!4d77.7167648!16s%2Fg%2F11xg4gg0r!19sChIJI8DmpzwSrjsRt0U8NscsMj4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "dreams-salon-spa",
    "name": "Dreams Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "26, 10th Cross Rd, near Asha Food Camp",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 589,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 13.0009391,
    "longitude": 77.5728371,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Dreams+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae174c1d0ef321:0xbbc5e2da94385a9!8m2!3d13.0009391!4d77.5728371!16s%2Fg%2F11fcv4_5tc!19sChIJIfMOHUwXrjsRqYVDqS1evAs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-meraki",
    "name": "Spa Meraki",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 533,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9669659,
    "longitude": 77.6412837,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spa+Meraki/data=!4m7!3m6!1s0x3bae141d241577f5:0x9bd3ed34d4de2092!8m2!3d12.9669659!4d77.6412837!16s%2Fg%2F11f37q5hsx!19sChIJ9XcVJB0UrjsRkiDe1DTt05s?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "body-raaga-wellness-spa-jayanagar",
    "name": "Body Raaga Wellness Spa Jayanagar",
    "description": "Highly rated wellness spa in Jayanagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 370,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.931084,
    "longitude": 77.5859616,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Body+Raaga+Wellness+Spa+Jayanagar/data=!4m7!3m6!1s0x3bae15a29ccfb033:0xe22a84da4509feac!8m2!3d12.931084!4d77.5859616!16s%2Fg%2F11bc70_m5h!19sChIJM7DPnKIVrjsRrP4JRdqEKuI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "body-raaga-wellness-spa-indiranagar",
    "name": "Body Raaga Wellness Spa Indiranagar",
    "description": "Highly rated wellness spa in Indiranagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 347,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.969598,
    "longitude": 77.6382944,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Body+Raaga+Wellness+Spa+Indiranagar/data=!4m7!3m6!1s0x3bae16a76178de39:0xaa07c3b77ae91bd3!8m2!3d12.969598!4d77.6382944!16s%2Fg%2F1pxwslgf2!19sChIJOd54YacWrjsR0xvperfDB6o?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "salon-perimeter-rajaji-nagar",
    "name": "Salon Perimeter Rajaji Nagar",
    "description": "Highly rated beauty spa in Rajajinagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Rajajinagar",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 342,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 13.0034757,
    "longitude": 77.5501832,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Salon+Perimeter+Rajaji+Nagar/data=!4m7!3m6!1s0x3bae3d9a03663931:0xa99e1416b984d3de!8m2!3d13.0034757!4d77.5501832!16s%2Fg%2F11qnny5lc0!19sChIJMTlmA5o9rjsR3tOEuRYUnqk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "asian-woman-spa",
    "name": "Asian Woman Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "543, 16th A Main",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 328,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.926878,
    "longitude": 77.623139,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Asian+Woman+Spa/data=!4m7!3m6!1s0x3bae145f29368611:0xd16ca95ab85071b8!8m2!3d12.926878!4d77.623139!16s%2Fg%2F1thvfcmg!19sChIJEYY2KV8UrjsRuHFQuFqpbNE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "four-fountains-de-stress-spa",
    "name": "Four Fountains De-Stress Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 280,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9168875,
    "longitude": 77.5864457,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Four+Fountains+De-Stress+Spa/data=!4m7!3m6!1s0x3bae150b458b259b:0xfb975dee36e6bf6d!8m2!3d12.9168875!4d77.5864457!16s%2Fg%2F11hbnwkt8_!19sChIJmyWLRQsVrjsRbb_mNu5dl_s?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "pure-salon-spa-koramangla",
    "name": "Pure Salon & Spa Koramangla",
    "description": "Highly rated beauty spa in Koramangala with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 261,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9334356,
    "longitude": 77.628469,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Pure+Salon+%26+Spa+Koramangla/data=!4m7!3m6!1s0x3bae3e5684d17853:0x59ec0d72d66999ff!8m2!3d12.9334356!4d77.628469!16s%2Fg%2F11bwc7485q!19sChIJU3jRhFY-rjsR_5lp1nIN7Fk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ruan-spa-koramangala",
    "name": "Ruan Spa Koramangala",
    "description": "Highly rated day spa in Koramangala with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 254,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9349464,
    "longitude": 77.6230669,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ruan+Spa+Koramangala/data=!4m7!3m6!1s0x3bae15c723838bc1:0xc114ca97f45f22c1!8m2!3d12.9349464!4d77.6230669!16s%2Fg%2F11jmwl8738!19sChIJwYuDI8cVrjsRwSJf9JfKFME?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "zen-spa",
    "name": "Zen spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Towers, 51/27, Old Madras Road",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 246,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9630263,
    "longitude": 77.7020636,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Zen+spa/data=!4m7!3m6!1s0x3bae11f2e0d293d9:0x7e7661044c879fd2!8m2!3d12.9630263!4d77.7020636!16s%2Fg%2F11v418gfy1!19sChIJ2ZPS4PIRrjsR0p-HTARhdn4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "d5n-beauty-lounge",
    "name": "D5N Beauty Lounge",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 225,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 13.0248536,
    "longitude": 77.5922248,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/D5N+Beauty+Lounge/data=!4m7!3m6!1s0x3bae17ba6a8bb495:0xb8065d4a2f2065d4!8m2!3d13.0248536!4d77.5922248!16s%2Fg%2F11f10fmg8t!19sChIJlbSLaroXrjsR1GUgL0pdBrg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "maya-medi-spa-best-dermatologist-in-bangalore",
    "name": "Maya Medi Spa - Best Dermatologist in Bangalore",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 222,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9643744,
    "longitude": 77.6417667,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Maya+Medi+Spa+-+Best+Dermatologist+in+Bangalore/data=!4m7!3m6!1s0x3bae15f77ccf67cb:0x48cfe7b6a97cc42b!8m2!3d12.9643744!4d77.6417667!16s%2Fg%2F11j0bhy556!19sChIJy2fPfPcVrjsRK8R8qbbnz0g?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "moie-s-unisex-salon",
    "name": "Moie's unisex salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "855, 14th Cross, Chinmaya Mission Hospital Rd, opp. Health & Glow",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 219,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9752762,
    "longitude": 77.6351104,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Moie%27s+unisex+salon/data=!4m7!3m6!1s0x3bae16a3e78679f1:0x93743c2fd5c1f4e0!8m2!3d12.9752762!4d77.6351104!16s%2Fg%2F1ptwyz525!19sChIJ8XmG56MWrjsR4PTB1S88dJM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "riya-b2b-spa-with-happy-ending-massage-koramangla-bangalore",
    "name": "Riya b2b Spa with happy ending massage Koramangla Bangalore",
    "description": "Highly rated day spa in Koramangala with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 216,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9369079,
    "longitude": 77.6282609,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Riya+b2b+Spa+with+happy+ending+massage+Koramangla+Bangalore/data=!4m7!3m6!1s0x3bae15ea511d3699:0x35294410d3ee154c!8m2!3d12.9369079!4d77.6282609!16s%2Fg%2F11sk2qzcqt!19sChIJmTYdUeoVrjsRTBXu0xBEKTU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "aloe-spa-in-madiwala",
    "name": "Aloe Spa in Madiwala",
    "description": "Highly rated day spa in Madiwala with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Madiwala",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 207,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9217784,
    "longitude": 77.6205874,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Aloe+Spa+in+Madiwala/data=!4m7!3m6!1s0x3bae14bef1a1d64b:0xbd2dd4f5c8197239!8m2!3d12.9217784!4d77.6205874!16s%2Fg%2F11g9dg1q_n!19sChIJS9ah8b4UrjsROXIZyPXULb0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "footworks-foot-spa",
    "name": "Footworks-Foot Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 178,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9854569,
    "longitude": 77.5960245,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Footworks-Foot+Spa/data=!4m7!3m6!1s0x3bae1668a0e68659:0xd25d48aaf098f125!8m2!3d12.9854569!4d77.5960245!16s%2Fg%2F12qg2q96p!19sChIJWYbmoGgWrjsRJfGY8KpIXdI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "mr-smile-beauty-spa-massage-parlour-in-bangalore",
    "name": "Mr Smile Beauty Spa - Massage Parlour in Bangalore",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "2, 2nd floor, 9th cross 2nd Main Road, Guttahalli Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 166,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9990472,
    "longitude": 77.5755406,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Mr+Smile+Beauty+Spa+-+Massage+Parlour+in+Bangalore/data=!4m7!3m6!1s0x3bae17472be23bad:0x9b36d96c95ddca7!8m2!3d12.9990472!4d77.5755406!16s%2Fg%2F11q3cxh_48!19sChIJrTviK0cXrjsRp9xdyZZtswk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "snip-dark-salon-spa",
    "name": "Snip Dark Salon Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "668, 1st Floor",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 163,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9158085,
    "longitude": 77.6513381,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Snip+Dark+Salon+Spa/data=!4m7!3m6!1s0x3bae15011b4f1efd:0x864a3a5c163a2d8e!8m2!3d12.9158085!4d77.6513381!16s%2Fg%2F11sd8rg04c!19sChIJ_R5PGwEVrjsRji06Flw6SoY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sunday-the-spa",
    "name": "Sunday The Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 144,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9158282,
    "longitude": 77.6344758,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sunday+The+Spa/data=!4m7!3m6!1s0x3bae15ad50a64a73:0xae1a853a6b8209b4!8m2!3d12.9158282!4d77.6344758!16s%2Fg%2F11fb2kqvty!19sChIJc0qmUK0VrjsRtAmCazqFGq4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "relaxing-zone-spa-b2b-happy-endinbangalore",
    "name": "Relaxing zone spa. B2B. Happy endinbangalore",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "9th block, 1139, 26th A Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 143,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9144289,
    "longitude": 77.600202,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Relaxing+zone+spa.+B2B.+Happy+endinbangalore/data=!4m7!3m6!1s0x3bae1508ffffffff:0x24e5a103a1aa040e!8m2!3d12.9144289!4d77.600202!16s%2Fg%2F11rhnps87p!19sChIJ_____wgVrjsRDgSqoQOh5SQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sparadise-jp-nagar-bangalore",
    "name": "Sparadise Jp Nagar Bangalore",
    "description": "Highly rated day spa in JP Nagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "JP Nagar",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 131,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9123184,
    "longitude": 77.5855605,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sparadise+Jp+Nagar+Bangalore/data=!4m7!3m6!1s0x3bae151cfab78369:0xd77f8c45c39c72f2!8m2!3d12.9123184!4d77.5855605!16s%2Fg%2F11jsh2_2bl!19sChIJaYO3-hwVrjsR8nKcw0WMf9c?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "angel-crown-spa",
    "name": "Angel Crown Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 127,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9719197,
    "longitude": 77.6404376,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Angel+Crown+Spa/data=!4m7!3m6!1s0x3bae17f18cca9145:0x141fe81811fe11e7!8m2!3d12.9719197!4d77.6404376!16s%2Fg%2F11lsmmln9z!19sChIJRZHKjPEXrjsR5xH-ERjoHxQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "prime-wellness-male-to-male-spa-near-frazer-town",
    "name": "Prime Wellness | Male To Male Spa Near Frazer Town",
    "description": "Highly rated wellness spa in Frazer Town with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Frazer Town",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 126,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9993713,
    "longitude": 77.608466,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Prime+Wellness+%7C+Male+To+Male+Spa+Near+Frazer+Town/data=!4m7!3m6!1s0x3bae17b22f87f7e7:0x38a9958f00c3c855!8m2!3d12.9993713!4d77.608466!16s%2Fg%2F11pls2ckbm!19sChIJ5_eHL7IXrjsRVcjDAI-VqTg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "shea-spa-on-race-course-road",
    "name": "Shea Spa on Race Course Road",
    "description": "Highly rated day spa in Race Course Road with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Race Course Road",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 115,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9839597,
    "longitude": 77.5765525,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Shea+Spa+on+Race+Course+Road/data=!4m7!3m6!1s0x3bae17cbf301574f:0x59848a492bde05e8!8m2!3d12.9839597!4d77.5765525!16s%2Fg%2F11gxrv_zgt!19sChIJT1cB88sXrjsR6AXeK0mKhFk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "cedar-salon-spa",
    "name": "Cedar Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "3568, 1st floor, 13th G Main Road, 4th Cross, Link Rd 4",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 111,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9655844,
    "longitude": 77.6396895,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Cedar+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae1404ec33691b:0x687c88e28cab9ac!8m2!3d12.9655844!4d77.6396895!16s%2Fg%2F11hb51v47b!19sChIJG2kz7AQUrjsRrLnKKI7IhwY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "asya-thai-spa-hsr-layout",
    "name": "Asya Thai Spa, HSR Layout",
    "description": "Highly rated thai spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 102,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.910146,
    "longitude": 77.651904,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Asya+Thai+Spa,+HSR+Layout/data=!4m7!3m6!1s0x3bae15e82e8fb55b:0x2514bb791ff5aad6!8m2!3d12.910146!4d77.651904!16s%2Fg%2F11shx3zw3l!19sChIJW7WPLugVrjsR1qr1H3m7FCU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "glance-salon-spa",
    "name": "Glance Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 95,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9336404,
    "longitude": 77.6155689,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Glance+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae144fb95f8f8f:0x249ab00033560d48!8m2!3d12.9336404!4d77.6155689!16s%2Fg%2F11f51_0mpq!19sChIJj49fuU8UrjsRSA1WMwCwmiQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "roots-spa-unisex-salon",
    "name": "Roots Spa & Unisex Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "23, 12th cross, Main Road, behind Coffee Day",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 94,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9993549,
    "longitude": 77.5766841,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Roots+Spa+%26+Unisex+Salon/data=!4m7!3m6!1s0x3bae17ab3c4169a1:0xc5778a14d7ea282a!8m2!3d12.9993549!4d77.5766841!16s%2Fg%2F11vt6my248!19sChIJoWlBPKsXrjsRKijq1xSKd8U?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "hera-thai-spa-therapy-centre",
    "name": "Hera Thai Spa & Therapy Centre",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "5th floor, Ashrith Corner, 152/5, Neeladri Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 93,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.8415645,
    "longitude": 77.6450387,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Hera+Thai+Spa+%26+Therapy+Centre/data=!4m7!3m6!1s0x3bae6bc92da9fab3:0x4b6ee149780478b!8m2!3d12.8415645!4d77.6450387!16s%2Fg%2F11vz1wqr0n!19sChIJs_qpLclrrjsRi0eAlxTutgQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "studior-salon-spa-school",
    "name": "StudioR Salon Spa School",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 90,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9871419,
    "longitude": 77.5511059,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/StudioR+Salon+Spa+School/data=!4m7!3m6!1s0x3bae16253e21fae1:0x9caae145c7fab484!8m2!3d12.9871419!4d77.5511059!16s%2Fg%2F11c1pgz725!19sChIJ4fohPiUWrjsRhLT6x0Xhqpw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "cherish-spa",
    "name": "Cherish Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 87,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9909814,
    "longitude": 77.5561928,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Cherish+Spa/data=!4m7!3m6!1s0x3bae3de1121a26cf:0xda27971afd145962!8m2!3d12.9909814!4d77.5561928!16s%2Fg%2F11t10qn7c3!19sChIJzyYaEuE9rjsRYlkU_RqXJ9o?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "amaaya-thai-spa-salon",
    "name": "Amaaya Thai Spa & Salon",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 86,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9170169,
    "longitude": 77.5938686,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Amaaya+Thai+Spa+%26+Salon/data=!4m7!3m6!1s0x3bae15da90dada23:0x6800d4aa46b198a7!8m2!3d12.9170169!4d77.5938686!16s%2Fg%2F11qp17_h52!19sChIJI9rakNoVrjsRp5ixRqrUAGg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-studio-bengaluru",
    "name": "Spa Studio - Bengaluru",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "1st Floor, Spa Studio, 481, Siddhaiah Puranik Rd, next to HP Petrol Pump",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 75,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9961813,
    "longitude": 77.5400808,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spa+Studio+-+Bengaluru/data=!4m7!3m6!1s0x3bae3d78398ac42b:0x3612dc1745273140!8m2!3d12.9961813!4d77.5400808!16s%2Fg%2F11s84y6sqd!19sChIJK8SKOXg9rjsRQDEnRRfcEjY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ayurdhama-beauty-spa-best-spa-in-bangalore-best-massage-center-in-bangalore",
    "name": "Ayurdhama Beauty Spa - Best Spa In Bangalore | Best Massage Center In Bangalore",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd Floor, Kalpa complex, No.35, Yelenahalli Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 72,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.8716256,
    "longitude": 77.6166277,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ayurdhama+Beauty+Spa+-+Best+Spa+In+Bangalore+%7C+Best+Massage+Center+In+Bangalore/data=!4m7!3m6!1s0x3bae15493afa5b2b:0x24b4d64f8ad59ad6!8m2!3d12.8716256!4d77.6166277!16s%2Fg%2F11rh_cjwx1!19sChIJK1v6OkkVrjsR1prVik_WtCQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "avyanna-spa-spa-in-whitefield-spa-near-me-whitefield-spa-service-whitefield-massage-spa-in-whitefield",
    "name": "AVYANNA SPA | Spa in Whitefield | Spa Near Me Whitefield | Spa Service Whitefield | massage spa in Whitefield",
    "description": "Highly rated day spa in Whitefield with excellent reviews and professional service.",
    "address": "Site No.6, Surabi Complex",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 69,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9843896,
    "longitude": 77.7497645,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/AVYANNA+SPA+%7C+Spa+in+Whitefield+%7C+Spa+Near+Me+Whitefield+%7C+Spa+Service+Whitefield+%7C+massage+spa+in+Whitefield/data=!4m7!3m6!1s0x3bae0f9a6bb92841:0x9d0362f12dbb36f3!8m2!3d12.9843896!4d77.7497645!16s%2Fg%2F11lty6k5k0!19sChIJQSi5a5oPrjsR8za7LfFiA50?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "hands-of-gold-spa-beauty",
    "name": "Hands Of Gold Spa&Beauty",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "1st Floor, Commercial Complex, SpringSeas CrossWinds, Hagadur Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 66,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9640435,
    "longitude": 77.7526687,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Hands+Of+Gold+Spa%26Beauty/data=!4m7!3m6!1s0x3bae0d989e59a087:0xfb38a5130710525f!8m2!3d12.9640435!4d77.7526687!16s%2Fg%2F11grbyy_mx!19sChIJh6BZnpgNrjsRX1IQBxOlOPs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "siroy-unisex-salon-wellness-spa",
    "name": "SIROY UNISEX SALON WELLNESS SPA",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "No 3081, 6th Main Rd, behind VGR Plaza",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 58,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9729517,
    "longitude": 77.6357309,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/SIROY+UNISEX+SALON+WELLNESS+SPA/data=!4m7!3m6!1s0x3bae16a13a144f1f:0xf95f4dcf3dacf7d5!8m2!3d12.9729517!4d77.6357309!16s%2Fg%2F11f_kp4xs7!19sChIJH08UOqEWrjsR1fesPc9NX_k?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vip-spa-salon",
    "name": "VIP Spa & Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 52,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 13.0214397,
    "longitude": 77.5924145,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/VIP+Spa+%26+Salon/data=!4m7!3m6!1s0x3bae1799020a45b3:0xdc8523b097d84677!8m2!3d13.0214397!4d77.5924145!16s%2Fg%2F11p5lvqlhm!19sChIJs0UKApkXrjsRd0bYl7Ajhdw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "elsa-salon-wellness-spa",
    "name": "Elsa Salon & Wellness Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 50,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9081373,
    "longitude": 77.6353282,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Elsa+Salon+%26+Wellness+Spa/data=!4m7!3m6!1s0x3bae15e26f2dd34d:0x65a9331dfe25122b!8m2!3d12.9081373!4d77.6353282!16s%2Fg%2F11v6b_kd_9!19sChIJTdMtb-IVrjsRKxIl_h0zqWU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "elegance-salon-and-spa",
    "name": "Elegance Salon And Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 50,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 13.0083731,
    "longitude": 77.568933,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Elegance+Salon+And+Spa/data=!4m7!3m6!1s0x3bae162c96e55555:0x29d929ac77987cce!8m2!3d13.0083731!4d77.568933!16s%2Fg%2F11byyr5hp2!19sChIJVVXlliwWrjsRznyYd6wp2Sk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "seven-days-spa-in-silk-board",
    "name": "Seven Days Spa In Silk Board",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "1st Floor, Hotel Inn @ Silicon Valley 756/L, Junction towards HSR Layout",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 46,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9177924,
    "longitude": 77.6237806,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Seven+Days+Spa+In+Silk+Board/data=!4m7!3m6!1s0x3bae15e3309b9199:0x11c7907f70d05831!8m2!3d12.9177924!4d77.6237806!16s%2Fg%2F11j_7xbyjg!19sChIJmZGbMOMVrjsRMVjQcH-QxxE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "keisha-beauty-salon-spa-r",
    "name": "Keisha Beauty Salon & SPA(r)",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 45,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9671333,
    "longitude": 77.6364166,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Keisha+Beauty+Salon+%26+SPA%28r%29/data=!4m7!3m6!1s0x3bae141dd9b12b13:0x3bebca1cd39d1d11!8m2!3d12.9671333!4d77.6364166!16s%2Fg%2F11fyln1kh0!19sChIJEyux2R0UrjsRER2d0xzK6zs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "raya-thai-spa-spa-in-hsr-layout-bangalore",
    "name": "Raya Thai Spa - Spa in HSR Layout, Bangalore",
    "description": "Highly rated thai spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 45,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9142638,
    "longitude": 77.6515974,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Raya+Thai+Spa+-+Spa+in+HSR+Layout,+Bangalore/data=!4m7!3m6!1s0x3bae1504bdb2cb71:0xa7bb06cf6b1a97ee!8m2!3d12.9142638!4d77.6515974!16s%2Fg%2F11w1jf3y18!19sChIJccuyvQQVrjsR7pcaa88Gu6c?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "b2b-massage-spa-best-relaxation-your-self",
    "name": "B2b massage spa Best Relaxation your self",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "1558, 19th Main Rd, near Indian oil petrol pump",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 42,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9194981,
    "longitude": 77.6448762,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/B2b+massage+spa+Best+Relaxation+your+self/data=!4m7!3m6!1s0x3bae15ea249e782d:0xac2d204749e1950f!8m2!3d12.9194981!4d77.6448762!16s%2Fg%2F11srtw841x!19sChIJLXieJOoVrjsRD5XhSUcgLaw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-body-vibe-welness-spa",
    "name": "The Body Vibe Welness Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "# 28, Hagadur Main Rd, opp. Prestige Ozone",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 42,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9631337,
    "longitude": 77.7503263,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Body+Vibe+Welness+Spa/data=!4m7!3m6!1s0x3bae0d1cfe5d5aab:0xa56bcb85fe922275!8m2!3d12.9631337!4d77.7503263!16s%2Fg%2F11k78qb9fv!19sChIJq1pd_hwNrjsRdSKS_oXLa6U?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-ce-the-spa-best-spa-in-st-marks-road-bangalore",
    "name": "SPA.ce the Spa - Best spa in St. Marks Road, Bangalore",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 41,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9691132,
    "longitude": 77.6002945,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/SPA.ce+the+Spa+-+Best+spa+in+St.+Marks+Road,+Bangalore/data=!4m7!3m6!1s0x3bae17f86e4edea5:0xddf577c848245355!8m2!3d12.9691132!4d77.6002945!16s%2Fg%2F11rvhnq869!19sChIJpd5ObvgXrjsRVVMkSMh39d0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "oshin-beauty-parlour",
    "name": "Oshin Beauty Parlour",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 34,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 13.0075306,
    "longitude": 77.5670566,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Oshin+Beauty+Parlour/data=!4m7!3m6!1s0x3bae162b90ce4b3b:0xf73ecf07ebe93cf8!8m2!3d13.0075306!4d77.5670566!16s%2Fg%2F1hm4ny_cq!19sChIJO0vOkCsWrjsR-Dzp6wfPPvc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "atharva-unisex-spa",
    "name": "Atharva Unisex Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 32,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9757109,
    "longitude": 77.5335292,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Atharva+Unisex+Spa/data=!4m7!3m6!1s0x3bae3d08fff1b3bd:0x41f7c8b8e4a57881!8m2!3d12.9757109!4d77.5335292!16s%2Fg%2F11ww3z3_wb!19sChIJvbPx_wg9rjsRgXil5LjI90E?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "r15-spa-hsr-layout",
    "name": "R15 Spa HSR Layout",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "No 1216, 2nd floor, 14th main, 22nd Cross Rd, opp. Venkateshwara Garments, above U fashion",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 27,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9094325,
    "longitude": 77.6381801,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/R15+Spa+HSR+Layout/data=!4m7!3m6!1s0x3bae1547918b9865:0x31e0cd99bf0189c0!8m2!3d12.9094325!4d77.6381801!16s%2Fg%2F11y58_cr7y!19sChIJZZiLkUcVrjsRwIkBv5nN4DE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "silver-spa-and-salon-best-spa-in-nallurhalli",
    "name": "Silver spa and salon | best Spa In Nallurhalli",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 20,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9693913,
    "longitude": 77.7367401,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Silver+spa+and+salon+%7C+best+Spa+In+Nallurhalli/data=!4m7!3m6!1s0x3bae13dc57353d4f:0x895a6bea626c6571!8m2!3d12.9693913!4d77.7367401!16s%2Fg%2F11h5pfknjj!19sChIJTz01V9wTrjsRcWVsYuprWok?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "hiroshi-spa",
    "name": "Hiroshi Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "475/2, Hiroshi Spa, 1st Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 18,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9338109,
    "longitude": 77.6194462,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Hiroshi+Spa/data=!4m7!3m6!1s0x3bae1576f053b76f:0x8511e753c3572b8!8m2!3d12.9338109!4d77.6194462!16s%2Fg%2F11t1877459!19sChIJb7dT8HYVrjsRuHI1PHUeUQg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "best-spa-in-jeevan-bhima-nagar-lovely-med-spa",
    "name": "Best Spa in Jeevan Bhima Nagar | Lovely Med Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Door No. 1303, Benaka Plaza, Jeevan Bima Nagar Main Rd, above TVS Showroom",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 17,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9680272,
    "longitude": 77.6512087,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Best+Spa+in+Jeevan+Bhima+Nagar+%7C+Lovely+Med+Spa/data=!4m7!3m6!1s0x3bae17cb4a0e57a3:0x90146da504ff3a52!8m2!3d12.9680272!4d77.6512087!16s%2Fg%2F11rylj_6r9!19sChIJo1cOSssXrjsRUjr_BKVtFJA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "orchid-salon-and-spa",
    "name": "Orchid salon and spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Sanjay Nagar Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 16,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 13.0268563,
    "longitude": 77.5799768,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Orchid+salon+and+spa/data=!4m7!3m6!1s0x3bae17e5aa25cebf:0x71e1c66d394afb60!8m2!3d13.0268563!4d77.5799768!16s%2Fg%2F11tfkd6njp!19sChIJv84lquUXrjsRYPtKOW3G4XE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sigma-wellness-premium-male-to-male-luxury-spa-in-jayanagar-bengaluru",
    "name": "Sigma Wellness | Premium Male-to-Male Luxury Spa in Jayanagar, Bengaluru",
    "description": "Highly rated wellness spa in Jayanagar with excellent reviews and professional service.",
    "address": "673-C, 12th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 16,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9241741,
    "longitude": 77.5739513,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sigma+Wellness+%7C+Premium+Male-to-Male+Luxury+Spa+in+Jayanagar,+Bengaluru/data=!4m7!3m6!1s0x3bae156fa2c2a225:0x2007fcea3e2c269d!8m2!3d12.9241741!4d77.5739513!16s%2Fg%2F11yj57bttt!19sChIJJaLCom8VrjsRnSYsPur8ByA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vive-salon-and-spa-best-salon-in-bangalore-best-spa-in-rajajinagar-bangalore",
    "name": "VIVE SALON AND SPA | Best Salon in Bangalore | Best Spa in Rajajinagar Bangalore",
    "description": "Highly rated beauty spa in Rajajinagar with excellent reviews and professional service.",
    "address": "57,50TH CROSS, 14th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Rajajinagar",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 14,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.98748,
    "longitude": 77.5536657,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/VIVE+SALON+AND+SPA+%7C+Best+Salon+in+Bangalore+%7C+Best+Spa+in+Rajajinagar+Bangalore/data=!4m7!3m6!1s0x3bae3dec74262895:0xc116bd42effb1d7e!8m2!3d12.98748!4d77.5536657!16s%2Fg%2F11y9pt29wh!19sChIJlSgmdOw9rjsRfh3770K9FsE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-ritz-carlton-spa-bangalore",
    "name": "The Ritz Carlton Spa Bangalore",
    "description": "Highly rated luxury spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 14,
    "spa_type": "Luxury Spa",
    "services": [
      "Signature Massage",
      "Hot Stone Therapy",
      "Premium Facial",
      "Body Wrap",
      "Couples Spa",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.967265,
    "longitude": 77.6016299,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Ritz+Carlton+Spa+Bangalore/data=!4m7!3m6!1s0x3bae17aea8630d29:0xe68de2622addaf4f!8m2!3d12.967265!4d77.6016299!16s%2Fg%2F11vbjyj61r!19sChIJKQ1jqK4XrjsRT6_dKmLijeY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "shine-spa",
    "name": "Shine Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Prestige Shantiniketan, Hoodi",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 11,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9890682,
    "longitude": 77.7298644,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Shine+Spa/data=!4m7!3m6!1s0x3bae11d09244b321:0xb066b64a1073bbce!8m2!3d12.9890682!4d77.7298644!16s%2Fg%2F11j3twyn93!19sChIJIbNEktARrjsRzrtzEEq2ZrA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "splash-wellness-laxury-spa-indiranagar",
    "name": "Splash Wellness laxury spa indiranagar",
    "description": "Highly rated wellness spa in Indiranagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.4,
    "reviews_count": 7,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9674298,
    "longitude": 77.6364293,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Splash+Wellness+laxury+spa+indiranagar/data=!4m7!3m6!1s0x3bae1529a58e91f3:0xf0edd94b080d5d01!8m2!3d12.9674298!4d77.6364293!16s%2Fg%2F11vbkr4vs1!19sChIJ85GOpSkVrjsRAV0NCEvZ7fA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-zuri-whitefield-bengaluru",
    "name": "The Zuri Whitefield, Bengaluru",
    "description": "Highly rated day spa in Whitefield with excellent reviews and professional service.",
    "address": "Bangalore",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 8933,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9901636,
    "longitude": 77.7233533,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Zuri+Whitefield,+Bengaluru/data=!4m10!3m9!1s0x3bae11eca67a4595:0x8df549946d852668!5m2!4m1!1i2!8m2!3d12.9901636!4d77.7233533!16s%2Fg%2F1v9l96f8!19sChIJlUV6puwRrjsRaCaFbZRJ9Y0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "naturals-hair-beauty-salon-in-hopefarm",
    "name": "Naturals Hair & Beauty Salon in Hopefarm",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 2245,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9792056,
    "longitude": 77.7512507,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Naturals+Hair+%26+Beauty+Salon+in+Hopefarm/data=!4m7!3m6!1s0x3bae0f67d7e1bfc3:0x46b07bf33ce1c624!8m2!3d12.9792056!4d77.7512507!16s%2Fg%2F1vxz818t!19sChIJw7_h12cPrjsRJMbhPPN7sEY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bodycraft-spa-and-salon-sadashivnagar",
    "name": "Bodycraft Spa and Salon - Sadashivnagar",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "1st Flr, 403, 8th Main Rd, above Starbucks Coffee, above Starbucks",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 1856,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 13.0090623,
    "longitude": 77.5803033,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bodycraft+Spa+and+Salon+-+Sadashivnagar/data=!4m7!3m6!1s0x3bae16349177f3b1:0x623c7b09001b9774!8m2!3d13.0090623!4d77.5803033!16s%2Fg%2F11b6ncgqrh!19sChIJsfN3kTQWrjsRdJcbAAl7PGI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "salon-perimeter-malleshwara",
    "name": "Salon Perimeter Malleshwara",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Sai Prabhu, 8, Sirur Park B St",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 1187,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9931037,
    "longitude": 77.5724725,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Salon+Perimeter+Malleshwara/data=!4m7!3m6!1s0x3bae16234793ffff:0xb6f307b235397a22!8m2!3d12.9931037!4d77.5724725!16s%2Fg%2F11d_z8ly3p!19sChIJ__-TRyMWrjsRIno5NbIH87Y?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vlcc-beauty-clinic-hsr-layout-bangalore",
    "name": "VLCC BEAUTY CLINIC ( HSR Layout, Bangalore )",
    "description": "Highly rated beauty spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 1183,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9104899,
    "longitude": 77.6516807,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/VLCC+BEAUTY+CLINIC+%28+HSR+Layout,+Bangalore+%29/data=!4m7!3m6!1s0x3bae149da6366833:0x43e3f7911ac31e9d!8m2!3d12.9104899!4d77.6516807!16s%2Fg%2F11bx8q8dxj!19sChIJM2g2pp0UrjsRnR7DGpH340M?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "hop-salon-malleswaram",
    "name": "HOP Salon (Malleswaram)",
    "description": "Highly rated beauty spa in Malleshwaram with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Malleshwaram",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 582,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9946253,
    "longitude": 77.571334,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/HOP+Salon+%28Malleswaram%29/data=!4m7!3m6!1s0x3bae16249b57ae3f:0xd6751255b1f88e89!8m2!3d12.9946253!4d77.571334!16s%2Fg%2F1hm2xhbtl!19sChIJP65XmyQWrjsRiY74sVUSddY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "hr-wellness-spa-salon",
    "name": "HR Wellness Spa & Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 534,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 13.0191695,
    "longitude": 77.6432606,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/HR+Wellness+Spa+%26+Salon/data=!4m7!3m6!1s0x3bae172895fcd9ef:0x4ea06998fb06fcc3!8m2!3d13.0191695!4d77.6432606!16s%2Fg%2F1q64kgpfw!19sChIJ79n8lSgXrjsRw_wG-5hpoE4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "s-h-salon-n-spaa-best-salon-in-koramangala",
    "name": "S&H Salon N Spaa - Best Salon in koramangala",
    "description": "Highly rated beauty spa in Koramangala with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 478,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9387132,
    "longitude": 77.63213,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/S%26H+Salon+N+Spaa+-+Best+Salon+in+koramangala/data=!4m7!3m6!1s0x3bae1469b7969193:0xf6ce29f8640f6bdc!8m2!3d12.9387132!4d77.63213!16s%2Fg%2F11f_zczzz_!19sChIJk5GWt2kUrjsR3GsPZPgpzvY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-roots-salon-spa-and-ayurveda",
    "name": "THE ROOTS\u00ae\ufe0f Salon Spa and Ayurveda",
    "description": "Highly rated ayurvedic spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 384,
    "spa_type": "Ayurvedic Spa",
    "services": [
      "Abhyanga",
      "Shirodhara",
      "Panchakarma",
      "Pizhichil",
      "Kerala Massage",
      "Ayurvedic Facial"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.969097,
    "longitude": 77.7401008,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/THE+ROOTS%C2%AE%EF%B8%8F+Salon+Spa+and+Ayurveda/data=!4m7!3m6!1s0x3bae134a61cbe573:0xb44087c333f0ba74!8m2!3d12.969097!4d77.7401008!16s%2Fg%2F11f8jw9d89!19sChIJc-XLYUoTrjsRdLrwM8OHQLQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "body-raaga-wellness-spa-whitefield",
    "name": "Body Raaga Wellness Spa Whitefield",
    "description": "Highly rated wellness spa in Whitefield with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 335,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9722169,
    "longitude": 77.7512584,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Body+Raaga+Wellness+Spa+Whitefield/data=!4m7!3m6!1s0x3bae0dfe60571b39:0x9d43e6d42f226d11!8m2!3d12.9722169!4d77.7512584!16s%2Fg%2F1z44yqyrp!19sChIJORtXYP4NrjsREW0iL9TmQ50?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "lotus-unique-family-salon-and-spa",
    "name": "Lotus unique family salon and spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 323,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9213683,
    "longitude": 77.5933068,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Lotus+unique+family+salon+and+spa/data=!4m7!3m6!1s0x3bae15082b0eac7d:0x10201603b796fdd0!8m2!3d12.9213683!4d77.5933068!16s%2Fg%2F11b8076t06!19sChIJfawOKwgVrjsR0P2WtwMWIBA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ziva-spa-spa-in-jp-nagar-bangalore",
    "name": "Ziva Spa - Spa In JP Nagar Bangalore",
    "description": "Highly rated day spa in JP Nagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "JP Nagar",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 320,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.8881411,
    "longitude": 77.5820958,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ziva+Spa+-+Spa+In+JP+Nagar+Bangalore/data=!4m7!3m6!1s0x3bae1519fc86b64f:0xbd4975e7970b6c70!8m2!3d12.8881411!4d77.5820958!16s%2Fg%2F11gk8ylk05!19sChIJT7aG_BkVrjsRcGwLl-d1Sb0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "pinkk-bluue-lounge",
    "name": "Pinkk Bluue Lounge",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 314,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.969071,
    "longitude": 77.640568,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Pinkk+Bluue+Lounge/data=!4m7!3m6!1s0x3bae141d60d1314f:0xe0394fd8867ab223!8m2!3d12.969071!4d77.640568!16s%2Fg%2F11fz9j8mz_!19sChIJTzHRYB0UrjsRI7J6hthPOeA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-ce-the-spa",
    "name": "SPA.ce the Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 300,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9656048,
    "longitude": 77.6383863,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/SPA.ce+the+Spa/data=!4m7!3m6!1s0x3bae141c44ffc47b:0xef5f79fc7043ebe8!8m2!3d12.9656048!4d77.6383863!16s%2Fg%2F11cjpd5lth!19sChIJe8T_RBwUrjsR6OtDcPx5X-8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "space-the-spa",
    "name": "Space the spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 231,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9872737,
    "longitude": 77.593971,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Space+the+spa/data=!4m7!3m6!1s0x3bae16420334a38d:0x51dc3544b1e557c4!8m2!3d12.9872737!4d77.593971!16s%2Fg%2F1wnd_hv6!19sChIJjaM0A0IWrjsRxFflsUQ13FE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nest-salon-spa",
    "name": "Nest Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "2583, 17th Main, 2nd Cross",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 189,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9631721,
    "longitude": 77.6437066,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nest+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae15d1c4dfeca7:0xdddffb3cc50e403c!8m2!3d12.9631721!4d77.6437066!16s%2Fg%2F11fprxwwhk!19sChIJp-zfxNEVrjsRPEAOxTz7390?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "footworks-lounge-koramangala-india-s-finest-foot-reflexology-chain",
    "name": "Footworks Lounge - Koramangala - India's finest Foot Reflexology Chain",
    "description": "Highly rated day spa in Koramangala with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 183,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9394802,
    "longitude": 77.6216933,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Footworks+Lounge+-+Koramangala+-+India%27s+finest+Foot+Reflexology+Chain/data=!4m7!3m6!1s0x3bae1460cce75f21:0xe404d53dd580ccf3!8m2!3d12.9394802!4d77.6216933!16s%2Fg%2F1263hg129!19sChIJIV_nzGAUrjsR88yA1T3VBOQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "body-and-soul-spa-koramangala",
    "name": "Body and soul spa koramangala",
    "description": "Highly rated day spa in Koramangala with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 175,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9362673,
    "longitude": 77.6225428,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Body+and+soul+spa+koramangala/data=!4m7!3m6!1s0x3bae1565fa523479:0x5cb7fd47b2a1b556!8m2!3d12.9362673!4d77.6225428!16s%2Fg%2F11hdnzl408!19sChIJeTRS-mUVrjsRVrWhskf9t1w?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "green-day-spa",
    "name": "Green Day Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 167,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9731882,
    "longitude": 77.641595,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Green+Day+Spa/data=!4m7!3m6!1s0x3bae170ef5e0b4c1:0x148d248785f847e7!8m2!3d12.9731882!4d77.641595!16s%2Fg%2F11tcjnz5wj!19sChIJwbTg9Q4XrjsR50f4hYckjRQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "body-raaga-wellness-spa-aloft-hotel-itpl",
    "name": "Body Raaga Wellness Spa Aloft Hotel itpl",
    "description": "Highly rated wellness spa in ITPL with excellent reviews and professional service.",
    "address": "17 , Aloft hotel, Sadarmangala Road , Thigalarapalaya ,Hoodi, ITPL Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "ITPL",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 149,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9903137,
    "longitude": 77.7326003,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Body+Raaga+Wellness+Spa+Aloft+Hotel+itpl/data=!4m7!3m6!1s0x3bae11ef48b09689:0x1ea719f41b51c5db!8m2!3d12.9903137!4d77.7326003!16s%2Fg%2F11dylvs0xy!19sChIJiZawSO8RrjsR28VRG_QZpx4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "lotus-buddha-spa",
    "name": "Lotus Buddha Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 147,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9335231,
    "longitude": 77.6268632,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Lotus+Buddha+Spa/data=!4m7!3m6!1s0x3bae155cdbb4312b:0xe3561f73be3cb9d2!8m2!3d12.9335231!4d77.6268632!16s%2Fg%2F11f5vdgfdf!19sChIJKzG021wVrjsR0rk8vnMfVuM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "venky-s-unisex-salon",
    "name": "Venky's Unisex Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "11, Sri Sai Krupa, Venkata Ranga Iyengar Rd, opposite Shri Sai Mandali (Malleshwara)",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 138,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 13.0045872,
    "longitude": 77.5709722,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Venky%27s+Unisex+Salon/data=!4m7!3m6!1s0x3bae162e60df47f7:0x27df35faaba7a7de!8m2!3d13.0045872!4d77.5709722!16s%2Fg%2F12hp7qnb7!19sChIJ90ffYC4WrjsR3qenq_o13yc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-1-thai-spa",
    "name": "The 1 Thai Spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "15, 13th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 122,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 13.0036345,
    "longitude": 77.5783713,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+1+Thai+Spa/data=!4m7!3m6!1s0x3bae171f58bf9239:0x665803802adec721!8m2!3d13.0036345!4d77.5783713!16s%2Fg%2F11jsng5d2h!19sChIJOZK_WB8XrjsRIcfeKoADWGY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "aaroh-thai-spa",
    "name": "Aaroh Thai Spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 95,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.8866762,
    "longitude": 77.5819993,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Aaroh+Thai+Spa/data=!4m7!3m6!1s0x3bae150427179103:0xcbafb20284cf6fbf!8m2!3d12.8866762!4d77.5819993!16s%2Fg%2F11h3mv_z34!19sChIJA5EXJwQVrjsRv2_PhAKyr8s?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "siddhi-spa-beauty-best-spa",
    "name": "Siddhi Spa & Beauty- Best SPA",
    "description": "Highly rated beauty spa in Whitefield with excellent reviews and professional service.",
    "address": "2nd Floor, 183, Whitefield Main Rd, above Sbi Bank, opposite Nexus",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 91,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9593315,
    "longitude": 77.7462934,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Siddhi+Spa+%26+Beauty-+Best+SPA/data=!4m7!3m6!1s0x3bae0df63beedacd:0x56fb25c5addfba9d!8m2!3d12.9593315!4d77.7462934!16s%2Fg%2F11h9z82x3_!19sChIJzdruO_YNrjsRnbrfrcUl-1Y?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "triya-salon-and-studio",
    "name": "Triya Salon and studio",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "25/1, ground Floor, Pampa Layout",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 80,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 13.0514302,
    "longitude": 77.5974419,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Triya+Salon+and+studio/data=!4m7!3m6!1s0x3bae1703fec5452f:0x6fb0ece6077e4fc2!8m2!3d13.0514302!4d77.5974419!16s%2Fg%2F11gtz5j795!19sChIJL0XF_gMXrjsRwk9-B-bssG8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "day-rituals-spa",
    "name": "Day Rituals Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 71,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 13.0661237,
    "longitude": 77.579943,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Day+Rituals+Spa/data=!4m7!3m6!1s0x3bae19991dc227b1:0x98dcc7ea6427325!8m2!3d13.0661237!4d77.579943!16s%2Fg%2F11lt5s0bjt!19sChIJsSfCHZkZrjsRJXNCpn7MjQk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "glam-glow-mens-parlour",
    "name": "Glam & Glow Mens Parlour",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 68,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 13.0053607,
    "longitude": 77.5756266,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Glam+%26+Glow+Mens+Parlour/data=!4m7!3m6!1s0x3bae163185876291:0x423b8ca0df2ff54f!8m2!3d13.0053607!4d77.5756266!16s%2Fg%2F11c1xm52k5!19sChIJkWKHhTEWrjsRT_Uv36CMO0I?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "eco-beauty-spa",
    "name": "Eco Beauty Spa",
    "description": "Highly rated beauty spa in Koramangala with excellent reviews and professional service.",
    "address": "club, opp. to koramangala, opp. Ganapathi Temple Road",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 63,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.938569,
    "longitude": 77.6188097,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Eco+Beauty+Spa/data=!4m7!3m6!1s0x3bae15168bfe4719:0xfe994a3ca7a7e082!8m2!3d12.938569!4d77.6188097!16s%2Fg%2F11h4f0jt6z!19sChIJGUf-ixYVrjsRguCnpzxKmf4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "morning-glory-unisex-salon-and-spa",
    "name": "Morning Glory Unisex Salon and Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Rajendra Infotech Techeguyz, St, Philomena Hospital Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 52,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 13.0403897,
    "longitude": 77.6202916,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Morning+Glory+Unisex+Salon+and+Spa/data=!4m7!3m6!1s0x3bae1776a41ce2b5:0x471b74e1a7f8f6d6!8m2!3d13.0403897!4d77.6202916!16s%2Fg%2F11vprs0mnd!19sChIJteIcpHYXrjsR1vb4p-F0G0c?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "la-thai-spa",
    "name": "La Thai Spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "17th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 52,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9123592,
    "longitude": 77.6422397,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/La+Thai+Spa/data=!4m7!3m6!1s0x3bae15ab3f5560b1:0x474519f17471455f!8m2!3d12.9123592!4d77.6422397!16s%2Fg%2F11hzqwdb8p!19sChIJsWBVP6sVrjsRX0VxdPEZRUc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-deep-ocean-wellness-center-jayanagar-m2m",
    "name": "The Deep Ocean Wellness Center - Jayanagar - M2M",
    "description": "Highly rated wellness spa in Jayanagar with excellent reviews and professional service.",
    "address": "147, 36th A Cross, 7th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 50,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9229337,
    "longitude": 77.5817498,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Deep+Ocean+Wellness+Center+-+Jayanagar+-+M2M/data=!4m7!3m6!1s0x3bae15f3a07b27f1:0x9d83ac007e9c39d5!8m2!3d12.9229337!4d77.5817498!16s%2Fg%2F11m68mfzzt!19sChIJ8Sd7oPMVrjsR1TmcfgCsg50?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "golden-star-unisex-salon-spa",
    "name": "Golden Star Unisex Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "135, Vijaya Arcade, 3, Lal Bagh Main Rd, opp. to Maruthi Suzuki",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 49,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9605785,
    "longitude": 77.5877671,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Golden+Star+Unisex+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae15363d5a9d9d:0x2e6e68edba9392ad!8m2!3d12.9605785!4d77.5877671!16s%2Fg%2F11try3sjpn!19sChIJnZ1aPTYVrjsRrZKTuu1obi4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "tulip-thai-spa-whitefield",
    "name": "TULIP THAI SPA - WHITEFIELD",
    "description": "Highly rated thai spa in Whitefield with excellent reviews and professional service.",
    "address": "Sy No. 220B, 1st Floor, ITPL Main Rd, near Manipal Hospital 1",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 48,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9882418,
    "longitude": 77.7298189,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/TULIP+THAI+SPA+-+WHITEFIELD/data=!4m7!3m6!1s0x3bae115c7de1d3f7:0xd4f3c20ae6a2df10!8m2!3d12.9882418!4d77.7298189!16s%2Fg%2F11y2gy0_jc!19sChIJ99PhfVwRrjsREN-i5grC89Q?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "urban-zen-spa",
    "name": "Urban Zen Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 47,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9692799,
    "longitude": 77.6009409,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Urban+Zen+Spa/data=!4m7!3m6!1s0x3bae178b09ea9ffd:0x9b1fbde622a1eb81!8m2!3d12.9692799!4d77.6009409!16s%2Fg%2F11tc7pyzjq!19sChIJ_Z_qCYsXrjsRgeuhIua9H5s?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "relax-ayurvedic-saloon-and-spa",
    "name": "Relax Ayurvedic Saloon and Spa",
    "description": "Highly rated ayurvedic spa in Bangalore with excellent reviews and professional service.",
    "address": "284/1 Between 17th &, 18th Cross",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 44,
    "spa_type": "Ayurvedic Spa",
    "services": [
      "Abhyanga",
      "Shirodhara",
      "Panchakarma",
      "Pizhichil",
      "Kerala Massage",
      "Ayurvedic Facial"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 13.0079555,
    "longitude": 77.5712953,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Relax+Ayurvedic+Saloon+and+Spa/data=!4m7!3m6!1s0x3bae17bf5b9df929:0xe8c9536b558c7c8!8m2!3d13.0079555!4d77.5712953!16s%2Fg%2F11s1q_g912!19sChIJKfmdW78XrjsRyMdYtTaVjA4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "roca-unisex-salon-and-spa",
    "name": "Roca unisex salon and Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 34,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9337201,
    "longitude": 77.6288256,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Roca+unisex+salon+and+Spa/data=!4m7!3m6!1s0x3bae151b06e403eb:0xa78ba11de4149a6d!8m2!3d12.9337201!4d77.6288256!16s%2Fg%2F11j4gyrccz!19sChIJ6wPkBhsVrjsRbZoU5B2hi6c?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "marvel-garden-unisex-salon-and-spa",
    "name": "Marvel Garden Unisex Salon and Spa",
    "description": "Highly rated beauty spa in Varthur with excellent reviews and professional service.",
    "address": "No 06, SPK Building, Varthur Main Rd, opposite Sigma Tech Park",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Varthur",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 32,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.956675,
    "longitude": 77.743206,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Marvel+Garden+Unisex+Salon+and+Spa/data=!4m7!3m6!1s0x3bae13defc911add:0xf8fdd900585b8104!8m2!3d12.956675!4d77.743206!16s%2Fg%2F11h54l__dl!19sChIJ3RqR_N4TrjsRBIFbWADZ_fg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "f-k-star-wellness-spa",
    "name": "F K STAR WELLNESS SPA",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "84, Industrial Town, Magadi Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 26,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9765887,
    "longitude": 77.5471162,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/F+K+STAR+WELLNESS+SPA/data=!4m7!3m6!1s0x3bae3d5bfbf52a59:0xe7ab326686516c9f!8m2!3d12.9765887!4d77.5471162!16s%2Fg%2F11w7cjyq7w!19sChIJWSr1-1s9rjsRn2xRhmYyq-c?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "infuse-spa-at-four-seasons-hotel-bengaluru-at-embassy-one",
    "name": "Infuse Spa at Four Seasons Hotel Bengaluru at Embassy ONE",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 20,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 13.0193514,
    "longitude": 77.5848443,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Infuse+Spa+at+Four+Seasons+Hotel+Bengaluru+at+Embassy+ONE/data=!4m7!3m6!1s0x3bae17a7a5112873:0x27e3dc583cea499a!8m2!3d13.0193514!4d77.5848443!16s%2Fg%2F11j8v_t78n!19sChIJcygRpacXrjsRmknqPFjc4yc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "m2-spa-salon-best-spa",
    "name": "M2 Spa & Salon- Best Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 19,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9686503,
    "longitude": 77.649986,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/M2+Spa+%26+Salon-+Best+Spa/data=!4m7!3m6!1s0x3bae15683cbcce77:0x46d74f567f578083!8m2!3d12.9686503!4d77.649986!16s%2Fg%2F11td4p_9hc!19sChIJd868PGgVrjsRg4BXf1ZP10Y?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-heaven-international-spa",
    "name": "The Heaven International Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "5th Floor, Smart Square, No. 501, Shri Krishna Temple Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 16,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9791695,
    "longitude": 77.6415933,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Heaven+International+Spa/data=!4m7!3m6!1s0x3bae15e3e0d2527f:0xc8ff9abda4b8706!8m2!3d12.9791695!4d77.6415933!16s%2Fg%2F11mt0y9hn8!19sChIJf1LS4OMVrjsRBodL2qv5jww?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "aqua-spa",
    "name": "AQUA SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd floor, monk mansion, Aqua spa, Symbiosis - CGI Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 11,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.8411204,
    "longitude": 77.6649609,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/AQUA+SPA/data=!4m7!3m6!1s0x3bae6d617b459ec7:0x340aaa529fe473f4!8m2!3d12.8411204!4d77.6649609!16s%2Fg%2F11ltwt__x1!19sChIJx55Fe2FtrjsR9HPkn1KqCjQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sap-spa",
    "name": "SAP Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 10,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9354825,
    "longitude": 77.6129571,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/SAP+Spa/data=!4m7!3m6!1s0x3bae15149444c4d7:0xdfb92e122705a431!8m2!3d12.9354825!4d77.6129571!16s%2Fg%2F11tnxm6fcn!19sChIJ18RElBQVrjsRMaQFJxIuud8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "shine-spa-sheraton",
    "name": "Shine Spa Sheraton",
    "description": "Highly rated luxury spa in Bangalore with excellent reviews and professional service.",
    "address": "No.26, 1, Dr Rajkumar Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 6,
    "spa_type": "Luxury Spa",
    "services": [
      "Signature Massage",
      "Hot Stone Therapy",
      "Premium Facial",
      "Body Wrap",
      "Couples Spa",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9871942,
    "longitude": 77.5601574,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Shine+Spa+Sheraton/data=!4m7!3m6!1s0x3bae3d78994b06c5:0xc200d292b02d1eef!8m2!3d12.9871942!4d77.5601574!16s%2Fg%2F11j4sxhzwn!19sChIJxQZLmXg9rjsR7x4tsJLSAMI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bessenya-wellness-center-spa-relaxing-deep-tissue-ayurvedic-massage-in-jayanagar-bangalore",
    "name": "Bessenya Wellness Center - Spa | Relaxing, Deep Tissue & Ayurvedic Massage in Jayanagar, Bangalore",
    "description": "Highly rated ayurvedic spa in Jayanagar with excellent reviews and professional service.",
    "address": "HOTEL COZZY INN, 1st Floor, 22, Tilak Nagar Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 6,
    "spa_type": "Ayurvedic Spa",
    "services": [
      "Abhyanga",
      "Shirodhara",
      "Panchakarma",
      "Pizhichil",
      "Kerala Massage",
      "Ayurvedic Facial"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9285583,
    "longitude": 77.5975506,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bessenya+Wellness+Center+-+Spa+%7C+Relaxing,+Deep+Tissue+%26+Ayurvedic+Massage+in+Jayanagar,+Bangalore/data=!4m7!3m6!1s0x3bae15a816907c29:0x9ecda3de22434fc1!8m2!3d12.9285583!4d77.5975506!16s%2Fg%2F11y0m6tl1k!19sChIJKXyQFqgVrjsRwU9DIt6jzZ4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "piko-spa",
    "name": "Piko Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "No. 4/4, Immadihalli Main Rd, opposite Sri Rama Temple",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 6,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9685376,
    "longitude": 77.7560632,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Piko+Spa/data=!4m7!3m6!1s0x3bae0d41da6e3b0b:0x12f1c56cb7516fb7!8m2!3d12.9685376!4d77.7560632!16s%2Fg%2F11m6lywhd7!19sChIJCztu2kENrjsRt29Rt2zF8RI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sun-saloon-spa",
    "name": "Sun Saloon & Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "No. 6, Immadihalli Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 6,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9691738,
    "longitude": 77.7545241,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sun+Saloon+%26+Spa/data=!4m7!3m6!1s0x3bae0dcf2dcef631:0x100bb6d3f021d4bf!8m2!3d12.9691738!4d77.7545241!16s%2Fg%2F11ftk_lzlk!19sChIJMfbOLc8NrjsRv9Qh8NO2CxA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "shellspa",
    "name": "shellspa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "White lotus lifescapes, No 4005, 100 Feet Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 4,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9627605,
    "longitude": 77.6412279,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/shellspa/data=!4m7!3m6!1s0x3bae1746977fc099:0x7e71ef7c65a5a5fb!8m2!3d12.9627605!4d77.6412279!16s%2Fg%2F11g_x09mt7!19sChIJmcB_l0YXrjsR-6WlZXzvcX4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-white-spa",
    "name": "The White Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "163, 17th C Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.3,
    "reviews_count": 4,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9358463,
    "longitude": 77.6206286,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+White+Spa/data=!4m7!3m6!1s0x3bae144540779e4d:0xb253664d55389ff!8m2!3d12.9358463!4d77.6206286!16s%2Fg%2F11j8k7qggb!19sChIJTZ53QEUUrjsR_4lT1WQ2JQs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "naturals-salon-spa-richmond-town",
    "name": "Naturals Salon & Spa Richmond Town",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 913,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9599304,
    "longitude": 77.6022482,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Naturals+Salon+%26+Spa+Richmond+Town/data=!4m7!3m6!1s0x3bae15d3d9196075:0xd0135e3f55a7f13!8m2!3d12.9599304!4d77.6022482!16s%2Fg%2F11cmbc__zg!19sChIJdWAZ2dMVrjsRE39a9eM1AQ0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vlcc-beauty-clinic-palace-road-bangalore",
    "name": "VLCC BEAUTY CLINIC ( Palace Road, Bangalore)",
    "description": "Highly rated beauty spa in Sankey Road with excellent reviews and professional service.",
    "address": "# 190, New Ward No. 35, 3rd Floor, Sankey Rd, opp. Bharat Petrol Pump",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Sankey Road",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 652,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 13.0063575,
    "longitude": 77.5794227,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/VLCC+BEAUTY+CLINIC+%28+Palace+Road,+Bangalore%29/data=!4m7!3m6!1s0x1105702b4026d6ff:0x31f856b6d343d6e4!8m2!3d13.0063575!4d77.5794227!16s%2Fg%2F11btn15cp4!19sChIJ_9YmQCtwBRER5NZD07ZW-DE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nira-thai-spa-at-jp-nagar",
    "name": "Nira Thai Spa at JP Nagar",
    "description": "Highly rated thai spa in JP Nagar with excellent reviews and professional service.",
    "address": "3rd floor Shravani Buildtech, 745/AB, 15TH Cross 24th Main Road next to Nandini hotel above McDonald\u2019s Donald\u2019s JP Nagar 6th Phase, 15th Main Rd, above mc donalds, next to nandini hotel",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "JP Nagar",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 471,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9060679,
    "longitude": 77.5855642,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nira+Thai+Spa+at+JP+Nagar/data=!4m7!3m6!1s0x3bae156427eb5ef7:0x965ca050469416e5!8m2!3d12.9060679!4d77.5855642!16s%2Fg%2F11fjzx2538!19sChIJ917rJ2QVrjsR5RaURlCgXJY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "play-salon-nexus-whitefield",
    "name": "Play Salon | Nexus Whitefield",
    "description": "Highly rated beauty spa in Whitefield with excellent reviews and professional service.",
    "address": "The Forum Neighbourhood Mall, Whitefield Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Whitefield",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 341,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9595385,
    "longitude": 77.7486057,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Play+Salon+%7C+Nexus+Whitefield/data=!4m7!3m6!1s0x3bae0dde28f18ed9:0xb4ff9b17b6d84279!8m2!3d12.9595385!4d77.7486057!16s%2Fg%2F11t1633qql!19sChIJ2Y7xKN4NrjsReULYtheb_7Q?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "walk-in-beauty-thai-spa",
    "name": "Walk In Beauty Thai Spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 326,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9715751,
    "longitude": 77.647025,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Walk+In+Beauty+Thai+Spa/data=!4m7!3m6!1s0x3bae16a991f836a7:0x39c6eb182a705631!8m2!3d12.9715751!4d77.647025!16s%2Fg%2F119wjs54s!19sChIJpzb4kakWrjsRMVZwKhjrxjk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-bengaluru-craft-and-salon",
    "name": "The Bengaluru craft and salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 217,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9351522,
    "longitude": 77.5837883,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Bengaluru+craft+and+salon/data=!4m7!3m6!1s0x3bae1597cc929de9:0x6db460cced1aa926!8m2!3d12.9351522!4d77.5837883!16s%2Fg%2F11g8nzq5s6!19sChIJ6Z2SzJcVrjsRJqka7cxgtG0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "gaigui-salon-spa",
    "name": "Gaigui Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 177,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9337892,
    "longitude": 77.6289484,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Gaigui+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae145d3ea0cdf7:0xfe0e6db4ee567929!8m2!3d12.9337892!4d77.6289484!16s%2Fg%2F1yg6c_nhf!19sChIJ982gPl0UrjsRKXlW7rRtDv4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "b2b-spa",
    "name": "B2B Spa",
    "description": "Highly rated day spa in Koramangala with excellent reviews and professional service.",
    "address": "Sony World, RMZ Gateway, 8, 80 Feet Rd, 4th Block, AVS Layout, near Koramangala",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 155,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9372427,
    "longitude": 77.6272609,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/B2B+Spa/data=!4m7!3m6!1s0x3bae1549fb80f31f:0x7c3935f14a4ff439!8m2!3d12.9372427!4d77.6272609!16s%2Fg%2F11nn44mfwg!19sChIJH_OA-0kVrjsROfRPSvE1OXw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "keva-ayurveda-hsr",
    "name": "Keva Ayurveda HSR",
    "description": "Highly rated ayurvedic spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 143,
    "spa_type": "Ayurvedic Spa",
    "services": [
      "Abhyanga",
      "Shirodhara",
      "Panchakarma",
      "Pizhichil",
      "Kerala Massage",
      "Ayurvedic Facial"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9144388,
    "longitude": 77.6405492,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Keva+Ayurveda+HSR/data=!4m7!3m6!1s0x3bae148fb4cd3ce5:0x72a30aee3717156a!8m2!3d12.9144388!4d77.6405492!16s%2Fg%2F11bbrj69by!19sChIJ5TzNtI8UrjsRahUXN-4Ko3I?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "miracle-thai-spa-salon",
    "name": "Miracle Thai spa & Salon",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "120, 4TH Floor , Santhosh Towers, near KTPO",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 123,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9773429,
    "longitude": 77.724883,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Miracle+Thai+spa+%26+Salon/data=!4m7!3m6!1s0x3bae11a8608cdd37:0xc2e04a50362bcd31!8m2!3d12.9773429!4d77.724883!16s%2Fg%2F11h7b1l24w!19sChIJN92MYKgRrjsRMc0rNlBK4MI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "rian-luxury-thai-spa-marathahalli",
    "name": "Rian Luxury Thai Spa Marathahalli",
    "description": "Highly rated thai spa in Marathahalli with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Marathahalli",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 120,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9478244,
    "longitude": 77.6993099,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Rian+Luxury+Thai+Spa+Marathahalli/data=!4m7!3m6!1s0x3bae15fea88d65ed:0xb283776a3439090f!8m2!3d12.9478244!4d77.6993099!16s%2Fg%2F11rvlrvdfx!19sChIJ7WWNqP4VrjsRDwk5NGp3g7I?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "aroma-s-spa",
    "name": "Aroma's Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 113,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 13.0279282,
    "longitude": 77.637507,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Aroma%27s+Spa/data=!4m7!3m6!1s0x3bae1723b89504bd:0x1aece3bfc2aa0b10!8m2!3d13.0279282!4d77.637507!16s%2Fg%2F11k4_d536x!19sChIJvQSVuCMXrjsREAuqwr_j7Bo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ayurveda-jeevana-spa",
    "name": "Ayurveda Jeevana Spa",
    "description": "Highly rated ayurvedic spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 97,
    "spa_type": "Ayurvedic Spa",
    "services": [
      "Abhyanga",
      "Shirodhara",
      "Panchakarma",
      "Pizhichil",
      "Kerala Massage",
      "Ayurvedic Facial"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.8852659,
    "longitude": 77.5873669,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ayurveda+Jeevana+Spa/data=!4m7!3m6!1s0x3bae15db970f836f:0xfba8afab7a91d51f!8m2!3d12.8852659!4d77.5873669!16s%2Fg%2F11fk8v839w!19sChIJb4MPl9sVrjsRH9WRequvqPs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "fika-spa",
    "name": "Fika Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "545, 8th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 76,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9314684,
    "longitude": 77.6288185,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Fika+Spa/data=!4m7!3m6!1s0x3bae145da54a79e9:0xfd28ea42c2b3bb51!8m2!3d12.9314684!4d77.6288185!16s%2Fg%2F11dzwhjx0w!19sChIJ6XlKpV0UrjsRUbuzwkLqKP0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "juwel-spa-and-wellness",
    "name": "Juwel Spa and Wellness",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 72,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9739123,
    "longitude": 77.6462856,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Juwel+Spa+and+Wellness/data=!4m7!3m6!1s0x3bae16a9403b5cf7:0x35c0a58b84ad6fc6!8m2!3d12.9739123!4d77.6462856!16s%2Fg%2F11b6gf14_x!19sChIJ91w7QKkWrjsRxm-thIulwDU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "deep-ocean-therapy-center-m2m",
    "name": "Deep Ocean Therapy Center - M2M",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 60,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 13.0034522,
    "longitude": 77.550654,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Deep+Ocean+Therapy+Center+-+M2M/data=!4m7!3m6!1s0x2d2e3cf0e08f7093:0x5d59698ec394e28!8m2!3d13.0034522!4d77.550654!16s%2Fg%2F11w9bg4vqk!19sChIJk3CP4PA8Li0RKE457JiW1QU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "f2m-b2b-unisex-spa",
    "name": "F2M -B2B unisex spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Bangalore",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 59,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9234043,
    "longitude": 77.6176311,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/F2M+-B2B+unisex+spa/data=!4m7!3m6!1s0x3bae15066276c3e3:0xebf0c0c3ed8c8833!8m2!3d12.9234043!4d77.6176311!16s%2Fg%2F11tk4f0tj1!19sChIJ48N2YgYVrjsRM4iM7cPA8Os?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "tattvaa-wellness-spa-beauty-salon",
    "name": "Tattvaa - Wellness Spa & Beauty Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Hotel Presidency #47 4th floor, KIADB Layout",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 44,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.8531905,
    "longitude": 77.6753642,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Tattvaa+-+Wellness+Spa+%26+Beauty+Salon/data=!4m7!3m6!1s0x3bae6d9a8d1ebc59:0x596a09b68c79c724!8m2!3d12.8531905!4d77.6753642!16s%2Fg%2F11s9g790l9!19sChIJWbwejZptrjsRJMd5jLYJalk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "arowana-reflexology-spa-and-salon",
    "name": "Arowana reflexology spa and salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Building 31, 1st floor, 1st Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 42,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.928679,
    "longitude": 77.6356442,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Arowana+reflexology+spa+and+salon/data=!4m7!3m6!1s0x3bae15d9f68a92d5:0x49cce0567906ba29!8m2!3d12.928679!4d77.6356442!16s%2Fg%2F11rj3z78dd!19sChIJ1ZKK9tkVrjsRKboGeVbgzEk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "dream-land-spa-and-saloon",
    "name": "Dream Land Spa and Saloon",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "47, 41st Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 41,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9898007,
    "longitude": 77.5556793,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Dream+Land+Spa+and+Saloon/data=!4m7!3m6!1s0x3bae3d523bbf338b:0xdec5c0f779b55134!8m2!3d12.9898007!4d77.5556793!16s%2Fg%2F11h4lmxd5b!19sChIJizO_O1I9rjsRNFG1effAxd4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-relax-b2b-massage-happy-ending-spa-bangalore",
    "name": "The relax b2b massage happy ending spa bangalore",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 37,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9673135,
    "longitude": 77.7157673,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+relax+b2b+massage+happy+ending+spa+bangalore/data=!4m7!3m6!1s0x3bae1389ba41e383:0xd0e6687395219969!8m2!3d12.9673135!4d77.7157673!16s%2Fg%2F11shx_ypf4!19sChIJg-NBuokTrjsRaZkhlXNo5tA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "prolife-spa",
    "name": "Prolife spa",
    "description": "Highly rated day spa in Indiranagar with excellent reviews and professional service.",
    "address": "2nd floor, UR road indiranagar Landmark, 3163, 12th A Main Rd, near ESI hospital",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 33,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9692113,
    "longitude": 77.6358828,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Prolife+spa/data=!4m7!3m6!1s0x3bae17b9240fbb17:0x17f543168ca903a0!8m2!3d12.9692113!4d77.6358828!16s%2Fg%2F11vlskghz7!19sChIJF7sPJLkXrjsRoAOpjBZD9Rc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bodyshine",
    "name": "BODYSHINE",
    "description": "Highly rated day spa in Indiranagar with excellent reviews and professional service.",
    "address": "1st Phase, #154, Body Shine Spa & Salon 1st floor 9th Cross Rd, Binnamangala, Stage 1, Indiranagar, Bengaluru, Karnataka - India 560038",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 25,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9768847,
    "longitude": 77.6357475,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/BODYSHINE/data=!4m7!3m6!1s0x3bae174576e2b715:0x60610ba3f33c4af8!8m2!3d12.9768847!4d77.6357475!16s%2Fg%2F11h3qrmlpp!19sChIJFbfidkUXrjsR-Eo886MLYWA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "kaamya-salon-spa",
    "name": "Kaamya salon spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Bus stop, 96/1Ashwathnagar, Sanjay Nagar Main Rd, opp. ashwathnagar",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 25,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 13.0270699,
    "longitude": 77.5796419,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Kaamya+salon+spa/data=!4m7!3m6!1s0x3bae17633e6dae75:0x85333f8244b21066!8m2!3d13.0270699!4d77.5796419!16s%2Fg%2F11kbb23xws!19sChIJda5tPmMXrjsRZhCyRII_M4U?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sky-retreat-spa",
    "name": "Sky Retreat spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "275,4th floor, JMJ Apartments, 100 Feet Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 24,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9740973,
    "longitude": 77.6407191,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sky+Retreat+spa/data=!4m7!3m6!1s0x3bae1756d9cb81e7:0xf9214b9040a95f3e!8m2!3d12.9740973!4d77.6407191!16s%2Fg%2F11grc291jb!19sChIJ54HL2VYXrjsRPl-pQJBLIfk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-ritual",
    "name": "Spa Ritual",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 18,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 13.0421519,
    "longitude": 77.6249623,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spa+Ritual/data=!4m7!3m6!1s0x3bae17cc5776b27f:0x9494a324dd406629!8m2!3d13.0421519!4d77.6249623!16s%2Fg%2F11h31w4z84!19sChIJf7J2V8wXrjsRKWZA3SSjlJQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "new-glare-spa",
    "name": "NEW GLARE SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "block 9, Glare spa th, 1830, 41 st cross, 26th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 18,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9167283,
    "longitude": 77.58947,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/NEW+GLARE+SPA/data=!4m7!3m6!1s0x3bae15f98eac1bb3:0x177366cc0b6b7204!8m2!3d12.9167283!4d77.58947!16s%2Fg%2F11l2k5b64g!19sChIJsxusjvkVrjsRBHJrC8xmcxc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vianch-salon-and-spa",
    "name": "Vianch Salon and spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 17,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.993026,
    "longitude": 77.5562766,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Vianch+Salon+and+spa/data=!4m7!3m6!1s0x3bae3d00704f6627:0x395415ac8350fdea!8m2!3d12.993026!4d77.5562766!16s%2Fg%2F11yppt9jpg!19sChIJJ2ZPcAA9rjsR6v1Qg6wVVDk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "blue-sea-spa",
    "name": "Blue sea spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "1, 902 John ark ,80 feet road, block road, 6th A Main Rd, near Jubilee tea and bakery",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 17,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9298474,
    "longitude": 77.6337955,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Blue+sea+spa/data=!4m7!3m6!1s0x3bae15069e721d91:0xc34886aa13be4f7f!8m2!3d12.9298474!4d77.6337955!16s%2Fg%2F11txphzdfz!19sChIJkR1yngYVrjsRf0--E6qGSMM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "glossy-spa-and-salon-best-in-jayanagar-bangalore",
    "name": "Glossy Spa and Salon, Best in Jayanagar, Bangalore",
    "description": "Highly rated beauty spa in Jayanagar with excellent reviews and professional service.",
    "address": "No. 233/A, 2nd floor, 39th cross, 26th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 13,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9206741,
    "longitude": 77.5933027,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Glossy+Spa+and+Salon,+Best+in+Jayanagar,+Bangalore/data=!4m7!3m6!1s0x3bae15a88a19404f:0x11cca7d86bd143b5!8m2!3d12.9206741!4d77.5933027!16s%2Fg%2F11vwrrjkz3!19sChIJT0AZiqgVrjsRtUPRa9inzBE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-palace-beauty-spa",
    "name": "THE PALACE BEAUTY SPA",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "1th Floor Dharan Residency Hotel Vidyanagar 5th Cross Hosur",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 10,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.8216969,
    "longitude": 77.686999,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/THE+PALACE+BEAUTY+SPA/data=!4m7!3m6!1s0x3bae6dcb065ce0db:0xbeb1bba6eb7f2f5a!8m2!3d12.8216969!4d77.686999!16s%2Fg%2F11lv48ts6h!19sChIJ2-BcBsttrjsRWi9_66a7sb4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "pink-passion-beauty-spa",
    "name": "Pink Passion Beauty & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 6,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 13.0024932,
    "longitude": 77.5553512,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Pink+Passion+Beauty+%26+Spa/data=!4m7!3m6!1s0x3bae3d278d0a0b65:0xcbcd1c179b1fbd2e!8m2!3d13.0024932!4d77.5553512!16s%2Fg%2F11rxmr19xp!19sChIJZQsKjSc9rjsRLr0fmxcczcs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "golden-birds-beauty-salon",
    "name": "Golden birds beauty salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "32/1, Sultanpalya Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.2,
    "reviews_count": 5,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 13.0355751,
    "longitude": 77.6047976,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Golden+birds+beauty+salon/data=!4m7!3m6!1s0x3bae170007d78d93:0x228f1db857f77e0c!8m2!3d13.0355751!4d77.6047976!16s%2Fg%2F11zk6zj875!19sChIJk43XBwAXrjsRDH73V7gdjyI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "jawed-habib-hair-studio-indiranagar",
    "name": "Jawed Habib Hair studio Indiranagar",
    "description": "Highly rated day spa in Indiranagar with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 1201,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9740165,
    "longitude": 77.6359348,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Jawed+Habib+Hair+studio+Indiranagar/data=!4m7!3m6!1s0x3bae16a581bc92cf:0x3f154a2ba7b461e8!8m2!3d12.9740165!4d77.6359348!16s%2Fg%2F11fy996q0y!19sChIJz5K8gaUWrjsR6GG0pytKFT8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vip-spa",
    "name": "VIP Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 390,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 13.029704,
    "longitude": 77.578462,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/VIP+Spa/data=!4m7!3m6!1s0x3bae169ea347270f:0x72bb8fa30f755830!8m2!3d13.029704!4d77.578462!16s%2Fg%2F11c2qq0cyv!19sChIJDydHo54WrjsRMFh1D6OPu3I?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "flicks-salon-spa",
    "name": "Flicks Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "898/1, 80 Feet Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 234,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9396617,
    "longitude": 77.6258093,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Flicks+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae16803701df7f:0x747ae18127470a2f!8m2!3d12.9396617!4d77.6258093!16s%2Fg%2F1tf_fvs2!19sChIJf98BN4AWrjsRLwpHJ4HhenQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "trendjuvenate-best-massage-spa-center-in-koramangala-bangalore",
    "name": "Trendjuvenate - Best Massage Spa Center in Koramangala, Bangalore",
    "description": "Highly rated day spa in Koramangala with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Koramangala",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 227,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9292249,
    "longitude": 77.6350657,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Trendjuvenate+-+Best+Massage+Spa+Center+in+Koramangala,+Bangalore/data=!4m7!3m6!1s0x3bae146149f159a1:0xb871b846c12e7b91!8m2!3d12.9292249!4d77.6350657!16s%2Fg%2F1vfp21t4!19sChIJoVnxSWEUrjsRkXsuwUa4cbg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "blanca-paloma-spa-and-salon-best-spa-in-indiranagar",
    "name": "Blanca Paloma Spa and Salon | Best Spa in Indiranagar",
    "description": "Highly rated beauty spa in Indiranagar with excellent reviews and professional service.",
    "address": "A, 1st Floor, No. 317, 6th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 220,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9739157,
    "longitude": 77.645564,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Blanca+Paloma+Spa+and+Salon+%7C+Best+Spa+in+Indiranagar/data=!4m7!3m6!1s0x3bae16afdb4cc6cf:0xb838bba28be0a658!8m2!3d12.9739157!4d77.645564!16s%2Fg%2F11b7tq_5xv!19sChIJz8ZM268WrjsRWKbgi6K7OLg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "zuan-thai-spa",
    "name": "Zuan Thai Spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "949, 2nd floor ,12th Main, 100 Feet Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 199,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9701984,
    "longitude": 77.6390829,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Zuan+Thai+Spa/data=!4m7!3m6!1s0x3bae177a465aec7f:0xb1b08fb572e67318!8m2!3d12.9701984!4d77.6390829!16s%2Fg%2F11h2xlt6wd!19sChIJf-xaRnoXrjsRGHPmcrWPsLE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "moksha-wellness-spa",
    "name": "Moksha Wellness Spa",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 191,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9092694,
    "longitude": 77.6491765,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Moksha+Wellness+Spa/data=!4m7!3m6!1s0x3bae157fd6d3c3b3:0x8bd2cb1792c5bfb8!8m2!3d12.9092694!4d77.6491765!16s%2Fg%2F11h7q4gz5k!19sChIJs8PT1n8VrjsRuL_FkhfL0os?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "o3-spa-and-salon",
    "name": "O3 spa and salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 115,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9771471,
    "longitude": 77.7337489,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/O3+spa+and+salon/data=!4m7!3m6!1s0x3bae11f77da6f6f3:0xeefc3a301a1e5235!8m2!3d12.9771471!4d77.7337489!16s%2Fg%2F11c6mk7fnl!19sChIJ8_amffcRrjsRNVIeGjA6_O4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sunit-b2b-happy-ending-spa",
    "name": "Sunit b2b happy ending spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "352, Park Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 93,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9670571,
    "longitude": 77.7156937,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sunit+b2b+happy+ending+spa/data=!4m7!3m6!1s0x3bae13ccb04b7fbf:0xf5bbbf6c6341cbe5!8m2!3d12.9670571!4d77.7156937!16s%2Fg%2F11ts43v0k3!19sChIJv39LsMwTrjsR5ctBY2y_u_U?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa",
    "name": "Spa",
    "description": "Highly rated day spa in ITPL with excellent reviews and professional service.",
    "address": "ITPB, ITPL Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "ITPL",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 87,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9864157,
    "longitude": 77.737444,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spa/data=!4m7!3m6!1s0x3bae11fbb81e9f0b:0x26d14f62333381c8!8m2!3d12.9864157!4d77.737444!16s%2Fg%2F11f017ls83!19sChIJC58euPsRrjsRyIEzM2JP0SY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "gladden-spa",
    "name": "Gladden Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 86,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9726255,
    "longitude": 77.6350957,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Gladden+Spa/data=!4m7!3m6!1s0x3bae17d9f95ebdb7:0x501ff62156e8a0ac!8m2!3d12.9726255!4d77.6350957!16s%2Fg%2F11grq29k49!19sChIJt71e-dkXrjsRrKDoViH2H1A?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "royal-day-unisex-spa",
    "name": "Royal Day Unisex Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "1st Floor, Madhav Mansion, No 1 #22, Philomena Hospital Rd, opp. : Five Star Wines",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 81,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 13.0401745,
    "longitude": 77.6199375,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Royal+Day+Unisex+Spa/data=!4m7!3m6!1s0x3bae176587e77c99:0xa8f72367c574f9a4!8m2!3d13.0401745!4d77.6199375!16s%2Fg%2F11l38g_cjz!19sChIJmXznh2UXrjsRpPl0xWcj96g?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "river-day-spa",
    "name": "River Day Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Door No-477, 15th Cross Road",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 79,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9813798,
    "longitude": 77.6360494,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/River+Day+Spa/data=!4m7!3m6!1s0x3bae17d272f44f67:0xfc4d38b00d05e7dc!8m2!3d12.9813798!4d77.6360494!16s%2Fg%2F11rsctdqg_!19sChIJZ0_0ctIXrjsR3OcFDbA4Tfw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "retreat-spa-salon",
    "name": "Retreat Spa & Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 77,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.940884,
    "longitude": 77.624227,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Retreat+Spa+%26+Salon/data=!4m7!3m6!1s0x3bae1446af79a16d:0xf83c57acf2ae5eac!8m2!3d12.940884!4d77.624227!16s%2Fg%2F11d_25r242!19sChIJbaF5r0YUrjsRrF6u8qxXPPg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "v3a-spa",
    "name": "V3A SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 71,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9916988,
    "longitude": 77.5562545,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/V3A+SPA/data=!4m7!3m6!1s0x3bae3d44025e60cd:0x9d189546bc246d19!8m2!3d12.9916988!4d77.5562545!16s%2Fg%2F11gjnbb9b1!19sChIJzWBeAkQ9rjsRGW0kvEaVGJ0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vegas-spa-and-saloon-btm-layout",
    "name": "Vegas Spa and Saloon @ BTM Layout",
    "description": "Highly rated day spa in BTM Layout with excellent reviews and professional service.",
    "address": "8th cross, 154, 29th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "BTM Layout",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 61,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9094882,
    "longitude": 77.6143639,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Vegas+Spa+and+Saloon+@+BTM+Layout/data=!4m7!3m6!1s0x3bae159a6e14a04d:0x75fa56a506617f70!8m2!3d12.9094882!4d77.6143639!16s%2Fg%2F11jp16j_r9!19sChIJTaAUbpoVrjsRcH9hBqVW-nU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bliss-spa-btm-1-stage-bangalore",
    "name": "Bliss spa btm 1 stage Bangalore",
    "description": "Highly rated day spa in BTM Layout with excellent reviews and professional service.",
    "address": "singnel , and, UDUPI GARDEN, 16 th main 8 th cross, park",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "BTM Layout",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 60,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9199096,
    "longitude": 77.6105467,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bliss+spa+btm+1+stage+Bangalore/data=!4m7!3m6!1s0x3bae154ccbbb9429:0xf2f0c193a091d045!8m2!3d12.9199096!4d77.6105467!16s%2Fg%2F11rycr8fbs!19sChIJKZS7y0wVrjsRRdCRoJPB8PI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "slim-life-spa",
    "name": "Slim Life & Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 59,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9555909,
    "longitude": 77.7186499,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Slim+Life+%26+Spa/data=!4m7!3m6!1s0x3bae123e9d9ffc19:0xd897a7b888afff13!8m2!3d12.9555909!4d77.7186499!16s%2Fg%2F11fy_gcsg1!19sChIJGfyfnT4SrjsRE_-viLinl9g?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-infinity-massage-hsr-layout-bangalore",
    "name": "Spa Infinity Massage HSR Layout Bangalore",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 51,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9123422,
    "longitude": 77.6429392,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spa+Infinity+Massage+HSR+Layout+Bangalore/data=!4m7!3m6!1s0x3bae1546c676498b:0xf44279f257f66e74!8m2!3d12.9123422!4d77.6429392!16s%2Fg%2F11t2m15z_7!19sChIJi0l2xkYVrjsRdG72V_J5QvQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "fancyflower-spa",
    "name": "FancyFlower Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 51,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 13.0147648,
    "longitude": 77.6359388,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/FancyFlower+Spa/data=!4m7!3m6!1s0x3bae176c1f3bc92f:0xae16f4a5a8371460!8m2!3d13.0147648!4d77.6359388!16s%2Fg%2F11j9m5j46_!19sChIJL8k7H2wXrjsRYBQ3qKX0Fq4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "rue-spa",
    "name": "Rue Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "1st Floor, Besides Market, Square Mall, 51 Hotel Monarch Stays, Hosur Rd, opp. Anjaneya Temple",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 46,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9223,
    "longitude": 77.6197799,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Rue+Spa/data=!4m7!3m6!1s0x3bae15cd1253594f:0xa06dc7bd70417300!8m2!3d12.9223!4d77.6197799!16s%2Fg%2F11k4x6n_2y!19sChIJT1lTEs0VrjsRAHNBcL3HbaA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "raya-thai-spa-spa-near-banashankari-2nd-stage",
    "name": "Raya Thai Spa | Spa Near Banashankari 2nd Stage",
    "description": "Highly rated thai spa in Banashankari with excellent reviews and professional service.",
    "address": "4 Th Floor, Lakshmi Sagar Hotel, Surabhi Sahakara Sadhana Attima, 2, 13th Cross Rd, beside Banashankari 2nd Stage",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Banashankari",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 45,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9294516,
    "longitude": 77.5637254,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Raya+Thai+Spa+%7C+Spa+Near+Banashankari+2nd+Stage/data=!4m7!3m6!1s0x4103772bf9576003:0xff6c7f10cd49179f!8m2!3d12.9294516!4d77.5637254!16s%2Fg%2F11vpzf2jpb!19sChIJA2BX-St3A0ERnxdJzRB_bP8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sonali-unic-spa-b-b-massage-parlor-in-bangalore",
    "name": "SONALI UNIC SPA B-B MASSAGE PARLOR IN BANGALORE.",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "R H PLAZA, 3rd Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 39,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9387447,
    "longitude": 77.629174,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/SONALI+UNIC+SPA+B-B+MASSAGE+PARLOR+IN+BANGALORE./data=!4m7!3m6!1s0x3bae1569bf1d6739:0x6a2a549635a00341!8m2!3d12.9387447!4d77.629174!16s%2Fg%2F11h_d4c9h2!19sChIJOWcdv2kVrjsRQQOgNZZUKmo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "lily-petals-doorstep-massage-services-in-bangalore-massage-at-home-near-me",
    "name": "Lily Petals - Doorstep massage services in Bangalore, Massage at home near me",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "Royal Space, Buliding No.154/20 V247, 3rd floor, 5th main, HSR layout",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 30,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9083167,
    "longitude": 77.6323455,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Lily+Petals+-+Doorstep+massage+services+in+Bangalore,+Massage+at+home+near+me/data=!4m7!3m6!1s0x3bae1511fd29adad:0x537a4cf30bbd2295!8m2!3d12.9083167!4d77.6323455!16s%2Fg%2F11l2clrmx8!19sChIJra0p_REVrjsRlSK9C_NMelM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "be-well-relaxing-spa-spa-near-jayanagar-9th-block",
    "name": "Be Well Relaxing Spa | Spa Near Jayanagar 9th Block",
    "description": "Highly rated day spa in Jayanagar with excellent reviews and professional service.",
    "address": "3rd floor, Poornima Towers, 26, 26th Main Rd, above Apollo Pharmacy, opposite Raggigudda Temple Arch",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 29,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9170955,
    "longitude": 77.5931708,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Be+Well+Relaxing+Spa+%7C+Spa+Near+Jayanagar+9th+Block/data=!4m7!3m6!1s0x3bae154d5c0a5c27:0xd0ccff0e41684d63!8m2!3d12.9170955!4d77.5931708!16s%2Fg%2F11rvc2cw2c!19sChIJJ1wKXE0VrjsRY01oQQ7_zNA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nisarga-ayurvedic-spa",
    "name": "Nisarga ayurvedic Spa",
    "description": "Highly rated ayurvedic spa in Bangalore with excellent reviews and professional service.",
    "address": "21,1st Floor,2nd cross, 3rd Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 28,
    "spa_type": "Ayurvedic Spa",
    "services": [
      "Abhyanga",
      "Shirodhara",
      "Panchakarma",
      "Pizhichil",
      "Kerala Massage",
      "Ayurvedic Facial"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9247994,
    "longitude": 77.6165927,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nisarga+ayurvedic+Spa/data=!4m7!3m6!1s0x3bae156d930c0503:0xf9df1dae04dfced5!8m2!3d12.9247994!4d77.6165927!16s%2Fg%2F11ry76l4kn!19sChIJAwUMk20VrjsR1c7fBK4d3_k?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ozana-spa-hsr-layout",
    "name": "Ozana Spa - HSR Layout",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "Opp Karur Vysya Bank 387 7th Sector, 9th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 21,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9078305,
    "longitude": 77.634995,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ozana+Spa+-+HSR+Layout/data=!4m7!3m6!1s0x3bae158e6a3562ff:0x2459b2edeb99f820!8m2!3d12.9078305!4d77.634995!16s%2Fg%2F11sxy7tdq2!19sChIJ_2I1ao4VrjsRIPiZ6-2yWSQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ora-wellness-spa",
    "name": "ORA WELLNESS & SPA",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "No.387, 9th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 20,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9078266,
    "longitude": 77.6352083,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/ORA+WELLNESS+%26+SPA/data=!4m7!3m6!1s0x3bae15c91a088051:0x966953eed4105b!8m2!3d12.9078266!4d77.6352083!16s%2Fg%2F11j93_jy8p!19sChIJUYAIGskVrjsRWxDU7lNplgA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "royal-life-unisex-salon-and-spa",
    "name": "Royal life unisex salon and spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd floor, Dasarahalli main road, 19th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 16,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 13.0555666,
    "longitude": 77.6063638,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Royal+life+unisex+salon+and+spa/data=!4m7!3m6!1s0x3bae176e8daeccdd:0x7e11940d72fdd588!8m2!3d13.0555666!4d77.6063638!16s%2Fg%2F11vdhjyz2t!19sChIJ3cyujW4XrjsRiNX9cg2UEX4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "b2b-happy-ending-spa-bangalore",
    "name": "B2B happy ending spa Bangalore",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "9, 1st A Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 15,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9321873,
    "longitude": 77.6324145,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/B2B+happy+ending+spa+Bangalore/data=!4m7!3m6!1s0x3bae15726a8f07d9:0x7fb6e2540e806db6!8m2!3d12.9321873!4d77.6324145!16s%2Fg%2F11tt6jh3pl!19sChIJ2QePanIVrjsRtm2ADlTitn8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "retreat-spa-and-salon-indiranagar",
    "name": "Retreat Spa and Salon - Indiranagar",
    "description": "Highly rated beauty spa in Indiranagar with excellent reviews and professional service.",
    "address": "3rd floor, 780, 9th A Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Indiranagar",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 14,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9775407,
    "longitude": 77.6396612,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Retreat+Spa+and+Salon+-+Indiranagar/data=!4m7!3m6!1s0x3bae17d559e002cb:0x64e639361e46bfa9!8m2!3d12.9775407!4d77.6396612!16s%2Fg%2F11m9_k3l2s!19sChIJywLgWdUXrjsRqb9GHjY55mQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "a-wings-saloon-and-spa",
    "name": "A wings saloon and spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "1st floor # 62/B/17, GR towers, 10th A cross, 19th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 12,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 13.0019771,
    "longitude": 77.5504187,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/A+wings+saloon+and+spa/data=!4m7!3m6!1s0x3bae3d4b33772381:0xddd706054d6bdc2a!8m2!3d13.0019771!4d77.5504187!16s%2Fg%2F11y74n05v1!19sChIJgSN3M0s9rjsRKtxrTQUG190?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vivanta-unisex-health-wellness-spa",
    "name": "Vivanta unisex health wellness spa",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "No.46, mg tower, Dr Rajkumar Rd, opp. federal bank, above Airtel shop",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 9,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.99137,
    "longitude": 77.5578267,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Vivanta+unisex+health+wellness+spa/data=!4m7!3m6!1s0x3bae3d88c3ce1f77:0x270b5964a9a32c5!8m2!3d12.99137!4d77.5578267!16s%2Fg%2F11h_cm7w1h!19sChIJdx_Ow4g9rjsRxTKaSpa1cAI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bmc-house-saloon-and-spa",
    "name": "BMC HOUSE SALOON AND SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 9,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.8429315,
    "longitude": 77.6408786,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/BMC+HOUSE+SALOON+AND+SPA/data=!4m7!3m6!1s0x3bae6b9acec59425:0x89259c3707737172!8m2!3d12.8429315!4d77.6408786!16s%2Fg%2F11s5tylggq!19sChIJJZTFzpprrjsRcnFzBzecJYk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "oxide-wellness-spa-best-spa-in-hsr-layout",
    "name": "OXIDE WELLNESS SPA/BEST SPA IN HSR LAYOUT",
    "description": "Highly rated wellness spa in HSR Layout with excellent reviews and professional service.",
    "address": "19th Main Rd, near Indian petrol bunk",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 9,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9069869,
    "longitude": 77.644472,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/OXIDE+WELLNESS+SPA%2FBEST+SPA+IN+HSR+LAYOUT/data=!4m7!3m6!1s0x3bae152ac2ad970b:0xc4ce524b2d76ee9!8m2!3d12.9069869!4d77.644472!16s%2Fg%2F11m6xgx62d!19sChIJC5etwioVrjsR6W7XsiTlTAw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sliver-spa-saloon",
    "name": "Sliver Spa Saloon",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Bangalore",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 8,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9695979,
    "longitude": 77.7446715,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sliver+Spa+Saloon/data=!4m7!3m6!1s0x3bae0d560966a737:0x3c2c07b5122e089e!8m2!3d12.9695979!4d77.7446715!16s%2Fg%2F11fk0lt_zh!19sChIJN6dmCVYNrjsRngguErUHLDw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "zola-b2b-relaxing-luxury-spa",
    "name": "ZOLA b2b Relaxing LUXURY SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Bangalore",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.1,
    "reviews_count": 7,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9021263,
    "longitude": 77.6322321,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/ZOLA+b2b+Relaxing+LUXURY+SPA/data=!4m7!3m6!1s0x3bae15d916064245:0x46e3e3b1df1408a!8m2!3d12.9021263!4d77.6322321!16s%2Fg%2F11tbwdxsz5!19sChIJRUIGFtkVrjsRikDxHTs-bgQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ode-spa-jayanagar-bengaluru",
    "name": "Ode Spa - Jayanagar, Bengaluru",
    "description": "Highly rated day spa in Jayanagar with excellent reviews and professional service.",
    "address": "H. No: 554, 10A Main Road, 36th Cross Rd, opp. Eden Park Resturent",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 434,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9231453,
    "longitude": 77.5853382,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ode+Spa+-+Jayanagar,+Bengaluru/data=!4m7!3m6!1s0x3bae159f971e8881:0xac44d3e9b3d48ad7!8m2!3d12.9231453!4d77.5853382!16s%2Fg%2F11c2qlk9zt!19sChIJgYgel58VrjsR14rUs-nTRKw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "citrine-spa-salons-spa-in-sanjay-nagar",
    "name": "Citrine Spa - Salons/Spa in Sanjay Nagar",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 164,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 13.0328686,
    "longitude": 77.5759844,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Citrine+Spa+-+Salons%2FSpa+in+Sanjay+Nagar/data=!4m7!3m6!1s0x3bae17c28b7438ef:0x61501eb81f441ddb!8m2!3d13.0328686!4d77.5759844!16s%2Fg%2F11c601vct8!19sChIJ7zh0i8IXrjsR2x1EH7geUGE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "rian-thai-spa",
    "name": "Rian Thai Spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 160,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9732999,
    "longitude": 77.6468199,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Rian+Thai+Spa/data=!4m7!3m6!1s0x3bae17a5a406fd33:0x1b41184bcd51d043!8m2!3d12.9732999!4d77.6468199!16s%2Fg%2F11p780jlwr!19sChIJM_0GpKUXrjsRQ9BRzUsYQRs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "glamour-unisex-salon-spa",
    "name": "Glamour Unisex Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 121,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 13.0083571,
    "longitude": 77.5713727,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Glamour+Unisex+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae162da7d2bf8d:0x10c5c476c7752433!8m2!3d13.0083571!4d77.5713727!16s%2Fg%2F11bxc3x8b3!19sChIJjb_Spy0WrjsRMyR1x3bExRA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "acqueen-thai-spa",
    "name": "Acqueen thai spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "No 35/1) , 3rd floor, 27th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 117,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.930691,
    "longitude": 77.5825739,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Acqueen+thai+spa/data=!4m7!3m6!1s0x3bae159a0f05bfd1:0x1479dfb6fc42bb5c!8m2!3d12.930691!4d77.5825739!16s%2Fg%2F11h_cnqjwy!19sChIJ0b8FD5oVrjsRXLtC_LbfeRQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "rian-thai-spa-new-bel-rd",
    "name": "Rian Thai Spa New BEL Rd",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "Aljosan, 2nd floor Floor, Plot No. 27, New BEL Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 114,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 13.0323221,
    "longitude": 77.5696946,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Rian+Thai+Spa+New+BEL+Rd/data=!4m7!3m6!1s0x3bae179f91dc7c9d:0x4fcfde97d56cfa91!8m2!3d13.0323221!4d77.5696946!16s%2Fg%2F11s60wx_wr!19sChIJnXzckZ8XrjsRkfps1Zfez08?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "tantra-spa",
    "name": "Tantra SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "12, 60 Feet Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 74,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9354295,
    "longitude": 77.6227148,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Tantra+SPA/data=!4m7!3m6!1s0x3bae152427411ad9:0xe4af68647f61391d!8m2!3d12.9354295!4d77.6227148!16s%2Fg%2F11gj0x7jb1!19sChIJ2RpBJyQVrjsRHTlhf2Ror-Q?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sohum-spa",
    "name": "Sohum Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "La Marvella, 1, 14th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 58,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9369229,
    "longitude": 77.5806,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sohum+Spa/data=!4m7!3m6!1s0x3bae1596c005e69f:0xbeeb45ecc7930929!8m2!3d12.9369229!4d77.5806!16s%2Fg%2F11c2nj065n!19sChIJn-YFwJYVrjsRKQmTx-xF674?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ayurvedic-salon-and-spa",
    "name": "Ayurvedic Salon and Spa",
    "description": "Highly rated ayurvedic spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 52,
    "spa_type": "Ayurvedic Spa",
    "services": [
      "Abhyanga",
      "Shirodhara",
      "Panchakarma",
      "Pizhichil",
      "Kerala Massage",
      "Ayurvedic Facial"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9233253,
    "longitude": 77.5548094,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ayurvedic+Salon+and+Spa/data=!4m7!3m6!1s0x3bae3fa4cbfd595d:0x76ae4c7f0549a1c4!8m2!3d12.9233253!4d77.5548094!16s%2Fg%2F11q9fs00fv!19sChIJXVn9y6Q_rjsRxKFJBX9MrnY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sukho-thai-spa",
    "name": "Sukho Thai Spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "3rd block, Manadi Towers, 233, 9th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 51,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9321583,
    "longitude": 77.5841261,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sukho+Thai+Spa/data=!4m7!3m6!1s0x3bae158a08a14325:0x6dd4bab706d0c3ce!8m2!3d12.9321583!4d77.5841261!16s%2Fg%2F11gmwn23yn!19sChIJJUOhCIoVrjsRzsPQBre61G0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "golden-wave-salon-spa",
    "name": "Golden Wave Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 46,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 13.0298892,
    "longitude": 77.6342819,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Golden+Wave+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae177fa5137053:0xec2e2f63feac1276!8m2!3d13.0298892!4d77.6342819!16s%2Fg%2F11fl8znytz!19sChIJU3ATpX8XrjsRdhKs_mMvLuw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "maya-wellness-spa",
    "name": "Maya Wellness Spa",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "Apartment, 75/15, Naveen Terraces, 100 Feet Rd, opp. Marks & Spencer, near Sony World Signal",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 43,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.938177,
    "longitude": 77.628945,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Maya+Wellness+Spa/data=!4m7!3m6!1s0x3bae153163457ca5:0x8315362ef9acfd35!8m2!3d12.938177!4d77.628945!16s%2Fg%2F11y75p6vkn!19sChIJpXxFYzEVrjsRNf2s-S42FYM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "aloha-spa-and-wellness",
    "name": "ALOHA SPA AND WELLNESS",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd floor, HDFC Bank, No:83, 7th Cross Rd, opp. BDA Complex",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 42,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9313388,
    "longitude": 77.6235922,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/ALOHA+SPA+AND+WELLNESS/data=!4m7!3m6!1s0x3bae1547dd177717:0x8cc850b6a01b646e!8m2!3d12.9313388!4d77.6235922!16s%2Fg%2F11pcnbnyc0!19sChIJF3cX3UcVrjsRbmQboLZQyIw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "glam-spa-wellness-ejipura",
    "name": "GLAM SPA WELLNESS | Ejipura",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "1st Floor, 1st Cross, 1st Main 100 Feet Road, Ejipura Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 42,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9386657,
    "longitude": 77.6317265,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/GLAM+SPA+WELLNESS+%7C+Ejipura/data=!4m7!3m6!1s0x3bae15a90aaa69bb:0x61062abe7cd24cb2!8m2!3d12.9386657!4d77.6317265!16s%2Fg%2F11qh2r3xls!19sChIJu2mqCqkVrjsRskzSfL4qBmE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "trustlook-spa",
    "name": "Trustlook spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 36,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9797074,
    "longitude": 77.6397992,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Trustlook+spa/data=!4m7!3m6!1s0x3bae172c23964711:0x7475f0fb603aed5e!8m2!3d12.9797074!4d77.6397992!16s%2Fg%2F11qh2rdf94!19sChIJEUeWIywXrjsRXu06YPvwdXQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-soul-new-bel-road-bangalore",
    "name": "Spa Soul - New Bel Road Bangalore",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "3, rk plaza, 80 Feet Rd, New BEL Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 34,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 13.027429,
    "longitude": 77.5774205,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spa+Soul+-+New+Bel+Road+Bangalore/data=!4m7!3m6!1s0x3bae17b49014ec19:0x394742f187e6e7da!8m2!3d13.027429!4d77.5774205!16s%2Fg%2F11yj8vnyzx!19sChIJGewUkLQXrjsR2ufmh_FCRzk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nirvana-the-spa",
    "name": "Nirvana the Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "144-C/1, Kirloskar Road",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 33,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.824631,
    "longitude": 77.6815432,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nirvana+the+Spa/data=!4m7!3m6!1s0x3bae6c5cad7ceeff:0xee3f08922f2b4ed1!8m2!3d12.824631!4d77.6815432!16s%2Fg%2F11dxb0xcd4!19sChIJ_-58rVxsrjsR0U4rL5IIP-4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "srk-ayurvedic-saloon-spa",
    "name": "SRK Ayurvedic Saloon & Spa",
    "description": "Highly rated ayurvedic spa in Bangalore with excellent reviews and professional service.",
    "address": "108, Pipeline Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 29,
    "spa_type": "Ayurvedic Spa",
    "services": [
      "Abhyanga",
      "Shirodhara",
      "Panchakarma",
      "Pizhichil",
      "Kerala Massage",
      "Ayurvedic Facial"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 13.0014363,
    "longitude": 77.5369224,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/SRK+Ayurvedic+Saloon+%26+Spa/data=!4m7!3m6!1s0x3bae3d6fae0950c7:0xb623751962425e95!8m2!3d13.0014363!4d77.5369224!16s%2Fg%2F11ryf3m9hg!19sChIJx1AJrm89rjsRlV5CYhl1I7Y?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nathan-thai-spa",
    "name": "Nathan Thai Spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "First Floor, Jeevan Bima Nagar Main Rd, above Biriyani Bhojana Hotel, opposite Miranda School",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 22,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9683422,
    "longitude": 77.650226,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nathan+Thai+Spa/data=!4m7!3m6!1s0x3bae15f9eba59599:0xd21733880481527d!8m2!3d12.9683422!4d77.650226!16s%2Fg%2F11md0j0xzd!19sChIJmZWl6_kVrjsRfVKBBIgzF9I?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "hope-tag-salon-and-spa",
    "name": "Hope Tag Salon and Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "9, 1st Floor, No, 2nd Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 22,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9822788,
    "longitude": 77.6393306,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Hope+Tag+Salon+and+Spa/data=!4m7!3m6!1s0x3bae17f9a2e10553:0x9337b266859d8ec!8m2!3d12.9822788!4d77.6393306!16s%2Fg%2F11h1drqsb_!19sChIJUwXhovkXrjsR7NhZaCZ7Mwk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ayush-wellness-salon-and-spa",
    "name": "Ayush Wellness Salon And Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "1st floor, 671, 45th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 22,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9175205,
    "longitude": 77.5758608,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ayush+Wellness+Salon+And+Spa/data=!4m7!3m6!1s0x3bae156fd2f7b44d:0x2227d37c6de0d8d4!8m2!3d12.9175205!4d77.5758608!16s%2Fg%2F11sszn2cbp!19sChIJTbT30m8VrjsR1NjgbXzTJyI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sara-spa-and-salon",
    "name": "Sara Spa and Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "3H5Q+5G8, Kodigehalli Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 17,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 13.0579012,
    "longitude": 77.5888384,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sara+Spa+and+Salon/data=!4m7!3m6!1s0x3bae19a17d1d972b:0x524a029dcb314f58!8m2!3d13.0579012!4d77.5888384!16s%2Fg%2F11v14fnc94!19sChIJK5cdfaEZrjsRWE8xy50CSlI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "golden-touch-beauty-salon-and-spa",
    "name": "Golden Touch Beauty Salon And Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "No. 717, 61st Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 14,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.984221,
    "longitude": 77.5545314,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Golden+Touch+Beauty+Salon+And+Spa/data=!4m7!3m6!1s0x3bae3df3bc11a1cd:0xfd1c4df037ca990c!8m2!3d12.984221!4d77.5545314!16s%2Fg%2F1tfrf67_!19sChIJzaERvPM9rjsRDJnKN_BNHP0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "millennium-spa",
    "name": "Millennium Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "560038, 80 Feet Road, next to Bsnl",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 13,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9733741,
    "longitude": 77.6413887,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Millennium+Spa/data=!4m7!3m6!1s0x3bae16a63c6ac395:0x34d5899ecf46b45d!8m2!3d12.9733741!4d77.6413887!16s%2Fg%2F11fy9kf8_k!19sChIJlcNqPKYWrjsRXbRGz56J1TQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "u-me-spa",
    "name": "U & ME SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "410,3rd floor, Sanjeevaiah Complex",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 11,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9568039,
    "longitude": 77.7394815,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/U+%26+ME+SPA/data=!4m7!3m6!1s0x3bae13a47062bfb7:0xfad609c6e3ca6ac6!8m2!3d12.9568039!4d77.7394815!16s%2Fg%2F11ssjsk9lq!19sChIJt79icKQTrjsRxmrK48YJ1vo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "flora-wellness-male-to-male-spa-in-hbr-layout-bangalore-body-massage-center",
    "name": "Flora Wellness | Male-to-Male Spa in HBR Layout , Bangalore | Body Massage Center",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "20th Block, 2nd floor, No. 208/V, 44th Cross",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 9,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 13.0398151,
    "longitude": 77.6347906,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Flora+Wellness+%7C+Male-to-Male+Spa+in+HBR+Layout+,+Bangalore+%7C+Body+Massage+Center/data=!4m7!3m6!1s0x3bae17a117b39691:0xd0c2f22929979393!8m2!3d13.0398151!4d77.6347906!16s%2Fg%2F11yspd73sv!19sChIJkZazF6EXrjsRk5OXKSnywtA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "fabwell-healthcare",
    "name": "Fabwell Healthcare",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "232, Anam Plaza, 19, 9th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 9,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9319009,
    "longitude": 77.5836445,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Fabwell+Healthcare/data=!4m7!3m6!1s0x3bae1597f2198dfb:0x7673370be3696103!8m2!3d12.9319009!4d77.5836445!16s%2Fg%2F11byyfzm92!19sChIJ-40Z8pcVrjsRA2Fp4ws3c3Y?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "seven-star-unisex-spa-in-immadihalli",
    "name": "Seven Star Unisex Spa in Immadihalli",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "74/A, Immadihalli Main Rd, near SP fitness Studio, opposite to Royal Wholesale Mart",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 8,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9678399,
    "longitude": 77.757956,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Seven+Star+Unisex+Spa+in+Immadihalli/data=!4m7!3m6!1s0x3bae0de733460875:0xc100659482387c55!8m2!3d12.9678399!4d77.757956!16s%2Fg%2F11vqzsqymm!19sChIJdQhGM-cNrjsRVXw4gpRlAME?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "global-salon-spa",
    "name": "global salon & spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "6, Immadihalli Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 8,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9685465,
    "longitude": 77.755151,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/global+salon+%26+spa/data=!4m7!3m6!1s0x3bae0dc315ef9535:0x4e7a290704d410cf!8m2!3d12.9685465!4d77.755151!16s%2Fg%2F11vwvw38db!19sChIJNZXvFcMNrjsRzxDUBAcpek4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "g-n-mansion",
    "name": "G.N. Mansion",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "389, 13th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 6,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 13.0074893,
    "longitude": 77.579292,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/G.N.+Mansion/data=!4m7!3m6!1s0x3bae16347531e399:0x7f7ce8265670c8d7!8m2!3d13.0074893!4d77.579292!16s%2Fg%2F1vtqtjr1!19sChIJmeMxdTQWrjsR18hwVibofH8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "belezza-day-spa-jayanagar",
    "name": "Belezza Day Spa Jayanagar",
    "description": "Highly rated day spa in Jayanagar with excellent reviews and professional service.",
    "address": "Townhouse OAK Onyx International, 25, Swagath Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 4,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9285501,
    "longitude": 77.5975733,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Belezza+Day+Spa+Jayanagar/data=!4m7!3m6!1s0x3bae153458eb4ba1:0x3f82828fe35d2966!8m2!3d12.9285501!4d77.5975733!16s%2Fg%2F11h7kb138m!19sChIJoUvrWDQVrjsRZild44-Cgj8?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "the-blanca-paloma-spa-and-salon",
    "name": "The Blanca Paloma Spa and Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "317, 6th Main Rd, opp. to Paul Thangaiah Church",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 2,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9738982,
    "longitude": 77.645529,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/The+Blanca+Paloma+Spa+and+Salon/data=!4m7!3m6!1s0x3bae175e4bd75199:0x6da378fdd178bb!8m2!3d12.9738982!4d77.645529!16s%2Fg%2F11w2841twl!19sChIJmVHXS14XrjsRu3jR_XijbQA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nirvana-thai-spa",
    "name": "Nirvana Thai spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "WJMF+P9Q",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 2,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9343125,
    "longitude": 77.6234375,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nirvana+Thai+spa/data=!4m7!3m6!1s0x3bae15f2ecd81a89:0x42503469bbf225fe!8m2!3d12.9343125!4d77.6234375!16s%2Fg%2F11v9lm25gt!19sChIJiRrY7PIVrjsR_iXyu2k0UEI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "maple-wellness",
    "name": "Maple Wellness",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "2H49+7G7, 15th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 4.0,
    "reviews_count": 1,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 13.0056618,
    "longitude": 77.5687955,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Maple+Wellness/data=!4m7!3m6!1s0x3bae3f707ad2a741:0x77611a61baafddb7!8m2!3d13.0056618!4d77.5687955!16s%2Fg%2F11lw37ymhg!19sChIJQafSenA_rjsRt92vumEaYXc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "kanaka-grand-hebbal-hotel-bangalore",
    "name": "Kanaka Grand Hebbal Hotel Bangalore",
    "description": "Highly rated day spa in Hebbal with excellent reviews and professional service.",
    "address": "Bangalore",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Hebbal",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 513,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 13.0361883,
    "longitude": 77.5899793,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Kanaka+Grand+Hebbal+Hotel+Bangalore/data=!4m10!3m9!1s0x3bae17781b053c83:0xa2855359494ee04!5m2!4m1!1i2!8m2!3d13.0361883!4d77.5899793!16s%2Fg%2F11g0mv86_0!19sChIJgzwFG3gXrjsRBO6UlDVVKAo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "thai-refresh-spa",
    "name": "Thai Refresh Spa",
    "description": "Highly rated thai spa in Sankey Road with excellent reviews and professional service.",
    "address": "190, 4th Floor, JP Square, Sankey Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Sankey Road",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 160,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 13.0062829,
    "longitude": 77.5794404,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Thai+Refresh+Spa/data=!4m7!3m6!1s0x3bae163406c75c03:0x4cd388b3b5da3e46!8m2!3d13.0062829!4d77.5794404!16s%2Fg%2F1q4knb46m!19sChIJA1zHBjQWrjsRRj7atbOI00w?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "lets-relax-thai-spa-jayanagar",
    "name": "Lets Relax Thai Spa Jayanagar",
    "description": "Highly rated thai spa in Jayanagar with excellent reviews and professional service.",
    "address": "294, 10th Main, 39th B Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Jayanagar",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 116,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9205451,
    "longitude": 77.5846558,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Lets+Relax+Thai+Spa+Jayanagar/data=!4m7!3m6!1s0x3bae157558c78c5b:0x879c0dd00720d4d3!8m2!3d12.9205451!4d77.5846558!16s%2Fg%2F11c6_ds8nq!19sChIJW4zHWHUVrjsR09QgB9ANnIc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "berry-thai-spa-massage-thai-spa-in-cunningham-road-bangalore",
    "name": "Berry Thai Spa - Massage / Thai / Spa in Cunningham Road, Bangalore",
    "description": "Highly rated thai spa in Cunningham Road with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Cunningham Road",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 110,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9858024,
    "longitude": 77.5957409,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Berry+Thai+Spa+-+Massage+%2F+Thai+%2F+Spa+in+Cunningham+Road,+Bangalore/data=!4m7!3m6!1s0x3bae17413c47df65:0x6a1acce2d5493ebe!8m2!3d12.9858024!4d77.5957409!16s%2Fg%2F11gywpqslt!19sChIJZd9HPEEXrjsRvj5J1eLMGmo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "exotic-spa",
    "name": "Exotic Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "ground floor, no 11, begur hobli, near Devarachikkanahalli Road",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 107,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9111066,
    "longitude": 77.60579,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Exotic+Spa/data=!4m7!3m6!1s0x3bae15d17e4276d3:0xe8d3ec33a2c4680a!8m2!3d12.9111066!4d77.60579!16s%2Fg%2F11gvzl3ks8!19sChIJ03ZCftEVrjsRCmjEojPs0-g?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sean-thai-spa-btm-layout-best-thai-spa-in-btm-layout-bangalore-spa",
    "name": "Sean Thai Spa BTM Layout | best Thai spa in BTM Layout | Bangalore spa",
    "description": "Highly rated thai spa in BTM Layout with excellent reviews and professional service.",
    "address": "3rd Floor, 805/A, 7th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "BTM Layout",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 105,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9139892,
    "longitude": 77.6088654,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sean+Thai+Spa+BTM+Layout+%7C+best+Thai+spa+in+BTM+Layout+%7C+Bangalore+spa/data=!4m7!3m6!1s0x3bae15d0c4c9f425:0x4b7f08f210e50d17!8m2!3d12.9139892!4d77.6088654!16s%2Fg%2F11j94qh78r!19sChIJJfTJxNAVrjsRFw3lEPIIf0s?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "berry-thai-spa-hsr",
    "name": "Berry Thai Spa HSR",
    "description": "Highly rated thai spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 91,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9124441,
    "longitude": 77.6387004,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Berry+Thai+Spa+HSR/data=!4m7!3m6!1s0x3bae1491d378841b:0xc5f297668ce4bd82!8m2!3d12.9124441!4d77.6387004!16s%2Fg%2F11f3tvq93m!19sChIJG4R405EUrjsRgr3kjGaX8sU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spotlight-spa",
    "name": "Spotlight Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "1st floor, 83/4, 13th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 90,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9683924,
    "longitude": 77.6402286,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spotlight+Spa/data=!4m7!3m6!1s0x3bae1593405e4725:0x83dabb89b8d142f!8m2!3d12.9683924!4d77.6402286!16s%2Fg%2F11kcljjxn6!19sChIJJUdeQJMVrjsRLxSNm7irPQg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-city",
    "name": "SPA CITY",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 86,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9274252,
    "longitude": 77.5775376,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/SPA+CITY/data=!4m7!3m6!1s0x3bae1523ebd70d0d:0xbd68f840fcfe1467!8m2!3d12.9274252!4d77.5775376!16s%2Fg%2F11j5h54ft5!19sChIJDQ3X6yMVrjsRZxT-_ED4aL0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "body-shine-spa-saloon",
    "name": "Body Shine Spa & Saloon",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 84,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9612556,
    "longitude": 77.5876864,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Body+Shine+Spa+%26+Saloon/data=!4m7!3m6!1s0x3bae151cab38e249:0x3b00d15e3b30e67f!8m2!3d12.9612556!4d77.5876864!16s%2Fg%2F11h0816jc4!19sChIJSeI4qxwVrjsRf-YwO17RADs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "eden-la-bella-spa",
    "name": "Eden LA Bella Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Bangalore",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 70,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9691284,
    "longitude": 77.7376278,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Eden+LA+Bella+Spa/data=!4m7!3m6!1s0x3bae1203764e1765:0x5a3cfd30a436b2e8!8m2!3d12.9691284!4d77.7376278!16s%2Fg%2F11gfd737qm!19sChIJZRdOdgMSrjsR6LI2pDD9PFo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "berry-thai-spa",
    "name": "Berry Thai Spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 56,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9090329,
    "longitude": 77.6400368,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Berry+Thai+Spa/data=!4m7!3m6!1s0x3bae1594debd20fd:0x9b8169e10eecc668!8m2!3d12.9090329!4d77.6400368!16s%2Fg%2F11g_rdy5hy!19sChIJ_SC93pQVrjsRaMbsDuFpgZs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "arya-unisex-salon-spa",
    "name": "ARYA UNISEX SALON & SPA",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "No. 1375/8, east end circle",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 55,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9166975,
    "longitude": 77.5961442,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/ARYA+UNISEX+SALON+%26+SPA/data=!4m7!3m6!1s0x3bae1559250bbde9:0xea818e9a012a4e7b!8m2!3d12.9166975!4d77.5961442!16s%2Fg%2F11n0pk0822!19sChIJ6b0LJVkVrjsRe04qAZqOgeo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "shivai-thai-spa",
    "name": "Shivai Thai Spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "664, 3rd Floor 1st Stage,100Ft Road, 100 FT Road",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 53,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9773241,
    "longitude": 77.6411072,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Shivai+Thai+Spa/data=!4m7!3m6!1s0x3bae16a777991055:0xfb576109b99eb343!8m2!3d12.9773241!4d77.6411072!16s%2Fg%2F11c6nh7phh!19sChIJVRCZd6cWrjsRQ7OeuQlhV_s?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "o3-unisex-salon-and-spa",
    "name": "O3 Unisex Salon And Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 49,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 13.0638645,
    "longitude": 77.587842,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/O3+Unisex+Salon+And+Spa/data=!4m7!3m6!1s0x3bae196850bf51f3:0x244b3aec0946dbd9!8m2!3d13.0638645!4d77.587842!16s%2Fg%2F11h37ghdt_!19sChIJ81G_UGgZrjsR2dtGCew6SyQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "berry-spa-malleswaram",
    "name": "Berry Spa Malleswaram",
    "description": "Highly rated day spa in Malleshwaram with excellent reviews and professional service.",
    "address": "Sai Sharan Heights-78, 4th Main, 15th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Malleshwaram",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 44,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 13.0057333,
    "longitude": 77.5688825,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Berry+Spa+Malleswaram/data=!4m7!3m6!1s0x3bae17dc3bdf796d:0x5968c087826462c4!8m2!3d13.0057333!4d77.5688825!16s%2Fg%2F11h_c8f6v6!19sChIJbXnfO9wXrjsRxGJkgofAaFk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "white-eden-garden-unisex-salon-and-spa",
    "name": "White Eden Garden Unisex Salon and Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Ny No. 5/5, BARTON SQUARE, 386/35, Road, near Mayura Bakery",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 42,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9699055,
    "longitude": 77.7513594,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/White+Eden+Garden+Unisex+Salon+and+Spa/data=!4m7!3m6!1s0x3bae11fe2d6916a7:0xa06ce2afecc3e844!8m2!3d12.9699055!4d77.7513594!16s%2Fg%2F11hk88vk9y!19sChIJpxZpLf4RrjsRROjD7K_ibKA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "komal-wellness-spa",
    "name": "Komal Wellness Spa",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "6th Floor, Purple Orchid, 65, Pattandur Agrahara Maithri Layout 1st Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 34,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9836226,
    "longitude": 77.7550478,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Komal+Wellness+Spa/data=!4m7!3m6!1s0x3bae0f1c5ba54f6d:0xa0a2fe66466207a0!8m2!3d12.9836226!4d77.7550478!16s%2Fg%2F11stk2ms38!19sChIJbU-lWxwPrjsRoAdiRmb-oqA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sara-spa",
    "name": "Sara Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "105, 17th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 32,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.937725,
    "longitude": 77.6237441,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sara+Spa/data=!4m7!3m6!1s0x3bae144fd28dc37b:0xcc115bbd7bdd0e36!8m2!3d12.937725!4d77.6237441!16s%2Fg%2F11h42q0vhk!19sChIJe8ON0k8UrjsRNg7de71bEcw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "england-spa",
    "name": "England spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "England spa & salon, 171, 9th Cross Rd, opposite to Silvan smart office",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 22,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9802507,
    "longitude": 77.6390214,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/England+spa/data=!4m7!3m6!1s0x3bae16a921a4c4ad:0x172cac1c239e3a06!8m2!3d12.9802507!4d77.6390214!16s%2Fg%2F11f33t5wk8!19sChIJrcSkIakWrjsRBjqeIxysLBc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "tara-spa",
    "name": "Tara spa",
    "description": "Highly rated day spa in Varthur with excellent reviews and professional service.",
    "address": "10/2, Varthur Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Varthur",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 20,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9556245,
    "longitude": 77.7189441,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Tara+spa/data=!4m7!3m6!1s0x3bae13007ad6c401:0x2aa21bfdf622cb0f!8m2!3d12.9556245!4d77.7189441!16s%2Fg%2F11t3131dfn!19sChIJAcTWegATrjsRD8si9v0boio?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "avon-international-spa",
    "name": "Avon International Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "XJGQ+9QJ, 854/A, 10th Main Rd, next to Central Bank of India",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 17,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9759483,
    "longitude": 77.6392698,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Avon+International+Spa/data=!4m7!3m6!1s0x3bae17ac50f6de1f:0xf2ce8589a1d935db!8m2!3d12.9759483!4d77.6392698!16s%2Fg%2F11sbdv_6pz!19sChIJH972UKwXrjsR2zXZoYmFzvI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "london-salon-spa",
    "name": "London Salon & SPA",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "London Salon & Spa, # 1699, 19th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 16,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9064481,
    "longitude": 77.6446181,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/London+Salon+%26+SPA/data=!4m7!3m6!1s0x3bae1503bf556495:0xbe56575c58377cf!8m2!3d12.9064481!4d77.6446181!16s%2Fg%2F11lksctn4r!19sChIJlWRVvwMVrjsRz3eDxXVl5Qs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nanesh-unisex-beauty-salon-spa",
    "name": "Nanesh Unisex Beauty Salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 15,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9295551,
    "longitude": 77.6320086,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nanesh+Unisex+Beauty+Salon+%26+Spa/data=!4m7!3m6!1s0x3bae154b4b28bc9b:0xd038d072a3005c4!8m2!3d12.9295551!4d77.6320086!16s%2Fg%2F11p712vnxn!19sChIJm7woS0sVrjsRxAUwKgeNAw0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "traditional-thai-spa-and-salon",
    "name": "Traditional Thai spa and salon",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "traditional Thai spa and salon, Dasarahalli Main Rd, next to Union Bank",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.9,
    "reviews_count": 7,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 13.0552045,
    "longitude": 77.600135,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Traditional+Thai+spa+and+salon/data=!4m7!3m6!1s0x3bae17de358be053:0xca92465c2a123846!8m2!3d13.0552045!4d77.600135!16s%2Fg%2F11tfk901kd!19sChIJU-CLNd4XrjsRRjgSKlxGkso?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "diamond-lounge-unisex-salon-and-spa",
    "name": "Diamond Lounge Unisex Salon and SPA",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "24, 1st Floor, 1st Main Rd, opp. to Total Gas, above Saptagiri Suzuki Showroom",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.8,
    "reviews_count": 145,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9869205,
    "longitude": 77.540231,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Diamond+Lounge+Unisex+Salon+and+SPA/data=!4m7!3m6!1s0x3bae3deab41b4d79:0x9b9034081ead91f5!8m2!3d12.9869205!4d77.540231!16s%2Fg%2F11hbvs0n1q!19sChIJeU0btOo9rjsR9ZGtHgg0kJs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "spa-nation",
    "name": "Spa Nation",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "1st cross, Plot No. 990, 12th Main Rd, near Skin Deep Tattoo",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.8,
    "reviews_count": 109,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9688945,
    "longitude": 77.6405935,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Spa+Nation/data=!4m7!3m6!1s0x3bae16a60ed3a813:0xa5ed2968bfca224e!8m2!3d12.9688945!4d77.6405935!16s%2Fg%2F11f15915g8!19sChIJE6jTDqYWrjsRTiLKv2gp7aU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "dew-unisex-salon-and-spa",
    "name": "Dew Unisex salon and Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "10th cross, 19th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.8,
    "reviews_count": 108,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 13.0039953,
    "longitude": 77.550781,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Dew+Unisex+salon+and+Spa/data=!4m7!3m6!1s0x3bae3d2fff2c6d09:0x3b410fd6c94c0fc4!8m2!3d13.0039953!4d77.550781!16s%2Fg%2F11f6ybjf63!19sChIJCW0s_y89rjsRxA9MydYPQTs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "feather-touch-relax-best-unisex-spa-in-bangalore-l-spa-in-frazer-town",
    "name": "Feather Touch Relax - Best Unisex Spa in Bangalore l Spa in Frazer Town",
    "description": "Highly rated day spa in Frazer Town with excellent reviews and professional service.",
    "address": "1st Floor, Robertson Rd, next to KEB Office",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Frazer Town",
    "phone": "",
    "rating": 3.8,
    "reviews_count": 54,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9959401,
    "longitude": 77.6155996,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Feather+Touch+Relax+-+Best+Unisex+Spa+in+Bangalore+l+Spa+in+Frazer+Town/data=!4m7!3m6!1s0x3bae17e012e86a3b:0xece7893e63370a9b!8m2!3d12.9959401!4d77.6155996!16s%2Fg%2F11kc8pl33_!19sChIJO2roEuAXrjsRmwo3Yz6J5-w?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sukhothai-spa",
    "name": "SukhoThai Spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.8,
    "reviews_count": 52,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9169135,
    "longitude": 77.6515858,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/SukhoThai+Spa/data=!4m7!3m6!1s0x3bae15aef6595f6f:0x5e7a392d24a80d5b!8m2!3d12.9169135!4d77.6515858!16s%2Fg%2F11gmwzwgdr!19sChIJb19Z9q4VrjsRWw2oJC05el4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "amoda-spa-and-wellness-door-step-home-spa",
    "name": "Amoda Spa and wellness(Door Step/Home Spa)",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "Bangalore",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.8,
    "reviews_count": 51,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.8513216,
    "longitude": 77.6481046,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Amoda+Spa+and+wellness%28Door+Step%2FHome+Spa%29/data=!4m7!3m6!1s0x3bae6b6154528bdd:0xda7b1aef11020aa3!8m2!3d12.8513216!4d77.6481046!16s%2Fg%2F11f15fkfkq!19sChIJ3YtSVGFrrjsRowoCEe8ae9o?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "golden-leaff-unisex-salon-and-spa",
    "name": "Golden Leaff Unisex Salon and Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "#42 MG Towers 2nd floor next HP petrol bunk, Dr Rajkumar Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.8,
    "reviews_count": 44,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9914265,
    "longitude": 77.5577972,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Golden+Leaff+Unisex+Salon+and+Spa/data=!4m7!3m6!1s0x3bae3d0c78a16267:0x57cbd83e01584499!8m2!3d12.9914265!4d77.5577972!16s%2Fg%2F11n103gsl6!19sChIJZ2KheAw9rjsRmURYAT7Yy1c?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ablluo-luxury-spa",
    "name": "Ablluo Luxury spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "3rd floor, A V S Compound, no .23/1, 80 Feet Rd, near Sony Signal",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.8,
    "reviews_count": 27,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9367355,
    "longitude": 77.6276675,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ablluo+Luxury+spa/data=!4m7!3m6!1s0x3bae15f7c96afbf9:0xfcebd794b5a552db!8m2!3d12.9367355!4d77.6276675!16s%2Fg%2F11sbwsts7f!19sChIJ-ftqyfcVrjsR21KltZTX6_w?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ks-dreams-beauty-and-spa",
    "name": "Ks Dreams Beauty And Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "102, Mg And Kp Complex",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.8,
    "reviews_count": 24,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9803665,
    "longitude": 77.7335547,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ks+Dreams+Beauty+And+Spa/data=!4m7!3m6!1s0x3bae11f0a6544b59:0xfe86c001f8547f67!8m2!3d12.9803665!4d77.7335547!16s%2Fg%2F11tf41fd7c!19sChIJWUtUpvARrjsRZ39U-AHAhv4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "influence-unisex-salon-n-spa",
    "name": "Influence Unisex Salon n Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd Flr, Premier Court, 547/5, Chinmaya Mission Hospital Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.8,
    "reviews_count": 23,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9780703,
    "longitude": 77.6376013,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Influence+Unisex+Salon+n+Spa/data=!4m7!3m6!1s0x3bae16a48bf46edb:0x8520a9c82aebfc5a!8m2!3d12.9780703!4d77.6376013!16s%2Fg%2F11fy4v76vz!19sChIJ2270i6QWrjsRWvzrKsipIIU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "miracle-spa-saloon",
    "name": "Miracle spa & saloon",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "near DTDC office",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.8,
    "reviews_count": 19,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9824965,
    "longitude": 77.7635042,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Miracle+spa+%26+saloon/data=!4m7!3m6!1s0x3bae0f0e6d5ed9bb:0xcea22fd1e4fe9d68!8m2!3d12.9824965!4d77.7635042!16s%2Fg%2F11t1lcphrc!19sChIJu9lebQ4PrjsRaJ3-5NEvos4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "blue-water-spa-and-salon",
    "name": "Blue Water Spa and Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Top floor, 62, 1st Main Rd, beside corner house building",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.8,
    "reviews_count": 17,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9363684,
    "longitude": 77.6150961,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Blue+Water+Spa+and+Salon/data=!4m7!3m6!1s0x3bae15b26b7b17f7:0xcec3182287fdc705!8m2!3d12.9363684!4d77.6150961!16s%2Fg%2F11t409s7s8!19sChIJ9xd7a7IVrjsRBcf9hyIYw84?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ebony-saloon-and-spa-rajajinagar",
    "name": "Ebony saloon and Spa Rajajinagar",
    "description": "Highly rated day spa in Rajajinagar with excellent reviews and professional service.",
    "address": "XGPX+PPG, 1st Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Rajajinagar",
    "phone": "",
    "rating": 3.8,
    "reviews_count": 15,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9868188,
    "longitude": 77.5493383,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ebony+saloon+and+Spa+Rajajinagar/data=!4m7!3m6!1s0x3bae3d9828da90cd:0x490705ee16eec256!8m2!3d12.9868188!4d77.5493383!16s%2Fg%2F11vkk259yj!19sChIJzZDaKJg9rjsRVsLuFu4FB0k?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "aesthetic-spa-and-salon",
    "name": "Aesthetic Spa And Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "98",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.8,
    "reviews_count": 14,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9678685,
    "longitude": 77.602341,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Aesthetic+Spa+And+Salon/data=!4m7!3m6!1s0x3bae167f56a96f4f:0xb70f98ce05017f55!8m2!3d12.9678685!4d77.602341!16s%2Fg%2F11f5hlvq24!19sChIJT2-pVn8WrjsRVX8BBc6YD7c?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "stone-touch-salon-and-spa-centre",
    "name": "STONE TOUCH SALON AND SPA CENTRE",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "No 16, Poonachi Residency, Sri Lakshmi Narasimha Swamy Temple Main Rd, opp. to Vasavi residency, near Sri Laxmi",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.8,
    "reviews_count": 12,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.8511791,
    "longitude": 77.6495088,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/STONE+TOUCH+SALON+AND+SPA+CENTRE/data=!4m7!3m6!1s0x3bae6d21496bd473:0x71db4cb8775542c8!8m2!3d12.8511791!4d77.6495088!16s%2Fg%2F11rdvrpsv8!19sChIJc9RrSSFtrjsRyEJVd7hM23E?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "royal-bloom-salon-spa",
    "name": "Royal bloom salon & Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "135/13,2nd floor,16 th cross, 19th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.8,
    "reviews_count": 8,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.999262,
    "longitude": 77.5508824,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Royal+bloom+salon+%26+Spa/data=!4m7!3m6!1s0x3bae3d767436fbed:0x5d92bb00e5052363!8m2!3d12.999262!4d77.5508824!16s%2Fg%2F11w9_ry5mm!19sChIJ7fs2dHY9rjsRYyMF5QC7kl0?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "aesthetic-salon-and-spa",
    "name": "AESTHETIC SALON AND SPA",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.7,
    "reviews_count": 159,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 13.0433726,
    "longitude": 77.5995246,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/AESTHETIC+SALON+AND+SPA/data=!4m7!3m6!1s0x3bae179a56a3186d:0x9cd493f44d0a2ad4!8m2!3d13.0433726!4d77.5995246!16s%2Fg%2F11dfqykkfg!19sChIJbRijVpoXrjsR1CoKTfST1Jw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sixth-sense-salon-and-spa",
    "name": "Sixth Sense Salon and Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "WHW9+P4Q, Ramakrishna Ashrama Cir",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.7,
    "reviews_count": 103,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9468458,
    "longitude": 77.5678724,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sixth+Sense+Salon+and+Spa/data=!4m7!3m6!1s0x3bae15f3f14351f5:0xc0b9d6f56fcef2fd!8m2!3d12.9468458!4d77.5678724!16s%2Fg%2F11f08b_6ym!19sChIJ9VFD8fMVrjsR_fLOb_XWucA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "soul-ecstasy",
    "name": "Soul Ecstasy",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.7,
    "reviews_count": 73,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.983366,
    "longitude": 77.751922,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Soul+Ecstasy/data=!4m7!3m6!1s0x3bae0e04899fc609:0xa6464563b6f7dd5!8m2!3d12.983366!4d77.751922!16s%2Fg%2F11hbvv287q!19sChIJCcafiQQOrjsR1X1vO1ZkZAo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "renaissance-salon-and-spa",
    "name": "Renaissance Salon and Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "638, 12th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.7,
    "reviews_count": 64,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9473538,
    "longitude": 77.6188843,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Renaissance+Salon+and+Spa/data=!4m7!3m6!1s0x3bae145d37f42b9d:0x622f337775253227!8m2!3d12.9473538!4d77.6188843!16s%2Fg%2F11btp6ptym!19sChIJnSv0N10UrjsRJzIldXczL2I?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "o3-unisex-spa-and-salon",
    "name": "O3 Unisex Spa and Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "34, Borewell Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.7,
    "reviews_count": 47,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9690265,
    "longitude": 77.740151,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/O3+Unisex+Spa+and+Salon/data=!4m7!3m6!1s0x3bae121cc63d2ee1:0x5589aa86f0456056!8m2!3d12.9690265!4d77.740151!16s%2Fg%2F11dyp42m3x!19sChIJ4S49xhwSrjsRVmBF8IaqiVU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "peacock-unisex-salon-and-spa",
    "name": "Peacock Unisex Salon and Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "2767, 1ST FLOOR, 1ST MAIN ROAD, DEFENCE COLONY RD, Kodigehalli Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.7,
    "reviews_count": 23,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 13.0590237,
    "longitude": 77.5848735,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Peacock+Unisex+Salon+and+Spa/data=!4m7!3m6!1s0x3bae192889fd0b71:0x1b80622694855469!8m2!3d13.0590237!4d77.5848735!16s%2Fg%2F11rn8gjcqv!19sChIJcQv9iSgZrjsRaVSFlCZigBs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ishayu-ayurveda",
    "name": "Ishayu Ayurveda",
    "description": "Highly rated ayurvedic spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.7,
    "reviews_count": 12,
    "spa_type": "Ayurvedic Spa",
    "services": [
      "Abhyanga",
      "Shirodhara",
      "Panchakarma",
      "Pizhichil",
      "Kerala Massage",
      "Ayurvedic Facial"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 13.0058056,
    "longitude": 77.5713435,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ishayu+Ayurveda/data=!4m7!3m6!1s0x3bae162dd980e93f:0x326e603ed3ea06f7!8m2!3d13.0058056!4d77.5713435!16s%2Fg%2F11gfm67wtc!19sChIJP-mA2S0WrjsR9wbq0z5gbjI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "blooming-day-spa-bangalore",
    "name": "Blooming Day Spa Bangalore",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.7,
    "reviews_count": 10,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.8008794,
    "longitude": 77.7124015,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Blooming+Day+Spa+Bangalore/data=!4m7!3m6!1s0x3bae6d156d830c3f:0x2794d38e1cf73296!8m2!3d12.8008794!4d77.7124015!16s%2Fg%2F11rhrl3fdj!19sChIJPwyDbRVtrjsRljL3HI7TlCc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bangalore-day-night-massage-spa",
    "name": "Bangalore Day Night Massage Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "4th Floor, 427, 10th G Main Rd, above Just Bake Block",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.7,
    "reviews_count": 7,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9833389,
    "longitude": 77.5555274,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bangalore+Day+Night+Massage+Spa/data=!4m7!3m6!1s0x3bae3d9bf4e7ce4d:0x9b73a3930f4645c!8m2!3d12.9833389!4d77.5555274!16s%2Fg%2F11xyryxdmf!19sChIJTc7n9Js9rjsRXGT0MDk6twk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "rox-unisex-salon-spa",
    "name": "ROX UNISEX SALON & SPA",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "83/4, 13th A Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.7,
    "reviews_count": 3,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9682477,
    "longitude": 77.6402699,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/ROX+UNISEX+SALON+%26+SPA/data=!4m7!3m6!1s0x3bae150045294f05:0xaa0bdde4bf96cab4!8m2!3d12.9682477!4d77.6402699!16s%2Fg%2F11x2x7pxt3!19sChIJBU8pRQAVrjsRtMqWv-TdC6o?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "iconic-spa-ind",
    "name": "Iconic Spa Ind",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "1st Floor, Above Khan Saheb Grills & Rolls Sri Shiva Sai Complex 7th Main Road, 13th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.7,
    "reviews_count": 3,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9714332,
    "longitude": 77.6350848,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Iconic+Spa+Ind/data=!4m7!3m6!1s0x3bae17f3cf182e47:0xda0cef8c27954479!8m2!3d12.9714332!4d77.6350848!16s%2Fg%2F11v0gd2f1h!19sChIJRy4Yz_MXrjsReUSVJ4zvDNo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "professional-beauty-spa",
    "name": "Professional Beauty spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Sumangali Sevashrama Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.7,
    "reviews_count": 3,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 13.0368165,
    "longitude": 77.5931317,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Professional+Beauty+spa/data=!4m7!3m6!1s0x3bae1762595b6223:0xb012db30517fb713!8m2!3d13.0368165!4d77.5931317!16s%2Fg%2F11y86tbq7d!19sChIJI2JbWWIXrjsRE7d_UTDbErA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nature-beauty-saloon-and-spa",
    "name": "Nature Beauty Saloon And Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "No 42/1 H block, 1st Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.7,
    "reviews_count": 3,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 13.0340282,
    "longitude": 77.6066987,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nature+Beauty+Saloon+And+Spa/data=!4m7!3m6!1s0x3bae17b23f28d8d3:0x6b004db0ac373a4!8m2!3d13.0340282!4d77.6066987!16s%2Fg%2F11hdj_lm4x!19sChIJ09goP7IXrjsRpHPDCtsEsAY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "dyu-kids-spa-in-hsr-layout-bangalore",
    "name": "DYU Kids Spa in HSR Layout Bangalore",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "1098, 5th Floor, 14th Main Rd, near BDA Complex, next to Max Store",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 3.7,
    "reviews_count": 3,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9111849,
    "longitude": 77.6382411,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/DYU+Kids+Spa+in+HSR+Layout+Bangalore/data=!4m7!3m6!1s0x3bae158ebae7befd:0xa52ab288b520d65e!8m2!3d12.9111849!4d77.6382411!16s%2Fg%2F11t_xzr14g!19sChIJ_b7nuo4VrjsRXtYgtYiyKqU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "eden-la-bella-spa-salon",
    "name": "Eden La Bella Spa & Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd Floor, MCC Centre, opposite Sigma Tech Park",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.7,
    "reviews_count": 3,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 12.9566521,
    "longitude": 77.7442134,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Eden+La+Bella+Spa+%26+Salon/data=!4m7!3m6!1s0x3bae1350dfb038b1:0x8a52ec3b258b5594!8m2!3d12.9566521!4d77.7442134!16s%2Fg%2F11x2b64jmc!19sChIJsTiw31ATrjsRlFWLJTvsUoo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "le-royal-saloon-and-spa",
    "name": "le royal saloon and spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Building No.1/2, 3rd Floor, 18th cross main road, E Park Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.7,
    "reviews_count": 3,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 13.0083983,
    "longitude": 77.5707706,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/le+royal+saloon+and+spa/data=!4m7!3m6!1s0x3bae17b57276f643:0x1112187561debd67!8m2!3d13.0083983!4d77.5707706!16s%2Fg%2F11tb2xy3xv!19sChIJQ_Z2crUXrjsRZ73eYXUYEhE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "bengaluru-body-spa-center",
    "name": "Bengaluru Body Spa Center",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.7,
    "reviews_count": 3,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.9964705,
    "longitude": 77.5979163,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Bengaluru+Body+Spa+Center/data=!4m7!3m6!1s0x3bae17005c9d48f5:0xcca0be63d7c7982e!8m2!3d12.9964705!4d77.5979163!16s%2Fg%2F11ysbh5tdv!19sChIJ9UidXAAXrjsRLpjH12O-oMw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "vegas-spa-and-saloon-hsr-layout",
    "name": "Vegas Spa And Saloon@ HSR Layout",
    "description": "Highly rated day spa in HSR Layout with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "HSR Layout",
    "phone": "",
    "rating": 3.6,
    "reviews_count": 156,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9062381,
    "longitude": 77.644419,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Vegas+Spa+And+Saloon@+HSR+Layout/data=!4m7!3m6!1s0x3bae15e898ad04b5:0x2505bf0060432aab!8m2!3d12.9062381!4d77.644419!16s%2Fg%2F11f6gj694v!19sChIJtQStmOgVrjsRqypDYAC_BSU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "irish-spa",
    "name": "Irish Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.6,
    "reviews_count": 83,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.989261,
    "longitude": 77.5729,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Irish+Spa/data=!4m7!3m6!1s0x3bae1622aef9796d:0x2891d1ce8b86e2ce!8m2!3d12.989261!4d77.5729!16s%2Fg%2F11f3qystlt!19sChIJbXn5riIWrjsRzuKGi87RkSg?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "shine-spa-for-sheraton",
    "name": "Shine Spa for Sheraton",
    "description": "Highly rated luxury spa in Bangalore with excellent reviews and professional service.",
    "address": "26/1, Dr Rajkumar Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.6,
    "reviews_count": 29,
    "spa_type": "Luxury Spa",
    "services": [
      "Signature Massage",
      "Hot Stone Therapy",
      "Premium Facial",
      "Body Wrap",
      "Couples Spa",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 13.0114992,
    "longitude": 77.5561457,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Shine+Spa+for+Sheraton/data=!4m7!3m6!1s0x3bae3da058c4c851:0xeeaf7761dce5392a!8m2!3d13.0114992!4d77.5561457!16s%2Fg%2F11j0t_vns1!19sChIJUcjEWKA9rjsRKjnl3GF3r-4?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "honey-gold-7-unisex-spa",
    "name": "Honey Gold 7 Unisex Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "36/3, 27th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.6,
    "reviews_count": 27,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 12.9015116,
    "longitude": 77.6506046,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Honey+Gold+7+Unisex+Spa/data=!4m7!3m6!1s0x3bae152e637bb99f:0x42b77a64123b902c!8m2!3d12.9015116!4d77.6506046!16s%2Fg%2F11tg8p22tz!19sChIJn7l7Yy4VrjsRLJA7EmR6t0I?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "cloud-9-salon-and-spa",
    "name": "Cloud 9 Salon and Spa",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Fortune Select, J P Cosmos, Cunningham Cres Rd, behind Grand Sigma Mall",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.6,
    "reviews_count": 27,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9897034,
    "longitude": 77.5947866,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Cloud+9+Salon+and+Spa/data=!4m7!3m6!1s0x3bae166818ec9d2b:0xea936fdcdeb16dde!8m2!3d12.9897034!4d77.5947866!16s%2Fg%2F11b5qrw6ck!19sChIJK53sGGgWrjsR3m2x3txvk-o?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "unwind-spa",
    "name": "Unwind spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Plot No: 123, 2nd Floor, 1st Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.6,
    "reviews_count": 22,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9347098,
    "longitude": 77.6162404,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Unwind+spa/data=!4m7!3m6!1s0x3bae14457457c5bd:0xc5b8f8707548e752!8m2!3d12.9347098!4d77.6162404!16s%2Fg%2F11lm10cdy9!19sChIJvcVXdEUUrjsRUudIdXD4uMU?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "nara-thai-spa-sadashivanagar",
    "name": "Nara Thai Spa sadashivanagar",
    "description": "Highly rated thai spa in Sadashivanagar with excellent reviews and professional service.",
    "address": "1st Floor, 384/1-1-2, 13th Main Rd, adjacent Sankey Tank Trail",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Sadashivanagar",
    "phone": "",
    "rating": 3.6,
    "reviews_count": 20,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 13.006941,
    "longitude": 77.5788905,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Nara+Thai+Spa+sadashivanagar/data=!4m7!3m6!1s0x3bae17b7f56f4fe9:0x84e91663b2fb4e30!8m2!3d13.006941!4d77.5788905!16s%2Fg%2F11w1c1xlqg!19sChIJ6U9v9bcXrjsRME77smMW6YQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ayurvedic-adda",
    "name": "Ayurvedic Adda",
    "description": "Highly rated ayurvedic spa in Bangalore with excellent reviews and professional service.",
    "address": "79, 2nd Floor, Park, Santrupti Nilaya, 20th C cross Rd, near Coffee Board Layout",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.6,
    "reviews_count": 14,
    "spa_type": "Ayurvedic Spa",
    "services": [
      "Abhyanga",
      "Shirodhara",
      "Panchakarma",
      "Pizhichil",
      "Kerala Massage",
      "Ayurvedic Facial"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 13.0527414,
    "longitude": 77.6064037,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ayurvedic+Adda/data=!4m7!3m6!1s0x3bae17cfb6bd5c6b:0x1a253902879e7b56!8m2!3d13.0527414!4d77.6064037!16s%2Fg%2F11sbbd63xh!19sChIJa1y9ts8XrjsRVnuehwI5JRo?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "lux-spa",
    "name": "Lux Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "No 2633, 1st Floor, Above Sketchers showroom 13th cross, 27th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.6,
    "reviews_count": 11,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9157748,
    "longitude": 77.6515999,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Lux+Spa/data=!4m7!3m6!1s0x3bae15c4b03abaa7:0x96a37ba6b1ae10ed!8m2!3d12.9157748!4d77.6515999!16s%2Fg%2F11vy873rnm!19sChIJp7o6sMQVrjsR7RCusaZ7o5Y?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "cloud-9-wellness-spa-and-salon",
    "name": "Cloud 9 Wellness : Spa and Salon",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "4th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.6,
    "reviews_count": 7,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 12.9719275,
    "longitude": 77.6435532,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Cloud+9+Wellness+:+Spa+and+Salon/data=!4m7!3m6!1s0x3bae16a8675df5e1:0x72e25bed92d689f7!8m2!3d12.9719275!4d77.6435532!16s%2Fg%2F11b6lj95m3!19sChIJ4fVdZ6gWrjsR94nWku1b4nI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "green-line-unisex-salon-and-ayurvedic-spa",
    "name": "Green Line Unisex Salon And Ayurvedic Spa",
    "description": "Highly rated ayurvedic spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.5,
    "reviews_count": 23,
    "spa_type": "Ayurvedic Spa",
    "services": [
      "Abhyanga",
      "Shirodhara",
      "Panchakarma",
      "Pizhichil",
      "Kerala Massage",
      "Ayurvedic Facial"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 13.0015015,
    "longitude": 77.5504656,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Green+Line+Unisex+Salon+And+Ayurvedic+Spa/data=!4m7!3m6!1s0x3bae3d2fcbad2839:0xbb5128b8bd6e67c1!8m2!3d13.0015015!4d77.5504656!16s%2Fg%2F11gnprk586!19sChIJOSityy89rjsRwWduvbgoUbs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "body-spa",
    "name": "Body Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "6Th Cross",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.5,
    "reviews_count": 11,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 12.9368849,
    "longitude": 77.6246667,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Body+Spa/data=!4m7!3m6!1s0x3bae15035837a047:0xbc329b72cfeb2c47!8m2!3d12.9368849!4d77.6246667!16s%2Fg%2F11fp8wrbwy!19sChIJR6A3WAMVrjsRRyzrz3KbMrw?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "amazing-saloon-spa",
    "name": "Amazing Saloon & Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "1st Floor, 6, Kempapura Main Rd, near Syndicate Bank",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.5,
    "reviews_count": 6,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?w=800&q=80"
    ],
    "latitude": 13.0495086,
    "longitude": 77.5970182,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Amazing+Saloon+%26+Spa/data=!4m7!3m6!1s0x3bae178583316587:0xa44915b9cac4566f!8m2!3d13.0495086!4d77.5970182!16s%2Fg%2F11c5j6xys3!19sChIJh2Uxg4UXrjsRb1bEyrkVSaQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "a-new-you-spa",
    "name": "A NEW YOU Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "121, eshwar plaza, Chord Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.4,
    "reviews_count": 42,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?w=800&q=80"
    ],
    "latitude": 12.9959988,
    "longitude": 77.5503589,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/A+NEW+YOU+Spa/data=!4m7!3m6!1s0x3bae3d2ec881284b:0x773bd70de73f1f8d!8m2!3d12.9959988!4d77.5503589!16s%2Fg%2F11gy9rz5df!19sChIJSyiByC49rjsRjR8_5w3XO3c?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "float-fly-unisex-salon-spa",
    "name": "FLOAT & FLY UNISEX SALON & SPA",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "1694, 19th Main Rd, near Indian Petrol Bunk",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.4,
    "reviews_count": 5,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1596178060810-72f53ce9a65c?w=800&q=80"
    ],
    "latitude": 12.90659,
    "longitude": 77.6445928,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/FLOAT+%26+FLY+UNISEX+SALON+%26+SPA/data=!4m7!3m6!1s0x3bae150b4fd2569b:0xb4e31fa57a1d0d1f!8m2!3d12.90659!4d77.6445928!16s%2Fg%2F11sjp8yh_2!19sChIJm1bSTwsVrjsRHw0deqUf47Q?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sawadee-thai-spa",
    "name": "sawadee thai spa",
    "description": "Highly rated thai spa in Bangalore with excellent reviews and professional service.",
    "address": "84, Lane, 3rd Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.4,
    "reviews_count": 5,
    "spa_type": "Thai Spa",
    "services": [
      "Traditional Thai Massage",
      "Thai Herbal Compress",
      "Thai Foot Massage",
      "Thai Oil Massage",
      "Aromatherapy"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=800&q=80"
    ],
    "latitude": 12.9334417,
    "longitude": 77.6221452,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/sawadee+thai+spa/data=!4m7!3m6!1s0x3bae15fd4435b795:0x4629c86d2d645b27!8m2!3d12.9334417!4d77.6221452!16s%2Fg%2F11hdr4dpnt!19sChIJlbc1RP0VrjsRJ1tkLW3IKUY?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "7c-health-care",
    "name": "7C Health Care",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.3,
    "reviews_count": 79,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&q=80"
    ],
    "latitude": 12.9685288,
    "longitude": 77.6375587,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/7C+Health+Care/data=!4m7!3m6!1s0x3bae141df46665d9:0x670d401bf16237b1!8m2!3d12.9685288!4d77.6375587!16s%2Fg%2F11bbs2zm69!19sChIJ2WVm9B0UrjsRsTdi8RtADWc?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "ocean-spa",
    "name": "Ocean spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "\u00b7",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.3,
    "reviews_count": 72,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=800&q=80"
    ],
    "latitude": 12.9369057,
    "longitude": 77.6246111,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Ocean+spa/data=!4m7!3m6!1s0x3bae144468260217:0x6935504098a1255f!8m2!3d12.9369057!4d77.6246111!16s%2Fg%2F11c1n7wk31!19sChIJFwImaEQUrjsRXyWhmEBQNWk?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "strawberry-vip-spa-massage-parlour",
    "name": "strawberry vip spa massage parlour",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "2nd floor, no 135, 19th Main Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.3,
    "reviews_count": 3,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1591343395082-e120087004b4?w=800&q=80"
    ],
    "latitude": 13.0009848,
    "longitude": 77.5504251,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/strawberry+vip+spa+massage+parlour/data=!4m7!3m6!1s0x3bae3d1fe82d3631:0x8432d9873fe69f46!8m2!3d13.0009848!4d77.5504251!16s%2Fg%2F11xn7rhmx8!19sChIJMTYt6B89rjsRRp_mP4fZMoQ?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "sparsh-spa",
    "name": "Sparsh Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "No 64/1 1st Floor, 8th B Main Rd, near Namdini Hotel",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.2,
    "reviews_count": 36,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=800&q=80"
    ],
    "latitude": 12.9311585,
    "longitude": 77.5826765,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Sparsh+Spa/data=!4m7!3m6!1s0x3bae15bfcb1503e7:0x8c938845369dee07!8m2!3d12.9311585!4d77.5826765!16s%2Fg%2F11j4swv658!19sChIJ5wMVy78VrjsRB-6dNkWIk4w?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "chloe",
    "name": "Chloe",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Unit : F/25, 1st Floor, Lulu Global Mall",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.2,
    "reviews_count": 24,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&q=80"
    ],
    "latitude": 12.9806343,
    "longitude": 77.5636547,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Chloe/data=!4m7!3m6!1s0x3bae161dbc950001:0xf0ca858c4262b48f!8m2!3d12.9806343!4d77.5636547!16s%2Fg%2F11v3tmzj48!19sChIJAQCVvB0WrjsRj7RiQoyFyvA?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "a-body-mantra-spa",
    "name": "A BODY MANTRA SPA",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "4th Floor, 419, Dr Rajkumar Rd, above just Bake",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.2,
    "reviews_count": 17,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531263708802-1bc27c605e7e?w=800&q=80"
    ],
    "latitude": 12.9794978,
    "longitude": 77.5538828,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/A+BODY+MANTRA+SPA/data=!4m7!3m6!1s0x3bae3df7cc744ced:0x419156787855f5a0!8m2!3d12.9794978!4d77.5538828!16s%2Fg%2F11t29f6nfl!19sChIJ7Ux0zPc9rjsRoPVVeHhWkUE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "splash-wellness-laxury-spa",
    "name": "Splash Wellness laxury spa",
    "description": "Highly rated wellness spa in Bangalore with excellent reviews and professional service.",
    "address": "17th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.1,
    "reviews_count": 19,
    "spa_type": "Wellness Spa",
    "services": [
      "De-Stress Massage",
      "Pain Relief Therapy",
      "Relaxation Massage",
      "Body Treatment",
      "Wellness Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1552693673-1bf958298935?w=800&q=80"
    ],
    "latitude": 12.9143174,
    "longitude": 77.6383528,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Splash+Wellness+laxury+spa/data=!4m7!3m6!1s0x3bae152970a36b3b:0xf1246dcaf5607bb1!8m2!3d12.9143174!4d77.6383528!16s%2Fg%2F11sc_wl23q!19sChIJO2ujcCkVrjsRsXtg9cptJPE?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "urban-life-body-care",
    "name": "Urban Life Body Care",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Richmond Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.0,
    "reviews_count": 3,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80"
    ],
    "latitude": 12.9669712,
    "longitude": 77.6082877,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Urban+Life+Body+Care/data=!4m7!3m6!1s0xa279c76110d620e5:0xb144411b8ce004f!8m2!3d12.9669712!4d77.6082877!16s%2Fg%2F11ssrck61b!19sChIJ5SDWEGHHeaIRTwDOuBFEFAs?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "limra-spa-massage-home-service",
    "name": "Limra Spa & Massage Home service",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "6, 12th Cross Rd",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.0,
    "reviews_count": 2,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1531299244174-d247dd4e5a66?w=800&q=80"
    ],
    "latitude": 13.0348493,
    "longitude": 77.6022576,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Limra+Spa+%26+Massage+Home+service/data=!4m7!3m6!1s0x3bae1700286d0db5:0x222ac9945994365b!8m2!3d13.0348493!4d77.6022576!16s%2Fg%2F11xp33v74h!19sChIJtQ1tKAAXrjsRWzaUWZTJKiI?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "california-spa",
    "name": "California Spa",
    "description": "Highly rated day spa in Bangalore with excellent reviews and professional service.",
    "address": "Soni Signal",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.0,
    "reviews_count": 2,
    "spa_type": "Day Spa",
    "services": [
      "Swedish Massage",
      "Deep Tissue",
      "Express Facial",
      "Body Scrub",
      "Aromatherapy",
      "Head Massage"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80"
    ],
    "latitude": 12.9355743,
    "longitude": 77.6146736,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/California+Spa/data=!4m7!3m6!1s0x3bae144e1495156d:0x236fd29e79411190!8m2!3d12.9355743!4d77.6146736!16s%2Fg%2F11xp657n3y!19sChIJbRWVFE4UrjsRkBFBeZ7SbyM?authuser=0&hl=en&rclk=1"
  },
  {
    "id": "herbal-louts-herbal-lotus-beauty-parlour",
    "name": "Herbal Louts Herbal Lotus Beauty Parlour",
    "description": "Highly rated beauty spa in Bangalore with excellent reviews and professional service.",
    "address": "Herbal Lotus Beauty Parlour, V, Nagenahalli Bus Stop",
    "city": "Bangalore",
    "state": "Karnataka",
    "area": "Bangalore",
    "phone": "",
    "rating": 3.0,
    "reviews_count": 1,
    "spa_type": "Beauty Spa",
    "services": [
      "Facial",
      "Hair Spa",
      "Body Polish",
      "Manicure",
      "Pedicure",
      "Bridal Package"
    ],
    "price_range": "\u20b9\u20b9",
    "opening_hours": "10:00 AM - 9:00 PM",
    "images": [
      "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80"
    ],
    "latitude": 13.039215,
    "longitude": 77.606023,
    "amenities": [
      "AC",
      "Private Rooms",
      "Steam Room",
      "Shower",
      "Parking"
    ],
    "google_maps_url": "https://www.google.com/maps/place/Herbal+Louts+Herbal+Lotus+Beauty+Parlour/data=!4m7!3m6!1s0x3bae1746b386fcaf:0x4bf62877796b8cdd!8m2!3d13.039215!4d77.606023!16s%2Fg%2F11ltrt_b62!19sChIJr_yGs0YXrjsR3YxreXco9ks?authuser=0&hl=en&rclk=1"
  }
];

export const STATES = ['Karnataka'];
export const CITIES = ['Bangalore'];
export const CITIES_BY_STATE = {'Karnataka': ['Bangalore']};
export const AREAS = [...new Set(ALL_SPAS.map(s => s.area))].sort();
export const SPA_TYPES = [...new Set(ALL_SPAS.map(s => s.spa_type))].sort();

export const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon/2) * Math.sin(dLon/2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
};

export const getNearbySpas = (lat, lng, maxDist = 50) => 
    ALL_SPAS.map(s => ({...s, distance: calculateDistance(lat, lng, s.latitude, s.longitude)}))
    .filter(s => s.distance <= maxDist)
    .sort((a, b) => a.distance - b.distance);
